import * as React from 'react';
import React__default, { useState, useRef, useMemo, useEffect, useLayoutEffect, useCallback, forwardRef, memo, Suspense } from 'react';
import { __awaiter } from 'tslib';
import { suspend, clear as clear$1 } from 'suspend-react';
import _ from 'lodash';
import { useGLTF, OrbitControls, CameraControls, useProgress, Environment, StatsGl, Grid, useCursor, useHelper, Sphere, PerspectiveCamera, useAnimations, Box, Edges, useTexture as useTexture$1, Html, TransformControls as TransformControls$1 } from '@react-three/drei';
import * as THREE from 'three';
import { TextureLoader, DirectionalLightHelper, SpotLightHelper, PointLightHelper, HemisphereLightHelper, CameraHelper, TrianglesDrawMode, TriangleFanDrawMode, TriangleStripDrawMode, Quaternion, Matrix4, LoaderUtils, FileLoader, MeshBasicMaterial, Color, LinearSRGBColorSpace, SRGBColorSpace, BufferAttribute, InterleavedBuffer, InterleavedBufferAttribute, LinearFilter, LinearMipmapLinearFilter, RepeatWrapping, PointsMaterial, Material as Material$1, LineBasicMaterial, MeshStandardMaterial, DoubleSide, Vector2, PropertyBinding, BufferGeometry, SkinnedMesh, Mesh, LineSegments, Line, LineLoop, Points, Group, PerspectiveCamera as PerspectiveCamera$1, MathUtils, OrthographicCamera, Skeleton, AnimationClip, Bone, Object3D, InterpolateLinear, ColorManagement, Loader, SpotLight as SpotLight$2, PointLight as PointLight$1, DirectionalLight as DirectionalLight$1, MeshPhysicalMaterial, Vector3, InstancedMesh, NearestFilter, NearestMipmapNearestFilter, LinearMipmapNearestFilter, NearestMipmapLinearFilter, ClampToEdgeWrapping, MirroredRepeatWrapping, InterpolateDiscrete, FrontSide, ImageBitmapLoader, Texture, VectorKeyframeTrack, NumberKeyframeTrack, QuaternionKeyframeTrack, Box3, Sphere as Sphere$1, Interpolant } from 'three';
import _create from 'zustand';
import { useThree, useFrame, extend, Canvas, useLoader, useGraph } from '@react-three/fiber';
import { GroundProjectedEnv, ARButton, OrbitControls as OrbitControls$1, TransformControls, SkeletonUtils } from 'three-stdlib';
import { Resolution } from 'postprocessing';
import * as fflate from 'three/examples/jsm/libs/fflate.module.js';
import { SMAA, Bloom, Noise, DepthOfField, ChromaticAberration, BrightnessContrast, HueSaturation, SSAO, ToneMapping, Vignette, EffectComposer } from '@react-three/postprocessing';
import { Perf } from 'r3f-perf';
import { HDRJPGLoader } from '@monogrid/gainmap-js';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import * as ReactDOM from 'react-dom';

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }
  return object;
}
function _get() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get.bind();
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get.apply(this, arguments);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function () {};
      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global_1 =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || commonjsGlobal || Function('return this')();

var fails = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var functionBindNative = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var call$2 = Function.prototype.call;

var functionCall = functionBindNative ? call$2.bind(call$2) : function () {
  return call$2.apply(call$2, arguments);
};

var $propertyIsEnumerable$1 = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$6 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$6 && !$propertyIsEnumerable$1.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var f$7 = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$6(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable$1;

var objectPropertyIsEnumerable = {
	f: f$7
};

var createPropertyDescriptor = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var FunctionPrototype$3 = Function.prototype;
var call$1 = FunctionPrototype$3.call;
var uncurryThisWithBind = functionBindNative && FunctionPrototype$3.bind.bind(call$1, call$1);

var functionUncurryThis = functionBindNative ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$1.apply(fn, arguments);
  };
};

var toString$1 = functionUncurryThis({}.toString);
var stringSlice$a = functionUncurryThis(''.slice);

var classofRaw = function (it) {
  return stringSlice$a(toString$1(it), 8, -1);
};

var $Object$4 = Object;
var split$3 = functionUncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classofRaw(it) == 'String' ? split$3(it, '') : $Object$4(it);
} : $Object$4;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined = function (it) {
  return it === null || it === undefined;
};

var $TypeError$j = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible = function (it) {
  if (isNullOrUndefined(it)) throw $TypeError$j("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings



var toIndexedObject = function (it) {
  return indexedObject(requireObjectCoercible(it));
};

var documentAll$2 = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll$2 == 'undefined' && documentAll$2 !== undefined;

var documentAll_1 = {
  all: documentAll$2,
  IS_HTMLDDA: IS_HTMLDDA
};

var documentAll$1 = documentAll_1.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable = documentAll_1.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll$1;
} : function (argument) {
  return typeof argument == 'function';
};

var documentAll = documentAll_1.all;

var isObject = documentAll_1.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

var getBuiltIn = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global_1[namespace]) : global_1[namespace] && global_1[namespace][method];
};

var objectIsPrototypeOf = functionUncurryThis({}.isPrototypeOf);

var engineUserAgent = typeof navigator != 'undefined' && String(navigator.userAgent) || '';

var process$4 = global_1.process;
var Deno$1 = global_1.Deno;
var versions = process$4 && process$4.versions || Deno$1 && Deno$1.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && engineUserAgent) {
  match = engineUserAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = engineUserAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */




var $String$5 = global_1.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String$5(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && engineV8Version && engineV8Version < 41;
});

/* eslint-disable es/no-symbol -- required for testing */


var useSymbolAsUid = symbolConstructorDetection
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var $Object$3 = Object;

var isSymbol = useSymbolAsUid ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && objectIsPrototypeOf($Symbol.prototype, $Object$3(it));
};

var $String$4 = String;

var tryToString = function (argument) {
  try {
    return $String$4(argument);
  } catch (error) {
    return 'Object';
  }
};

var $TypeError$i = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable = function (argument) {
  if (isCallable(argument)) return argument;
  throw $TypeError$i(tryToString(argument) + ' is not a function');
};

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};

var $TypeError$h = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = functionCall(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = functionCall(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = functionCall(fn, input))) return val;
  throw $TypeError$h("Can't convert object to primitive value");
};

var isPure = false;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$5 = Object.defineProperty;

var defineGlobalProperty = function (key, value) {
  try {
    defineProperty$5(global_1, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global_1[key] = value;
  } return value;
};

var SHARED = '__core-js_shared__';
var store$1 = global_1[SHARED] || defineGlobalProperty(SHARED, {});

var sharedStore = store$1;

var shared = createCommonjsModule(function (module) {
(module.exports = function (key, value) {
  return sharedStore[key] || (sharedStore[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.30.2',
  mode: 'global',
  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.30.2/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});
});

var $Object$2 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject = function (argument) {
  return $Object$2(requireObjectCoercible(argument));
};

var hasOwnProperty = functionUncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};

var id = 0;
var postfix = Math.random();
var toString = functionUncurryThis(1.0.toString);

var uid = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};

var Symbol$1 = global_1.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = useSymbolAsUid ? Symbol$1['for'] || Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;

var wellKnownSymbol = function (name) {
  if (!hasOwnProperty_1(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = symbolConstructorDetection && hasOwnProperty_1(Symbol$1, name)
      ? Symbol$1[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

var $TypeError$g = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = functionCall(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw $TypeError$g("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var document$3 = global_1.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject(document$3) && isObject(document$3.createElement);

var documentCreateElement = function (it) {
  return EXISTS$1 ? document$3.createElement(it) : {};
};

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !descriptors && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(documentCreateElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var f$6 = descriptors ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (ie8DomDefine) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwnProperty_1(O, P)) return createPropertyDescriptor(!functionCall(objectPropertyIsEnumerable.f, O, P), O[P]);
};

var objectGetOwnPropertyDescriptor = {
	f: f$6
};

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = descriptors && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});

var $String$3 = String;
var $TypeError$f = TypeError;

// `Assert: Type(argument) is Object`
var anObject = function (argument) {
  if (isObject(argument)) return argument;
  throw $TypeError$f($String$3(argument) + ' is not an object');
};

var $TypeError$e = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var f$5 = descriptors ? v8PrototypeDefineBug ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (ie8DomDefine) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError$e('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var objectDefineProperty = {
	f: f$5
};

var createNonEnumerableProperty = descriptors ? function (object, key, value) {
  return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var FunctionPrototype$2 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = descriptors && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwnProperty_1(FunctionPrototype$2, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!descriptors || (descriptors && getDescriptor(FunctionPrototype$2, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var functionToString$1 = functionUncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(sharedStore.inspectSource)) {
  sharedStore.inspectSource = function (it) {
    return functionToString$1(it);
  };
}

var inspectSource = sharedStore.inspectSource;

var WeakMap$1 = global_1.WeakMap;

var weakMapBasicDetection = isCallable(WeakMap$1) && /native code/.test(String(WeakMap$1));

var keys$1 = shared('keys');

var sharedKey = function (key) {
  return keys$1[key] || (keys$1[key] = uid(key));
};

var hiddenKeys$1 = {};

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$6 = global_1.TypeError;
var WeakMap = global_1.WeakMap;
var set$2, get$1, has;

var enforce = function (it) {
  return has(it) ? get$1(it) : set$2(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get$1(it)).type !== TYPE) {
      throw TypeError$6('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (weakMapBasicDetection || sharedStore.state) {
  var store = sharedStore.state || (sharedStore.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set$2 = function (it, metadata) {
    if (store.has(it)) throw TypeError$6(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get$1 = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys$1[STATE] = true;
  set$2 = function (it, metadata) {
    if (hasOwnProperty_1(it, STATE)) throw TypeError$6(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get$1 = function (it) {
    return hasOwnProperty_1(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwnProperty_1(it, STATE);
  };
}

var internalState = {
  set: set$2,
  get: get$1,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var makeBuiltIn_1 = createCommonjsModule(function (module) {
var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;



var enforceInternalState = internalState.enforce;
var getInternalState = internalState.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = functionUncurryThis(''.slice);
var replace = functionUncurryThis(''.replace);
var join = functionUncurryThis([].join);

var CONFIGURABLE_LENGTH = descriptors && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
    name = '[' + replace($String(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwnProperty_1(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (descriptors) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwnProperty_1(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwnProperty_1(options, 'constructor') && options.constructor) {
      if (descriptors) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwnProperty_1(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');
});

var defineBuiltIn = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn_1(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else objectDefineProperty.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var ceil = Math.ceil;
var floor$8 = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor$8 : ceil)(n);
};

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : mathTrunc(number);
};

var max$4 = Math.max;
var min$7 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max$4(integer + length, 0) : min$7(integer, length);
};

var min$6 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength = function (argument) {
  return argument > 0 ? min$6(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike = function (obj) {
  return toLength(obj.length);
};

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$5 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$5(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$5(false)
};

var indexOf$1 = arrayIncludes.indexOf;


var push$8 = functionUncurryThis([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwnProperty_1(hiddenKeys$1, key) && hasOwnProperty_1(O, key) && push$8(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwnProperty_1(O, key = names[i++])) {
    ~indexOf$1(result, key) || push$8(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var f$4 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return objectKeysInternal(O, hiddenKeys);
};

var objectGetOwnPropertyNames = {
	f: f$4
};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var f$3 = Object.getOwnPropertySymbols;

var objectGetOwnPropertySymbols = {
	f: f$3
};

var concat$3 = functionUncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = objectGetOwnPropertyNames.f(anObject(it));
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  return getOwnPropertySymbols ? concat$3(keys, getOwnPropertySymbols(it)) : keys;
};

var copyConstructorProperties$1 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = objectDefineProperty.f;
  var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwnProperty_1(target, key) && !(exceptions && hasOwnProperty_1(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

var isForced_1 = isForced;

var getOwnPropertyDescriptor$5 = objectGetOwnPropertyDescriptor.f;






/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global_1;
  } else if (STATIC) {
    target = global_1[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global_1[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor$5(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties$1(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};

var engineIsNode = typeof process != 'undefined' && classofRaw(process) == 'process';

var functionUncurryThisAccessor = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return functionUncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};

var $String$2 = String;
var $TypeError$d = TypeError;

var aPossiblePrototype = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw $TypeError$d("Can't set " + $String$2(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */




// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = functionUncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var defineProperty$4 = objectDefineProperty.f;



var TO_STRING_TAG$4 = wellKnownSymbol('toStringTag');

var setToStringTag = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwnProperty_1(target, TO_STRING_TAG$4)) {
    defineProperty$4(target, TO_STRING_TAG$4, { configurable: true, value: TAG });
  }
};

var defineBuiltInAccessor = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn_1(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn_1(descriptor.set, name, { setter: true });
  return objectDefineProperty.f(target, name, descriptor);
};

var SPECIES$6 = wellKnownSymbol('species');

var setSpecies = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);

  if (descriptors && Constructor && !Constructor[SPECIES$6]) {
    defineBuiltInAccessor(Constructor, SPECIES$6, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var $TypeError$c = TypeError;

var anInstance = function (it, Prototype) {
  if (objectIsPrototypeOf(Prototype, it)) return it;
  throw $TypeError$c('Incorrect invocation');
};

var TO_STRING_TAG$3 = wellKnownSymbol('toStringTag');
var test$1 = {};

test$1[TO_STRING_TAG$3] = 'z';

var toStringTagSupport = String(test$1) === '[object z]';

var TO_STRING_TAG$2 = wellKnownSymbol('toStringTag');
var $Object$1 = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof = toStringTagSupport ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object$1(it), TO_STRING_TAG$2)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};

var noop = function () { /* empty */ };
var empty = [];
var construct$1 = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec$3 = functionUncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct$1(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec$3(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor = !construct$1 || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var $TypeError$b = TypeError;

// `Assert: IsConstructor(argument) is true`
var aConstructor = function (argument) {
  if (isConstructor(argument)) return argument;
  throw $TypeError$b(tryToString(argument) + ' is not a constructor');
};

var SPECIES$5 = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined(S = anObject(C)[SPECIES$5]) ? defaultConstructor : aConstructor(S);
};

var FunctionPrototype$1 = Function.prototype;
var apply = FunctionPrototype$1.apply;
var call = FunctionPrototype$1.call;

// eslint-disable-next-line es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (functionBindNative ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});

var functionUncurryThisClause = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return functionUncurryThis(fn);
};

var bind$1 = functionUncurryThisClause(functionUncurryThisClause.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : functionBindNative ? bind$1(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var html = getBuiltIn('document', 'documentElement');

var arraySlice = functionUncurryThis([].slice);

var $TypeError$a = TypeError;

var validateArgumentsLength = function (passed, required) {
  if (passed < required) throw $TypeError$a('Not enough arguments');
  return passed;
};

// eslint-disable-next-line redos/no-vulnerable -- safe
var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(engineUserAgent);

var set$1 = global_1.setImmediate;
var clear = global_1.clearImmediate;
var process$3 = global_1.process;
var Dispatch = global_1.Dispatch;
var Function$2 = global_1.Function;
var MessageChannel = global_1.MessageChannel;
var String$1 = global_1.String;
var counter = 0;
var queue$2 = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;

fails(function () {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = global_1.location;
});

var run = function (id) {
  if (hasOwnProperty_1(queue$2, id)) {
    var fn = queue$2[id];
    delete queue$2[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var eventListener = function (event) {
  run(event.data);
};

var globalPostMessageDefer = function (id) {
  // old engines have not location.origin
  global_1.postMessage(String$1(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set$1 || !clear) {
  set$1 = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable(handler) ? handler : Function$2(handler);
    var args = arraySlice(arguments, 1);
    queue$2[++counter] = function () {
      functionApply(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue$2[id];
  };
  // Node.js 0.8-
  if (engineIsNode) {
    defer = function (id) {
      process$3.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !engineIsIos) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = eventListener;
    defer = functionBindContext(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global_1.addEventListener &&
    isCallable(global_1.postMessage) &&
    !global_1.importScripts &&
    $location && $location.protocol !== 'file:' &&
    !fails(globalPostMessageDefer)
  ) {
    defer = globalPostMessageDefer;
    global_1.addEventListener('message', eventListener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in documentCreateElement('script')) {
    defer = function (id) {
      html.appendChild(documentCreateElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task$1 = {
  set: set$1,
  clear: clear
};

var Queue = function () {
  this.head = null;
  this.tail = null;
};

Queue.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    var tail = this.tail;
    if (tail) tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      var next = this.head = entry.next;
      if (next === null) this.tail = null;
      return entry.item;
    }
  }
};

var queue$1 = Queue;

var engineIsIosPebble = /ipad|iphone|ipod/i.test(engineUserAgent) && typeof Pebble != 'undefined';

var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(engineUserAgent);

var getOwnPropertyDescriptor$4 = objectGetOwnPropertyDescriptor.f;
var macrotask = task$1.set;






var MutationObserver = global_1.MutationObserver || global_1.WebKitMutationObserver;
var document$2 = global_1.document;
var process$2 = global_1.process;
var Promise$1 = global_1.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor$4(global_1, 'queueMicrotask');
var microtask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
var notify$1, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!microtask) {
  var queue = new queue$1();

  var flush = function () {
    var parent, fn;
    if (engineIsNode && (parent = process$2.domain)) parent.exit();
    while (fn = queue.get()) try {
      fn();
    } catch (error) {
      if (queue.head) notify$1();
      throw error;
    }
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!engineIsIos && !engineIsNode && !engineIsWebosWebkit && MutationObserver && document$2) {
    toggle = true;
    node = document$2.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify$1 = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!engineIsIosPebble && Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise$1;
    then = functionBindContext(promise.then, promise);
    notify$1 = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (engineIsNode) {
    notify$1 = function () {
      process$2.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // `webpack` dev server bug on IE global methods - use bind(fn, global)
    macrotask = functionBindContext(macrotask, global_1);
    notify$1 = function () {
      macrotask(flush);
    };
  }

  microtask = function (fn) {
    if (!queue.head) notify$1();
    queue.add(fn);
  };
}

var microtask_1 = microtask;

var hostReportErrors = function (a, b) {
  try {
    // eslint-disable-next-line no-console -- safe
    arguments.length == 1 ? console.error(a) : console.error(a, b);
  } catch (error) { /* empty */ }
};

var perform = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var promiseNativeConstructor = global_1.Promise;

/* global Deno -- Deno case */
var engineIsDeno = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';

var engineIsBrowser = !engineIsDeno && !engineIsNode
  && typeof window == 'object'
  && typeof document == 'object';

promiseNativeConstructor && promiseNativeConstructor.prototype;
var SPECIES$4 = wellKnownSymbol('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT$1 = isCallable(global_1.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR$5 = isForced_1('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(promiseNativeConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(promiseNativeConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && engineV8Version === 66) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!engineV8Version || engineV8Version < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new promiseNativeConstructor(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES$4] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (engineIsBrowser || engineIsDeno) && !NATIVE_PROMISE_REJECTION_EVENT$1;
});

var promiseConstructorDetection = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR$5,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT$1,
  SUBCLASSING: SUBCLASSING
};

var $TypeError$9 = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw $TypeError$9('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable(resolve);
  this.reject = aCallable(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
var f$2 = function (C) {
  return new PromiseCapability(C);
};

var newPromiseCapability$1 = {
	f: f$2
};

var task = task$1.set;









var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR$4 = promiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = promiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = promiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = internalState.getterFor(PROMISE);
var setInternalState$6 = internalState.set;
var NativePromisePrototype$1 = promiseNativeConstructor && promiseNativeConstructor.prototype;
var PromiseConstructor = promiseNativeConstructor;
var PromisePrototype = NativePromisePrototype$1;
var TypeError$5 = global_1.TypeError;
var document$1 = global_1.document;
var process$1 = global_1.process;
var newPromiseCapability = newPromiseCapability$1.f;
var newGenericPromiseCapability = newPromiseCapability;

var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global_1.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && isCallable(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state == FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(TypeError$5('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        functionCall(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask_1(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$1.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global_1.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global_1['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  functionCall(task, global_1, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (engineIsNode) {
          process$1.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = engineIsNode || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  functionCall(task, global_1, function () {
    var promise = state.facade;
    if (engineIsNode) {
      process$1.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError$5("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask_1(function () {
        var wrapper = { done: false };
        try {
          functionCall(then, value,
            bind(internalResolve, wrapper, state),
            bind(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR$4) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable(executor);
    functionCall(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState$6(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new queue$1(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable(onRejected) && onRejected;
    reaction.domain = engineIsNode ? process$1.domain : undefined;
    if (state.state == PENDING) state.reactions.add(reaction);
    else microtask_1(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };

  newPromiseCapability$1.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (isCallable(promiseNativeConstructor) && NativePromisePrototype$1 !== Object.prototype) {
    nativeThen = NativePromisePrototype$1.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn(NativePromisePrototype$1, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          functionCall(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype$1.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (objectSetPrototypeOf) {
      objectSetPrototypeOf(NativePromisePrototype$1, PromisePrototype);
    }
  }
}

_export({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR$4 }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false);
setSpecies(PROMISE);

var iterators = {};

var ITERATOR$8 = wellKnownSymbol('iterator');
var ArrayPrototype$1 = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod = function (it) {
  return it !== undefined && (iterators.Array === it || ArrayPrototype$1[ITERATOR$8] === it);
};

var ITERATOR$7 = wellKnownSymbol('iterator');

var getIteratorMethod = function (it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR$7)
    || getMethod(it, '@@iterator')
    || iterators[classof(it)];
};

var $TypeError$8 = TypeError;

var getIterator = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(functionCall(iteratorMethod, argument));
  throw $TypeError$8(tryToString(argument) + ' is not iterable');
};

var iteratorClose = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = functionCall(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};

var $TypeError$7 = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

var iterate = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = functionBindContext(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw $TypeError$7(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && objectIsPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = functionCall(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && objectIsPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};

var ITERATOR$6 = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$6] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$6] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var FORCED_PROMISE_CONSTRUCTOR$3 = promiseConstructorDetection.CONSTRUCTOR;

var promiseStaticsIncorrectIteration = FORCED_PROMISE_CONSTRUCTOR$3 || !checkCorrectnessOfIteration(function (iterable) {
  promiseNativeConstructor.all(iterable).then(undefined, function () { /* empty */ });
});

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
_export({ target: 'Promise', stat: true, forced: promiseStaticsIncorrectIteration }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability$1.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        functionCall($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var FORCED_PROMISE_CONSTRUCTOR$2 = promiseConstructorDetection.CONSTRUCTOR;





var NativePromisePrototype = promiseNativeConstructor && promiseNativeConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
_export({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR$2, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (isCallable(promiseNativeConstructor)) {
  var method = getBuiltIn('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
_export({ target: 'Promise', stat: true, forced: promiseStaticsIncorrectIteration }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability$1.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        functionCall($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var FORCED_PROMISE_CONSTRUCTOR$1 = promiseConstructorDetection.CONSTRUCTOR;

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
_export({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR$1 }, {
  reject: function reject(r) {
    var capability = newPromiseCapability$1.f(this);
    functionCall(capability.reject, undefined, r);
    return capability.promise;
  }
});

var promiseResolve = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability$1.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var FORCED_PROMISE_CONSTRUCTOR = promiseConstructorDetection.CONSTRUCTOR;


getBuiltIn('Promise');

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
_export({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(this, x);
  }
});

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
var objectToString = toStringTagSupport ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!toStringTagSupport) {
  defineBuiltIn(Object.prototype, 'toString', objectToString, { unsafe: true });
}

var devUrl = 'https://back-test.amaspace.co/';
var loadProduct = function loadProduct(id, apiKey) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var body, response, data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(apiKey && id)) {
            _context.next = 16;
            break;
          }
          console.log(id);
          body = {
            domain: location.hostname,
            accessToken: apiKey,
            product_id: id
          };
          _context.next = 5;
          return fetch(devUrl + "api/share/get-product", {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
          });
        case 5:
          response = _context.sent;
          _context.next = 8;
          return response.json();
        case 8:
          data = _context.sent;
          console.log(body);
          console.log(data);
          if (response.ok) {
            _context.next = 15;
            break;
          }
          _context.next = 14;
          return loadAsset(id, apiKey);
        case 14:
          return _context.abrupt("return", _context.sent);
        case 15:
          return _context.abrupt("return", data);
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
};
var loadAsset = function loadAsset(id, apiKey) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var response, data;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!(apiKey && id)) {
            _context2.next = 10;
            break;
          }
          _context2.next = 3;
          return fetch(devUrl + "api/get-asset?id=" + id, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'X-Shared-Domain': location.hostname,
              'X-Shared-Access-Token': apiKey
            }
          });
        case 3:
          response = _context2.sent;
          _context2.next = 6;
          return response.json();
        case 6:
          data = _context2.sent;
          console.log(data);
          if (!response.ok) {
            console.log(data.message);
          }
          return _context2.abrupt("return", data);
        case 10:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
};

var useLoadAsset = function useLoadAsset(assetId, apiKey) {
  var data = suspend(function () {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return loadAsset(assetId, apiKey);
          case 2:
            return _context.abrupt("return", _context.sent);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  }, [assetId]);
  return data;
};

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray = Array.isArray || function isArray(argument) {
  return classofRaw(argument) == 'Array';
};

var SPECIES$3 = wellKnownSymbol('species');
var $Array$4 = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesConstructor = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array$4 || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES$3];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array$4 : C;
};

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};

var push$7 = functionUncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod$4 = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = indexedObject(O);
    var boundFunction = functionBindContext(callbackfn, that);
    var length = lengthOfArrayLike(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push$7(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push$7(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var arrayIteration = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod$4(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod$4(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod$4(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod$4(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod$4(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod$4(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod$4(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod$4(7)
};

var arrayMethodIsStrict = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};

var $forEach$1 = arrayIteration.forEach;


var STRICT_METHOD$4 = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
var arrayForEach = !STRICT_METHOD$4 ? function forEach(callbackfn /* , thisArg */) {
  return $forEach$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;

// `Array.prototype.forEach` method
// https://tc39.es/ecma262/#sec-array.prototype.foreach
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
_export({ target: 'Array', proto: true, forced: [].forEach != arrayForEach }, {
  forEach: arrayForEach
});

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`


var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;

var handlePrototype$1 = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== arrayForEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', arrayForEach);
  } catch (error) {
    CollectionPrototype.forEach = arrayForEach;
  }
};

for (var COLLECTION_NAME$1 in domIterables) {
  if (domIterables[COLLECTION_NAME$1]) {
    handlePrototype$1(global_1[COLLECTION_NAME$1] && global_1[COLLECTION_NAME$1].prototype);
  }
}

handlePrototype$1(domTokenListPrototype);

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys = Object.keys || function keys(O) {
  return objectKeysInternal(O, enumBugKeys);
};

var FAILS_ON_PRIMITIVES$1 = fails(function () { objectKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
_export({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES$1 }, {
  keys: function keys(it) {
    return objectKeys(toObject(it));
  }
});

var FUNCTION_NAME_EXISTS = functionName.EXISTS;



var FunctionPrototype = Function.prototype;
var functionToString = functionUncurryThis(FunctionPrototype.toString);
var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var regExpExec = functionUncurryThis(nameRE.exec);
var NAME$1 = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (descriptors && !FUNCTION_NAME_EXISTS) {
  defineBuiltInAccessor(FunctionPrototype, NAME$1, {
    configurable: true,
    get: function () {
      try {
        return regExpExec(nameRE, functionToString(this))[1];
      } catch (error) {
        return '';
      }
    }
  });
}

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$3 = Object.defineProperty;
var concat$2 = functionUncurryThis([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (descriptors && $assign({ b: 1 }, $assign(defineProperty$3({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$3(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  var propertyIsEnumerable = objectPropertyIsEnumerable.f;
  while (argumentsLength > index) {
    var S = indexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat$2(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!descriptors || functionCall(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
_export({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== objectAssign }, {
  assign: objectAssign
});

/* global Bun -- Deno case */
var engineIsBun = typeof Bun == 'function' && Bun && typeof Bun.version == 'string';

var Function$1 = global_1.Function;
// dirty IE9- and Bun 0.3.0- checks
var WRAP = /MSIE .\./.test(engineUserAgent) || engineIsBun && (function () {
  var version = global_1.Bun.version.split('.');
  return version.length < 3 || version[0] == 0 && (version[1] < 3 || version[1] == 3 && version[2] == 0);
})();

// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
var schedulersFix = function (scheduler, hasTimeArg) {
  var firstParamIndex = hasTimeArg ? 2 : 1;
  return WRAP ? function (handler, timeout /* , ...arguments */) {
    var boundArgs = validateArgumentsLength(arguments.length, 1) > firstParamIndex;
    var fn = isCallable(handler) ? handler : Function$1(handler);
    var params = boundArgs ? arraySlice(arguments, firstParamIndex) : [];
    var callback = boundArgs ? function () {
      functionApply(fn, this, params);
    } : fn;
    return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
  } : scheduler;
};

var setInterval$1 = schedulersFix(global_1.setInterval, true);

// Bun / IE9- setInterval additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
_export({ global: true, bind: true, forced: global_1.setInterval !== setInterval$1 }, {
  setInterval: setInterval$1
});

var setTimeout$1 = schedulersFix(global_1.setTimeout, true);

// Bun / IE9- setTimeout additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
_export({ global: true, bind: true, forced: global_1.setTimeout !== setTimeout$1 }, {
  setTimeout: setTimeout$1
});

var $every$1 = arrayIteration.every;


var STRICT_METHOD$3 = arrayMethodIsStrict('every');

// `Array.prototype.every` method
// https://tc39.es/ecma262/#sec-array.prototype.every
_export({ target: 'Array', proto: true, forced: !STRICT_METHOD$3 }, {
  every: function every(callbackfn /* , thisArg */) {
    return $every$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var f$1 = descriptors && !v8PrototypeDefineBug ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) objectDefineProperty.f(O, key = keys[index++], props[key]);
  return O;
};

var objectDefineProperties = {
	f: f$1
};

/* global ActiveXObject -- old IE, WSH */








var GT = '>';
var LT = '<';
var PROTOTYPE$1 = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE$1][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys$1[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE$1] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE$1] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : objectDefineProperties.f(result, Properties);
};

var defineProperty$2 = objectDefineProperty.f;

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  defineProperty$2(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: objectCreate(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var $find$1 = arrayIteration.find;


var FIND = 'find';
var SKIPS_HOLES = true;

// Shouldn't skip holes
// eslint-disable-next-line es/no-array-prototype-find -- testing
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
_export({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);

var $String$1 = String;

var toString_1 = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String$1(argument);
};

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags = function () {
  var that = anObject(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp$2 = global_1.RegExp;

var UNSUPPORTED_Y$2 = fails(function () {
  var re = $RegExp$2('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y$2 || fails(function () {
  return !$RegExp$2('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y$2 || fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$2('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y$2
};

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = global_1.RegExp;

var regexpUnsupportedDotAll = fails(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global_1.RegExp;

var regexpUnsupportedNcg = fails(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */







var getInternalState$3 = internalState.get;



var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt$6 = functionUncurryThis(''.charAt);
var indexOf = functionUncurryThis(''.indexOf);
var replace$6 = functionUncurryThis(''.replace);
var stringSlice$9 = functionUncurryThis(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  functionCall(nativeExec, re1, 'a');
  functionCall(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y$1 = regexpStickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y$1 || regexpUnsupportedDotAll || regexpUnsupportedNcg;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState$3(re);
    var str = toString_1(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = functionCall(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y$1 && re.sticky;
    var flags = functionCall(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace$6(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice$9(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$6(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = functionCall(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice$9(match.input, charsAdded);
        match[0] = stringSlice$9(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      functionCall(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = objectCreate(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec = patchedExec;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
_export({ target: 'RegExp', proto: true, forced: /./.exec !== regexpExec }, {
  exec: regexpExec
});

// TODO: Remove from `core-js@4` since it's moved to entry points








var SPECIES$2 = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES$2] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = functionUncurryThisClause(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = functionUncurryThisClause(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn(String.prototype, KEY, methods[0]);
    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};

var MATCH$1 = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classofRaw(it) == 'RegExp');
};

var charAt$5 = functionUncurryThis(''.charAt);
var charCodeAt$2 = functionUncurryThis(''.charCodeAt);
var stringSlice$8 = functionUncurryThis(''.slice);

var createMethod$3 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString_1(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt$2(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt$2(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt$5(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice$8(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$3(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$3(true)
};

var charAt$4 = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex = function (S, index, unicode) {
  return index + (unicode ? charAt$4(S, index).length : 1);
};

var createProperty = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) objectDefineProperty.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};

var $Array$3 = Array;
var max$3 = Math.max;

var arraySliceSimple = function (O, start, end) {
  var length = lengthOfArrayLike(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = $Array$3(max$3(fin - k, 0));
  for (var n = 0; k < fin; k++, n++) createProperty(result, n, O[k]);
  result.length = n;
  return result;
};

var $TypeError$6 = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable(exec)) {
    var result = functionCall(exec, R, S);
    if (result !== null) anObject(result);
    return result;
  }
  if (classofRaw(R) === 'RegExp') return functionCall(regexpExec, R, S);
  throw $TypeError$6('RegExp#exec called on incompatible receiver');
};

var UNSUPPORTED_Y = regexpStickyHelpers.UNSUPPORTED_Y;
var MAX_UINT32 = 0xFFFFFFFF;
var min$5 = Math.min;
var $push = [].push;
var exec$2 = functionUncurryThis(/./.exec);
var push$6 = functionUncurryThis($push);
var stringSlice$7 = functionUncurryThis(''.slice);

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

// @@split logic
fixRegexpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = toString_1(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegexp(separator)) {
        return functionCall(nativeSplit, string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = functionCall(regexpExec, separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          push$6(output, stringSlice$7(string, lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) functionApply($push, output, arraySliceSimple(match, 1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !exec$2(separatorCopy, '')) push$6(output, '');
      } else push$6(output, stringSlice$7(string, lastLastIndex));
      return output.length > lim ? arraySliceSimple(output, 0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : functionCall(nativeSplit, this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = isNullOrUndefined(separator) ? undefined : getMethod(separator, SPLIT);
      return splitter
        ? functionCall(splitter, separator, O, limit)
        : functionCall(internalSplit, toString_1(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var rx = anObject(this);
      var S = toString_1(string);
      var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);

      if (res.done) return res.value;

      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y ? 'g' : 'y');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return regexpExecAbstract(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
        var z = regexpExecAbstract(splitter, UNSUPPORTED_Y ? stringSlice$7(S, q) : S);
        var e;
        if (
          z === null ||
          (e = min$5(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          push$6(A, stringSlice$7(S, p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            push$6(A, z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      push$6(A, stringSlice$7(S, p));
      return A;
    }
  ];
}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);

var SPECIES$1 = wellKnownSymbol('species');

var arrayMethodHasSpeciesSupport = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return engineV8Version >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES$1] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};

var $map$1 = arrayIteration.map;


var HAS_SPECIES_SUPPORT$3 = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$3 }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var $filter$1 = arrayIteration.filter;


var HAS_SPECIES_SUPPORT$2 = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$2 }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// `Array.isArray` method
// https://tc39.es/ecma262/#sec-array.isarray
_export({ target: 'Array', stat: true }, {
  isArray: isArray
});

var $TypeError$5 = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

var doesNotExceedSafeInteger = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError$5('Maximum allowed index exceeded');
  return it;
};

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = engineV8Version >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED$a = !IS_CONCAT_SPREADABLE_SUPPORT || !arrayMethodHasSpeciesSupport('concat');

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
_export({ target: 'Array', proto: true, arity: 1, forced: FORCED$a }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike(E);
        doesNotExceedSafeInteger(n + len);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        doesNotExceedSafeInteger(n + 1);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});

var $includes$1 = arrayIncludes.includes;



// FF99+ bug
var BROKEN_ON_SPARSE = fails(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
_export({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes$1(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');

var $TypeError$4 = TypeError;

var notARegexp = function (it) {
  if (isRegexp(it)) {
    throw $TypeError$4("The method doesn't accept regular expressions");
  } return it;
};

var MATCH = wellKnownSymbol('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var stringIndexOf$1 = functionUncurryThis(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
_export({ target: 'String', proto: true, forced: !correctIsRegexpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf$1(
      toString_1(requireObjectCoercible(this)),
      toString_1(notARegexp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

var $propertyIsEnumerable = objectPropertyIsEnumerable.f;

var propertyIsEnumerable = functionUncurryThis($propertyIsEnumerable);
var push$5 = functionUncurryThis([].push);

// `Object.{ entries, values }` methods implementation
var createMethod$2 = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!descriptors || propertyIsEnumerable(O, key)) {
        push$5(result, TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

var objectToArray = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: createMethod$2(true),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: createMethod$2(false)
};

var $values = objectToArray.values;

// `Object.values` method
// https://tc39.es/ecma262/#sec-object.values
_export({ target: 'Object', stat: true }, {
  values: function values(O) {
    return $values(O);
  }
});

// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? functionBindContext(mapper, thisArg) : false;
  var element, elementLen;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      if (depth > 0 && isArray(element)) {
        elementLen = lengthOfArrayLike(element);
        targetIndex = flattenIntoArray(target, original, element, elementLen, targetIndex, depth - 1) - 1;
      } else {
        doesNotExceedSafeInteger(targetIndex + 1);
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
};

var flattenIntoArray_1 = flattenIntoArray;

// `Array.prototype.flat` method
// https://tc39.es/ecma262/#sec-array.prototype.flat
_export({ target: 'Array', proto: true }, {
  flat: function flat(/* depthArg = 1 */) {
    var depthArg = arguments.length ? arguments[0] : undefined;
    var O = toObject(this);
    var sourceLen = lengthOfArrayLike(O);
    var A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray_1(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toIntegerOrInfinity(depthArg));
    return A;
  }
});

var AMAMeshType;
(function (AMAMeshType) {
  AMAMeshType["Scene"] = "Scene";
  AMAMeshType["Object3D"] = "Object3D";
  AMAMeshType["Mesh"] = "Mesh";
  AMAMeshType["Group"] = "Group";
  AMAMeshType["Model_Group"] = "Model_Group";
  AMAMeshType["Bone"] = "Bone";
  AMAMeshType["SkinnedMesh"] = "SkinnedMesh";
  AMAMeshType["Sprite"] = "Sprite";
  AMAMeshType["Plane"] = "Plane";
  AMAMeshType["Box"] = "Box";
  AMAMeshType["Sphere"] = "Sphere";
  AMAMeshType["Directional_Light"] = "Directional_Light";
  AMAMeshType["Spot_Light"] = "Spot_Light";
  AMAMeshType["Point_Light"] = "Point_Light";
  AMAMeshType["Area_Light"] = "Area_Light";
  AMAMeshType["Hemisphere_Light"] = "Hemisphere_Light";
  AMAMeshType["PerspectiveCamera"] = "PerspectiveCamera";
  AMAMeshType["Default_Camera"] = "Default_Camera";
  AMAMeshType["New_Annotation"] = "New_Annotation";
  AMAMeshType["Target"] = "Target";
  AMAMeshType["Camera"] = "Camera";
})(AMAMeshType || (AMAMeshType = {}));
var AMAMode;
(function (AMAMode) {
  AMAMode["VIEWER"] = "VIEWER";
  AMAMode["EDITOR"] = "EDITOR";
})(AMAMode || (AMAMode = {}));
var AMATransformMode;
(function (AMATransformMode) {
  AMATransformMode["TRANSLATE"] = "translate";
  AMATransformMode["ROTATE"] = "rotate";
  AMATransformMode["SCALE"] = "scale";
})(AMATransformMode || (AMATransformMode = {}));
var AMARuleTypeAction;
(function (AMARuleTypeAction) {
  AMARuleTypeAction[AMARuleTypeAction["SetAttributeVisible"] = 19] = "SetAttributeVisible";
  AMARuleTypeAction[AMARuleTypeAction["SetAttributeEnabled"] = 20] = "SetAttributeEnabled";
  AMARuleTypeAction[AMARuleTypeAction["SetAttributeValue"] = 21] = "SetAttributeValue";
  AMARuleTypeAction[AMARuleTypeAction["SetAttributeValueVisibility"] = 22] = "SetAttributeValueVisibility";
  AMARuleTypeAction[AMARuleTypeAction["SetAttributeValueEnabled"] = 23] = "SetAttributeValueEnabled";
  AMARuleTypeAction[AMARuleTypeAction["CustomScript"] = 24] = "CustomScript";
  AMARuleTypeAction[AMARuleTypeAction["SetVisibility"] = 25] = "SetVisibility";
  AMARuleTypeAction[AMARuleTypeAction["SetMaterial"] = 26] = "SetMaterial";
  AMARuleTypeAction[AMARuleTypeAction["SetModel"] = 27] = "SetModel";
  AMARuleTypeAction[AMARuleTypeAction["SetProperty"] = 28] = "SetProperty";
  AMARuleTypeAction[AMARuleTypeAction["SetActiveCamera"] = 29] = "SetActiveCamera";
  AMARuleTypeAction[AMARuleTypeAction["ActivateAnimation"] = 30] = "ActivateAnimation";
})(AMARuleTypeAction || (AMARuleTypeAction = {}));
var AMAHotspotType;
(function (AMAHotspotType) {
  AMAHotspotType["DEFAULT"] = "DEFAULT";
  AMAHotspotType["WITH_ANIMATION"] = "WITH_ANIMATION";
})(AMAHotspotType || (AMAHotspotType = {}));
var AMARuleTypeCondition;
(function (AMARuleTypeCondition) {
  AMARuleTypeCondition[AMARuleTypeCondition["OnPageLoad"] = 8] = "OnPageLoad";
  AMARuleTypeCondition[AMARuleTypeCondition["OnClickAnnotation"] = 9] = "OnClickAnnotation";
  AMARuleTypeCondition[AMARuleTypeCondition["OnClickModelPart"] = 10] = "OnClickModelPart";
})(AMARuleTypeCondition || (AMARuleTypeCondition = {}));

var AMAMaterialType;
(function (AMAMaterialType) {
  AMAMaterialType["MeshStandardMaterial"] = "MeshStandardMaterial";
})(AMAMaterialType || (AMAMaterialType = {}));

var isMeshAMA = function isMeshAMA(mesh) {
  return 'isMesh' in mesh;
};
var isCamera = function isCamera(mesh) {
  return (mesh === null || mesh === void 0 ? void 0 : mesh.type) === AMAMeshType.PerspectiveCamera || (mesh === null || mesh === void 0 ? void 0 : mesh.type) === AMAMeshType.Default_Camera;
};
var isLight = function isLight(mesh) {
  return (mesh === null || mesh === void 0 ? void 0 : mesh.type) === AMAMeshType.Directional_Light || (mesh === null || mesh === void 0 ? void 0 : mesh.type) === AMAMeshType.Hemisphere_Light || (mesh === null || mesh === void 0 ? void 0 : mesh.type) === AMAMeshType.Spot_Light || (mesh === null || mesh === void 0 ? void 0 : mesh.type) === AMAMeshType.Point_Light || (mesh === null || mesh === void 0 ? void 0 : mesh.type) === AMAMeshType.Area_Light;
};
var isCustomShapes = function isCustomShapes(mesh) {
  return (mesh === null || mesh === void 0 ? void 0 : mesh.type) === AMAMeshType.Plane || (mesh === null || mesh === void 0 ? void 0 : mesh.type) === AMAMeshType.Sphere || (mesh === null || mesh === void 0 ? void 0 : mesh.type) === AMAMeshType.Box;
};
function isSpecificObject(mesh, type) {
  return (mesh === null || mesh === void 0 ? void 0 : mesh.type) === type;
}
var isStandardMaterial = function isStandardMaterial(material) {
  return 'isMeshStandardMaterial' in material;
};
var isDirectionalLight = function isDirectionalLight(node) {
  return node instanceof THREE.DirectionalLight;
};
var isSpotLight = function isSpotLight(node) {
  return node instanceof THREE.SpotLight;
};
var isHemisphereLight = function isHemisphereLight(node) {
  return node instanceof THREE.HemisphereLight;
};
var isPointLight = function isPointLight(node) {
  return node instanceof THREE.PointLight;
};
var isAMASphereGeometry = function isAMASphereGeometry(node) {
  return node instanceof THREE.SphereGeometry;
};
var isAMAPlaneGeometry = function isAMAPlaneGeometry(node) {
  return node instanceof THREE.PlaneGeometry;
};
var isAMABoxGeometry = function isAMABoxGeometry(node) {
  return node instanceof THREE.BoxGeometry;
};

var BasicConcrete = /*#__PURE__*/_createClass(function BasicConcrete(data) {
  _classCallCheck(this, BasicConcrete);
  this.name = data.name;
  this.id = data.id;
  this.dbId = data.dbId;
  this.position = data.position;
  this.rotation = data.rotation;
  this.scale = data.scale;
  this.animations = data.animations;
  this.children = data.children;
  this.visible = data.visible;
  this.receiveShadow = true;
  this.castShadow = true;
  this.userData = Object.assign(Object.assign({}, data.userData), {
    dbId: data.dbId,
    visibleInAR: typeof data.userData.visibleInAR == 'boolean' ? data.userData.visibleInAR : true
  });
});

var MeshConcrete = /*#__PURE__*/function (_BasicConcrete) {
  _inherits(MeshConcrete, _BasicConcrete);
  var _super = _createSuper(MeshConcrete);
  function MeshConcrete(data) {
    var _this;
    _classCallCheck(this, MeshConcrete);
    _this = _super.call(this, data);
    _this.type = AMAMeshType.Mesh;
    _this.material = data.material;
    _this.geometry = data.geometry;
    _this.updatedMaterial = data.updatedMaterial;
    _this.lazyLoadStep = data.lazyLoadStep;
    _this.lazyLoad = data.lazyLoad;
    return _this;
  }
  return _createClass(MeshConcrete);
}(BasicConcrete);

var Object3DConcrete = /*#__PURE__*/function (_BasicConcrete) {
  _inherits(Object3DConcrete, _BasicConcrete);
  var _super = _createSuper(Object3DConcrete);
  function Object3DConcrete(data) {
    var _this;
    _classCallCheck(this, Object3DConcrete);
    _this = _super.call(this, data);
    _this.type = AMAMeshType.Object3D;
    return _this;
  }
  return _createClass(Object3DConcrete);
}(BasicConcrete);

var GroupConcrete = /*#__PURE__*/function (_BasicConcrete) {
  _inherits(GroupConcrete, _BasicConcrete);
  var _super = _createSuper(GroupConcrete);
  function GroupConcrete(data) {
    var _this;
    _classCallCheck(this, GroupConcrete);
    _this = _super.call(this, data);
    _this.type = data.type;
    return _this;
  }
  return _createClass(GroupConcrete);
}(BasicConcrete);

var SceneConcrete = /*#__PURE__*/function (_BasicConcrete) {
  _inherits(SceneConcrete, _BasicConcrete);
  var _super = _createSuper(SceneConcrete);
  function SceneConcrete(data) {
    var _this;
    _classCallCheck(this, SceneConcrete);
    _this = _super.call(this, data);
    _this.type = AMAMeshType.Scene;
    return _this;
  }
  return _createClass(SceneConcrete);
}(BasicConcrete);

var BoneConcrete = /*#__PURE__*/function (_BasicConcrete) {
  _inherits(BoneConcrete, _BasicConcrete);
  var _super = _createSuper(BoneConcrete);
  function BoneConcrete(data) {
    var _this;
    _classCallCheck(this, BoneConcrete);
    _this = _super.call(this, data);
    _this.type = AMAMeshType.Bone;
    _this.object = data.object;
    _this.castShadow = false;
    _this.receiveShadow = false;
    return _this;
  }
  return _createClass(BoneConcrete);
}(BasicConcrete);

var SkinnedMeshConcrete = /*#__PURE__*/function (_BasicConcrete) {
  _inherits(SkinnedMeshConcrete, _BasicConcrete);
  var _super = _createSuper(SkinnedMeshConcrete);
  function SkinnedMeshConcrete(data) {
    var _this;
    _classCallCheck(this, SkinnedMeshConcrete);
    _this = _super.call(this, data);
    _this.type = AMAMeshType.SkinnedMesh;
    _this.skeleton = data.skeleton;
    _this.geometry = data.geometry;
    _this.material = data.material;
    return _this;
  }
  return _createClass(SkinnedMeshConcrete);
}(BasicConcrete);

var PlaneConcrete = /*#__PURE__*/function (_BasicConcrete) {
  _inherits(PlaneConcrete, _BasicConcrete);
  var _super = _createSuper(PlaneConcrete);
  function PlaneConcrete(data) {
    var _this;
    _classCallCheck(this, PlaneConcrete);
    _this = _super.call(this, data);
    _this.type = AMAMeshType.Plane;
    _this.updatedMaterial = data.updatedMaterial;
    _this.updatedGeometry = data.updatedGeometry;
    _this.geometry = data.geometry;
    _this.material = data.material;
    _this.userData = {
      id: data.id
    };
    return _this;
  }
  return _createClass(PlaneConcrete);
}(BasicConcrete);

var SphereConcrete = /*#__PURE__*/function (_BasicConcrete) {
  _inherits(SphereConcrete, _BasicConcrete);
  var _super = _createSuper(SphereConcrete);
  function SphereConcrete(data) {
    var _this;
    _classCallCheck(this, SphereConcrete);
    _this = _super.call(this, data);
    _this.type = AMAMeshType.Sphere;
    _this.updatedMaterial = data.updatedMaterial;
    _this.updatedGeometry = data.updatedGeometry;
    _this.geometry = data.geometry;
    _this.material = data.material;
    _this.userData = {
      id: data.id
    };
    return _this;
  }
  return _createClass(SphereConcrete);
}(BasicConcrete);

var BoxConcrete = /*#__PURE__*/function (_BasicConcrete) {
  _inherits(BoxConcrete, _BasicConcrete);
  var _super = _createSuper(BoxConcrete);
  function BoxConcrete(data) {
    var _this;
    _classCallCheck(this, BoxConcrete);
    _this = _super.call(this, data);
    _this.type = AMAMeshType.Box;
    _this.updatedMaterial = data.updatedMaterial;
    _this.updatedGeometry = data.updatedGeometry;
    _this.geometry = data.geometry;
    _this.material = data.material;
    _this.userData = {
      id: data.id
    };
    return _this;
  }
  return _createClass(BoxConcrete);
}(BasicConcrete);

var DirectionalConcrete = /*#__PURE__*/function (_BasicConcrete) {
  _inherits(DirectionalConcrete, _BasicConcrete);
  var _super = _createSuper(DirectionalConcrete);
  function DirectionalConcrete(data) {
    var _this;
    _classCallCheck(this, DirectionalConcrete);
    _this = _super.call(this, data);
    _this.type = AMAMeshType.Directional_Light;
    _this.updatedLight = data.updatedLight;
    _this.userData = {
      id: data.id
    };
    return _this;
  }
  return _createClass(DirectionalConcrete);
}(BasicConcrete);

var SpotConcrete = /*#__PURE__*/function (_BasicConcrete) {
  _inherits(SpotConcrete, _BasicConcrete);
  var _super = _createSuper(SpotConcrete);
  function SpotConcrete(data) {
    var _this;
    _classCallCheck(this, SpotConcrete);
    _this = _super.call(this, data);
    _this.type = AMAMeshType.Spot_Light;
    _this.updatedLight = data.updatedLight;
    _this.userData = {
      id: data.id
    };
    return _this;
  }
  return _createClass(SpotConcrete);
}(BasicConcrete);

var AreaConcrete = /*#__PURE__*/function (_BasicConcrete) {
  _inherits(AreaConcrete, _BasicConcrete);
  var _super = _createSuper(AreaConcrete);
  function AreaConcrete(data) {
    var _this;
    _classCallCheck(this, AreaConcrete);
    _this = _super.call(this, data);
    _this.type = AMAMeshType.Area_Light;
    _this.updatedLight = data.updatedLight;
    _this.userData = {
      id: data.id
    };
    return _this;
  }
  return _createClass(AreaConcrete);
}(BasicConcrete);

var HemisphereConcrete = /*#__PURE__*/function (_BasicConcrete) {
  _inherits(HemisphereConcrete, _BasicConcrete);
  var _super = _createSuper(HemisphereConcrete);
  function HemisphereConcrete(data) {
    var _this;
    _classCallCheck(this, HemisphereConcrete);
    _this = _super.call(this, data);
    _this.type = AMAMeshType.Hemisphere_Light;
    _this.updatedLight = data.updatedLight;
    _this.userData = {
      id: data.id
    };
    return _this;
  }
  return _createClass(HemisphereConcrete);
}(BasicConcrete);

var PointConcrete = /*#__PURE__*/function (_BasicConcrete) {
  _inherits(PointConcrete, _BasicConcrete);
  var _super = _createSuper(PointConcrete);
  function PointConcrete(data) {
    var _this;
    _classCallCheck(this, PointConcrete);
    _this = _super.call(this, data);
    _this.type = AMAMeshType.Point_Light;
    _this.updatedLight = data.updatedLight;
    _this.userData = {
      id: data.id
    };
    return _this;
  }
  return _createClass(PointConcrete);
}(BasicConcrete);

var FIRST_TIME = {
  camera: 'FIRST_TIME_CAMERA',
  click: 'FIRST_TIME_CLICK'
};
var DEFAULT_CAMERA_POSITION = new THREE.Vector3(0, 1, 7);
var DEFAULT_CAMERA_TARGET = new THREE.Vector3(0, 0, 0);
var DEFAULT_CONTROLS_PROPS = {
  minPolarAngle: 0,
  minAzimuthAngle: -Infinity,
  maxPolarAngle: Math.PI,
  maxAzimuthAngle: Infinity,
  maxDistance: Infinity,
  minDistance: 0,
  rotateSpeed: 1,
  zoomSpeed: 1,
  autoRotate: false,
  autoRotateSpeed: 2
};
var DEFAULT_CAMERA_PROPS = {
  fov: 50,
  near: 0.1,
  far: 2000,
  scale: new THREE.Vector3(1, 1, 1)
};
var firstTimeCamera = {
  name: FIRST_TIME.camera,
  type: AMAMeshType.Default_Camera,
  id: THREE.MathUtils.generateUUID(),
  children: [],
  position: new THREE.Vector3(2, 20, 0),
  scale: new THREE.Vector3(1, 1, 1),
  rotation: new THREE.Euler(0, 0, 0),
  custom: true,
  userData: {},
  visible: true,
  updatedControls: {
    maxAzimuthAngle: 0,
    minAzimuthAngle: 0,
    maxPolarAngle: 0,
    minPolarAngle: 0,
    maxDistance: 18,
    minDistance: 18
  },
  target: {
    position: new THREE.Vector3(2, 2, 0)
  }
};
var CONFIG_DEFAULT = {
  id: THREE.MathUtils.generateUUID(),
  attributes: [],
  materials: [],
  objects: [],
  defaultObjects: [],
  textures: [],
  annotations: [],
  animations: [],
  rules: [],
  customObjects: [],
  actions: [],
  conditions: [],
  cameras: [],
  uploadedModels: [],
  additionalOptions: {}
};
var PROPS_TO_UPDATE_TREE = ['name'];
var DEFAULT_CAMERA = {
  cameraId: '',
  cameraPos: DEFAULT_CAMERA_POSITION,
  cameraTarget: DEFAULT_CAMERA_TARGET
};
var DEFAULT_INIT_CONFIG = {
  mode: AMAMode.VIEWER,
  backgroundColor: '#e4e4e4',
  grid: true
};
var DEFAULT_MATERIAL_PROPS = {
  name: '',
  color: new THREE.Color(1, 1, 1),
  emissive: new THREE.Color(0, 0, 0),
  fog: false,
  lightMapIntensity: 1,
  metalness: 0,
  roughness: 1,
  side: THREE.FrontSide,
  blending: THREE.NormalBlending,
  transparent: true,
  alphaTest: 0,
  alpha: 1,
  depthTest: true,
  depthWrite: true,
  opacity: 1,
  doubleside: false,
  wireframe: false
};
var GROUP_NODES_NAME = 'ALL_NODES';
var TARGET_CUSTOM_URL = 'https://amaspace-dev.s3.amazonaws.com/client777/a594b2e0-f77c-4021-8397-9b475b30d58c__1210e2d5-fc40-4bfd-9258-16a206807dbe__SM_Yellow_01.glb';
var TARGET_NAME = 'SM_Yellow_01';
var HOTSPOT_URL = 'https://amaspace-dev.s3.amazonaws.com/client777/58e7ca2c-ca06-4ae3-bc51-be9d940062df__hotspot.png';
var DEFAULT_LOADING_PROGRESS = {
  isLoading: false,
  isLoaded: false,
  isRendered: false
};
var DEFAULT_ENVIRONMENT_GROUND = {
  height: 1,
  radius: 80,
  scale: 80
};

var PerspectiveCameraConcrete = /*#__PURE__*/function (_BasicConcrete) {
  _inherits(PerspectiveCameraConcrete, _BasicConcrete);
  var _super = _createSuper(PerspectiveCameraConcrete);
  function PerspectiveCameraConcrete(data) {
    var _this;
    _classCallCheck(this, PerspectiveCameraConcrete);
    var _a, _b, _c, _d, _e;
    _this = _super.call(this, data);
    _this.type = data.type;
    _this.custom = data.custom;
    _this.target = {
      position: data.target ? ((_b = (_a = data.target) === null || _a === void 0 ? void 0 : _a.position) === null || _b === void 0 ? void 0 : _b.isVector3) ? (_c = data.target) === null || _c === void 0 ? void 0 : _c.position : new THREE.Vector3().copy(data.target) : null,
      object: (_d = data.target) === null || _d === void 0 ? void 0 : _d.object
    };
    _this.updatedCamera = Object.assign(Object.assign(Object.assign({}, DEFAULT_CAMERA_PROPS), data.updatedCamera), {
      scale: ((_e = data.updatedCamera) === null || _e === void 0 ? void 0 : _e.scale) ? new THREE.Vector3().copy(data.updatedCamera.scale) : DEFAULT_CAMERA_PROPS.scale
    });
    _this.updatedControls = NodeUpdate.fixJSONInfinity(Object.assign(Object.assign({}, DEFAULT_CONTROLS_PROPS), data.updatedControls));
    _this.userData = Object.assign(Object.assign({}, data.userData), {
      id: data.userData.id || data.id,
      visibleInAR: false
    });
    return _this;
  }
  return _createClass(PerspectiveCameraConcrete);
}(BasicConcrete);

var TargetConcrete = /*#__PURE__*/function (_BasicConcrete) {
  _inherits(TargetConcrete, _BasicConcrete);
  var _super = _createSuper(TargetConcrete);
  function TargetConcrete(data) {
    var _this;
    _classCallCheck(this, TargetConcrete);
    _this = _super.call(this, data);
    _this.type = AMAMeshType.Target;
    _this.userData = Object.assign(Object.assign({}, data.userData), {
      id: data.id,
      visibleInAR: false
    });
    return _this;
  }
  return _createClass(TargetConcrete);
}(BasicConcrete);

var ObjectSceneFactory = /*#__PURE__*/function () {
  function ObjectSceneFactory() {
    _classCallCheck(this, ObjectSceneFactory);
  }
  _createClass(ObjectSceneFactory, null, [{
    key: "getObject",
    value: function getObject(type, data) {
      switch (type) {
        case AMAMeshType.Mesh:
          return new MeshConcrete(data);
        case AMAMeshType.Object3D:
          return new Object3DConcrete(data);
        case AMAMeshType.Group:
          return new GroupConcrete(data);
        case AMAMeshType.Model_Group:
          return new GroupConcrete(data);
        case AMAMeshType.Scene:
          return new SceneConcrete(data);
        case AMAMeshType.Bone:
          return new BoneConcrete(data);
        case AMAMeshType.SkinnedMesh:
          return new SkinnedMeshConcrete(data);
        case AMAMeshType.Plane:
          return new PlaneConcrete(data);
        case AMAMeshType.Sphere:
          return new SphereConcrete(data);
        case AMAMeshType.Box:
          return new BoxConcrete(data);
        case AMAMeshType.Directional_Light:
          return new DirectionalConcrete(data);
        case AMAMeshType.Spot_Light:
          return new SpotConcrete(data);
        case AMAMeshType.Area_Light:
          return new AreaConcrete(data);
        case AMAMeshType.Hemisphere_Light:
          return new HemisphereConcrete(data);
        case AMAMeshType.Point_Light:
          return new PointConcrete(data);
        case AMAMeshType.Target:
          return new TargetConcrete(data);
        case AMAMeshType.PerspectiveCamera:
        case AMAMeshType.Default_Camera:
          return new PerspectiveCameraConcrete(data);
        case AMAMeshType.Sprite:
        default:
          return new Object3DConcrete(data);
      }
    }
  }]);
  return ObjectSceneFactory;
}();

var TextureAMA = /*#__PURE__*/_createClass(function TextureAMA(data) {
  _classCallCheck(this, TextureAMA);
  this.id = data.id;
  this.url = data.url;
  this.type = data.type;
  this.patch = Object.assign(Object.assign({}, data.patch), {
    visible: data.patch.visible === undefined ? true : data.patch.visible
  });
});

var MaterialAMA = /*#__PURE__*/_createClass(function MaterialAMA(data) {
  _classCallCheck(this, MaterialAMA);
  this.id = data.id;
  this.properties = data.patch.properties;
  this.textures = data.patch.textures;
  this.userData = {
    id: data.id
  };
});

var AnnotationAMA = /*#__PURE__*/_createClass(function AnnotationAMA(data) {
  _classCallCheck(this, AnnotationAMA);
  this.id = data.id;
  this.name = data.name;
  this.value = data.value;
  this.position = data.position ? new THREE.Vector3().fromArray(JSON.parse(data.position)) : new THREE.Vector3(0, 0, 0);
  this.userData = {
    id: data.id
  };
  this.type = data.type;
  this.visible = data.visible;
});

/* eslint-disable es/no-object-getownpropertynames -- safe */


var $getOwnPropertyNames = objectGetOwnPropertyNames.f;


var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return arraySliceSimple(windowNames);
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var f = function getOwnPropertyNames(it) {
  return windowNames && classofRaw(it) == 'Window'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};

var objectGetOwnPropertyNamesExternal = {
	f: f
};

// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it


var arrayBufferNonExtensible = fails(function () {
  if (typeof ArrayBuffer == 'function') {
    var buffer = new ArrayBuffer(8);
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
    if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', { value: 8 });
  }
});

// eslint-disable-next-line es/no-object-isextensible -- safe
var $isExtensible = Object.isExtensible;
var FAILS_ON_PRIMITIVES = fails(function () { $isExtensible(1); });

// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
var objectIsExtensible = (FAILS_ON_PRIMITIVES || arrayBufferNonExtensible) ? function isExtensible(it) {
  if (!isObject(it)) return false;
  if (arrayBufferNonExtensible && classofRaw(it) == 'ArrayBuffer') return false;
  return $isExtensible ? $isExtensible(it) : true;
} : $isExtensible;

var freezing = !fails(function () {
  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});

var internalMetadata = createCommonjsModule(function (module) {
var defineProperty = objectDefineProperty.f;






var REQUIRED = false;
var METADATA = uid('meta');
var id = 0;

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + id++, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!hasOwnProperty_1(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!objectIsExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!hasOwnProperty_1(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!objectIsExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (freezing && REQUIRED && objectIsExtensible(it) && !hasOwnProperty_1(it, METADATA)) setMetadata(it);
  return it;
};

var enable = function () {
  meta.enable = function () { /* empty */ };
  REQUIRED = true;
  var getOwnPropertyNames = objectGetOwnPropertyNames.f;
  var splice = functionUncurryThis([].splice);
  var test = {};
  test[METADATA] = 1;

  // prevent exposing of metadata key
  if (getOwnPropertyNames(test).length) {
    objectGetOwnPropertyNames.f = function (it) {
      var result = getOwnPropertyNames(it);
      for (var i = 0, length = result.length; i < length; i++) {
        if (result[i] === METADATA) {
          splice(result, i, 1);
          break;
        }
      } return result;
    };

    _export({ target: 'Object', stat: true, forced: true }, {
      getOwnPropertyNames: objectGetOwnPropertyNamesExternal.f
    });
  }
};

var meta = module.exports = {
  enable: enable,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys$1[METADATA] = true;
});
internalMetadata.enable;
internalMetadata.fastKey;
internalMetadata.getWeakData;
internalMetadata.onFreeze;

// makes subclassing work correct for wrapped built-ins
var inheritIfRequired = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    objectSetPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) objectSetPrototypeOf($this, NewTargetPrototype);
  return $this;
};

var collection = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global_1[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function (KEY) {
    var uncurriedNativeMethod = functionUncurryThis(NativePrototype[KEY]);
    defineBuiltIn(NativePrototype, KEY,
      KEY == 'add' ? function add(value) {
        uncurriedNativeMethod(this, value === 0 ? 0 : value);
        return this;
      } : KEY == 'delete' ? function (key) {
        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY == 'get' ? function get(key) {
        return IS_WEAK && !isObject(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY == 'has' ? function has(key) {
        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };

  var REPLACE = isForced_1(
    CONSTRUCTOR_NAME,
    !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
      new NativeConstructor().entries().next();
    }))
  );

  if (REPLACE) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    internalMetadata.enable();
  } else if (isForced_1(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new -- required for testing
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance(dummy, NativePrototype);
        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
        if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  _export({ global: true, constructor: true, forced: Constructor != NativeConstructor }, exported);

  setToStringTag(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};

var defineBuiltIns = function (target, src, options) {
  for (var key in src) defineBuiltIn(target, key, src[key], options);
  return target;
};

var correctPrototypeGetter = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype$2 = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = correctPrototypeGetter ? $Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwnProperty_1(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype$2 : null;
};

var ITERATOR$5 = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype$2) || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$5].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype$2[ITERATOR$5])) {
  defineBuiltIn(IteratorPrototype$2, ITERATOR$5, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;





var returnThis$1 = function () { return this; };

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = objectCreate(IteratorPrototype$1, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false);
  iterators[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var PROPER_FUNCTION_NAME$1 = functionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var IteratorPrototype = iteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = iteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$4 = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  iteratorCreateConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$4]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = objectGetPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (objectGetPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (objectSetPrototypeOf) {
          objectSetPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR$4])) {
          defineBuiltIn(CurrentIteratorPrototype, ITERATOR$4, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME$1 && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME$1) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return functionCall(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else _export({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$4] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR$4, defaultIterator, { name: DEFAULT });
  }
  iterators[NAME] = defaultIterator;

  return methods;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject = function (value, done) {
  return { value: value, done: done };
};

var fastKey = internalMetadata.fastKey;


var setInternalState$5 = internalState.set;
var internalStateGetterFor = internalState.getterFor;

var collectionStrong = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var Constructor = wrapper(function (that, iterable) {
      anInstance(that, Prototype);
      setInternalState$5(that, {
        type: CONSTRUCTOR_NAME,
        index: objectCreate(null),
        first: undefined,
        last: undefined,
        size: 0
      });
      if (!descriptors) that.size = 0;
      if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var Prototype = Constructor.prototype;

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index;
      // change existing entry
      if (entry) {
        entry.value = value;
      // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: undefined,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (descriptors) state.size++;
        else that.size++;
        // add to index
        if (index !== 'F') state.index[index] = entry;
      } return that;
    };

    var getEntry = function (that, key) {
      var state = getInternalState(that);
      // fast case
      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index];
      // frozen object case
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key == key) return entry;
      }
    };

    defineBuiltIns(Prototype, {
      // `{ Map, Set }.prototype.clear()` methods
      // https://tc39.es/ecma262/#sec-map.prototype.clear
      // https://tc39.es/ecma262/#sec-set.prototype.clear
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var data = state.index;
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = undefined;
          delete data[entry.index];
          entry = entry.next;
        }
        state.first = state.last = undefined;
        if (descriptors) state.size = 0;
        else that.size = 0;
      },
      // `{ Map, Set }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.delete
      // https://tc39.es/ecma262/#sec-set.prototype.delete
      'delete': function (key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first == entry) state.first = next;
          if (state.last == entry) state.last = prev;
          if (descriptors) state.size--;
          else that.size--;
        } return !!entry;
      },
      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.foreach
      // https://tc39.es/ecma262/#sec-set.prototype.foreach
      forEach: function forEach(callbackfn /* , that = undefined */) {
        var state = getInternalState(this);
        var boundFunction = functionBindContext(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          // revert to the last existing entry
          while (entry && entry.removed) entry = entry.previous;
        }
      },
      // `{ Map, Set}.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.has
      // https://tc39.es/ecma262/#sec-set.prototype.has
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });

    defineBuiltIns(Prototype, IS_MAP ? {
      // `Map.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-map.prototype.get
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // `Map.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-map.prototype.set
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // `Set.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-set.prototype.add
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (descriptors) defineBuiltInAccessor(Prototype, 'size', {
      configurable: true,
      get: function () {
        return getInternalState(this).size;
      }
    });
    return Constructor;
  },
  setStrong: function (Constructor, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
    // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
    // https://tc39.es/ecma262/#sec-map.prototype.entries
    // https://tc39.es/ecma262/#sec-map.prototype.keys
    // https://tc39.es/ecma262/#sec-map.prototype.values
    // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
    // https://tc39.es/ecma262/#sec-set.prototype.entries
    // https://tc39.es/ecma262/#sec-set.prototype.keys
    // https://tc39.es/ecma262/#sec-set.prototype.values
    // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
    iteratorDefine(Constructor, CONSTRUCTOR_NAME, function (iterated, kind) {
      setInternalState$5(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: undefined
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last;
      // revert to the last existing entry
      while (entry && entry.removed) entry = entry.previous;
      // get next entry
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = undefined;
        return createIterResultObject(undefined, true);
      }
      // return step by kind
      if (kind == 'keys') return createIterResultObject(entry.key, false);
      if (kind == 'values') return createIterResultObject(entry.value, false);
      return createIterResultObject([entry.key, entry.value], false);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // `{ Map, Set }.prototype[@@species]` accessors
    // https://tc39.es/ecma262/#sec-get-map-@@species
    // https://tc39.es/ecma262/#sec-get-set-@@species
    setSpecies(CONSTRUCTOR_NAME);
  }
};
collectionStrong.getConstructor;
collectionStrong.setStrong;

// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
collection('Map', function (init) {
  return function Map() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);

var charAt$3 = stringMultibyte.charAt;





var STRING_ITERATOR = 'String Iterator';
var setInternalState$4 = internalState.set;
var getInternalState$2 = internalState.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
iteratorDefine(String, 'String', function (iterated) {
  setInternalState$4(this, {
    type: STRING_ITERATOR,
    string: toString_1(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState$2(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return createIterResultObject(undefined, true);
  point = charAt$3(string, index);
  state.index += point.length;
  return createIterResultObject(point, false);
});

var defineProperty$1 = objectDefineProperty.f;





var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$3 = internalState.set;
var getInternalState$1 = internalState.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = iteratorDefine(Array, 'Array', function (iterated, kind) {
  setInternalState$3(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$1(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  if (kind == 'keys') return createIterResultObject(index, false);
  if (kind == 'values') return createIterResultObject(target[index], false);
  return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = iterators.Arguments = iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (descriptors && values.name !== 'values') try {
  defineProperty$1(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

var ITERATOR$3 = wellKnownSymbol('iterator');
var TO_STRING_TAG$1 = wellKnownSymbol('toStringTag');
var ArrayValues = es_array_iterator.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$3] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR$3, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$3] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG$1]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG$1, COLLECTION_NAME);
    }
    if (domIterables[COLLECTION_NAME]) for (var METHOD_NAME in es_array_iterator) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== es_array_iterator[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, es_array_iterator[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = es_array_iterator[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in domIterables) {
  handlePrototype(global_1[COLLECTION_NAME] && global_1[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(domTokenListPrototype, 'DOMTokenList');

var resetters = [];
var create = function create(f) {
  if (f === undefined) return create;
  var store = _create(f);
  var initialState = store.getState();
  resetters.push(function () {
    store.setState(initialState, true);
  });
  return store;
};
var resetAllStores = function resetAllStores() {
  for (var _i = 0, _resetters = resetters; _i < _resetters.length; _i++) {
    var resetter = _resetters[_i];
    resetter();
  }
};
var createActiveMeshSlice = function createActiveMeshSlice(set) {
  return {
    activeMesh: undefined,
    setActiveMesh: function setActiveMesh(activeMesh) {
      return set({
        activeMesh: activeMesh
      });
    },
    activeMeshData: undefined,
    setActiveMeshData: function setActiveMeshData(activeMeshData) {
      return set({
        activeMeshData: activeMeshData
      });
    }
  };
};
var createAnnotationSlice = function createAnnotationSlice(set) {
  return {
    annotations: [],
    createAnnotation: function createAnnotation(hs) {
      return set(function (state) {
        return {
          config: Object.assign(Object.assign({}, state.config), {
            annotations: [].concat(_toConsumableArray(state.config.annotations), [hs])
          })
        };
      });
    },
    newAnnotation: undefined,
    setNewAnnotation: function setNewAnnotation(hs) {
      return set({
        newAnnotation: hs
      });
    }
  };
};
var createThreeSlice = function createThreeSlice(set) {
  return {
    threeState: undefined,
    createThreeScene: function createThreeScene(state) {
      return set({
        threeState: state
      });
    }
  };
};
var createTreeSlice = function createTreeSlice(set) {
  return {
    sceneTree: [],
    setSceneTree: function setSceneTree(tree) {
      return set({
        sceneTree: tree
      });
    },
    uploadModelTree: [],
    setUploadModelTree: function setUploadModelTree(tree) {
      return set({
        uploadModelTree: tree
      });
    },
    isUpdatedTree: {},
    runUpdateTree: function runUpdateTree(flag) {
      return set({
        isUpdatedTree: flag
      });
    }
  };
};
var createModelSlice = function createModelSlice(set) {
  return {
    bones: undefined,
    setBones: function setBones(bone) {
      return set({
        bones: bone
      });
    },
    activeAnimation: null,
    setActiveAnimation: function setActiveAnimation(anim) {
      return set({
        activeAnimation: anim
      });
    },
    animations: new Map(),
    defaultModel: undefined,
    setDefaultModel: function setDefaultModel(model) {
      return set({
        defaultModel: model
      });
    },
    modelGroup: undefined,
    setModelGroup: function setModelGroup(modelGroup) {
      return set({
        modelGroup: modelGroup
      });
    }
  };
};
var createConfigSlice$1 = function createConfigSlice(set, get) {
  return {
    defaultConfig: CONFIG_DEFAULT,
    setDefaultConfig: function setDefaultConfig(config) {
      return set({
        defaultConfig: config
      });
    },
    config: CONFIG_DEFAULT,
    setModelConfig: function setModelConfig(config) {
      return set({
        config: config
      });
    },
    deletedObjects: [],
    updateDeletedObjects: function updateDeletedObjects(obj) {
      return set(function (state) {
        return {
          deletedObjects: [].concat(_toConsumableArray(state.deletedObjects), [obj])
        };
      });
    },
    createCustomObjects: function createCustomObjects(newObj) {
      return set(function (state) {
        return {
          config: Object.assign(Object.assign({}, state.config), {
            customObjects: [].concat(_toConsumableArray(state.config.customObjects), [newObj])
          }),
          isUpdatedTree: {}
        };
      });
    },
    uploadedModelsConfig: [],
    setUploadedModelsConfig: function setUploadedModelsConfig(configs) {
      return set({
        uploadedModelsConfig: configs
      });
    },
    asyncUploadModelsConfig: function asyncUploadModelsConfig(config) {
      return set(function (state) {
        return {
          uploadedModelsConfig: [].concat(_toConsumableArray(state.uploadedModelsConfig), [config])
        };
      });
    },
    dynamicModels: [],
    setDynamicModels: function setDynamicModels(configs) {
      return set({
        dynamicModels: configs
      });
    },
    cache: new Map(),
    uploadedMaterialsConfig: [],
    asyncUploadMaterialsConfig: function asyncUploadMaterialsConfig(material) {
      return set(function (state) {
        return {
          uploadedMaterialsConfig: [].concat(_toConsumableArray(state.uploadedMaterialsConfig), [material])
        };
      });
    }
  };
};
var createSceneSlice = function createSceneSlice(set, get) {
  return {
    cameraControls: undefined,
    setCameraControls: function setCameraControls(controls) {
      return set({
        cameraControls: controls
      });
    },
    activeCamera: undefined,
    setActiveCamera: function setActiveCamera(camera) {
      return set({
        activeCamera: camera
      });
    },
    defaultCamera: undefined,
    setDefaultCamera: function setDefaultCamera(camera) {
      return set({
        defaultCamera: camera
      });
    },
    dynamicCamera: undefined,
    setDynamicCamera: function setDynamicCamera(pos) {
      return set({
        dynamicCamera: pos
      });
    },
    androidARController: undefined,
    setAndroidARController: function setAndroidARController(controller) {
      return set({
        androidARController: controller
      });
    },
    showGrid: true,
    toggleGrid: function toggleGrid(flag) {
      return set({
        showGrid: flag
      });
    },
    backgroundColor: '#e4e4e4',
    changeBackgroundColor: function changeBackgroundColor(color) {
      return set({
        backgroundColor: color
      });
    },
    postProcessing: {
      name: '',
      effect: {
        name: ''
      }
    },
    changePostProcessing: function changePostProcessing(pp) {
      return set({
        postProcessing: pp
      });
    },
    activeEnvironment: {
      ground: DEFAULT_ENVIRONMENT_GROUND,
      url: ''
    },
    setActiveEnvironment: function setActiveEnvironment(env) {
      return set({
        activeEnvironment: env
      });
    },
    animateCamera: false,
    setAnimateCamera: function setAnimateCamera(flag) {
      return set({
        animateCamera: flag
      });
    },
    defaultCameraPosition: {
      cameraId: '',
      cameraPos: DEFAULT_CAMERA_POSITION,
      cameraTarget: new THREE.Vector3(0, 0, 0)
    },
    setDefaultCameraPosition: function setDefaultCameraPosition(pos) {
      return set({
        defaultCameraPosition: pos
      });
    },
    previewScene: [],
    setPreviewScene: function setPreviewScene(preview) {
      return set({
        previewScene: preview
      });
    },
    cameraIsRotate: false,
    setCameraIsRotate: function setCameraIsRotate(flag) {
      return set({
        cameraIsRotate: flag
      });
    },
    hoveredObj: undefined,
    setHoveredObj: function setHoveredObj(obj) {
      return set({
        hoveredObj: obj
      });
    }
  };
};
var createAppSlice = function createAppSlice(set, get) {
  return {
    apiKey: undefined,
    setApiKey: function setApiKey(apiKey) {
      return set({
        apiKey: apiKey
      });
    },
    transformMode: AMATransformMode.TRANSLATE,
    updateTransformMode: function updateTransformMode(mode) {
      return set({
        transformMode: mode,
        axis: true
      });
    },
    axis: true,
    toggleAxis: function toggleAxis(flag) {
      return set({
        axis: flag
      });
    },
    mode: AMAMode.VIEWER,
    setMode: function setMode(mode) {
      return set({
        mode: mode
      });
    },
    controls: undefined,
    setControls: function setControls(controls) {
      return set({
        controls: controls
      });
    },
    asyncUpdateConfig: function asyncUpdateConfig(obj, newData) {
      if (get().config) {
        var currentNode = get().config.objects.find(function (item) {
          return item.userData.id === obj.userData.id;
        });
        var currentCustomNode = get().config.customObjects.find(function (item) {
          return item.userData.id === obj.userData.id;
        });
        var currentAnnotation = get().config.annotations.find(function (item) {
          return item.userData.id === obj.userData.id;
        });
        if (currentNode) {
          var another = get().config.objects.filter(function (item) {
            return item.userData.id !== obj.userData.id;
          });
          var _final = Object.assign(Object.assign({}, currentNode), newData);
          get().setModelConfig(Object.assign(Object.assign({}, get().config), {
            objects: [].concat(_toConsumableArray(another), [_final])
          }));
          return;
        }
        if (currentCustomNode) {
          var _another = get().config.customObjects.filter(function (item) {
            return item.userData.id !== obj.userData.id;
          });
          var _final2 = Object.assign(Object.assign({}, currentCustomNode), newData);
          get().setModelConfig(Object.assign(Object.assign({}, get().config), {
            customObjects: [].concat(_toConsumableArray(_another), [_final2])
          }));
          return;
        }
        if (currentAnnotation) {
          var _another2 = get().config.annotations.filter(function (item) {
            return item.userData.id !== obj.userData.id;
          });
          var _final3 = Object.assign(Object.assign({}, currentAnnotation), newData);
          get().setModelConfig(Object.assign(Object.assign({}, get().config), {
            annotations: [].concat(_toConsumableArray(_another2), [_final3])
          }));
          return;
        }
      }
    },
    focus: function focus(focusObject) {
      var objectFit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1.8;
      var _a, _b, _c;
      if (get().controls) {
        var box = new THREE.Box3();
        var delta = new THREE.Vector3();
        var sphere = new THREE.Sphere();
        var center = new THREE.Vector3();
        var cam = (_a = get().controls) === null || _a === void 0 ? void 0 : _a.object;
        cam.updateProjectionMatrix();
        box.setFromObject(focusObject);
        box.getCenter(center);
        (_b = get().controls) === null || _b === void 0 ? void 0 : _b.target.copy(center);
        var distance = box.getBoundingSphere(sphere).radius;
        if (distance < 0.01) return;
        delta.set(0, 0, 1);
        delta.applyQuaternion(cam.quaternion);
        delta.multiplyScalar(distance * objectFit);
        cam.position.copy(center).add(delta);
        (_c = get().controls) === null || _c === void 0 ? void 0 : _c.update();
        cam.updateMatrix();
      }
    },
    getCurrent: function getCurrent() {
      return get();
    }
  };
};
var createModelLoadingProgress = function createModelLoadingProgress(set) {
  return {
    loadingProgress: DEFAULT_LOADING_PROGRESS,
    setLoadingProgress: function setLoadingProgress(loadingProgress) {
      return set({
        loadingProgress: loadingProgress
      });
    }
  };
};
var useBoundStore = create()(function () {
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, createAnnotationSlice.apply(void 0, arguments)), createActiveMeshSlice.apply(void 0, arguments)), createThreeSlice.apply(void 0, arguments)), createModelSlice.apply(void 0, arguments)), createSceneSlice.apply(void 0, arguments)), createTreeSlice.apply(void 0, arguments)), createAppSlice.apply(void 0, arguments)), createConfigSlice$1.apply(void 0, arguments)), createModelLoadingProgress.apply(void 0, arguments));
});

var createConfigSlice = function createConfigSlice(set) {
  return {
    type: AMAMaterialType.MeshStandardMaterial,
    config: {
      id: '',
      properties: DEFAULT_MATERIAL_PROPS,
      textures: []
    },
    setConfig: function setConfig(config) {
      return set({
        config: config
      });
    }
  };
};
var useMaterialState = create()(function () {
  return Object.assign({}, createConfigSlice.apply(void 0, arguments));
});

var NodeUpdate = /*#__PURE__*/function () {
  function NodeUpdate() {
    _classCallCheck(this, NodeUpdate);
  }
  _createClass(NodeUpdate, null, [{
    key: "fixJSONInfinity",
    value: function fixJSONInfinity(data) {
      Object.keys(data).forEach(function (key) {
        if (data[key] === 'Infinity' || data[key] === '-Infinity') {
          data[key] = +data[key];
        }
      });
      return data;
    }
  }, {
    key: "smoothAppearanceNode",
    value: function smoothAppearanceNode(node, visible) {
      var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
      return new Promise(function (resolve, reject) {
        if (!node) return reject('No node');
        var count = 0;
        var meshs = [];
        var cache = useBoundStore.getState().cache;
        if (cache.get(node.name)) {
          node.visible = visible;
          resolve(node);
          return;
        }
        cache.set(node.name, node);
        node.traverse(function (item) {
          if (item instanceof THREE.Line) return;
          if (item instanceof THREE.Mesh) {
            count++;
            meshs.push(item);
            item.userData = Object.assign(Object.assign({}, item.userData), {
              lazyLoadStep: 0.5 * count
            });
          }
          item.visible = false;
          setTimeout(function () {
            item.visible = true;
          }, count * time);
        });
        var ti = setInterval(function () {
          var isComplete = meshs.every(function (i) {
            return i.visible;
          });
          if (isComplete) {
            clearInterval(ti);
            var t = setTimeout(function () {
              resolve(node);
              clearTimeout(t);
            }, 500);
          }
        }, 100);
      });
    }
  }, {
    key: "targetForCamera",
    value: function targetForCamera(allObjects, targetNode) {
      return allObjects.find(function (cam) {
        if ('isCamera' in cam) return;
        if (!cam.userData.name || !targetNode.userData.name) return;
        var name = cam.userData.name.split('.')[0];
        var name2 = targetNode.userData.name.split('.')[0];
        if (name == name2) {
          return targetNode;
        }
      });
    }
  }, {
    key: "updateNodes",
    value: function updateNodes(patchObjects, allModelNodes, configNodes, materialsAsset, texturesAsset, defaultData) {
      var result = _toConsumableArray(patchObjects);
      var newConfigNodes = _toConsumableArray(configNodes);
      var updatedNodes = result.map(function (node) {
        if (isCamera(node)) {
          return ObjectSceneFactory.getObject(AMAMeshType.PerspectiveCamera, node);
        }
        if (node) {
          var targetNode = allModelNodes.find(function (el) {
            return el.userData.id === node.userData.id;
          });
          if (targetNode) {
            return ObjectSceneFactory.getObject(targetNode.type, node);
          }
        }
      });
      for (var i = 0; i < newConfigNodes.length; i++) {
        var node = newConfigNodes[i];
        for (var k = 0; k < result.length; k++) {
          var custom = result[k];
          if ((node === null || node === void 0 ? void 0 : node.id) === (custom === null || custom === void 0 ? void 0 : custom.id)) {
            if (!custom.material) break;
            var materialAsset = _.find(materialsAsset, {
              id: custom.material.id
            });
            if (!materialAsset) break;
            var _MaterialUpdate$updat = MaterialUpdate.updateMaterial(materialAsset, texturesAsset),
              textures = _MaterialUpdate$updat.textures,
              properties = _MaterialUpdate$updat.properties;
            var _final = Object.assign(Object.assign({}, materialAsset), {
              patch: {
                properties: properties,
                textures: textures
              }
            });
            if ('material' in node) {
              node.material = new MaterialAMA(_final);
            }
          }
        }
      }
      newConfigNodes.forEach(function (item, inx) {
        var _a, _b;
        var updated = _.find(updatedNodes, {
          id: item === null || item === void 0 ? void 0 : item.id
        });
        if (updated) {
          var res = Object.assign(Object.assign({}, updated), {
            position: ((_a = defaultData === null || defaultData === void 0 ? void 0 : defaultData.target) === null || _a === void 0 ? void 0 : _a.position) ? new THREE.Vector3().fromArray(updated.position).add((_b = defaultData === null || defaultData === void 0 ? void 0 : defaultData.target) === null || _b === void 0 ? void 0 : _b.position) : new THREE.Vector3().fromArray(updated.position),
            scale: new THREE.Vector3().fromArray(updated.scale),
            rotation: new THREE.Euler().fromArray(updated.rotation)
          });
          if (item.type === AMAMeshType.Mesh) {
            res.material = item.material;
            res.geometry = item.geometry;
          }
          newConfigNodes[inx] = ObjectSceneFactory.getObject(updated.type, res);
        }
      });
      return newConfigNodes;
    }
  }, {
    key: "updateCustomNodes",
    value: function updateCustomNodes(nodes, customAsset, materialsAsset, texturesAsset, targetPosition) {
      var result = _toConsumableArray(nodes);
      for (var i = 0; i < result.length; i++) {
        var node = result[i];
        for (var k = 0; k < customAsset.length; k++) {
          var custom = customAsset[k];
          if (node.userData.id === custom.id) {
            var materialAsset = _.find(materialsAsset, {
              id: custom.material
            });
            if (!materialAsset) break;
            var _MaterialUpdate$updat2 = MaterialUpdate.updateMaterial(materialAsset, texturesAsset),
              textures = _MaterialUpdate$updat2.textures,
              properties = _MaterialUpdate$updat2.properties;
            var _final2 = Object.assign(Object.assign({}, materialAsset), {
              patch: {
                properties: properties,
                textures: textures
              }
            });
            node.material = new MaterialAMA(_final2);
          }
        }
      }
      return result.map(function (node) {
        var _a, _b, _c;
        var nodePosition = Array.isArray(node.position) ? new THREE.Vector3().fromArray(node.position) : node.position;
        var nodeRotation = Array.isArray(node.rotation) ? new THREE.Euler().fromArray(node.rotation) : node.rotation;
        var nodeScale = Array.isArray(node.scale) ? new THREE.Vector3().fromArray(node.scale) : node.scale;
        if (isCamera(node)) {
          var targetCameraPosition = ((_a = node === null || node === void 0 ? void 0 : node.target) === null || _a === void 0 ? void 0 : _a.position) && new THREE.Vector3().copy((_b = node === null || node === void 0 ? void 0 : node.target) === null || _b === void 0 ? void 0 : _b.position);
          var nodeTarget = nodes.find(function (item) {
            var _a;
            return item.id === ((_a = node === null || node === void 0 ? void 0 : node.target) === null || _a === void 0 ? void 0 : _a.object);
          });
          var _res = Object.assign(Object.assign({}, node), {
            position: targetPosition ? nodePosition.add(targetPosition) : nodePosition,
            scale: nodeScale,
            rotation: nodeRotation,
            target: {
              position: targetCameraPosition
            }
          });
          if (targetPosition && ((_c = _res === null || _res === void 0 ? void 0 : _res.target) === null || _c === void 0 ? void 0 : _c.position)) {
            var cameraTarget = new THREE.Vector3().copy(_res.target.position);
            var updatedCameraTarget = {
              position: cameraTarget === null || cameraTarget === void 0 ? void 0 : cameraTarget.add(targetPosition)
            };
            _res.target = updatedCameraTarget;
          }
          if (nodeTarget) {
            _res.target = Object.assign(Object.assign({}, _res.target), {
              position: new THREE.Vector3().fromArray(nodeTarget.position),
              object: nodeTarget.id
            });
          }
          return ObjectSceneFactory.getObject(node.type, _res);
        }
        var res = Object.assign(Object.assign({}, node), {
          position: targetPosition ? nodePosition.add(targetPosition) : nodePosition,
          scale: new THREE.Vector3().fromArray(node.scale),
          rotation: new THREE.Euler().fromArray(node.rotation)
        });
        return ObjectSceneFactory.getObject(node.type, res);
      }).filter(function (item) {
        return item;
      });
    }
  }, {
    key: "updatedDeletedNodes",
    value: function updatedDeletedNodes(nodes, deletedNodes) {
      var result = _toConsumableArray(nodes);
      return result.filter(function (item, inx) {
        var del = _.find(deletedNodes, {
          id: item.id
        });
        if (!del) {
          return item;
        }
      });
    }
  }]);
  return NodeUpdate;
}();
var MaterialUpdate = /*#__PURE__*/function () {
  function MaterialUpdate() {
    _classCallCheck(this, MaterialUpdate);
  }
  _createClass(MaterialUpdate, null, [{
    key: "updateMaterialProps",
    value: function updateMaterialProps(updatedProps, defaultProps) {
      var result = Object.assign({}, updatedProps);
      var newMaterial = Object.assign({}, defaultProps);
      Object.keys(result).forEach(function (node) {
        if (result[node] !== undefined) {
          newMaterial[node] = result[node];
        }
      });
      return newMaterial;
    }
  }, {
    key: "updateMaterialTexture",
    value: function updateMaterialTexture(updatedTextures, defaultTextures) {
      var _final3 = _toConsumableArray(defaultTextures);
      var newUpdated = _toConsumableArray(updatedTextures);
      _final3.forEach(function (item, inx) {
        if (item) {
          var updated = newUpdated.find(function (el) {
            return el.type === item.type;
          });
          if (updated) {
            _final3[inx] = updated;
            newUpdated = newUpdated.filter(function (el) {
              return el.id !== updated.id;
            });
          }
        }
      });
      return [].concat(_toConsumableArray(_final3), _toConsumableArray(newUpdated));
    }
  }, {
    key: "updateMaterial",
    value: function updateMaterial(material, allTextures) {
      var defaultMaterial = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
      var updatedProps = material.patch.updatedProps ? material.patch.updatedProps : {};
      var updatedTextures = material.patch.updatedTextures ? material.patch.updatedTextures : [];
      var defaultProps = material.patch.properties;
      var defaultTextures = material.patch.textures;
      var textures = [];
      for (var key in defaultTextures) {
        var find = _.find(allTextures, {
          id: defaultTextures[key]
        });
        if (find) {
          find.type = key;
          textures.push(new TextureAMA(find));
        }
      }
      if (updatedProps && Object.keys(updatedProps).length) {
        defaultProps = MaterialUpdate.updateMaterialProps(updatedProps, defaultProps);
      }
      if (updatedTextures && updatedTextures.length) {
        textures = MaterialUpdate.updateMaterialTexture(updatedTextures, textures);
      }
      var df = defaultMaterial ? defaultMaterial : DEFAULT_MATERIAL_PROPS;
      defaultProps = Object.assign(Object.assign(Object.assign({}, df), defaultProps), {
        normalScale: defaultMaterial === null || defaultMaterial === void 0 ? void 0 : defaultMaterial.normalScale
      });
      return {
        id: material.id,
        textures: textures,
        properties: defaultProps
      };
    }
  }]);
  return MaterialUpdate;
}();
var DefaultObjects = /*#__PURE__*/function () {
  function DefaultObjects() {
    _classCallCheck(this, DefaultObjects);
  }
  _createClass(DefaultObjects, null, [{
    key: "createDefaultCamera",
    value: function createDefaultCamera(defaultSceneConfig) {
      var _a, _b;
      var idCamera = THREE.MathUtils.generateUUID();
      var cameraPos = (_a = defaultSceneConfig === null || defaultSceneConfig === void 0 ? void 0 : defaultSceneConfig.cameraPosition) === null || _a === void 0 ? void 0 : _a.cameraPos;
      var cameraTarget = (_b = defaultSceneConfig === null || defaultSceneConfig === void 0 ? void 0 : defaultSceneConfig.cameraPosition) === null || _b === void 0 ? void 0 : _b.cameraTarget;
      var cameraPosVec = cameraPos ? new THREE.Vector3(cameraPos.x, cameraPos.y, cameraPos.z) : DEFAULT_CAMERA_POSITION;
      var cameraTargetVec = cameraTarget ? new THREE.Vector3(cameraTarget.x, cameraTarget.y, cameraTarget.z) : DEFAULT_CAMERA_TARGET;
      return ObjectSceneFactory.getObject(AMAMeshType.Default_Camera, {
        name: "default_Perspective_Camera",
        type: AMAMeshType.Default_Camera,
        id: idCamera,
        target: {
          position: cameraTargetVec
        },
        children: [],
        position: cameraPosVec,
        scale: new THREE.Vector3(1, 1, 1),
        rotation: new THREE.Euler(0, 0, 0),
        custom: true,
        userData: {
          id: idCamera,
          visibleInAR: true
        },
        visible: true
      });
    }
  }, {
    key: "createModelGroup",
    value: function createModelGroup(configNodes, defaultData, model) {
      var _a;
      var nodesNotParent = configNodes.filter(function (i) {
        return !i.userData.parent;
      }).map(function (i) {
        return i.id;
      });
      var t = {
        position: ((_a = defaultData === null || defaultData === void 0 ? void 0 : defaultData.target) === null || _a === void 0 ? void 0 : _a.position) || new THREE.Vector3(0, 0, 0),
        scale: new THREE.Vector3(1, 1, 1),
        rotation: new THREE.Euler(0, 0, 0),
        id: model.id,
        name: model.name,
        type: AMAMeshType.Model_Group,
        children: nodesNotParent,
        visible: true,
        userData: {
          id: model.id,
          visibleInAR: true
        }
      };
      return ObjectSceneFactory.getObject(AMAMeshType.Model_Group, t);
    }
  }]);
  return DefaultObjects;
}();
var Config = /*#__PURE__*/function () {
  function Config() {
    _classCallCheck(this, Config);
  }
  _createClass(Config, null, [{
    key: "isValidJSON",
    value: function isValidJSON(string) {
      try {
        JSON.parse(string);
        return true;
      } catch (error) {
        return false;
      }
    }
  }, {
    key: "createActionsFromRules",
    value: function createActionsFromRules(rules) {
      var cloneRules = _toConsumableArray(rules);
      var finalActions = [];
      cloneRules.forEach(function (rule) {
        rule.action.forEach(function (action) {
          var cloneAction = Object.assign({}, action);
          if (typeof cloneAction.value === 'string') {
            if (Config.isValidJSON(cloneAction.value)) cloneAction.value = JSON.parse(cloneAction.value);
          }
          finalActions.push(cloneAction);
        });
      });
      return finalActions;
    }
  }, {
    key: "createConditionsFromRules",
    value: function createConditionsFromRules(rules) {
      var cloneRules = _toConsumableArray(rules);
      var finalConditions = [];
      cloneRules.forEach(function (rule) {
        rule.condition.forEach(function (condition) {
          var cloneCondition = Object.assign({}, condition);
          finalConditions.push(cloneCondition);
        });
      });
      return finalConditions;
    }
  }, {
    key: "createValidAnnotations",
    value: function createValidAnnotations(annotations, defaultData) {
      var cloneAnnotations = _toConsumableArray(annotations);
      return cloneAnnotations.map(function (item) {
        var _a, _b;
        if ((_a = defaultData === null || defaultData === void 0 ? void 0 : defaultData.target) === null || _a === void 0 ? void 0 : _a.position) {
          var annotationInstance = Object.assign({}, item);
          var parsedPosition = JSON.parse(item.position);
          var positionVector = new THREE.Vector3().fromArray(parsedPosition);
          var correctedPositionVector = positionVector.add((_b = defaultData === null || defaultData === void 0 ? void 0 : defaultData.target) === null || _b === void 0 ? void 0 : _b.position);
          annotationInstance.position = "[" + correctedPositionVector.x + ", " + correctedPositionVector.y + ", " + correctedPositionVector.z + "]";
          return new AnnotationAMA(annotationInstance);
        }
        return new AnnotationAMA(item);
      });
    }
  }, {
    key: "createValidMaterial",
    value: function createValidMaterial(materials, nodes, allTextures) {
      var cloneMaterials = _toConsumableArray(materials);
      return cloneMaterials.map(function (item) {
        var targetMaterial = nodes.map(function (el) {
          if (!(el instanceof THREE.Mesh)) return null;
          if (el.material.userData.id === item.id) {
            return el.material;
          }
          return null;
        }).filter(function (i) {
          return i;
        });
        var _MaterialUpdate$updat3 = MaterialUpdate.updateMaterial(item, allTextures, targetMaterial[0]),
          textures = _MaterialUpdate$updat3.textures,
          properties = _MaterialUpdate$updat3.properties;
        var _final4 = Object.assign(Object.assign({}, item), {
          patch: {
            properties: properties,
            textures: textures
          }
        });
        return new MaterialAMA(_final4);
      });
    }
  }, {
    key: "createValidTexture",
    value: function createValidTexture(textures) {
      var cloneTextures = _toConsumableArray(textures);
      return cloneTextures.map(function (item) {
        return new TextureAMA(item);
      });
    }
  }, {
    key: "createMaterialForNode",
    value: function createMaterialForNode(node, materials, allTextures) {
      var nodeMaterial = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var res = materials.filter(function (i) {
        return node.material === i.id;
      }).map(function (item) {
        var _MaterialUpdate$updat4 = MaterialUpdate.updateMaterial(item, allTextures, nodeMaterial),
          textures = _MaterialUpdate$updat4.textures,
          properties = _MaterialUpdate$updat4.properties;
        var _final5 = Object.assign(Object.assign({}, item), {
          patch: {
            properties: properties,
            textures: textures
          }
        });
        return new MaterialAMA(_final5);
      });
      return res[0];
    }
  }, {
    key: "createChildrenForNode",
    value: function createChildrenForNode(node, allNodes) {
      var parent = allNodes.filter(function (n) {
        var _a, _b;
        return ((_a = n === null || n === void 0 ? void 0 : n.patch) === null || _a === void 0 ? void 0 : _a.parent) === ((_b = node === null || node === void 0 ? void 0 : node.userData) === null || _b === void 0 ? void 0 : _b.id);
      });
      return _toConsumableArray(parent).map(function (i) {
        return i.id;
      });
    }
  }, {
    key: "findBoneInModel",
    value: function findBoneInModel(allObjects) {
      return allObjects.find(function (item) {
        if (!(item instanceof THREE.Bone)) return;
        if (item.name.includes('root') && item.isBone) return item;
      });
    }
  }, {
    key: "allCameras",
    value: function allCameras(customObjs) {
      var configObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var defaultCamera = customObjs.filter(function (i) {
        return i.type === AMAMeshType.Default_Camera;
      });
      var customCameras = [].concat(_toConsumableArray(customObjs), _toConsumableArray(configObj)).filter(function (i) {
        return i.type === AMAMeshType.PerspectiveCamera;
      });
      return [].concat(_toConsumableArray(defaultCamera), _toConsumableArray(customCameras));
    }
  }]);
  return Config;
}();
var useTransformDefault = function useTransformDefault(inputData) {
  if (!inputData || (inputData === null || inputData === void 0 ? void 0 : inputData.message)) return;
  var _final6 = React__default.useMemo(function () {
    var _a;
    var data = Object.assign({}, inputData);
    var model = _.find(data.assets, {
      type: 'model'
    });
    if (!model) return;
    var mat = function mat() {
      var allMaterial = _.filter(data.assets, {
        type: 'material'
      });
      var newMaterial = _toConsumableArray(allMaterial);
      newMaterial.forEach(function (item) {
        var _a;
        var textures = {};
        var ojb = item.patch.textures;
        for (var key in ojb) {
          textures[key] = (_a = _.find(data.assets, {
            id: ojb[key]
          })) === null || _a === void 0 ? void 0 : _a.id;
        }
        item.textures = textures;
      });
      return newMaterial;
    };
    var nodes = function nodes() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Composite';
      var allNodes = _.filter(data.assets, {
        type: type
      });
      var newNodes = _toConsumableArray(allNodes);
      newNodes.forEach(function (item) {
        var connections = _.filter(data.connections, {
          asset_to: item.id
        });
        if (!connections.length) return;
        var material = _.find(data.assets, {
          id: connections[0].asset_from
        });
        if (material) {
          item.material = material.id;
        }
      });
      return newNodes;
    };
    var _final7 = {
      id: model.id,
      textures: _.filter(data.assets, {
        type: 'texture'
      }),
      material: mat(),
      annotation: model.annotation,
      attributes: (_a = data === null || data === void 0 ? void 0 : data.product) === null || _a === void 0 ? void 0 : _a.attributes,
      scene: {
        model: model,
        nodes: nodes(),
        customNodes: nodes('Composite_custom')
      }
    };
    return _final7;
  }, []);
  return _final6;
};
var useTransformDefaultMaterial = function useTransformDefaultMaterial(data) {
  var material = _.find(data.assets, {
    type: 'material'
  });
  if (!material) return;
  return MaterialUpdate.updateMaterial(material, data.assets);
};
var useTransformDefaultScene = function useTransformDefaultScene(data) {
  var _a, _b, _c, _d, _e;
  var scene = _.find(data.assets, {
    type: 'scene'
  });
  if (!scene) return;
  var materials = function materials() {
    var allMaterial = _.filter(data.assets, {
      type: 'material'
    });
    var newMaterial = _toConsumableArray(allMaterial);
    newMaterial.forEach(function (item) {
      var _a;
      var textures = {};
      var ojb = item.patch.textures;
      for (var key in ojb) {
        textures[key] = (_a = _.find(data.assets, {
          id: ojb[key]
        })) === null || _a === void 0 ? void 0 : _a.id;
      }
      item.textures = textures;
    });
    return newMaterial;
  };
  var _final8 = {
    id: scene.id,
    annotation: scene.annotation,
    attributes: (_a = data === null || data === void 0 ? void 0 : data.product) === null || _a === void 0 ? void 0 : _a.attributes,
    materials: materials(),
    textures: _.filter(data.assets, {
      type: 'texture'
    }),
    customObjects: ((_c = (_b = scene.patch) === null || _b === void 0 ? void 0 : _b.config) === null || _c === void 0 ? void 0 : _c.customObjects) || [],
    defaultSceneConfig: ((_e = (_d = scene.patch) === null || _d === void 0 ? void 0 : _d.config) === null || _e === void 0 ? void 0 : _e.defaultSceneConfig) || [],
    scene: scene
  };
  return _final8;
};
var createDefaultConfig = function createDefaultConfig(input) {
  var defaultData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _a, _b, _c, _d, _e, _f;
  if (!input) return;
  var _input = _.cloneDeep(input);
  var custom = _input.customObjects;
  var customMaterial = _input.materials;
  var defaultSceneConfig = _input.defaultSceneConfig;
  var uploadedModelsConfig = (_a = input.scene.patch.config) === null || _a === void 0 ? void 0 : _a.uploadedModelsConfig;
  var defaultNodes = [];
  var defaultCamera = DefaultObjects.createDefaultCamera(defaultSceneConfig);
  var defaultCameraIsUpdated = custom.find(function (i) {
    return i.type === AMAMeshType.Default_Camera;
  });
  var newCustomObjs = defaultCameraIsUpdated ? [] : [defaultCamera];
  if (custom === null || custom === void 0 ? void 0 : custom.length) {
    newCustomObjs = [].concat(_toConsumableArray(newCustomObjs), _toConsumableArray(NodeUpdate.updateCustomNodes(custom, customMaterial, _input.materials, _input.textures, (_b = defaultData === null || defaultData === void 0 ? void 0 : defaultData.target) === null || _b === void 0 ? void 0 : _b.position)));
  }
  var ruleActions = Config.createActionsFromRules(_input.scene.rule);
  var ruleConditions = Config.createConditionsFromRules(_input.scene.rule);
  var configAnnotations = Config.createValidAnnotations(_input.annotation, defaultData);
  var configTextures = Config.createValidTexture(_input.textures);
  var cameras = Config.allCameras(newCustomObjs);
  var config = {
    id: ((_d = (_c = defaultData === null || defaultData === void 0 ? void 0 : defaultData.target) === null || _c === void 0 ? void 0 : _c.userData) === null || _d === void 0 ? void 0 : _d.id) || THREE.MathUtils.generateUUID(),
    textures: configTextures,
    defaultObjects: defaultNodes,
    cameras: cameras,
    objects: [],
    materials: [],
    attributes: _input.attributes,
    annotations: configAnnotations,
    animations: [],
    rules: _input.scene.rule,
    actions: ruleActions,
    conditions: ruleConditions,
    customObjects: newCustomObjs,
    defaultSceneConfig: defaultSceneConfig,
    uploadedModels: uploadedModelsConfig,
    additionalOptions: {
      relatedAttribute: (_e = defaultData.modelData) === null || _e === void 0 ? void 0 : _e.relatedAttribute,
      relatedChildrenAttributes: (_f = defaultData.modelData) === null || _f === void 0 ? void 0 : _f.relatedChildrenAttributes
    }
  };
  return config;
};
var useTransformModelConfig = function useTransformModelConfig(input) {
  var defaultData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _a, _b, _c, _d, _e;
  if (!input) return;
  var deleted = (_a = input.scene.model.patch.config) === null || _a === void 0 ? void 0 : _a.deletedObjects;
  var updated = (_b = input.scene.model.patch.config) === null || _b === void 0 ? void 0 : _b.objects;
  var custom = ((_c = input.scene.model.patch.config) === null || _c === void 0 ? void 0 : _c.customObjects) || [];
  var customMaterial = input.scene.customNodes;
  var defaultSceneConfig = (_d = input.scene.model.patch.config) === null || _d === void 0 ? void 0 : _d.defaultSceneConfig;
  var uploadedModelsConfig = ((_e = input.scene.model.patch.config) === null || _e === void 0 ? void 0 : _e.uploadedModelsConfig) || [];
  var productAttributes = input.attributes || [];
  var defaultNodes = [];
  var model = useGLTF(input.scene.model.url);
  var data = React__default.useMemo(function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    if (model) {
      var _input = _.cloneDeep(input);
      var allObjects = Object.values(model.nodes);
      var count = 0;
      var configNodes = _input.scene.nodes.map(function (node, inx) {
        var targetNode = allObjects.find(function (el) {
          return el.userData.id === node.patch.meshId;
        });
        if (targetNode) {
          targetNode.updateMatrix();
          var materialNode = Config.createMaterialForNode(node, _input.material, _input.textures, isMeshAMA(targetNode) && targetNode.material);
          if ('isMesh' in targetNode) count++;
          var childrenNode = Config.createChildrenForNode(targetNode, _input.scene.nodes);
          var tragetForCamera = NodeUpdate.targetForCamera(allObjects, targetNode);
          var res = {
            type: targetNode.type,
            object: targetNode,
            name: node.patch.name,
            id: node.id,
            dbId: node.dbId,
            position: targetNode === null || targetNode === void 0 ? void 0 : targetNode.position,
            rotation: targetNode === null || targetNode === void 0 ? void 0 : targetNode.rotation,
            scale: targetNode === null || targetNode === void 0 ? void 0 : targetNode.scale,
            animations: targetNode === null || targetNode === void 0 ? void 0 : targetNode.animations,
            material: materialNode,
            geometry: targetNode === null || targetNode === void 0 ? void 0 : targetNode.geometry,
            skeleton: targetNode === null || targetNode === void 0 ? void 0 : targetNode.skeleton,
            userData: targetNode === null || targetNode === void 0 ? void 0 : targetNode.userData,
            visible: targetNode === null || targetNode === void 0 ? void 0 : targetNode.visible,
            castShadow: targetNode === null || targetNode === void 0 ? void 0 : targetNode.castShadow,
            receiveShadow: targetNode === null || targetNode === void 0 ? void 0 : targetNode.receiveShadow,
            lazyLoad: defaultData === null || defaultData === void 0 ? void 0 : defaultData.lazyLoad,
            lazyLoadStep: 0.5 * count,
            target: tragetForCamera,
            children: childrenNode
          };
          if (isCamera(targetNode)) {
            var current = custom.find(function (i) {
              return i.userData.id === res.userData.id;
            });
            if (current) return;
            custom.push(ObjectSceneFactory.getObject(res.type, res));
            return;
          }
          return ObjectSceneFactory.getObject(res.type, res);
        }
        return null;
      }).filter(function (i) {
        return i;
      });
      var defaultCamera = DefaultObjects.createDefaultCamera(defaultSceneConfig);
      var defaultCameraIsUpdated = custom.find(function (i) {
        return i.type === AMAMeshType.Default_Camera;
      });
      var defaultModelGroup = DefaultObjects.createModelGroup(configNodes, defaultData, _input.scene.model);
      var parent = ObjectSceneFactory.getObject(AMAMeshType.Model_Group, defaultModelGroup);
      var newCustomObjs = defaultCameraIsUpdated ? [] : [defaultCamera];
      allObjects = [defaultModelGroup].concat(_toConsumableArray(allObjects));
      configNodes = [parent].concat(_toConsumableArray(configNodes)).filter(function (i) {
        return i;
      });
      defaultNodes = _toConsumableArray(configNodes);
      if (deleted === null || deleted === void 0 ? void 0 : deleted.length) {
        configNodes = _toConsumableArray(NodeUpdate.updatedDeletedNodes(configNodes, deleted));
      }
      if (updated === null || updated === void 0 ? void 0 : updated.length) {
        configNodes = _toConsumableArray(NodeUpdate.updateNodes(updated, allObjects, configNodes, _input.material, _input.textures, defaultData));
      }
      if (custom === null || custom === void 0 ? void 0 : custom.length) {
        newCustomObjs = [].concat(_toConsumableArray(newCustomObjs), _toConsumableArray(NodeUpdate.updateCustomNodes(custom, customMaterial, _input.material, _input.textures, (_a = defaultData === null || defaultData === void 0 ? void 0 : defaultData.target) === null || _a === void 0 ? void 0 : _a.position)));
      }
      var ruleActions = Config.createActionsFromRules(_input.scene.model.rule);
      var ruleConditions = Config.createConditionsFromRules(_input.scene.model.rule);
      var configAnnotations = Config.createValidAnnotations(_input.annotation, defaultData);
      var configTextures = Config.createValidTexture(_input.textures);
      var cameras = Config.allCameras(newCustomObjs, configNodes);
      var bone = Config.findBoneInModel(allObjects);
      var configMaterials = Config.createValidMaterial(_input.material, allObjects, _input.textures);
      var test = productAttributes.map(function (attr) {
        var _final9 = [];
        var _ruleActions = structuredClone(ruleActions);
        _ruleActions.forEach(function (action) {
          var _a, _b, _c, _d, _e, _f, _g;
          if (typeof action.value === 'string') return;
          if (!attr.default_value) return;
          if (!((_a = action === null || action === void 0 ? void 0 : action.value) === null || _a === void 0 ? void 0 : _a.attribute)) return;
          if (attr.replacement_attribute_id !== action.value.attribute.id) return;
          if (action.type_action === AMARuleTypeAction.SetModel) {
            var value = action.value || {};
            _final9.push({
              modelId: "parent_" + attr.default_value,
              attributeId: attr.id,
              name: (_b = value === null || value === void 0 ? void 0 : value.modelPart) === null || _b === void 0 ? void 0 : _b.name,
              target: {
                id: (_c = value === null || value === void 0 ? void 0 : value.modelPart) === null || _c === void 0 ? void 0 : _c.id
              },
              lazyLoad: true,
              type: 'model',
              additionalOptions: {
                relatedAttribute: attr.id,
                relatedChildrenAttributes: []
              }
            });
          }
          if (action.type_action === AMARuleTypeAction.SetMaterial) {
            var _value = action.value || {};
            _final9.push({
              modelId: "parent_" + attr.default_value,
              name: (_d = _value === null || _value === void 0 ? void 0 : _value.modelPart) === null || _d === void 0 ? void 0 : _d.name,
              target: {
                id: ((_e = _value === null || _value === void 0 ? void 0 : _value.modelPart) === null || _e === void 0 ? void 0 : _e.value) || ((_g = (_f = _value === null || _value === void 0 ? void 0 : _value.modelPart) === null || _f === void 0 ? void 0 : _f.patch) === null || _g === void 0 ? void 0 : _g.meshId)
              },
              lazyLoad: true,
              attributeId: attr.id,
              type: 'material'
            });
          }
        });
        return _.uniqBy(_final9, 'target');
      }).flat();
      var config = {
        id: ((_c = (_b = defaultData === null || defaultData === void 0 ? void 0 : defaultData.target) === null || _b === void 0 ? void 0 : _b.userData) === null || _c === void 0 ? void 0 : _c.id) || THREE.MathUtils.generateUUID(),
        cameras: cameras,
        textures: configTextures,
        defaultObjects: defaultNodes,
        objects: configNodes ? configNodes : [],
        materials: configMaterials,
        attributes: _input.attributes || [],
        annotations: configAnnotations,
        animations: model.animations.length ? _toConsumableArray(model.animations) : [],
        rules: _input.scene.model.rule,
        actions: ruleActions,
        conditions: ruleConditions,
        customObjects: newCustomObjs,
        defaultSceneConfig: defaultSceneConfig,
        uploadedModels: [].concat(_toConsumableArray(test), _toConsumableArray(uploadedModelsConfig)),
        additionalOptions: {
          modelId: (_e = (_d = input.scene) === null || _d === void 0 ? void 0 : _d.model) === null || _e === void 0 ? void 0 : _e.id,
          modelUrl: (_g = (_f = input.scene) === null || _f === void 0 ? void 0 : _f.model) === null || _g === void 0 ? void 0 : _g.url,
          bone: bone,
          relatedAttribute: (_h = defaultData.additionalOptions) === null || _h === void 0 ? void 0 : _h.relatedAttribute,
          relatedChildrenAttributes: (_j = defaultData.additionalOptions) === null || _j === void 0 ? void 0 : _j.relatedChildrenAttributes
        }
      };
      return config;
    }
  }, [model]);
  return data;
};

var ITERATOR$2 = wellKnownSymbol('iterator');

var urlConstructorDetection = !fails(function () {
  // eslint-disable-next-line unicorn/relative-url-style -- required for testing
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var searchParams = url.searchParams;
  var result = '';
  url.pathname = 'c%20d';
  searchParams.forEach(function (value, key) {
    searchParams['delete']('b');
    result += key + value;
  });
  return (isPure && !url.toJSON)
    || (!searchParams.size && (isPure || !descriptors))
    || !searchParams.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || searchParams.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !searchParams[ITERATOR$2]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};

var $Array$2 = Array;

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
var arrayFrom = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var IS_CONSTRUCTOR = isConstructor(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = functionBindContext(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod && !(this === $Array$2 && isArrayIteratorMethod(iteratorMethod))) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    result = IS_CONSTRUCTOR ? new this() : [];
    for (;!(step = functionCall(next, iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = lengthOfArrayLike(O);
    result = IS_CONSTRUCTOR ? new this(length) : $Array$2(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};

// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js


var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'
var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var baseMinusTMin = base - tMin;

var $RangeError$5 = RangeError;
var exec$1 = functionUncurryThis(regexSeparators.exec);
var floor$7 = Math.floor;
var fromCharCode = String.fromCharCode;
var charCodeAt$1 = functionUncurryThis(''.charCodeAt);
var join$4 = functionUncurryThis([].join);
var push$4 = functionUncurryThis([].push);
var replace$5 = functionUncurryThis(''.replace);
var split$2 = functionUncurryThis(''.split);
var toLowerCase$1 = functionUncurryThis(''.toLowerCase);

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */
var ucs2decode = function (string) {
  var output = [];
  var counter = 0;
  var length = string.length;
  while (counter < length) {
    var value = charCodeAt$1(string, counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = charCodeAt$1(string, counter++);
      if ((extra & 0xFC00) == 0xDC00) { // Low surrogate.
        push$4(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        push$4(output, value);
        counter--;
      }
    } else {
      push$4(output, value);
    }
  }
  return output;
};

/**
 * Converts a digit/integer into a basic code point.
 */
var digitToBasic = function (digit) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */
var adapt = function (delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor$7(delta / damp) : delta >> 1;
  delta += floor$7(delta / numPoints);
  while (delta > baseMinusTMin * tMax >> 1) {
    delta = floor$7(delta / baseMinusTMin);
    k += base;
  }
  return floor$7(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */
var encode = function (input) {
  var output = [];

  // Convert the input in UCS-2 to an array of Unicode code points.
  input = ucs2decode(input);

  // Cache the length.
  var inputLength = input.length;

  // Initialize the state.
  var n = initialN;
  var delta = 0;
  var bias = initialBias;
  var i, currentValue;

  // Handle the basic code points.
  for (i = 0; i < input.length; i++) {
    currentValue = input[i];
    if (currentValue < 0x80) {
      push$4(output, fromCharCode(currentValue));
    }
  }

  var basicLength = output.length; // number of basic code points.
  var handledCPCount = basicLength; // number of code points that have been handled;

  // Finish the basic string with a delimiter unless it's empty.
  if (basicLength) {
    push$4(output, delimiter);
  }

  // Main encoding loop:
  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next larger one:
    var m = maxInt;
    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    }

    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
    var handledCPCountPlusOne = handledCPCount + 1;
    if (m - n > floor$7((maxInt - delta) / handledCPCountPlusOne)) {
      throw $RangeError$5(OVERFLOW_ERROR);
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue < n && ++delta > maxInt) {
        throw $RangeError$5(OVERFLOW_ERROR);
      }
      if (currentValue == n) {
        // Represent delta as a generalized variable-length integer.
        var q = delta;
        var k = base;
        while (true) {
          var t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
          if (q < t) break;
          var qMinusT = q - t;
          var baseMinusT = base - t;
          push$4(output, fromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
          q = floor$7(qMinusT / baseMinusT);
          k += base;
        }

        push$4(output, fromCharCode(digitToBasic(q)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
        delta = 0;
        handledCPCount++;
      }
    }

    delta++;
    n++;
  }
  return join$4(output, '');
};

var stringPunycodeToAscii = function (input) {
  var encoded = [];
  var labels = split$2(replace$5(toLowerCase$1(input), regexSeparators, '\u002E'), '.');
  var i, label;
  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    push$4(encoded, exec$1(regexNonASCII, label) ? 'xn--' + encode(label) : label);
  }
  return join$4(encoded, '.');
};

var floor$6 = Math.floor;

var mergeSort = function (array, comparefn) {
  var length = array.length;
  var middle = floor$6(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge(
    array,
    mergeSort(arraySliceSimple(array, 0, middle), comparefn),
    mergeSort(arraySliceSimple(array, middle), comparefn),
    comparefn
  );
};

var insertionSort = function (array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];
    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }
    if (j !== i++) array[j] = element;
  } return array;
};

var merge = function (array, left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;

  while (lindex < llength || rindex < rlength) {
    array[lindex + rindex] = (lindex < llength && rindex < rlength)
      ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
      : lindex < llength ? left[lindex++] : right[rindex++];
  } return array;
};

var arraySort = mergeSort;

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`





























var ITERATOR$1 = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState$2 = internalState.set;
var getInternalParamsState = internalState.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = internalState.getterFor(URL_SEARCH_PARAMS_ITERATOR);
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$3 = Object.getOwnPropertyDescriptor;

// Avoid NodeJS experimental warning
var safeGetBuiltIn = function (name) {
  if (!descriptors) return global_1[name];
  var descriptor = getOwnPropertyDescriptor$3(global_1, name);
  return descriptor && descriptor.value;
};

var nativeFetch = safeGetBuiltIn('fetch');
var NativeRequest = safeGetBuiltIn('Request');
var Headers = safeGetBuiltIn('Headers');
var RequestPrototype = NativeRequest && NativeRequest.prototype;
var HeadersPrototype = Headers && Headers.prototype;
var RegExp$1 = global_1.RegExp;
var TypeError$4 = global_1.TypeError;
var decodeURIComponent = global_1.decodeURIComponent;
var encodeURIComponent$1 = global_1.encodeURIComponent;
var charAt$2 = functionUncurryThis(''.charAt);
var join$3 = functionUncurryThis([].join);
var push$3 = functionUncurryThis([].push);
var replace$4 = functionUncurryThis(''.replace);
var shift$1 = functionUncurryThis([].shift);
var splice = functionUncurryThis([].splice);
var split$1 = functionUncurryThis(''.split);
var stringSlice$6 = functionUncurryThis(''.slice);

var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function (bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp$1('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function (sequence) {
  try {
    return decodeURIComponent(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function (it) {
  var result = replace$4(it, plus, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent(result);
  } catch (error) {
    while (bytes) {
      result = replace$4(result, percentSequence(bytes--), percentDecode);
    }
    return result;
  }
};

var find = /[!'()~]|%20/g;

var replacements = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replacements[match];
};

var serialize = function (it) {
  return replace$4(encodeURIComponent$1(it), find, replacer);
};

var URLSearchParamsIterator = iteratorCreateConstructor(function Iterator(params, kind) {
  setInternalState$2(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    iterator: getIterator(getInternalParamsState(params).entries),
    kind: kind
  });
}, 'Iterator', function next() {
  var state = getInternalIteratorState(this);
  var kind = state.kind;
  var step = state.iterator.next();
  var entry = step.value;
  if (!step.done) {
    step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
  } return step;
}, true);

var URLSearchParamsState = function (init) {
  this.entries = [];
  this.url = null;

  if (init !== undefined) {
    if (isObject(init)) this.parseObject(init);
    else this.parseQuery(typeof init == 'string' ? charAt$2(init, 0) === '?' ? stringSlice$6(init, 1) : init : toString_1(init));
  }
};

URLSearchParamsState.prototype = {
  type: URL_SEARCH_PARAMS,
  bindURL: function (url) {
    this.url = url;
    this.update();
  },
  parseObject: function (object) {
    var iteratorMethod = getIteratorMethod(object);
    var iterator, next, step, entryIterator, entryNext, first, second;

    if (iteratorMethod) {
      iterator = getIterator(object, iteratorMethod);
      next = iterator.next;
      while (!(step = functionCall(next, iterator)).done) {
        entryIterator = getIterator(anObject(step.value));
        entryNext = entryIterator.next;
        if (
          (first = functionCall(entryNext, entryIterator)).done ||
          (second = functionCall(entryNext, entryIterator)).done ||
          !functionCall(entryNext, entryIterator).done
        ) throw TypeError$4('Expected sequence with length 2');
        push$3(this.entries, { key: toString_1(first.value), value: toString_1(second.value) });
      }
    } else for (var key in object) if (hasOwnProperty_1(object, key)) {
      push$3(this.entries, { key: key, value: toString_1(object[key]) });
    }
  },
  parseQuery: function (query) {
    if (query) {
      var attributes = split$1(query, '&');
      var index = 0;
      var attribute, entry;
      while (index < attributes.length) {
        attribute = attributes[index++];
        if (attribute.length) {
          entry = split$1(attribute, '=');
          push$3(this.entries, {
            key: deserialize(shift$1(entry)),
            value: deserialize(join$3(entry, '='))
          });
        }
      }
    }
  },
  serialize: function () {
    var entries = this.entries;
    var result = [];
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      push$3(result, serialize(entry.key) + '=' + serialize(entry.value));
    } return join$3(result, '&');
  },
  update: function () {
    this.entries.length = 0;
    this.parseQuery(this.url.query);
  },
  updateURL: function () {
    if (this.url) this.url.update();
  }
};

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance(this, URLSearchParamsPrototype);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  var state = setInternalState$2(this, new URLSearchParamsState(init));
  if (!descriptors) this.length = state.entries.length;
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

defineBuiltIns(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    validateArgumentsLength(arguments.length, 2);
    var state = getInternalParamsState(this);
    push$3(state.entries, { key: toString_1(name), value: toString_1(value) });
    if (!descriptors) this.length++;
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var key = toString_1(name);
    var index = 0;
    while (index < entries.length) {
      if (entries[index].key === key) splice(entries, index, 1);
      else index++;
    }
    if (!descriptors) this.length = entries.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = toString_1(name);
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = toString_1(name);
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) push$3(result, entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = toString_1(name);
    var index = 0;
    while (index < entries.length) {
      if (entries[index++].key === key) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var found = false;
    var key = toString_1(name);
    var val = toString_1(value);
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) splice(entries, index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) push$3(entries, { key: key, value: val });
    if (!descriptors) this.length = entries.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    arraySort(state.entries, function (a, b) {
      return a.key > b.key ? 1 : -1;
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = functionBindContext(callback, arguments.length > 1 ? arguments[1] : undefined);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
defineBuiltIn(URLSearchParamsPrototype, ITERATOR$1, URLSearchParamsPrototype.entries, { name: 'entries' });

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
defineBuiltIn(URLSearchParamsPrototype, 'toString', function toString() {
  return getInternalParamsState(this).serialize();
}, { enumerable: true });

// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if (descriptors) defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
  get: function size() {
    return getInternalParamsState(this).entries.length;
  },
  configurable: true,
  enumerable: true
});

setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

_export({ global: true, constructor: true, forced: !urlConstructorDetection }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!urlConstructorDetection && isCallable(Headers)) {
  var headersHas = functionUncurryThis(HeadersPrototype.has);
  var headersSet = functionUncurryThis(HeadersPrototype.set);

  var wrapRequestOptions = function (init) {
    if (isObject(init)) {
      var body = init.body;
      var headers;
      if (classof(body) === URL_SEARCH_PARAMS) {
        headers = init.headers ? new Headers(init.headers) : new Headers();
        if (!headersHas(headers, 'content-type')) {
          headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
        return objectCreate(init, {
          body: createPropertyDescriptor(0, toString_1(body)),
          headers: createPropertyDescriptor(0, headers)
        });
      }
    } return init;
  };

  if (isCallable(nativeFetch)) {
    _export({ global: true, enumerable: true, dontCallGetSet: true, forced: true }, {
      fetch: function fetch(input /* , init */) {
        return nativeFetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
      }
    });
  }

  if (isCallable(NativeRequest)) {
    var RequestConstructor = function Request(input /* , init */) {
      anInstance(this, RequestPrototype);
      return new NativeRequest(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
    };

    RequestPrototype.constructor = RequestConstructor;
    RequestConstructor.prototype = RequestPrototype;

    _export({ global: true, constructor: true, dontCallGetSet: true, forced: true }, {
      Request: RequestConstructor
    });
  }
}

var web_urlSearchParams_constructor = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
};

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`














var codeAt = stringMultibyte.codeAt;







var setInternalState$1 = internalState.set;
var getInternalURLState = internalState.getterFor('URL');
var URLSearchParams$1 = web_urlSearchParams_constructor.URLSearchParams;
var getInternalSearchParamsState = web_urlSearchParams_constructor.getState;

var NativeURL = global_1.URL;
var TypeError$3 = global_1.TypeError;
var parseInt$1 = global_1.parseInt;
var floor$5 = Math.floor;
var pow$2 = Math.pow;
var charAt$1 = functionUncurryThis(''.charAt);
var exec = functionUncurryThis(/./.exec);
var join$2 = functionUncurryThis([].join);
var numberToString = functionUncurryThis(1.0.toString);
var pop = functionUncurryThis([].pop);
var push$2 = functionUncurryThis([].push);
var replace$3 = functionUncurryThis(''.replace);
var shift = functionUncurryThis([].shift);
var split = functionUncurryThis(''.split);
var stringSlice$5 = functionUncurryThis(''.slice);
var toLowerCase = functionUncurryThis(''.toLowerCase);
var unshift = functionUncurryThis([].unshift);

var INVALID_AUTHORITY = 'Invalid authority';
var INVALID_SCHEME = 'Invalid scheme';
var INVALID_HOST = 'Invalid host';
var INVALID_PORT = 'Invalid port';

var ALPHA = /[a-z]/i;
// eslint-disable-next-line regexp/no-obscure-range -- safe
var ALPHANUMERIC = /[\d+-.a-z]/i;
var DIGIT = /\d/;
var HEX_START = /^0x/i;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\da-f]+$/i;
/* eslint-disable regexp/no-control-character -- safe */
var FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var LEADING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+/;
var TRAILING_C0_CONTROL_OR_SPACE = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/;
var TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable regexp/no-control-character -- safe */
var EOF;

// https://url.spec.whatwg.org/#ipv4-number-parser
var parseIPv4 = function (input) {
  var parts = split(input, '.');
  var partsLength, numbers, index, part, radix, number, ipv4;
  if (parts.length && parts[parts.length - 1] == '') {
    parts.length--;
  }
  partsLength = parts.length;
  if (partsLength > 4) return input;
  numbers = [];
  for (index = 0; index < partsLength; index++) {
    part = parts[index];
    if (part == '') return input;
    radix = 10;
    if (part.length > 1 && charAt$1(part, 0) == '0') {
      radix = exec(HEX_START, part) ? 16 : 8;
      part = stringSlice$5(part, radix == 8 ? 1 : 2);
    }
    if (part === '') {
      number = 0;
    } else {
      if (!exec(radix == 10 ? DEC : radix == 8 ? OCT : HEX, part)) return input;
      number = parseInt$1(part, radix);
    }
    push$2(numbers, number);
  }
  for (index = 0; index < partsLength; index++) {
    number = numbers[index];
    if (index == partsLength - 1) {
      if (number >= pow$2(256, 5 - partsLength)) return null;
    } else if (number > 255) return null;
  }
  ipv4 = pop(numbers);
  for (index = 0; index < numbers.length; index++) {
    ipv4 += numbers[index] * pow$2(256, 3 - index);
  }
  return ipv4;
};

// https://url.spec.whatwg.org/#concept-ipv6-parser
// eslint-disable-next-line max-statements -- TODO
var parseIPv6 = function (input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

  var chr = function () {
    return charAt$1(input, pointer);
  };

  if (chr() == ':') {
    if (charAt$1(input, 1) != ':') return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }
  while (chr()) {
    if (pieceIndex == 8) return;
    if (chr() == ':') {
      if (compress !== null) return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }
    value = length = 0;
    while (length < 4 && exec(HEX, chr())) {
      value = value * 16 + parseInt$1(chr(), 16);
      pointer++;
      length++;
    }
    if (chr() == '.') {
      if (length == 0) return;
      pointer -= length;
      if (pieceIndex > 6) return;
      numbersSeen = 0;
      while (chr()) {
        ipv4Piece = null;
        if (numbersSeen > 0) {
          if (chr() == '.' && numbersSeen < 4) pointer++;
          else return;
        }
        if (!exec(DIGIT, chr())) return;
        while (exec(DIGIT, chr())) {
          number = parseInt$1(chr(), 10);
          if (ipv4Piece === null) ipv4Piece = number;
          else if (ipv4Piece == 0) return;
          else ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255) return;
          pointer++;
        }
        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen == 2 || numbersSeen == 4) pieceIndex++;
      }
      if (numbersSeen != 4) return;
      break;
    } else if (chr() == ':') {
      pointer++;
      if (!chr()) return;
    } else if (chr()) return;
    address[pieceIndex++] = value;
  }
  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;
    while (pieceIndex != 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex != 8) return;
  return address;
};

var findLongestZeroSequence = function (ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index = 0;
  for (; index < 8; index++) {
    if (ipv6[index] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }
      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null) currStart = index;
      ++currLength;
    }
  }
  if (currLength > maxLength) {
    maxIndex = currStart;
    maxLength = currLength;
  }
  return maxIndex;
};

// https://url.spec.whatwg.org/#host-serializing
var serializeHost = function (host) {
  var result, index, compress, ignore0;
  // ipv4
  if (typeof host == 'number') {
    result = [];
    for (index = 0; index < 4; index++) {
      unshift(result, host % 256);
      host = floor$5(host / 256);
    } return join$2(result, '.');
  // ipv6
  } else if (typeof host == 'object') {
    result = '';
    compress = findLongestZeroSequence(host);
    for (index = 0; index < 8; index++) {
      if (ignore0 && host[index] === 0) continue;
      if (ignore0) ignore0 = false;
      if (compress === index) {
        result += index ? ':' : '::';
        ignore0 = true;
      } else {
        result += numberToString(host[index], 16);
        if (index < 7) result += ':';
      }
    }
    return '[' + result + ']';
  } return host;
};

var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = objectAssign({}, C0ControlPercentEncodeSet, {
  ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1
});
var pathPercentEncodeSet = objectAssign({}, fragmentPercentEncodeSet, {
  '#': 1, '?': 1, '{': 1, '}': 1
});
var userinfoPercentEncodeSet = objectAssign({}, pathPercentEncodeSet, {
  '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1
});

var percentEncode = function (chr, set) {
  var code = codeAt(chr, 0);
  return code > 0x20 && code < 0x7F && !hasOwnProperty_1(set, chr) ? chr : encodeURIComponent(chr);
};

// https://url.spec.whatwg.org/#special-scheme
var specialSchemes = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
};

// https://url.spec.whatwg.org/#windows-drive-letter
var isWindowsDriveLetter = function (string, normalized) {
  var second;
  return string.length == 2 && exec(ALPHA, charAt$1(string, 0))
    && ((second = charAt$1(string, 1)) == ':' || (!normalized && second == '|'));
};

// https://url.spec.whatwg.org/#start-with-a-windows-drive-letter
var startsWithWindowsDriveLetter = function (string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter(stringSlice$5(string, 0, 2)) && (
    string.length == 2 ||
    ((third = charAt$1(string, 2)) === '/' || third === '\\' || third === '?' || third === '#')
  );
};

// https://url.spec.whatwg.org/#single-dot-path-segment
var isSingleDot = function (segment) {
  return segment === '.' || toLowerCase(segment) === '%2e';
};

// https://url.spec.whatwg.org/#double-dot-path-segment
var isDoubleDot = function (segment) {
  segment = toLowerCase(segment);
  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};

// States:
var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};

var URLState = function (url, isBase, base) {
  var urlString = toString_1(url);
  var baseState, failure, searchParams;
  if (isBase) {
    failure = this.parse(urlString);
    if (failure) throw TypeError$3(failure);
    this.searchParams = null;
  } else {
    if (base !== undefined) baseState = new URLState(base, true);
    failure = this.parse(urlString, null, baseState);
    if (failure) throw TypeError$3(failure);
    searchParams = getInternalSearchParamsState(new URLSearchParams$1());
    searchParams.bindURL(this);
    this.searchParams = searchParams;
  }
};

URLState.prototype = {
  type: 'URL',
  // https://url.spec.whatwg.org/#url-parsing
  // eslint-disable-next-line max-statements -- TODO
  parse: function (input, stateOverride, base) {
    var url = this;
    var state = stateOverride || SCHEME_START;
    var pointer = 0;
    var buffer = '';
    var seenAt = false;
    var seenBracket = false;
    var seenPasswordToken = false;
    var codePoints, chr, bufferCodePoints, failure;

    input = toString_1(input);

    if (!stateOverride) {
      url.scheme = '';
      url.username = '';
      url.password = '';
      url.host = null;
      url.port = null;
      url.path = [];
      url.query = null;
      url.fragment = null;
      url.cannotBeABaseURL = false;
      input = replace$3(input, LEADING_C0_CONTROL_OR_SPACE, '');
      input = replace$3(input, TRAILING_C0_CONTROL_OR_SPACE, '$1');
    }

    input = replace$3(input, TAB_AND_NEW_LINE, '');

    codePoints = arrayFrom(input);

    while (pointer <= codePoints.length) {
      chr = codePoints[pointer];
      switch (state) {
        case SCHEME_START:
          if (chr && exec(ALPHA, chr)) {
            buffer += toLowerCase(chr);
            state = SCHEME;
          } else if (!stateOverride) {
            state = NO_SCHEME;
            continue;
          } else return INVALID_SCHEME;
          break;

        case SCHEME:
          if (chr && (exec(ALPHANUMERIC, chr) || chr == '+' || chr == '-' || chr == '.')) {
            buffer += toLowerCase(chr);
          } else if (chr == ':') {
            if (stateOverride && (
              (url.isSpecial() != hasOwnProperty_1(specialSchemes, buffer)) ||
              (buffer == 'file' && (url.includesCredentials() || url.port !== null)) ||
              (url.scheme == 'file' && !url.host)
            )) return;
            url.scheme = buffer;
            if (stateOverride) {
              if (url.isSpecial() && specialSchemes[url.scheme] == url.port) url.port = null;
              return;
            }
            buffer = '';
            if (url.scheme == 'file') {
              state = FILE;
            } else if (url.isSpecial() && base && base.scheme == url.scheme) {
              state = SPECIAL_RELATIVE_OR_AUTHORITY;
            } else if (url.isSpecial()) {
              state = SPECIAL_AUTHORITY_SLASHES;
            } else if (codePoints[pointer + 1] == '/') {
              state = PATH_OR_AUTHORITY;
              pointer++;
            } else {
              url.cannotBeABaseURL = true;
              push$2(url.path, '');
              state = CANNOT_BE_A_BASE_URL_PATH;
            }
          } else if (!stateOverride) {
            buffer = '';
            state = NO_SCHEME;
            pointer = 0;
            continue;
          } else return INVALID_SCHEME;
          break;

        case NO_SCHEME:
          if (!base || (base.cannotBeABaseURL && chr != '#')) return INVALID_SCHEME;
          if (base.cannotBeABaseURL && chr == '#') {
            url.scheme = base.scheme;
            url.path = arraySliceSimple(base.path);
            url.query = base.query;
            url.fragment = '';
            url.cannotBeABaseURL = true;
            state = FRAGMENT;
            break;
          }
          state = base.scheme == 'file' ? FILE : RELATIVE;
          continue;

        case SPECIAL_RELATIVE_OR_AUTHORITY:
          if (chr == '/' && codePoints[pointer + 1] == '/') {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
            pointer++;
          } else {
            state = RELATIVE;
            continue;
          } break;

        case PATH_OR_AUTHORITY:
          if (chr == '/') {
            state = AUTHORITY;
            break;
          } else {
            state = PATH;
            continue;
          }

        case RELATIVE:
          url.scheme = base.scheme;
          if (chr == EOF) {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySliceSimple(base.path);
            url.query = base.query;
          } else if (chr == '/' || (chr == '\\' && url.isSpecial())) {
            state = RELATIVE_SLASH;
          } else if (chr == '?') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySliceSimple(base.path);
            url.query = '';
            state = QUERY;
          } else if (chr == '#') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySliceSimple(base.path);
            url.query = base.query;
            url.fragment = '';
            state = FRAGMENT;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySliceSimple(base.path);
            url.path.length--;
            state = PATH;
            continue;
          } break;

        case RELATIVE_SLASH:
          if (url.isSpecial() && (chr == '/' || chr == '\\')) {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          } else if (chr == '/') {
            state = AUTHORITY;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            state = PATH;
            continue;
          } break;

        case SPECIAL_AUTHORITY_SLASHES:
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          if (chr != '/' || charAt$1(buffer, pointer + 1) != '/') continue;
          pointer++;
          break;

        case SPECIAL_AUTHORITY_IGNORE_SLASHES:
          if (chr != '/' && chr != '\\') {
            state = AUTHORITY;
            continue;
          } break;

        case AUTHORITY:
          if (chr == '@') {
            if (seenAt) buffer = '%40' + buffer;
            seenAt = true;
            bufferCodePoints = arrayFrom(buffer);
            for (var i = 0; i < bufferCodePoints.length; i++) {
              var codePoint = bufferCodePoints[i];
              if (codePoint == ':' && !seenPasswordToken) {
                seenPasswordToken = true;
                continue;
              }
              var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
              if (seenPasswordToken) url.password += encodedCodePoints;
              else url.username += encodedCodePoints;
            }
            buffer = '';
          } else if (
            chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
            (chr == '\\' && url.isSpecial())
          ) {
            if (seenAt && buffer == '') return INVALID_AUTHORITY;
            pointer -= arrayFrom(buffer).length + 1;
            buffer = '';
            state = HOST;
          } else buffer += chr;
          break;

        case HOST:
        case HOSTNAME:
          if (stateOverride && url.scheme == 'file') {
            state = FILE_HOST;
            continue;
          } else if (chr == ':' && !seenBracket) {
            if (buffer == '') return INVALID_HOST;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PORT;
            if (stateOverride == HOSTNAME) return;
          } else if (
            chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
            (chr == '\\' && url.isSpecial())
          ) {
            if (url.isSpecial() && buffer == '') return INVALID_HOST;
            if (stateOverride && buffer == '' && (url.includesCredentials() || url.port !== null)) return;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PATH_START;
            if (stateOverride) return;
            continue;
          } else {
            if (chr == '[') seenBracket = true;
            else if (chr == ']') seenBracket = false;
            buffer += chr;
          } break;

        case PORT:
          if (exec(DIGIT, chr)) {
            buffer += chr;
          } else if (
            chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
            (chr == '\\' && url.isSpecial()) ||
            stateOverride
          ) {
            if (buffer != '') {
              var port = parseInt$1(buffer, 10);
              if (port > 0xFFFF) return INVALID_PORT;
              url.port = (url.isSpecial() && port === specialSchemes[url.scheme]) ? null : port;
              buffer = '';
            }
            if (stateOverride) return;
            state = PATH_START;
            continue;
          } else return INVALID_PORT;
          break;

        case FILE:
          url.scheme = 'file';
          if (chr == '/' || chr == '\\') state = FILE_SLASH;
          else if (base && base.scheme == 'file') {
            if (chr == EOF) {
              url.host = base.host;
              url.path = arraySliceSimple(base.path);
              url.query = base.query;
            } else if (chr == '?') {
              url.host = base.host;
              url.path = arraySliceSimple(base.path);
              url.query = '';
              state = QUERY;
            } else if (chr == '#') {
              url.host = base.host;
              url.path = arraySliceSimple(base.path);
              url.query = base.query;
              url.fragment = '';
              state = FRAGMENT;
            } else {
              if (!startsWithWindowsDriveLetter(join$2(arraySliceSimple(codePoints, pointer), ''))) {
                url.host = base.host;
                url.path = arraySliceSimple(base.path);
                url.shortenPath();
              }
              state = PATH;
              continue;
            }
          } else {
            state = PATH;
            continue;
          } break;

        case FILE_SLASH:
          if (chr == '/' || chr == '\\') {
            state = FILE_HOST;
            break;
          }
          if (base && base.scheme == 'file' && !startsWithWindowsDriveLetter(join$2(arraySliceSimple(codePoints, pointer), ''))) {
            if (isWindowsDriveLetter(base.path[0], true)) push$2(url.path, base.path[0]);
            else url.host = base.host;
          }
          state = PATH;
          continue;

        case FILE_HOST:
          if (chr == EOF || chr == '/' || chr == '\\' || chr == '?' || chr == '#') {
            if (!stateOverride && isWindowsDriveLetter(buffer)) {
              state = PATH;
            } else if (buffer == '') {
              url.host = '';
              if (stateOverride) return;
              state = PATH_START;
            } else {
              failure = url.parseHost(buffer);
              if (failure) return failure;
              if (url.host == 'localhost') url.host = '';
              if (stateOverride) return;
              buffer = '';
              state = PATH_START;
            } continue;
          } else buffer += chr;
          break;

        case PATH_START:
          if (url.isSpecial()) {
            state = PATH;
            if (chr != '/' && chr != '\\') continue;
          } else if (!stateOverride && chr == '?') {
            url.query = '';
            state = QUERY;
          } else if (!stateOverride && chr == '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr != EOF) {
            state = PATH;
            if (chr != '/') continue;
          } break;

        case PATH:
          if (
            chr == EOF || chr == '/' ||
            (chr == '\\' && url.isSpecial()) ||
            (!stateOverride && (chr == '?' || chr == '#'))
          ) {
            if (isDoubleDot(buffer)) {
              url.shortenPath();
              if (chr != '/' && !(chr == '\\' && url.isSpecial())) {
                push$2(url.path, '');
              }
            } else if (isSingleDot(buffer)) {
              if (chr != '/' && !(chr == '\\' && url.isSpecial())) {
                push$2(url.path, '');
              }
            } else {
              if (url.scheme == 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
                if (url.host) url.host = '';
                buffer = charAt$1(buffer, 0) + ':'; // normalize windows drive letter
              }
              push$2(url.path, buffer);
            }
            buffer = '';
            if (url.scheme == 'file' && (chr == EOF || chr == '?' || chr == '#')) {
              while (url.path.length > 1 && url.path[0] === '') {
                shift(url.path);
              }
            }
            if (chr == '?') {
              url.query = '';
              state = QUERY;
            } else if (chr == '#') {
              url.fragment = '';
              state = FRAGMENT;
            }
          } else {
            buffer += percentEncode(chr, pathPercentEncodeSet);
          } break;

        case CANNOT_BE_A_BASE_URL_PATH:
          if (chr == '?') {
            url.query = '';
            state = QUERY;
          } else if (chr == '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr != EOF) {
            url.path[0] += percentEncode(chr, C0ControlPercentEncodeSet);
          } break;

        case QUERY:
          if (!stateOverride && chr == '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr != EOF) {
            if (chr == "'" && url.isSpecial()) url.query += '%27';
            else if (chr == '#') url.query += '%23';
            else url.query += percentEncode(chr, C0ControlPercentEncodeSet);
          } break;

        case FRAGMENT:
          if (chr != EOF) url.fragment += percentEncode(chr, fragmentPercentEncodeSet);
          break;
      }

      pointer++;
    }
  },
  // https://url.spec.whatwg.org/#host-parsing
  parseHost: function (input) {
    var result, codePoints, index;
    if (charAt$1(input, 0) == '[') {
      if (charAt$1(input, input.length - 1) != ']') return INVALID_HOST;
      result = parseIPv6(stringSlice$5(input, 1, -1));
      if (!result) return INVALID_HOST;
      this.host = result;
    // opaque host
    } else if (!this.isSpecial()) {
      if (exec(FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return INVALID_HOST;
      result = '';
      codePoints = arrayFrom(input);
      for (index = 0; index < codePoints.length; index++) {
        result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
      }
      this.host = result;
    } else {
      input = stringPunycodeToAscii(input);
      if (exec(FORBIDDEN_HOST_CODE_POINT, input)) return INVALID_HOST;
      result = parseIPv4(input);
      if (result === null) return INVALID_HOST;
      this.host = result;
    }
  },
  // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
  cannotHaveUsernamePasswordPort: function () {
    return !this.host || this.cannotBeABaseURL || this.scheme == 'file';
  },
  // https://url.spec.whatwg.org/#include-credentials
  includesCredentials: function () {
    return this.username != '' || this.password != '';
  },
  // https://url.spec.whatwg.org/#is-special
  isSpecial: function () {
    return hasOwnProperty_1(specialSchemes, this.scheme);
  },
  // https://url.spec.whatwg.org/#shorten-a-urls-path
  shortenPath: function () {
    var path = this.path;
    var pathSize = path.length;
    if (pathSize && (this.scheme != 'file' || pathSize != 1 || !isWindowsDriveLetter(path[0], true))) {
      path.length--;
    }
  },
  // https://url.spec.whatwg.org/#concept-url-serializer
  serialize: function () {
    var url = this;
    var scheme = url.scheme;
    var username = url.username;
    var password = url.password;
    var host = url.host;
    var port = url.port;
    var path = url.path;
    var query = url.query;
    var fragment = url.fragment;
    var output = scheme + ':';
    if (host !== null) {
      output += '//';
      if (url.includesCredentials()) {
        output += username + (password ? ':' + password : '') + '@';
      }
      output += serializeHost(host);
      if (port !== null) output += ':' + port;
    } else if (scheme == 'file') output += '//';
    output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + join$2(path, '/') : '';
    if (query !== null) output += '?' + query;
    if (fragment !== null) output += '#' + fragment;
    return output;
  },
  // https://url.spec.whatwg.org/#dom-url-href
  setHref: function (href) {
    var failure = this.parse(href);
    if (failure) throw TypeError$3(failure);
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-origin
  getOrigin: function () {
    var scheme = this.scheme;
    var port = this.port;
    if (scheme == 'blob') try {
      return new URLConstructor(scheme.path[0]).origin;
    } catch (error) {
      return 'null';
    }
    if (scheme == 'file' || !this.isSpecial()) return 'null';
    return scheme + '://' + serializeHost(this.host) + (port !== null ? ':' + port : '');
  },
  // https://url.spec.whatwg.org/#dom-url-protocol
  getProtocol: function () {
    return this.scheme + ':';
  },
  setProtocol: function (protocol) {
    this.parse(toString_1(protocol) + ':', SCHEME_START);
  },
  // https://url.spec.whatwg.org/#dom-url-username
  getUsername: function () {
    return this.username;
  },
  setUsername: function (username) {
    var codePoints = arrayFrom(toString_1(username));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.username = '';
    for (var i = 0; i < codePoints.length; i++) {
      this.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-password
  getPassword: function () {
    return this.password;
  },
  setPassword: function (password) {
    var codePoints = arrayFrom(toString_1(password));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.password = '';
    for (var i = 0; i < codePoints.length; i++) {
      this.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-host
  getHost: function () {
    var host = this.host;
    var port = this.port;
    return host === null ? ''
      : port === null ? serializeHost(host)
      : serializeHost(host) + ':' + port;
  },
  setHost: function (host) {
    if (this.cannotBeABaseURL) return;
    this.parse(host, HOST);
  },
  // https://url.spec.whatwg.org/#dom-url-hostname
  getHostname: function () {
    var host = this.host;
    return host === null ? '' : serializeHost(host);
  },
  setHostname: function (hostname) {
    if (this.cannotBeABaseURL) return;
    this.parse(hostname, HOSTNAME);
  },
  // https://url.spec.whatwg.org/#dom-url-port
  getPort: function () {
    var port = this.port;
    return port === null ? '' : toString_1(port);
  },
  setPort: function (port) {
    if (this.cannotHaveUsernamePasswordPort()) return;
    port = toString_1(port);
    if (port == '') this.port = null;
    else this.parse(port, PORT);
  },
  // https://url.spec.whatwg.org/#dom-url-pathname
  getPathname: function () {
    var path = this.path;
    return this.cannotBeABaseURL ? path[0] : path.length ? '/' + join$2(path, '/') : '';
  },
  setPathname: function (pathname) {
    if (this.cannotBeABaseURL) return;
    this.path = [];
    this.parse(pathname, PATH_START);
  },
  // https://url.spec.whatwg.org/#dom-url-search
  getSearch: function () {
    var query = this.query;
    return query ? '?' + query : '';
  },
  setSearch: function (search) {
    search = toString_1(search);
    if (search == '') {
      this.query = null;
    } else {
      if ('?' == charAt$1(search, 0)) search = stringSlice$5(search, 1);
      this.query = '';
      this.parse(search, QUERY);
    }
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-searchparams
  getSearchParams: function () {
    return this.searchParams.facade;
  },
  // https://url.spec.whatwg.org/#dom-url-hash
  getHash: function () {
    var fragment = this.fragment;
    return fragment ? '#' + fragment : '';
  },
  setHash: function (hash) {
    hash = toString_1(hash);
    if (hash == '') {
      this.fragment = null;
      return;
    }
    if ('#' == charAt$1(hash, 0)) hash = stringSlice$5(hash, 1);
    this.fragment = '';
    this.parse(hash, FRAGMENT);
  },
  update: function () {
    this.query = this.searchParams.serialize() || null;
  }
};

// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var URLConstructor = function URL(url /* , base */) {
  var that = anInstance(this, URLPrototype);
  var base = validateArgumentsLength(arguments.length, 1) > 1 ? arguments[1] : undefined;
  var state = setInternalState$1(that, new URLState(url, false, base));
  if (!descriptors) {
    that.href = state.serialize();
    that.origin = state.getOrigin();
    that.protocol = state.getProtocol();
    that.username = state.getUsername();
    that.password = state.getPassword();
    that.host = state.getHost();
    that.hostname = state.getHostname();
    that.port = state.getPort();
    that.pathname = state.getPathname();
    that.search = state.getSearch();
    that.searchParams = state.getSearchParams();
    that.hash = state.getHash();
  }
};

var URLPrototype = URLConstructor.prototype;

var accessorDescriptor = function (getter, setter) {
  return {
    get: function () {
      return getInternalURLState(this)[getter]();
    },
    set: setter && function (value) {
      return getInternalURLState(this)[setter](value);
    },
    configurable: true,
    enumerable: true
  };
};

if (descriptors) {
  // `URL.prototype.href` accessors pair
  // https://url.spec.whatwg.org/#dom-url-href
  defineBuiltInAccessor(URLPrototype, 'href', accessorDescriptor('serialize', 'setHref'));
  // `URL.prototype.origin` getter
  // https://url.spec.whatwg.org/#dom-url-origin
  defineBuiltInAccessor(URLPrototype, 'origin', accessorDescriptor('getOrigin'));
  // `URL.prototype.protocol` accessors pair
  // https://url.spec.whatwg.org/#dom-url-protocol
  defineBuiltInAccessor(URLPrototype, 'protocol', accessorDescriptor('getProtocol', 'setProtocol'));
  // `URL.prototype.username` accessors pair
  // https://url.spec.whatwg.org/#dom-url-username
  defineBuiltInAccessor(URLPrototype, 'username', accessorDescriptor('getUsername', 'setUsername'));
  // `URL.prototype.password` accessors pair
  // https://url.spec.whatwg.org/#dom-url-password
  defineBuiltInAccessor(URLPrototype, 'password', accessorDescriptor('getPassword', 'setPassword'));
  // `URL.prototype.host` accessors pair
  // https://url.spec.whatwg.org/#dom-url-host
  defineBuiltInAccessor(URLPrototype, 'host', accessorDescriptor('getHost', 'setHost'));
  // `URL.prototype.hostname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hostname
  defineBuiltInAccessor(URLPrototype, 'hostname', accessorDescriptor('getHostname', 'setHostname'));
  // `URL.prototype.port` accessors pair
  // https://url.spec.whatwg.org/#dom-url-port
  defineBuiltInAccessor(URLPrototype, 'port', accessorDescriptor('getPort', 'setPort'));
  // `URL.prototype.pathname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-pathname
  defineBuiltInAccessor(URLPrototype, 'pathname', accessorDescriptor('getPathname', 'setPathname'));
  // `URL.prototype.search` accessors pair
  // https://url.spec.whatwg.org/#dom-url-search
  defineBuiltInAccessor(URLPrototype, 'search', accessorDescriptor('getSearch', 'setSearch'));
  // `URL.prototype.searchParams` getter
  // https://url.spec.whatwg.org/#dom-url-searchparams
  defineBuiltInAccessor(URLPrototype, 'searchParams', accessorDescriptor('getSearchParams'));
  // `URL.prototype.hash` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hash
  defineBuiltInAccessor(URLPrototype, 'hash', accessorDescriptor('getHash', 'setHash'));
}

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
defineBuiltIn(URLPrototype, 'toJSON', function toJSON() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });

// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
defineBuiltIn(URLPrototype, 'toString', function toString() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });

if (NativeURL) {
  var nativeCreateObjectURL = NativeURL.createObjectURL;
  var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
  // `URL.createObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
  if (nativeCreateObjectURL) defineBuiltIn(URLConstructor, 'createObjectURL', functionBindContext(nativeCreateObjectURL, NativeURL));
  // `URL.revokeObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
  if (nativeRevokeObjectURL) defineBuiltIn(URLConstructor, 'revokeObjectURL', functionBindContext(nativeRevokeObjectURL, NativeURL));
}

setToStringTag(URLConstructor, 'URL');

_export({ global: true, constructor: true, forced: !urlConstructorDetection, sham: !descriptors }, {
  URL: URLConstructor
});

var nativeJoin = functionUncurryThis([].join);

var ES3_STRINGS = indexedObject != Object;
var FORCED$9 = ES3_STRINGS || !arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
_export({ target: 'Array', proto: true, forced: FORCED$9 }, {
  join: function join(separator) {
    return nativeJoin(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});

var BlendFunction = {
  SKIP: 0,
  SET: 1,
  ADD: 2,
  ALPHA: 3,
  AVERAGE: 4,
  COLOR: 5,
  COLOR_BURN: 6,
  COLOR_DODGE: 7,
  DARKEN: 8,
  DIFFERENCE: 9,
  DIVIDE: 10,
  DST: 11,
  EXCLUSION: 12,
  HARD_LIGHT: 13,
  HARD_MIX: 14,
  HUE: 15,
  INVERT: 16,
  INVERT_RGB: 17,
  LIGHTEN: 18,
  LINEAR_BURN: 19,
  LINEAR_DODGE: 20,
  LINEAR_LIGHT: 21,
  LUMINOSITY: 22,
  MULTIPLY: 23,
  NEGATION: 24,
  NORMAL: 25,
  OVERLAY: 26,
  PIN_LIGHT: 27,
  REFLECT: 28,
  SATURATION: 29,
  SCREEN: 30,
  SOFT_LIGHT: 31,
  SRC: 32,
  SUBTRACT: 33,
  VIVID_LIGHT: 34
};
var VignetteTechnique = {
  DEFAULT: 0,
  ESKIL: 1
};
var KernelSize = {
  VERY_SMALL: 0,
  SMALL: 1,
  MEDIUM: 2,
  LARGE: 3,
  VERY_LARGE: 4,
  HUGE: 5
};
var VIGNETTE_EFFECT = {
  name: 'vignette',
  darkness: {
    value: 0.5,
    min: 0,
    max: 10
  },
  offset: {
    value: 0.5,
    min: -10,
    max: 10
  },
  blendFunction: {
    value: BlendFunction.NORMAL
  },
  technique: {
    value: VignetteTechnique.DEFAULT
  },
  eskil: {
    value: false
  }
};
var NOISE_EFFECT = {
  name: 'noise',
  blendFunction: {
    value: BlendFunction.NORMAL
  },
  premultiply: {
    value: true
  }
};
var BLOOM_EFFECT = {
  name: 'bloom',
  mipmapBlur: {
    value: false
  },
  intensity: {
    value: 1.0
  },
  kernelSize: {
    value: KernelSize.LARGE
  },
  luminanceThreshold: {
    value: 0.9
  },
  luminanceSmoothing: {
    value: 0.025,
    min: 0,
    max: 1
  },
  resolutionX: {
    value: Resolution.AUTO_SIZE
  },
  resolutionY: {
    value: Resolution.AUTO_SIZE
  }
};
var DOF_EFFECT = {
  name: 'dof',
  blendFunction: {
    value: BlendFunction.NORMAL
  },
  focusDistance: {
    value: 2,
    min: 0,
    max: 4
  },
  focalLength: {
    value: 0.1,
    min: 0,
    max: 1
  },
  bokehScale: {
    value: 2,
    min: 0,
    max: 10
  }
};
var CHROMATIC_ABERRATION_EFFECT = {
  name: 'chromatic_aberration',
  radialModulation: {
    value: false
  },
  offset: {
    value: new THREE.Vector2(0.02, 0.02)
  },
  blendFunction: {
    value: BlendFunction.NORMAL
  },
  modulationOffset: {
    value: 0
  }
};
var BRIGHTNESS_CONTRAST_EFFECT = {
  name: 'brightness_contrast',
  brightness: {
    value: 0,
    min: -1,
    max: 1
  },
  contrast: {
    value: 0,
    min: -1,
    max: 1
  },
  blendFunction: {
    value: BlendFunction.NORMAL
  }
};
var SMAA_EFFECT = {
  name: 'smaa'
};
var SSAO_EFFECT = {
  name: 'ssao',
  samples: {
    value: 30
  },
  rings: {
    value: 4
  },
  distanceThreshold: {
    value: 1.0
  },
  distanceFalloff: {
    value: 0.0,
    min: 0,
    max: 1
  },
  rangeThreshold: {
    value: 0.5,
    min: 0,
    max: 1
  },
  rangeFalloff: {
    value: 0.1,
    min: 0,
    max: 1
  },
  luminanceInfluence: {
    value: 0.9
  },
  radius: {
    value: 20
  },
  bias: {
    value: 0.5
  },
  worldDistanceFalloff: {
    value: 0
  },
  worldDistanceThreshold: {
    value: 0
  },
  worldProximityFalloff: {
    value: 0
  },
  worldProximityThreshold: {
    value: 0
  }
};
var TONE_MAPPING_EFFECT = {
  name: 'tone_mapping',
  adaptive: {
    value: true
  },
  blendFunction: {
    value: BlendFunction.NORMAL
  },
  resolution: {
    value: 256
  },
  middleGrey: {
    value: 0.6
  },
  maxLuminance: {
    value: 16.0
  },
  averageLuminance: {
    value: 1.0
  },
  adaptationRate: {
    value: 1.0
  }
};
var HUE_SATURATION_EFFECT = {
  name: 'hue_saturation',
  blendFunction: {
    value: BlendFunction.NORMAL
  },
  hue: {
    value: 0,
    min: 0,
    max: Math.PI
  },
  saturation: {
    value: 0,
    min: 0,
    max: Math.PI
  }
};
var POST_PROCESSING_NAME = {
  BLOOM: BLOOM_EFFECT,
  NOISE: NOISE_EFFECT,
  DOF: DOF_EFFECT,
  CHROMATIC_ABERRATION: CHROMATIC_ABERRATION_EFFECT,
  BRIGHTNESS_CONTRAST: BRIGHTNESS_CONTRAST_EFFECT,
  SMAA: SMAA_EFFECT,
  TONE_MAPPING: TONE_MAPPING_EFFECT,
  SSAO: SSAO_EFFECT,
  HUE_SATURATION: HUE_SATURATION_EFFECT,
  VIGNETTE: VIGNETTE_EFFECT
};

function iOSCheck() {
  return ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) || navigator.userAgent.includes('Mac') && 'ontouchend' in document;
}

// eslint-disable-next-line es/no-typed-arrays -- safe
var arrayBufferBasicDetection = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';

var enforceInternalState = internalState.enforce;
var getInternalState = internalState.get;
var Int8Array$4 = global_1.Int8Array;
var Int8ArrayPrototype$1 = Int8Array$4 && Int8Array$4.prototype;
var Uint8ClampedArray$1 = global_1.Uint8ClampedArray;
var Uint8ClampedArrayPrototype = Uint8ClampedArray$1 && Uint8ClampedArray$1.prototype;
var TypedArray = Int8Array$4 && objectGetPrototypeOf(Int8Array$4);
var TypedArrayPrototype$1 = Int8ArrayPrototype$1 && objectGetPrototypeOf(Int8ArrayPrototype$1);
var ObjectPrototype$1 = Object.prototype;
var TypeError$2 = global_1.TypeError;

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var TYPED_ARRAY_TAG = uid('TYPED_ARRAY_TAG');
var TYPED_ARRAY_CONSTRUCTOR = 'TypedArrayConstructor';
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var NATIVE_ARRAY_BUFFER_VIEWS$1 = arrayBufferBasicDetection && !!objectSetPrototypeOf && classof(global_1.opera) !== 'Opera';
var TYPED_ARRAY_TAG_REQUIRED = false;
var NAME, Constructor, Prototype;

var TypedArrayConstructorsList = {
  Int8Array: 1,
  Uint8Array: 1,
  Uint8ClampedArray: 1,
  Int16Array: 2,
  Uint16Array: 2,
  Int32Array: 4,
  Uint32Array: 4,
  Float32Array: 4,
  Float64Array: 8
};

var BigIntArrayConstructorsList = {
  BigInt64Array: 8,
  BigUint64Array: 8
};

var isView = function isView(it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return klass === 'DataView'
    || hasOwnProperty_1(TypedArrayConstructorsList, klass)
    || hasOwnProperty_1(BigIntArrayConstructorsList, klass);
};

var getTypedArrayConstructor$1 = function (it) {
  var proto = objectGetPrototypeOf(it);
  if (!isObject(proto)) return;
  var state = getInternalState(proto);
  return (state && hasOwnProperty_1(state, TYPED_ARRAY_CONSTRUCTOR)) ? state[TYPED_ARRAY_CONSTRUCTOR] : getTypedArrayConstructor$1(proto);
};

var isTypedArray = function (it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return hasOwnProperty_1(TypedArrayConstructorsList, klass)
    || hasOwnProperty_1(BigIntArrayConstructorsList, klass);
};

var aTypedArray$m = function (it) {
  if (isTypedArray(it)) return it;
  throw TypeError$2('Target is not a typed array');
};

var aTypedArrayConstructor$2 = function (C) {
  if (isCallable(C) && (!objectSetPrototypeOf || objectIsPrototypeOf(TypedArray, C))) return C;
  throw TypeError$2(tryToString(C) + ' is not a typed array constructor');
};

var exportTypedArrayMethod$n = function (KEY, property, forced, options) {
  if (!descriptors) return;
  if (forced) for (var ARRAY in TypedArrayConstructorsList) {
    var TypedArrayConstructor = global_1[ARRAY];
    if (TypedArrayConstructor && hasOwnProperty_1(TypedArrayConstructor.prototype, KEY)) try {
      delete TypedArrayConstructor.prototype[KEY];
    } catch (error) {
      // old WebKit bug - some methods are non-configurable
      try {
        TypedArrayConstructor.prototype[KEY] = property;
      } catch (error2) { /* empty */ }
    }
  }
  if (!TypedArrayPrototype$1[KEY] || forced) {
    defineBuiltIn(TypedArrayPrototype$1, KEY, forced ? property
      : NATIVE_ARRAY_BUFFER_VIEWS$1 && Int8ArrayPrototype$1[KEY] || property, options);
  }
};

var exportTypedArrayStaticMethod = function (KEY, property, forced) {
  var ARRAY, TypedArrayConstructor;
  if (!descriptors) return;
  if (objectSetPrototypeOf) {
    if (forced) for (ARRAY in TypedArrayConstructorsList) {
      TypedArrayConstructor = global_1[ARRAY];
      if (TypedArrayConstructor && hasOwnProperty_1(TypedArrayConstructor, KEY)) try {
        delete TypedArrayConstructor[KEY];
      } catch (error) { /* empty */ }
    }
    if (!TypedArray[KEY] || forced) {
      // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
      try {
        return defineBuiltIn(TypedArray, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS$1 && TypedArray[KEY] || property);
      } catch (error) { /* empty */ }
    } else return;
  }
  for (ARRAY in TypedArrayConstructorsList) {
    TypedArrayConstructor = global_1[ARRAY];
    if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) {
      defineBuiltIn(TypedArrayConstructor, KEY, property);
    }
  }
};

for (NAME in TypedArrayConstructorsList) {
  Constructor = global_1[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
  else NATIVE_ARRAY_BUFFER_VIEWS$1 = false;
}

for (NAME in BigIntArrayConstructorsList) {
  Constructor = global_1[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
}

// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!NATIVE_ARRAY_BUFFER_VIEWS$1 || !isCallable(TypedArray) || TypedArray === Function.prototype) {
  // eslint-disable-next-line no-shadow -- safe
  TypedArray = function TypedArray() {
    throw TypeError$2('Incorrect invocation');
  };
  if (NATIVE_ARRAY_BUFFER_VIEWS$1) for (NAME in TypedArrayConstructorsList) {
    if (global_1[NAME]) objectSetPrototypeOf(global_1[NAME], TypedArray);
  }
}

if (!NATIVE_ARRAY_BUFFER_VIEWS$1 || !TypedArrayPrototype$1 || TypedArrayPrototype$1 === ObjectPrototype$1) {
  TypedArrayPrototype$1 = TypedArray.prototype;
  if (NATIVE_ARRAY_BUFFER_VIEWS$1) for (NAME in TypedArrayConstructorsList) {
    if (global_1[NAME]) objectSetPrototypeOf(global_1[NAME].prototype, TypedArrayPrototype$1);
  }
}

// WebKit bug - one more object in Uint8ClampedArray prototype chain
if (NATIVE_ARRAY_BUFFER_VIEWS$1 && objectGetPrototypeOf(Uint8ClampedArrayPrototype) !== TypedArrayPrototype$1) {
  objectSetPrototypeOf(Uint8ClampedArrayPrototype, TypedArrayPrototype$1);
}

if (descriptors && !hasOwnProperty_1(TypedArrayPrototype$1, TO_STRING_TAG)) {
  TYPED_ARRAY_TAG_REQUIRED = true;
  defineBuiltInAccessor(TypedArrayPrototype$1, TO_STRING_TAG, {
    configurable: true,
    get: function () {
      return isObject(this) ? this[TYPED_ARRAY_TAG] : undefined;
    }
  });
  for (NAME in TypedArrayConstructorsList) if (global_1[NAME]) {
    createNonEnumerableProperty(global_1[NAME], TYPED_ARRAY_TAG, NAME);
  }
}

var arrayBufferViewCore = {
  NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS$1,
  TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQUIRED && TYPED_ARRAY_TAG,
  aTypedArray: aTypedArray$m,
  aTypedArrayConstructor: aTypedArrayConstructor$2,
  exportTypedArrayMethod: exportTypedArrayMethod$n,
  exportTypedArrayStaticMethod: exportTypedArrayStaticMethod,
  getTypedArrayConstructor: getTypedArrayConstructor$1,
  isView: isView,
  isTypedArray: isTypedArray,
  TypedArray: TypedArray,
  TypedArrayPrototype: TypedArrayPrototype$1
};

/* eslint-disable no-new -- required for testing */



var NATIVE_ARRAY_BUFFER_VIEWS = arrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;

var ArrayBuffer$3 = global_1.ArrayBuffer;
var Int8Array$3 = global_1.Int8Array;

var typedArrayConstructorsRequireWrappers = !NATIVE_ARRAY_BUFFER_VIEWS || !fails(function () {
  Int8Array$3(1);
}) || !fails(function () {
  new Int8Array$3(-1);
}) || !checkCorrectnessOfIteration(function (iterable) {
  new Int8Array$3();
  new Int8Array$3(null);
  new Int8Array$3(1.5);
  new Int8Array$3(iterable);
}, true) || fails(function () {
  // Safari (11+) bug - a reason why even Safari 13 should load a typed array polyfill
  return new Int8Array$3(new ArrayBuffer$3(2), 1, undefined).length !== 1;
});

var $RangeError$4 = RangeError;

// `ToIndex` abstract operation
// https://tc39.es/ecma262/#sec-toindex
var toIndex = function (it) {
  if (it === undefined) return 0;
  var number = toIntegerOrInfinity(it);
  var length = toLength(number);
  if (number !== length) throw $RangeError$4('Wrong length or index');
  return length;
};

// IEEE754 conversions based on https://github.com/feross/ieee754
var $Array$1 = Array;
var abs = Math.abs;
var pow$1 = Math.pow;
var floor$4 = Math.floor;
var log$2 = Math.log;
var LN2 = Math.LN2;

var pack = function (number, mantissaLength, bytes) {
  var buffer = $Array$1(bytes);
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var rt = mantissaLength === 23 ? pow$1(2, -24) - pow$1(2, -77) : 0;
  var sign = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
  var index = 0;
  var exponent, mantissa, c;
  number = abs(number);
  // eslint-disable-next-line no-self-compare -- NaN check
  if (number != number || number === Infinity) {
    // eslint-disable-next-line no-self-compare -- NaN check
    mantissa = number != number ? 1 : 0;
    exponent = eMax;
  } else {
    exponent = floor$4(log$2(number) / LN2);
    c = pow$1(2, -exponent);
    if (number * c < 1) {
      exponent--;
      c *= 2;
    }
    if (exponent + eBias >= 1) {
      number += rt / c;
    } else {
      number += rt * pow$1(2, 1 - eBias);
    }
    if (number * c >= 2) {
      exponent++;
      c /= 2;
    }
    if (exponent + eBias >= eMax) {
      mantissa = 0;
      exponent = eMax;
    } else if (exponent + eBias >= 1) {
      mantissa = (number * c - 1) * pow$1(2, mantissaLength);
      exponent = exponent + eBias;
    } else {
      mantissa = number * pow$1(2, eBias - 1) * pow$1(2, mantissaLength);
      exponent = 0;
    }
  }
  while (mantissaLength >= 8) {
    buffer[index++] = mantissa & 255;
    mantissa /= 256;
    mantissaLength -= 8;
  }
  exponent = exponent << mantissaLength | mantissa;
  exponentLength += mantissaLength;
  while (exponentLength > 0) {
    buffer[index++] = exponent & 255;
    exponent /= 256;
    exponentLength -= 8;
  }
  buffer[--index] |= sign * 128;
  return buffer;
};

var unpack = function (buffer, mantissaLength) {
  var bytes = buffer.length;
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var nBits = exponentLength - 7;
  var index = bytes - 1;
  var sign = buffer[index--];
  var exponent = sign & 127;
  var mantissa;
  sign >>= 7;
  while (nBits > 0) {
    exponent = exponent * 256 + buffer[index--];
    nBits -= 8;
  }
  mantissa = exponent & (1 << -nBits) - 1;
  exponent >>= -nBits;
  nBits += mantissaLength;
  while (nBits > 0) {
    mantissa = mantissa * 256 + buffer[index--];
    nBits -= 8;
  }
  if (exponent === 0) {
    exponent = 1 - eBias;
  } else if (exponent === eMax) {
    return mantissa ? NaN : sign ? -Infinity : Infinity;
  } else {
    mantissa = mantissa + pow$1(2, mantissaLength);
    exponent = exponent - eBias;
  } return (sign ? -1 : 1) * mantissa * pow$1(2, exponent - mantissaLength);
};

var ieee754 = {
  pack: pack,
  unpack: unpack
};

// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
var arrayFill = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = lengthOfArrayLike(O);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};

var getOwnPropertyNames$1 = objectGetOwnPropertyNames.f;





var PROPER_FUNCTION_NAME = functionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;
var ARRAY_BUFFER$1 = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length';
var WRONG_INDEX = 'Wrong index';
var getInternalArrayBufferState = internalState.getterFor(ARRAY_BUFFER$1);
var getInternalDataViewState = internalState.getterFor(DATA_VIEW);
var setInternalState = internalState.set;
var NativeArrayBuffer$1 = global_1[ARRAY_BUFFER$1];
var $ArrayBuffer = NativeArrayBuffer$1;
var ArrayBufferPrototype = $ArrayBuffer && $ArrayBuffer[PROTOTYPE];
var $DataView = global_1[DATA_VIEW];
var DataViewPrototype$1 = $DataView && $DataView[PROTOTYPE];
var ObjectPrototype = Object.prototype;
var Array$1 = global_1.Array;
var RangeError$2 = global_1.RangeError;
var fill = functionUncurryThis(arrayFill);
var reverse = functionUncurryThis([].reverse);

var packIEEE754 = ieee754.pack;
var unpackIEEE754 = ieee754.unpack;

var packInt8 = function (number) {
  return [number & 0xFF];
};

var packInt16 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF];
};

var packInt32 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF, number >> 16 & 0xFF, number >> 24 & 0xFF];
};

var unpackInt32 = function (buffer) {
  return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
};

var packFloat32 = function (number) {
  return packIEEE754(number, 23, 4);
};

var packFloat64 = function (number) {
  return packIEEE754(number, 52, 8);
};

var addGetter = function (Constructor, key, getInternalState) {
  defineBuiltInAccessor(Constructor[PROTOTYPE], key, {
    configurable: true,
    get: function () {
      return getInternalState(this)[key];
    }
  });
};

var get = function (view, count, index, isLittleEndian) {
  var intIndex = toIndex(index);
  var store = getInternalDataViewState(view);
  if (intIndex + count > store.byteLength) throw RangeError$2(WRONG_INDEX);
  var bytes = store.bytes;
  var start = intIndex + store.byteOffset;
  var pack = arraySliceSimple(bytes, start, start + count);
  return isLittleEndian ? pack : reverse(pack);
};

var set = function (view, count, index, conversion, value, isLittleEndian) {
  var intIndex = toIndex(index);
  var store = getInternalDataViewState(view);
  if (intIndex + count > store.byteLength) throw RangeError$2(WRONG_INDEX);
  var bytes = store.bytes;
  var start = intIndex + store.byteOffset;
  var pack = conversion(+value);
  for (var i = 0; i < count; i++) bytes[start + i] = pack[isLittleEndian ? i : count - i - 1];
};

if (!arrayBufferBasicDetection) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, ArrayBufferPrototype);
    var byteLength = toIndex(length);
    setInternalState(this, {
      type: ARRAY_BUFFER$1,
      bytes: fill(Array$1(byteLength), 0),
      byteLength: byteLength
    });
    if (!descriptors) {
      this.byteLength = byteLength;
      this.detached = false;
    }
  };

  ArrayBufferPrototype = $ArrayBuffer[PROTOTYPE];

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, DataViewPrototype$1);
    anInstance(buffer, ArrayBufferPrototype);
    var bufferState = getInternalArrayBufferState(buffer);
    var bufferLength = bufferState.byteLength;
    var offset = toIntegerOrInfinity(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError$2('Wrong offset');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError$2(WRONG_LENGTH);
    setInternalState(this, {
      type: DATA_VIEW,
      buffer: buffer,
      byteLength: byteLength,
      byteOffset: offset,
      bytes: bufferState.bytes
    });
    if (!descriptors) {
      this.buffer = buffer;
      this.byteLength = byteLength;
      this.byteOffset = offset;
    }
  };

  DataViewPrototype$1 = $DataView[PROTOTYPE];

  if (descriptors) {
    addGetter($ArrayBuffer, 'byteLength', getInternalArrayBufferState);
    addGetter($DataView, 'buffer', getInternalDataViewState);
    addGetter($DataView, 'byteLength', getInternalDataViewState);
    addGetter($DataView, 'byteOffset', getInternalDataViewState);
  }

  defineBuiltIns(DataViewPrototype$1, {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined)) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 23);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 52);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packInt8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packInt8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packFloat32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packFloat64, value, arguments.length > 2 ? arguments[2] : undefined);
    }
  });
} else {
  var INCORRECT_ARRAY_BUFFER_NAME = PROPER_FUNCTION_NAME && NativeArrayBuffer$1.name !== ARRAY_BUFFER$1;
  /* eslint-disable no-new -- required for testing */
  if (!fails(function () {
    NativeArrayBuffer$1(1);
  }) || !fails(function () {
    new NativeArrayBuffer$1(-1);
  }) || fails(function () {
    new NativeArrayBuffer$1();
    new NativeArrayBuffer$1(1.5);
    new NativeArrayBuffer$1(NaN);
    return NativeArrayBuffer$1.length != 1 || INCORRECT_ARRAY_BUFFER_NAME && !CONFIGURABLE_FUNCTION_NAME;
  })) {
    /* eslint-enable no-new -- required for testing */
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, ArrayBufferPrototype);
      return new NativeArrayBuffer$1(toIndex(length));
    };

    $ArrayBuffer[PROTOTYPE] = ArrayBufferPrototype;

    for (var keys = getOwnPropertyNames$1(NativeArrayBuffer$1), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) {
        createNonEnumerableProperty($ArrayBuffer, key, NativeArrayBuffer$1[key]);
      }
    }

    ArrayBufferPrototype.constructor = $ArrayBuffer;
  } else if (INCORRECT_ARRAY_BUFFER_NAME && CONFIGURABLE_FUNCTION_NAME) {
    createNonEnumerableProperty(NativeArrayBuffer$1, 'name', ARRAY_BUFFER$1);
  }

  // WebKit bug - the same parent prototype for typed arrays and data view
  if (objectSetPrototypeOf && objectGetPrototypeOf(DataViewPrototype$1) !== ObjectPrototype) {
    objectSetPrototypeOf(DataViewPrototype$1, ObjectPrototype);
  }

  // iOS Safari 7.x bug
  var testView = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = functionUncurryThis(DataViewPrototype$1.setInt8);
  testView.setInt8(0, 2147483648);
  testView.setInt8(1, 2147483649);
  if (testView.getInt8(0) || !testView.getInt8(1)) defineBuiltIns(DataViewPrototype$1, {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8(this, byteOffset, value << 24 >> 24);
    }
  }, { unsafe: true });
}

setToStringTag($ArrayBuffer, ARRAY_BUFFER$1);
setToStringTag($DataView, DATA_VIEW);

var arrayBuffer = {
  ArrayBuffer: $ArrayBuffer,
  DataView: $DataView
};

var floor$3 = Math.floor;

// `IsIntegralNumber` abstract operation
// https://tc39.es/ecma262/#sec-isintegralnumber
// eslint-disable-next-line es/no-number-isinteger -- safe
var isIntegralNumber = Number.isInteger || function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor$3(it) === it;
};

var $RangeError$3 = RangeError;

var toPositiveInteger = function (it) {
  var result = toIntegerOrInfinity(it);
  if (result < 0) throw $RangeError$3("The argument can't be less than 0");
  return result;
};

var $RangeError$2 = RangeError;

var toOffset = function (it, BYTES) {
  var offset = toPositiveInteger(it);
  if (offset % BYTES) throw $RangeError$2('Wrong offset');
  return offset;
};

var isBigIntArray = function (it) {
  var klass = classof(it);
  return klass == 'BigInt64Array' || klass == 'BigUint64Array';
};

var $TypeError$3 = TypeError;

// `ToBigInt` abstract operation
// https://tc39.es/ecma262/#sec-tobigint
var toBigInt = function (argument) {
  var prim = toPrimitive(argument, 'number');
  if (typeof prim == 'number') throw $TypeError$3("Can't convert number to bigint");
  // eslint-disable-next-line es/no-bigint -- safe
  return BigInt(prim);
};

var aTypedArrayConstructor$1 = arrayBufferViewCore.aTypedArrayConstructor;


var typedArrayFrom = function from(source /* , mapfn, thisArg */) {
  var C = aConstructor(this);
  var O = toObject(source);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var i, length, result, thisIsBigIntArray, value, step, iterator, next;
  if (iteratorMethod && !isArrayIteratorMethod(iteratorMethod)) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    O = [];
    while (!(step = functionCall(next, iterator)).done) {
      O.push(step.value);
    }
  }
  if (mapping && argumentsLength > 2) {
    mapfn = functionBindContext(mapfn, arguments[2]);
  }
  length = lengthOfArrayLike(O);
  result = new (aTypedArrayConstructor$1(C))(length);
  thisIsBigIntArray = isBigIntArray(result);
  for (i = 0; length > i; i++) {
    value = mapping ? mapfn(O[i], i) : O[i];
    // FF30- typed arrays doesn't properly convert objects to typed array values
    result[i] = thisIsBigIntArray ? toBigInt(value) : +value;
  }
  return result;
};

var typedArrayConstructor = createCommonjsModule(function (module) {






















var getOwnPropertyNames = objectGetOwnPropertyNames.f;

var forEach = arrayIteration.forEach;







var getInternalState = internalState.get;
var setInternalState = internalState.set;
var enforceInternalState = internalState.enforce;
var nativeDefineProperty = objectDefineProperty.f;
var nativeGetOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var round = Math.round;
var RangeError = global_1.RangeError;
var ArrayBuffer = arrayBuffer.ArrayBuffer;
var ArrayBufferPrototype = ArrayBuffer.prototype;
var DataView = arrayBuffer.DataView;
var NATIVE_ARRAY_BUFFER_VIEWS = arrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;
var TYPED_ARRAY_TAG = arrayBufferViewCore.TYPED_ARRAY_TAG;
var TypedArray = arrayBufferViewCore.TypedArray;
var TypedArrayPrototype = arrayBufferViewCore.TypedArrayPrototype;
var aTypedArrayConstructor = arrayBufferViewCore.aTypedArrayConstructor;
var isTypedArray = arrayBufferViewCore.isTypedArray;
var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
var WRONG_LENGTH = 'Wrong length';

var fromList = function (C, list) {
  aTypedArrayConstructor(C);
  var index = 0;
  var length = list.length;
  var result = new C(length);
  while (length > index) result[index] = list[index++];
  return result;
};

var addGetter = function (it, key) {
  defineBuiltInAccessor(it, key, {
    configurable: true,
    get: function () {
      return getInternalState(this)[key];
    }
  });
};

var isArrayBuffer = function (it) {
  var klass;
  return objectIsPrototypeOf(ArrayBufferPrototype, it) || (klass = classof(it)) == 'ArrayBuffer' || klass == 'SharedArrayBuffer';
};

var isTypedArrayIndex = function (target, key) {
  return isTypedArray(target)
    && !isSymbol(key)
    && key in target
    && isIntegralNumber(+key)
    && key >= 0;
};

var wrappedGetOwnPropertyDescriptor = function getOwnPropertyDescriptor(target, key) {
  key = toPropertyKey(key);
  return isTypedArrayIndex(target, key)
    ? createPropertyDescriptor(2, target[key])
    : nativeGetOwnPropertyDescriptor(target, key);
};

var wrappedDefineProperty = function defineProperty(target, key, descriptor) {
  key = toPropertyKey(key);
  if (isTypedArrayIndex(target, key)
    && isObject(descriptor)
    && hasOwnProperty_1(descriptor, 'value')
    && !hasOwnProperty_1(descriptor, 'get')
    && !hasOwnProperty_1(descriptor, 'set')
    // TODO: add validation descriptor w/o calling accessors
    && !descriptor.configurable
    && (!hasOwnProperty_1(descriptor, 'writable') || descriptor.writable)
    && (!hasOwnProperty_1(descriptor, 'enumerable') || descriptor.enumerable)
  ) {
    target[key] = descriptor.value;
    return target;
  } return nativeDefineProperty(target, key, descriptor);
};

if (descriptors) {
  if (!NATIVE_ARRAY_BUFFER_VIEWS) {
    objectGetOwnPropertyDescriptor.f = wrappedGetOwnPropertyDescriptor;
    objectDefineProperty.f = wrappedDefineProperty;
    addGetter(TypedArrayPrototype, 'buffer');
    addGetter(TypedArrayPrototype, 'byteOffset');
    addGetter(TypedArrayPrototype, 'byteLength');
    addGetter(TypedArrayPrototype, 'length');
  }

  _export({ target: 'Object', stat: true, forced: !NATIVE_ARRAY_BUFFER_VIEWS }, {
    getOwnPropertyDescriptor: wrappedGetOwnPropertyDescriptor,
    defineProperty: wrappedDefineProperty
  });

  module.exports = function (TYPE, wrapper, CLAMPED) {
    var BYTES = TYPE.match(/\d+/)[0] / 8;
    var CONSTRUCTOR_NAME = TYPE + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + TYPE;
    var SETTER = 'set' + TYPE;
    var NativeTypedArrayConstructor = global_1[CONSTRUCTOR_NAME];
    var TypedArrayConstructor = NativeTypedArrayConstructor;
    var TypedArrayConstructorPrototype = TypedArrayConstructor && TypedArrayConstructor.prototype;
    var exported = {};

    var getter = function (that, index) {
      var data = getInternalState(that);
      return data.view[GETTER](index * BYTES + data.byteOffset, true);
    };

    var setter = function (that, index, value) {
      var data = getInternalState(that);
      if (CLAMPED) value = (value = round(value)) < 0 ? 0 : value > 0xFF ? 0xFF : value & 0xFF;
      data.view[SETTER](index * BYTES + data.byteOffset, value, true);
    };

    var addElement = function (that, index) {
      nativeDefineProperty(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };

    if (!NATIVE_ARRAY_BUFFER_VIEWS) {
      TypedArrayConstructor = wrapper(function (that, data, offset, $length) {
        anInstance(that, TypedArrayConstructorPrototype);
        var index = 0;
        var byteOffset = 0;
        var buffer, byteLength, length;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new ArrayBuffer(byteLength);
        } else if (isArrayBuffer(data)) {
          buffer = data;
          byteOffset = toOffset(offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - byteOffset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + byteOffset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (isTypedArray(data)) {
          return fromList(TypedArrayConstructor, data);
        } else {
          return functionCall(typedArrayFrom, TypedArrayConstructor, data);
        }
        setInternalState(that, {
          buffer: buffer,
          byteOffset: byteOffset,
          byteLength: byteLength,
          length: length,
          view: new DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });

      if (objectSetPrototypeOf) objectSetPrototypeOf(TypedArrayConstructor, TypedArray);
      TypedArrayConstructorPrototype = TypedArrayConstructor.prototype = objectCreate(TypedArrayPrototype);
    } else if (typedArrayConstructorsRequireWrappers) {
      TypedArrayConstructor = wrapper(function (dummy, data, typedArrayOffset, $length) {
        anInstance(dummy, TypedArrayConstructorPrototype);
        return inheritIfRequired(function () {
          if (!isObject(data)) return new NativeTypedArrayConstructor(toIndex(data));
          if (isArrayBuffer(data)) return $length !== undefined
            ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES), $length)
            : typedArrayOffset !== undefined
              ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES))
              : new NativeTypedArrayConstructor(data);
          if (isTypedArray(data)) return fromList(TypedArrayConstructor, data);
          return functionCall(typedArrayFrom, TypedArrayConstructor, data);
        }(), dummy, TypedArrayConstructor);
      });

      if (objectSetPrototypeOf) objectSetPrototypeOf(TypedArrayConstructor, TypedArray);
      forEach(getOwnPropertyNames(NativeTypedArrayConstructor), function (key) {
        if (!(key in TypedArrayConstructor)) {
          createNonEnumerableProperty(TypedArrayConstructor, key, NativeTypedArrayConstructor[key]);
        }
      });
      TypedArrayConstructor.prototype = TypedArrayConstructorPrototype;
    }

    if (TypedArrayConstructorPrototype.constructor !== TypedArrayConstructor) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, 'constructor', TypedArrayConstructor);
    }

    enforceInternalState(TypedArrayConstructorPrototype).TypedArrayConstructor = TypedArrayConstructor;

    if (TYPED_ARRAY_TAG) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, TYPED_ARRAY_TAG, CONSTRUCTOR_NAME);
    }

    var FORCED = TypedArrayConstructor != NativeTypedArrayConstructor;

    exported[CONSTRUCTOR_NAME] = TypedArrayConstructor;

    _export({ global: true, constructor: true, forced: FORCED, sham: !NATIVE_ARRAY_BUFFER_VIEWS }, exported);

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructor)) {
      createNonEnumerableProperty(TypedArrayConstructor, BYTES_PER_ELEMENT, BYTES);
    }

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructorPrototype)) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, BYTES_PER_ELEMENT, BYTES);
    }

    setSpecies(CONSTRUCTOR_NAME);
  };
} else module.exports = function () { /* empty */ };
});

// `Uint8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
typedArrayConstructor('Uint8', function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

var $TypeError$2 = TypeError;

var deletePropertyOrThrow = function (O, P) {
  if (!delete O[P]) throw $TypeError$2('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
};

var min$4 = Math.min;

// `Array.prototype.copyWithin` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.copywithin
// eslint-disable-next-line es/no-array-prototype-copywithin -- safe
var arrayCopyWithin = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = lengthOfArrayLike(O);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = min$4((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else deletePropertyOrThrow(O, to);
    to += inc;
    from += inc;
  } return O;
};

var u$ArrayCopyWithin = functionUncurryThis(arrayCopyWithin);
var aTypedArray$l = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$m = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.copyWithin` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.copywithin
exportTypedArrayMethod$m('copyWithin', function copyWithin(target, start /* , end */) {
  return u$ArrayCopyWithin(aTypedArray$l(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
});

var $every = arrayIteration.every;

var aTypedArray$k = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$l = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.every` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.every
exportTypedArrayMethod$l('every', function every(callbackfn /* , thisArg */) {
  return $every(aTypedArray$k(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});

var aTypedArray$j = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$k = arrayBufferViewCore.exportTypedArrayMethod;
var slice = functionUncurryThis(''.slice);

// V8 ~ Chrome < 59, Safari < 14.1, FF < 55, Edge <=18
var CONVERSION_BUG = fails(function () {
  var count = 0;
  // eslint-disable-next-line es/no-typed-arrays -- safe
  new Int8Array(2).fill({ valueOf: function () { return count++; } });
  return count !== 1;
});

// `%TypedArray%.prototype.fill` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.fill
exportTypedArrayMethod$k('fill', function fill(value /* , start, end */) {
  var length = arguments.length;
  aTypedArray$j(this);
  var actualValue = slice(classof(this), 0, 3) === 'Big' ? toBigInt(value) : +value;
  return functionCall(arrayFill, this, actualValue, length > 1 ? arguments[1] : undefined, length > 2 ? arguments[2] : undefined);
}, CONVERSION_BUG);

var arrayFromConstructorAndList = function (Constructor, list) {
  var index = 0;
  var length = lengthOfArrayLike(list);
  var result = new Constructor(length);
  while (length > index) result[index] = list[index++];
  return result;
};

var aTypedArrayConstructor = arrayBufferViewCore.aTypedArrayConstructor;
var getTypedArrayConstructor = arrayBufferViewCore.getTypedArrayConstructor;

// a part of `TypedArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#typedarray-species-create
var typedArraySpeciesConstructor = function (originalArray) {
  return aTypedArrayConstructor(speciesConstructor(originalArray, getTypedArrayConstructor(originalArray)));
};

var typedArrayFromSpeciesAndList = function (instance, list) {
  return arrayFromConstructorAndList(typedArraySpeciesConstructor(instance), list);
};

var $filter = arrayIteration.filter;


var aTypedArray$i = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$j = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.filter` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.filter
exportTypedArrayMethod$j('filter', function filter(callbackfn /* , thisArg */) {
  var list = $filter(aTypedArray$i(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  return typedArrayFromSpeciesAndList(this, list);
});

var $find = arrayIteration.find;

var aTypedArray$h = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$i = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.find` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.find
exportTypedArrayMethod$i('find', function find(predicate /* , thisArg */) {
  return $find(aTypedArray$h(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});

var $findIndex = arrayIteration.findIndex;

var aTypedArray$g = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$h = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.findindex
exportTypedArrayMethod$h('findIndex', function findIndex(predicate /* , thisArg */) {
  return $findIndex(aTypedArray$g(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});

var $forEach = arrayIteration.forEach;

var aTypedArray$f = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$g = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.forEach` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.foreach
exportTypedArrayMethod$g('forEach', function forEach(callbackfn /* , thisArg */) {
  $forEach(aTypedArray$f(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});

var $includes = arrayIncludes.includes;

var aTypedArray$e = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$f = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.includes` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.includes
exportTypedArrayMethod$f('includes', function includes(searchElement /* , fromIndex */) {
  return $includes(aTypedArray$e(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});

var $indexOf$1 = arrayIncludes.indexOf;

var aTypedArray$d = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$e = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.indexof
exportTypedArrayMethod$e('indexOf', function indexOf(searchElement /* , fromIndex */) {
  return $indexOf$1(aTypedArray$d(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});

var ITERATOR = wellKnownSymbol('iterator');
var Uint8Array$2 = global_1.Uint8Array;
var arrayValues = functionUncurryThis(es_array_iterator.values);
var arrayKeys = functionUncurryThis(es_array_iterator.keys);
var arrayEntries = functionUncurryThis(es_array_iterator.entries);
var aTypedArray$c = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$d = arrayBufferViewCore.exportTypedArrayMethod;
var TypedArrayPrototype = Uint8Array$2 && Uint8Array$2.prototype;

var GENERIC = !fails(function () {
  TypedArrayPrototype[ITERATOR].call([1]);
});

var ITERATOR_IS_VALUES = !!TypedArrayPrototype
  && TypedArrayPrototype.values
  && TypedArrayPrototype[ITERATOR] === TypedArrayPrototype.values
  && TypedArrayPrototype.values.name === 'values';

var typedArrayValues = function values() {
  return arrayValues(aTypedArray$c(this));
};

// `%TypedArray%.prototype.entries` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.entries
exportTypedArrayMethod$d('entries', function entries() {
  return arrayEntries(aTypedArray$c(this));
}, GENERIC);
// `%TypedArray%.prototype.keys` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.keys
exportTypedArrayMethod$d('keys', function keys() {
  return arrayKeys(aTypedArray$c(this));
}, GENERIC);
// `%TypedArray%.prototype.values` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.values
exportTypedArrayMethod$d('values', typedArrayValues, GENERIC || !ITERATOR_IS_VALUES, { name: 'values' });
// `%TypedArray%.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype-@@iterator
exportTypedArrayMethod$d(ITERATOR, typedArrayValues, GENERIC || !ITERATOR_IS_VALUES, { name: 'values' });

var aTypedArray$b = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$c = arrayBufferViewCore.exportTypedArrayMethod;
var $join = functionUncurryThis([].join);

// `%TypedArray%.prototype.join` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.join
exportTypedArrayMethod$c('join', function join(separator) {
  return $join(aTypedArray$b(this), separator);
});

/* eslint-disable es/no-array-prototype-lastindexof -- safe */






var min$3 = Math.min;
var $lastIndexOf = [].lastIndexOf;
var NEGATIVE_ZERO$1 = !!$lastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
var STRICT_METHOD$2 = arrayMethodIsStrict('lastIndexOf');
var FORCED$8 = NEGATIVE_ZERO$1 || !STRICT_METHOD$2;

// `Array.prototype.lastIndexOf` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
var arrayLastIndexOf = FORCED$8 ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
  // convert -0 to +0
  if (NEGATIVE_ZERO$1) return functionApply($lastIndexOf, this, arguments) || 0;
  var O = toIndexedObject(this);
  var length = lengthOfArrayLike(O);
  var index = length - 1;
  if (arguments.length > 1) index = min$3(index, toIntegerOrInfinity(arguments[1]));
  if (index < 0) index = length + index;
  for (;index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
  return -1;
} : $lastIndexOf;

var aTypedArray$a = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$b = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.lastindexof
exportTypedArrayMethod$b('lastIndexOf', function lastIndexOf(searchElement /* , fromIndex */) {
  var length = arguments.length;
  return functionApply(arrayLastIndexOf, aTypedArray$a(this), length > 1 ? [searchElement, arguments[1]] : [searchElement]);
});

var $map = arrayIteration.map;


var aTypedArray$9 = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$a = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.map` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.map
exportTypedArrayMethod$a('map', function map(mapfn /* , thisArg */) {
  return $map(aTypedArray$9(this), mapfn, arguments.length > 1 ? arguments[1] : undefined, function (O, length) {
    return new (typedArraySpeciesConstructor(O))(length);
  });
});

var $TypeError$1 = TypeError;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod$1 = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable(callbackfn);
    var O = toObject(that);
    var self = indexedObject(O);
    var length = lengthOfArrayLike(O);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw $TypeError$1('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod$1(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod$1(true)
};

var $reduce$1 = arrayReduce.left;

var aTypedArray$8 = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$9 = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.reduce` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduce
exportTypedArrayMethod$9('reduce', function reduce(callbackfn /* , initialValue */) {
  var length = arguments.length;
  return $reduce$1(aTypedArray$8(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
});

var $reduceRight = arrayReduce.right;

var aTypedArray$7 = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$8 = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.reduceRight` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduceright
exportTypedArrayMethod$8('reduceRight', function reduceRight(callbackfn /* , initialValue */) {
  var length = arguments.length;
  return $reduceRight(aTypedArray$7(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
});

var aTypedArray$6 = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$7 = arrayBufferViewCore.exportTypedArrayMethod;
var floor$2 = Math.floor;

// `%TypedArray%.prototype.reverse` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reverse
exportTypedArrayMethod$7('reverse', function reverse() {
  var that = this;
  var length = aTypedArray$6(that).length;
  var middle = floor$2(length / 2);
  var index = 0;
  var value;
  while (index < middle) {
    value = that[index];
    that[index++] = that[--length];
    that[length] = value;
  } return that;
});

var RangeError$1 = global_1.RangeError;
var Int8Array$2 = global_1.Int8Array;
var Int8ArrayPrototype = Int8Array$2 && Int8Array$2.prototype;
var $set = Int8ArrayPrototype && Int8ArrayPrototype.set;
var aTypedArray$5 = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$6 = arrayBufferViewCore.exportTypedArrayMethod;

var WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS = !fails(function () {
  // eslint-disable-next-line es/no-typed-arrays -- required for testing
  var array = new Uint8ClampedArray(2);
  functionCall($set, array, { length: 1, 0: 3 }, 1);
  return array[1] !== 3;
});

// https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other
var TO_OBJECT_BUG = WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS && arrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS && fails(function () {
  var array = new Int8Array$2(2);
  array.set(1);
  array.set('2', 1);
  return array[0] !== 0 || array[1] !== 2;
});

// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
exportTypedArrayMethod$6('set', function set(arrayLike /* , offset */) {
  aTypedArray$5(this);
  var offset = toOffset(arguments.length > 1 ? arguments[1] : undefined, 1);
  var src = toObject(arrayLike);
  if (WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS) return functionCall($set, this, src, offset);
  var length = this.length;
  var len = lengthOfArrayLike(src);
  var index = 0;
  if (len + offset > length) throw RangeError$1('Wrong length');
  while (index < len) this[offset + index] = src[index++];
}, !WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS || TO_OBJECT_BUG);

var aTypedArray$4 = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$5 = arrayBufferViewCore.exportTypedArrayMethod;

var FORCED$7 = fails(function () {
  // eslint-disable-next-line es/no-typed-arrays -- required for testing
  new Int8Array(1).slice();
});

// `%TypedArray%.prototype.slice` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.slice
exportTypedArrayMethod$5('slice', function slice(start, end) {
  var list = arraySlice(aTypedArray$4(this), start, end);
  var C = typedArraySpeciesConstructor(this);
  var index = 0;
  var length = list.length;
  var result = new C(length);
  while (length > index) result[index] = list[index++];
  return result;
}, FORCED$7);

var $some$1 = arrayIteration.some;

var aTypedArray$3 = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$4 = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.some` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.some
exportTypedArrayMethod$4('some', function some(callbackfn /* , thisArg */) {
  return $some$1(aTypedArray$3(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});

var firefox = engineUserAgent.match(/firefox\/(\d+)/i);

var engineFfVersion = !!firefox && +firefox[1];

var engineIsIeOrEdge = /MSIE|Trident/.test(engineUserAgent);

var webkit = engineUserAgent.match(/AppleWebKit\/(\d+)\./);

var engineWebkitVersion = !!webkit && +webkit[1];

var aTypedArray$2 = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$3 = arrayBufferViewCore.exportTypedArrayMethod;
var Uint16Array$1 = global_1.Uint16Array;
var nativeSort$1 = Uint16Array$1 && functionUncurryThisClause(Uint16Array$1.prototype.sort);

// WebKit
var ACCEPT_INCORRECT_ARGUMENTS = !!nativeSort$1 && !(fails(function () {
  nativeSort$1(new Uint16Array$1(2), null);
}) && fails(function () {
  nativeSort$1(new Uint16Array$1(2), {});
}));

var STABLE_SORT$1 = !!nativeSort$1 && !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (engineV8Version) return engineV8Version < 74;
  if (engineFfVersion) return engineFfVersion < 67;
  if (engineIsIeOrEdge) return true;
  if (engineWebkitVersion) return engineWebkitVersion < 602;

  var array = new Uint16Array$1(516);
  var expected = Array(516);
  var index, mod;

  for (index = 0; index < 516; index++) {
    mod = index % 4;
    array[index] = 515 - index;
    expected[index] = index - 2 * mod + 3;
  }

  nativeSort$1(array, function (a, b) {
    return (a / 4 | 0) - (b / 4 | 0);
  });

  for (index = 0; index < 516; index++) {
    if (array[index] !== expected[index]) return true;
  }
});

var getSortCompare$1 = function (comparefn) {
  return function (x, y) {
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (y !== y) return -1;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (x !== x) return 1;
    if (x === 0 && y === 0) return 1 / x > 0 && 1 / y < 0 ? 1 : -1;
    return x > y;
  };
};

// `%TypedArray%.prototype.sort` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.sort
exportTypedArrayMethod$3('sort', function sort(comparefn) {
  if (comparefn !== undefined) aCallable(comparefn);
  if (STABLE_SORT$1) return nativeSort$1(this, comparefn);

  return arraySort(aTypedArray$2(this), getSortCompare$1(comparefn));
}, !STABLE_SORT$1 || ACCEPT_INCORRECT_ARGUMENTS);

var aTypedArray$1 = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$2 = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.subarray` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.subarray
exportTypedArrayMethod$2('subarray', function subarray(begin, end) {
  var O = aTypedArray$1(this);
  var length = O.length;
  var beginIndex = toAbsoluteIndex(begin, length);
  var C = typedArraySpeciesConstructor(O);
  return new C(
    O.buffer,
    O.byteOffset + beginIndex * O.BYTES_PER_ELEMENT,
    toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - beginIndex)
  );
});

var Int8Array$1 = global_1.Int8Array;
var aTypedArray = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$1 = arrayBufferViewCore.exportTypedArrayMethod;
var $toLocaleString = [].toLocaleString;

// iOS Safari 6.x fails here
var TO_LOCALE_STRING_BUG = !!Int8Array$1 && fails(function () {
  $toLocaleString.call(new Int8Array$1(1));
});

var FORCED$6 = fails(function () {
  return [1, 2].toLocaleString() != new Int8Array$1([1, 2]).toLocaleString();
}) || !fails(function () {
  Int8Array$1.prototype.toLocaleString.call([1, 2]);
});

// `%TypedArray%.prototype.toLocaleString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tolocalestring
exportTypedArrayMethod$1('toLocaleString', function toLocaleString() {
  return functionApply(
    $toLocaleString,
    TO_LOCALE_STRING_BUG ? arraySlice(aTypedArray(this)) : aTypedArray(this),
    arraySlice(arguments)
  );
}, FORCED$6);

var exportTypedArrayMethod = arrayBufferViewCore.exportTypedArrayMethod;




var Uint8Array$1 = global_1.Uint8Array;
var Uint8ArrayPrototype = Uint8Array$1 && Uint8Array$1.prototype || {};
var arrayToString = [].toString;
var join$1 = functionUncurryThis([].join);

if (fails(function () { arrayToString.call({}); })) {
  arrayToString = function toString() {
    return join$1(this);
  };
}

var IS_NOT_ARRAY_METHOD = Uint8ArrayPrototype.toString != arrayToString;

// `%TypedArray%.prototype.toString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tostring
exportTypedArrayMethod('toString', arrayToString, IS_NOT_ARRAY_METHOD);

var ArrayBuffer$2 = arrayBuffer.ArrayBuffer;
var DataView$1 = arrayBuffer.DataView;
var DataViewPrototype = DataView$1.prototype;
var nativeArrayBufferSlice = functionUncurryThisClause(ArrayBuffer$2.prototype.slice);
var getUint8 = functionUncurryThisClause(DataViewPrototype.getUint8);
var setUint8 = functionUncurryThisClause(DataViewPrototype.setUint8);

var INCORRECT_SLICE = fails(function () {
  return !new ArrayBuffer$2(2).slice(1, undefined).byteLength;
});

// `ArrayBuffer.prototype.slice` method
// https://tc39.es/ecma262/#sec-arraybuffer.prototype.slice
_export({ target: 'ArrayBuffer', proto: true, unsafe: true, forced: INCORRECT_SLICE }, {
  slice: function slice(start, end) {
    if (nativeArrayBufferSlice && end === undefined) {
      return nativeArrayBufferSlice(anObject(this), start); // FF fix
    }
    var length = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    var result = new (speciesConstructor(this, ArrayBuffer$2))(toLength(fin - first));
    var viewSource = new DataView$1(this);
    var viewTarget = new DataView$1(result);
    var index = 0;
    while (first < fin) {
      setUint8(viewTarget, index++, getUint8(viewSource, first++));
    } return result;
  }
});

// `Array.prototype.fill` method
// https://tc39.es/ecma262/#sec-array.prototype.fill
_export({ target: 'Array', proto: true }, {
  fill: arrayFill
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('fill');

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
var thisNumberValue = functionUncurryThis(1.0.valueOf);

var nativeToPrecision = functionUncurryThis(1.0.toPrecision);

var FORCED$5 = fails(function () {
  // IE7-
  return nativeToPrecision(1, undefined) !== '1';
}) || !fails(function () {
  // V8 ~ Android 4.3-
  nativeToPrecision({});
});

// `Number.prototype.toPrecision` method
// https://tc39.es/ecma262/#sec-number.prototype.toprecision
_export({ target: 'Number', proto: true, forced: FORCED$5 }, {
  toPrecision: function toPrecision(precision) {
    return precision === undefined
      ? nativeToPrecision(thisNumberValue(this))
      : nativeToPrecision(thisNumberValue(this), precision);
  }
});

var $RangeError$1 = RangeError;

// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
var stringRepeat = function repeat(count) {
  var str = toString_1(requireObjectCoercible(this));
  var result = '';
  var n = toIntegerOrInfinity(count);
  if (n < 0 || n == Infinity) throw $RangeError$1('Wrong number of repetitions');
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};

// `String.prototype.repeat` method
// https://tc39.es/ecma262/#sec-string.prototype.repeat
_export({ target: 'String', proto: true }, {
  repeat: stringRepeat
});

var $RangeError = RangeError;
var $String = String;
var floor$1 = Math.floor;
var repeat = functionUncurryThis(stringRepeat);
var stringSlice$4 = functionUncurryThis(''.slice);
var nativeToFixed = functionUncurryThis(1.0.toFixed);

var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};

var log$1 = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

var multiply = function (data, n, c) {
  var index = -1;
  var c2 = c;
  while (++index < 6) {
    c2 += n * data[index];
    data[index] = c2 % 1e7;
    c2 = floor$1(c2 / 1e7);
  }
};

var divide = function (data, n) {
  var index = 6;
  var c = 0;
  while (--index >= 0) {
    c += data[index];
    data[index] = floor$1(c / n);
    c = (c % n) * 1e7;
  }
};

var dataToString = function (data) {
  var index = 6;
  var s = '';
  while (--index >= 0) {
    if (s !== '' || index === 0 || data[index] !== 0) {
      var t = $String(data[index]);
      s = s === '' ? t : s + repeat('0', 7 - t.length) + t;
    }
  } return s;
};

var FORCED$4 = fails(function () {
  return nativeToFixed(0.00008, 3) !== '0.000' ||
    nativeToFixed(0.9, 0) !== '1' ||
    nativeToFixed(1.255, 2) !== '1.25' ||
    nativeToFixed(1000000000000000128.0, 0) !== '1000000000000000128';
}) || !fails(function () {
  // V8 ~ Android 4.3-
  nativeToFixed({});
});

// `Number.prototype.toFixed` method
// https://tc39.es/ecma262/#sec-number.prototype.tofixed
_export({ target: 'Number', proto: true, forced: FORCED$4 }, {
  toFixed: function toFixed(fractionDigits) {
    var number = thisNumberValue(this);
    var fractDigits = toIntegerOrInfinity(fractionDigits);
    var data = [0, 0, 0, 0, 0, 0];
    var sign = '';
    var result = '0';
    var e, z, j, k;

    // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation
    if (fractDigits < 0 || fractDigits > 20) throw $RangeError('Incorrect fraction digits');
    // eslint-disable-next-line no-self-compare -- NaN check
    if (number != number) return 'NaN';
    if (number <= -1e21 || number >= 1e21) return $String(number);
    if (number < 0) {
      sign = '-';
      number = -number;
    }
    if (number > 1e-21) {
      e = log$1(number * pow(2, 69, 1)) - 69;
      z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(data, 0, z);
        j = fractDigits;
        while (j >= 7) {
          multiply(data, 1e7, 0);
          j -= 7;
        }
        multiply(data, pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(data, 1 << 23);
          j -= 23;
        }
        divide(data, 1 << j);
        multiply(data, 1, 1);
        divide(data, 2);
        result = dataToString(data);
      } else {
        multiply(data, 0, z);
        multiply(data, 1 << -e, 0);
        result = dataToString(data) + repeat('0', fractDigits);
      }
    }
    if (fractDigits > 0) {
      k = result.length;
      result = sign + (k <= fractDigits
        ? '0.' + repeat('0', fractDigits - k) + result
        : stringSlice$4(result, 0, k - fractDigits) + '.' + stringSlice$4(result, k - fractDigits));
    } else {
      result = sign + result;
    } return result;
  }
});

var USDZExporter = /*#__PURE__*/function () {
  function USDZExporter() {
    _classCallCheck(this, USDZExporter);
  }
  _createClass(USDZExporter, [{
    key: "parse",
    value: function () {
      var _parse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(scene) {
        var options,
          files,
          modelFileName,
          output,
          materials,
          textures,
          _loop,
          id,
          offset,
          filename,
          file,
          headerSize,
          offsetMod64,
          padLength,
          padding,
          _args2 = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
              options = Object.assign({
                ar: {
                  anchoring: {
                    type: 'plane'
                  },
                  planeAnchoring: {
                    alignment: 'horizontal'
                  }
                },
                quickLookCompatible: false
              }, options);
              files = {};
              modelFileName = 'model.usda'; // model file should be first in USDZ archive so we init it here
              files[modelFileName] = null;
              output = buildHeader();
              output += buildSceneStart(options);
              materials = {};
              textures = {};
              scene.traverseVisible(function (object) {
                if (object.isMesh) {
                  var geometry = object.geometry;
                  var material = object.material;
                  if (material.isMeshStandardMaterial) {
                    var geometryFileName = 'geometries/Geometry_' + geometry.id + '.usda';
                    if (!(geometryFileName in files)) {
                      var meshObject = buildMeshObject(geometry);
                      files[geometryFileName] = buildUSDFileAsString(meshObject);
                    }
                    if (!(material.uuid in materials)) {
                      materials[material.uuid] = material;
                    }
                    output += buildXform(object, geometry, material);
                  } else {
                    console.warn('THREE.USDZExporter: Unsupported material type (USDZ only supports MeshStandardMaterial)', object);
                  }
                } else if (object.isCamera) {
                  output += buildCamera(object);
                }
              });
              output += buildSceneEnd();
              output += buildMaterials(materials, textures, options.quickLookCompatible);
              files[modelFileName] = fflate.strToU8(output);
              output = null;
              _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
                var texture, canvas, blob;
                return _regeneratorRuntime().wrap(function _loop$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      texture = textures[id];
                      canvas = imageToCanvas(texture.image, texture.flipY);
                      _context.next = 4;
                      return new Promise(function (resolve) {
                        return canvas.toBlob(resolve, 'image/png', 1);
                      });
                    case 4:
                      blob = _context.sent;
                      _context.t0 = Uint8Array;
                      _context.next = 8;
                      return blob.arrayBuffer();
                    case 8:
                      _context.t1 = _context.sent;
                      files["textures/Texture_" + id + ".png"] = new _context.t0(_context.t1);
                    case 10:
                    case "end":
                      return _context.stop();
                  }
                }, _loop);
              });
              _context2.t0 = _regeneratorRuntime().keys(textures);
            case 16:
              if ((_context2.t1 = _context2.t0()).done) {
                _context2.next = 21;
                break;
              }
              id = _context2.t1.value;
              return _context2.delegateYield(_loop(), "t2", 19);
            case 19:
              _context2.next = 16;
              break;
            case 21:
              // 64 byte alignment
              // https://github.com/101arrowz/fflate/issues/39#issuecomment-777263109
              offset = 0;
              for (filename in files) {
                file = files[filename];
                headerSize = 34 + filename.length;
                offset += headerSize;
                offsetMod64 = offset & 63;
                if (offsetMod64 !== 4) {
                  padLength = 64 - offsetMod64;
                  padding = new Uint8Array(padLength);
                  files[filename] = [file, {
                    extra: {
                      12345: padding
                    }
                  }];
                }
                offset = file.length;
              }
              return _context2.abrupt("return", fflate.zipSync(files, {
                level: 0
              }));
            case 24:
            case "end":
              return _context2.stop();
          }
        }, _callee);
      }));
      function parse(_x) {
        return _parse.apply(this, arguments);
      }
      return parse;
    }()
  }]);
  return USDZExporter;
}();
function imageToCanvas(image, flipY) {
  if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof OffscreenCanvas !== 'undefined' && image instanceof OffscreenCanvas || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {
    var scale = 1024 / Math.max(image.width, image.height);
    var canvas = document.createElement('canvas');
    canvas.width = image.width * Math.min(1, scale);
    canvas.height = image.height * Math.min(1, scale);
    var context = canvas.getContext('2d');

    // TODO: We should be able to do this in the UsdTransform2d?

    if (flipY === true) {
      context.translate(0, canvas.height);
      context.scale(1, -1);
    }
    context.drawImage(image, 0, 0, canvas.width, canvas.height);
    return canvas;
  } else {
    throw new Error('THREE.USDZExporter: No valid image data found. Unable to process texture.');
  }
}

//

var PRECISION = 7;
function buildHeader() {
  return "#usda 1.0\n(\n\tcustomLayerData = {\n\t\tstring creator = \"Three.js USDZExporter\"\n\t}\n\tdefaultPrim = \"Root\"\n\tmetersPerUnit = 1\n\tupAxis = \"Y\"\n)\n\n";
}
function buildSceneStart(options) {
  return "def Xform \"Root\"\n{\n\tdef Scope \"Scenes\" (\n\t\tkind = \"sceneLibrary\"\n\t)\n\t{\n\t\tdef Xform \"Scene\" (\n\t\t\tcustomData = {\n\t\t\t\tbool preliminary_collidesWithEnvironment = 0\n\t\t\t\tstring sceneName = \"Scene\"\n\t\t\t}\n\t\t\tsceneName = \"Scene\"\n\t\t)\n\t\t{\n\t\ttoken preliminary:anchoring:type = \"" + options.ar.anchoring.type + "\"\n\t\ttoken preliminary:planeAnchoring:alignment = \"" + options.ar.planeAnchoring.alignment + "\"\n\n";
}
function buildSceneEnd() {
  return "\n\t\t}\n\t}\n}\n\n";
}
function buildUSDFileAsString(dataToInsert) {
  var output = buildHeader();
  output += dataToInsert;
  return fflate.strToU8(output);
}

// Xform

function buildXform(object, geometry, material) {
  var name = 'Object_' + object.id;
  var transform = buildMatrix(object.matrixWorld);
  if (object.matrixWorld.determinant() < 0) {
    console.warn('THREE.USDZExporter: USDZ does not support negative scales', object);
  }
  return "def Xform \"" + name + "\" (\n\tprepend references = @./geometries/Geometry_" + geometry.id + ".usda@</Geometry>\n\tprepend apiSchemas = [\"MaterialBindingAPI\"]\n)\n{\n\tmatrix4d xformOp:transform = " + transform + "\n\tuniform token[] xformOpOrder = [\"xformOp:transform\"]\n\n\trel material:binding = </Materials/Material_" + material.id + ">\n}\n\n";
}
function buildMatrix(matrix) {
  var array = matrix.elements;
  return "( " + buildMatrixRow(array, 0) + ", " + buildMatrixRow(array, 4) + ", " + buildMatrixRow(array, 8) + ", " + buildMatrixRow(array, 12) + " )";
}
function buildMatrixRow(array, offset) {
  return "(" + array[offset + 0] + ", " + array[offset + 1] + ", " + array[offset + 2] + ", " + array[offset + 3] + ")";
}

// Mesh

function buildMeshObject(geometry) {
  var mesh = buildMesh(geometry);
  return "\ndef \"Geometry\"\n{\n" + mesh + "\n}\n";
}
function buildMesh(geometry) {
  var name = 'Geometry';
  var attributes = geometry.attributes;
  var count = attributes.position.count;
  return "\n\tdef Mesh \"" + name + "\"\n\t{\n\t\tint[] faceVertexCounts = [" + buildMeshVertexCount(geometry) + "]\n\t\tint[] faceVertexIndices = [" + buildMeshVertexIndices(geometry) + "]\n\t\tnormal3f[] normals = [" + buildVector3Array(attributes.normal, count) + "] (\n\t\t\tinterpolation = \"vertex\"\n\t\t)\n\t\tpoint3f[] points = [" + buildVector3Array(attributes.position, count) + "]\n" + buildPrimvars(attributes, count) + "\n\t\tuniform token subdivisionScheme = \"none\"\n\t}\n";
}
function buildMeshVertexCount(geometry) {
  var count = geometry.index !== null ? geometry.index.count : geometry.attributes.position.count;
  return Array(count / 3).fill(3).join(', ');
}
function buildMeshVertexIndices(geometry) {
  var index = geometry.index;
  var array = [];
  if (index !== null) {
    for (var i = 0; i < index.count; i++) {
      array.push(index.getX(i));
    }
  } else {
    var length = geometry.attributes.position.count;
    for (var _i2 = 0; _i2 < length; _i2++) {
      array.push(_i2);
    }
  }
  return array.join(', ');
}
function buildVector3Array(attribute, count) {
  if (attribute === undefined) {
    console.warn('USDZExporter: Normals missing.');
    return Array(count).fill('(0, 0, 0)').join(', ');
  }
  var array = [];
  for (var i = 0; i < attribute.count; i++) {
    var x = attribute.getX(i);
    var y = attribute.getY(i);
    var z = attribute.getZ(i);
    array.push("(" + x.toPrecision(PRECISION) + ", " + y.toPrecision(PRECISION) + ", " + z.toPrecision(PRECISION) + ")");
  }
  return array.join(', ');
}
function buildVector2Array(attribute, count) {
  if (attribute === undefined) {
    console.warn('USDZExporter: UVs missing.');
    return Array(count).fill('(0, 0)').join(', ');
  }
  var array = [];
  for (var i = 0; i < attribute.count; i++) {
    var x = attribute.getX(i);
    var y = attribute.getY(i);
    array.push("(" + x.toPrecision(PRECISION) + ", " + (1 - y.toPrecision(PRECISION)) + ")");
  }
  return array.join(', ');
}
function buildPrimvars(attributes, count) {
  var string = '';
  for (var i = 0; i < 4; i++) {
    var id = i > 0 ? i : '';
    var attribute = attributes['uv' + id];
    if (attribute !== undefined) {
      string += "\n\t\ttexCoord2f[] primvars:st" + id + " = [" + buildVector2Array(attribute, count) + "] (\n\t\t\tinterpolation = \"vertex\"\n\t\t)";
    }
  }
  return string;
}

// Materials

function buildMaterials(materials, textures) {
  var quickLookCompatible = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var array = [];
  for (var uuid in materials) {
    var material = materials[uuid];
    array.push(buildMaterial(material, textures, quickLookCompatible));
  }
  return "def \"Materials\"\n{\n" + array.join('') + "\n}\n\n";
}
function buildMaterial(material, textures) {
  var quickLookCompatible = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  // https://graphics.pixar.com/usd/docs/UsdPreviewSurface-Proposal.html

  var pad = '			';
  var inputs = [];
  var samplers = [];
  function buildTexture(texture, mapType, color) {
    var id = texture.source.id + '_' + texture.flipY;
    textures[id] = texture;
    var uv = texture.channel > 0 ? 'st' + texture.channel : 'st';
    var WRAPPINGS = {
      1000: 'repeat',
      // RepeatWrapping
      1001: 'clamp',
      // ClampToEdgeWrapping
      1002: 'mirror' // MirroredRepeatWrapping
    };

    var repeat = texture.repeat.clone();
    var offset = texture.offset.clone();
    var rotation = texture.rotation;

    // rotation is around the wrong point. after rotation we need to shift offset again so that we're rotating around the right spot
    var xRotationOffset = Math.sin(rotation);
    var yRotationOffset = Math.cos(rotation);

    // texture coordinates start in the opposite corner, need to correct
    offset.y = 1 - offset.y - repeat.y;

    // turns out QuickLook is buggy and interprets texture repeat inverted/applies operations in a different order.
    // Apple Feedback: 	FB10036297 and FB11442287
    if (quickLookCompatible) {
      // This is NOT correct yet in QuickLook, but comes close for a range of models.
      // It becomes more incorrect the bigger the offset is

      offset.x = offset.x / repeat.x;
      offset.y = offset.y / repeat.y;
      offset.x += xRotationOffset / repeat.x;
      offset.y += yRotationOffset - 1;
    } else {
      // results match glTF results exactly. verified correct in usdview.
      offset.x += xRotationOffset * repeat.x;
      offset.y += (1 - yRotationOffset) * repeat.y;
    }
    return "\n\t\tdef Shader \"PrimvarReader_" + mapType + "\"\n\t\t{\n\t\t\tuniform token info:id = \"UsdPrimvarReader_float2\"\n\t\t\tfloat2 inputs:fallback = (0.0, 0.0)\n\t\t\ttoken inputs:varname = \"" + uv + "\"\n\t\t\tfloat2 outputs:result\n\t\t}\n\n\t\tdef Shader \"Transform2d_" + mapType + "\"\n\t\t{\n\t\t\tuniform token info:id = \"UsdTransform2d\"\n\t\t\ttoken inputs:in.connect = </Materials/Material_" + material.id + "/PrimvarReader_" + mapType + ".outputs:result>\n\t\t\tfloat inputs:rotation = " + (rotation * (180 / Math.PI)).toFixed(PRECISION) + "\n\t\t\tfloat2 inputs:scale = " + buildVector2(repeat) + "\n\t\t\tfloat2 inputs:translation = " + buildVector2(offset) + "\n\t\t\tfloat2 outputs:result\n\t\t}\n\n\t\tdef Shader \"Texture_" + texture.id + "_" + mapType + "\"\n\t\t{\n\t\t\tuniform token info:id = \"UsdUVTexture\"\n\t\t\tasset inputs:file = @textures/Texture_" + id + ".png@\n\t\t\tfloat2 inputs:st.connect = </Materials/Material_" + material.id + "/Transform2d_" + mapType + ".outputs:result>\n\t\t\t" + (color !== undefined ? 'float4 inputs:scale = ' + buildColor4(color) : '') + "\n\t\t\ttoken inputs:sourceColorSpace = \"" + (texture.colorSpace === THREE.NoColorSpace ? 'raw' : 'sRGB') + "\"\n\t\t\ttoken inputs:wrapS = \"" + WRAPPINGS[texture.wrapS] + "\"\n\t\t\ttoken inputs:wrapT = \"" + WRAPPINGS[texture.wrapT] + "\"\n\t\t\tfloat outputs:r\n\t\t\tfloat outputs:g\n\t\t\tfloat outputs:b\n\t\t\tfloat3 outputs:rgb\n\t\t\t" + (material.transparent || material.alphaTest > 0.0 ? 'float outputs:a' : '') + "\n\t\t}";
  }
  if (material.side === THREE.DoubleSide) {
    console.warn('THREE.USDZExporter: USDZ does not support double sided materials', material);
  }
  if (material.map !== null) {
    inputs.push(pad + "color3f inputs:diffuseColor.connect = </Materials/Material_" + material.id + "/Texture_" + material.map.id + "_diffuse.outputs:rgb>");
    if (material.transparent) {
      inputs.push(pad + "float inputs:opacity.connect = </Materials/Material_" + material.id + "/Texture_" + material.map.id + "_diffuse.outputs:a>");
    } else if (material.alphaTest > 0.0) {
      inputs.push(pad + "float inputs:opacity.connect = </Materials/Material_" + material.id + "/Texture_" + material.map.id + "_diffuse.outputs:a>");
      inputs.push(pad + "float inputs:opacityThreshold = " + material.alphaTest);
    }
    samplers.push(buildTexture(material.map, 'diffuse', material.color));
  } else {
    inputs.push(pad + "color3f inputs:diffuseColor = " + buildColor(material.color));
  }
  if (material.emissiveMap !== null) {
    inputs.push(pad + "color3f inputs:emissiveColor.connect = </Materials/Material_" + material.id + "/Texture_" + material.emissiveMap.id + "_emissive.outputs:rgb>");
    samplers.push(buildTexture(material.emissiveMap, 'emissive'));
  } else if (material.emissive.getHex() > 0) {
    inputs.push(pad + "color3f inputs:emissiveColor = " + buildColor(material.emissive));
  }
  if (material.normalMap !== null) {
    inputs.push(pad + "normal3f inputs:normal.connect = </Materials/Material_" + material.id + "/Texture_" + material.normalMap.id + "_normal.outputs:rgb>");
    samplers.push(buildTexture(material.normalMap, 'normal'));
  }
  if (material.aoMap !== null) {
    inputs.push(pad + "float inputs:occlusion.connect = </Materials/Material_" + material.id + "/Texture_" + material.aoMap.id + "_occlusion.outputs:r>");
    samplers.push(buildTexture(material.aoMap, 'occlusion'));
  }
  if (material.roughnessMap !== null && material.roughness === 1) {
    inputs.push(pad + "float inputs:roughness.connect = </Materials/Material_" + material.id + "/Texture_" + material.roughnessMap.id + "_roughness.outputs:g>");
    samplers.push(buildTexture(material.roughnessMap, 'roughness'));
  } else {
    inputs.push(pad + "float inputs:roughness = " + material.roughness);
  }
  if (material.metalnessMap !== null && material.metalness === 1) {
    inputs.push(pad + "float inputs:metallic.connect = </Materials/Material_" + material.id + "/Texture_" + material.metalnessMap.id + "_metallic.outputs:b>");
    samplers.push(buildTexture(material.metalnessMap, 'metallic'));
  } else {
    inputs.push(pad + "float inputs:metallic = " + material.metalness);
  }
  if (material.alphaMap !== null) {
    inputs.push(pad + "float inputs:opacity.connect = </Materials/Material_" + material.id + "/Texture_" + material.alphaMap.id + "_opacity.outputs:r>");
    inputs.push(pad + "float inputs:opacityThreshold = 0.0001");
    samplers.push(buildTexture(material.alphaMap, 'opacity'));
  } else {
    inputs.push(pad + "float inputs:opacity = " + material.opacity);
  }
  if (material.isMeshPhysicalMaterial) {
    inputs.push(pad + "float inputs:clearcoat = " + material.clearcoat);
    inputs.push(pad + "float inputs:clearcoatRoughness = " + material.clearcoatRoughness);
    inputs.push(pad + "float inputs:ior = " + material.ior);
  }
  return "\n\tdef Material \"Material_" + material.id + "\"\n\t{\n\t\tdef Shader \"PreviewSurface\"\n\t\t{\n\t\t\tuniform token info:id = \"UsdPreviewSurface\"\n" + inputs.join('\n') + "\n\t\t\tint inputs:useSpecularWorkflow = 0\n\t\t\ttoken outputs:surface\n\t\t}\n\n\t\ttoken outputs:surface.connect = </Materials/Material_" + material.id + "/PreviewSurface.outputs:surface>\n\n" + samplers.join('\n') + "\n\n\t}\n";
}
function buildColor(color) {
  return "(" + color.r + ", " + color.g + ", " + color.b + ")";
}
function buildColor4(color) {
  return "(" + color.r + ", " + color.g + ", " + color.b + ", 1.0)";
}
function buildVector2(vector) {
  return "(" + vector.x + ", " + vector.y + ")";
}
function buildCamera(camera) {
  var name = camera.name ? camera.name : 'Camera_' + camera.id;
  var transform = buildMatrix(camera.matrixWorld);
  if (camera.matrixWorld.determinant() < 0) {
    console.warn('THREE.USDZExporter: USDZ does not support negative scales', camera);
  }
  if (camera.isOrthographicCamera) {
    return "def Camera \"" + name + "\"\n\t\t{\n\t\t\tmatrix4d xformOp:transform = " + transform + "\n\t\t\tuniform token[] xformOpOrder = [\"xformOp:transform\"]\n\n\t\t\tfloat2 clippingRange = (" + camera.near.toPrecision(PRECISION) + ", " + camera.far.toPrecision(PRECISION) + ")\n\t\t\tfloat horizontalAperture = " + ((Math.abs(camera.left) + Math.abs(camera.right)) * 10).toPrecision(PRECISION) + "\n\t\t\tfloat verticalAperture = " + ((Math.abs(camera.top) + Math.abs(camera.bottom)) * 10).toPrecision(PRECISION) + "\n\t\t\ttoken projection = \"orthographic\"\n\t\t}\n\t\n\t";
  } else {
    return "def Camera \"" + name + "\"\n\t\t{\n\t\t\tmatrix4d xformOp:transform = " + transform + "\n\t\t\tuniform token[] xformOpOrder = [\"xformOp:transform\"]\n\n\t\t\tfloat2 clippingRange = (" + camera.near.toPrecision(PRECISION) + ", " + camera.far.toPrecision(PRECISION) + ")\n\t\t\tfloat focalLength = " + camera.getFocalLength().toPrecision(PRECISION) + "\n\t\t\tfloat focusDistance = " + camera.focus.toPrecision(PRECISION) + "\n\t\t\tfloat horizontalAperture = " + camera.getFilmWidth().toPrecision(PRECISION) + "\n\t\t\ttoken projection = \"perspective\"\n\t\t\tfloat verticalAperture = " + camera.getFilmHeight().toPrecision(PRECISION) + "\n\t\t}\n\t\n\t";
  }
}

var utilsScene = function utilsScene() {
  var appState = useBoundStore(function (state) {
    return state;
  });
  var changeCameraProps = function changeCameraProps(camera, returnToDefault) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve) {
              var _a, _b;
              if (!appState.cameraControls) return;
              if (!((_a = camera === null || camera === void 0 ? void 0 : camera.target) === null || _a === void 0 ? void 0 : _a.position)) return;
              appState.setDynamicCamera({
                position: camera.position,
                target: camera.target.position,
                returnToDefault: returnToDefault
              });
              var _camera$position = camera.position,
                posX = _camera$position.x,
                posY = _camera$position.y,
                posZ = _camera$position.z;
              var _camera$target$positi = camera.target.position,
                tarX = _camera$target$positi.x,
                tarY = _camera$target$positi.y,
                tarZ = _camera$target$positi.z;
              (_b = appState.cameraControls) === null || _b === void 0 ? void 0 : _b.setLookAt(posX, posY, posZ, tarX, tarY, tarZ, true).then(function () {
                appState.setActiveCamera(camera);
                resolve(true);
              });
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  };
  var updatePostProcessing = function updatePostProcessing(name, options) {
    var _a, _b, _c;
    if (POST_PROCESSING_NAME[name.toUpperCase()] && !options) {
      appState.changePostProcessing({
        name: name,
        effect: POST_PROCESSING_NAME[name.toUpperCase()]
      });
      return;
    }
    if (!options) return;
    var updatedEffect = ((_b = (_a = appState.postProcessing) === null || _a === void 0 ? void 0 : _a.effect) === null || _b === void 0 ? void 0 : _b.name) ? (_c = appState.postProcessing) === null || _c === void 0 ? void 0 : _c.effect : POST_PROCESSING_NAME[name.toUpperCase()];
    appState.changePostProcessing({
      name: name,
      effect: Object.assign(Object.assign({}, updatedEffect), options)
    });
  };
  var startARSession = function startARSession() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var _appState$threeState$;
      var objectToAddAfterSession, sceneForAR, flipBufferGeometryNormalsIndexed, traverseSceneForIOS, traverseSceneForAndroid, platformIsIos, createLinkAndClick, exportUSDZ;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            traverseSceneForAndroid = function _traverseSceneForAndr(object) {
              var _a;
              if (((_a = object.userData) === null || _a === void 0 ? void 0 : _a.visibleInAR) === false) {
                object.visible = false;
              }
            };
            traverseSceneForIOS = function _traverseSceneForIOS(object) {
              var _a;
              if (((_a = object.userData) === null || _a === void 0 ? void 0 : _a.visibleInAR) === false) {
                object.visible = false;
              }
              var scale = object.scale.clone();
              if (scale.x < 0 || scale.y < 0 || scale.z < 0) {
                if (object instanceof THREE.Object3D) {
                  object.traverse(function (child) {
                    if (child instanceof THREE.Mesh) {
                      child.visible = false;
                      var geometryWithFlippedNormals = flipBufferGeometryNormalsIndexed(child.geometry.clone());
                      child.updateMatrixWorld();
                      var newMesh = new THREE.Mesh(geometryWithFlippedNormals, child.material);
                      newMesh.applyMatrix4(child.matrixWorld);
                      newMesh.updateMatrixWorld();
                      sceneForAR && sceneForAR.add(newMesh);
                      return;
                    }
                  });
                }
              }
            };
            flipBufferGeometryNormalsIndexed = function _flipBufferGeometryNo(geometry) {
              var index = geometry.index.array;
              for (var i = 0, il = index.length / 3; i < il; i++) {
                var x = index[i * 3];
                index[i * 3] = index[i * 3 + 2];
                index[i * 3 + 2] = x;
              }
              geometry.index.needsUpdate = true;
              return geometry;
            };
            objectToAddAfterSession = [];
            appState.threeState && appState.threeState.scene.traverse(function (object) {
              if (object instanceof GroundProjectedEnv) {
                objectToAddAfterSession.push(object);
                appState.threeState && appState.threeState.scene.remove(object);
              }
            });
            sceneForAR = appState.threeState && appState.threeState.scene.clone();
            appState.threeState && (_appState$threeState$ = appState.threeState.scene).add.apply(_appState$threeState$, objectToAddAfterSession);
            if (sceneForAR) {
              _context3.next = 9;
              break;
            }
            return _context3.abrupt("return");
          case 9:
            platformIsIos = iOSCheck();
            if (!platformIsIos) {
              _context3.next = 18;
              break;
            }
            sceneForAR.traverse(traverseSceneForIOS);
            createLinkAndClick = function createLinkAndClick(url) {
              var link = document.createElement('a');
              link.href = url;
              link.download = 'asset.usdz';
              link.rel = 'ar';
              var img = document.createElement('img');
              img.src = HOTSPOT_URL;
              img.alt = 'arIcon';
              link.appendChild(img);
              link.click();
            };
            exportUSDZ = function exportUSDZ(mesh) {
              return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
                var exporter, arraybuffer, blob;
                return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      exporter = new USDZExporter();
                      _context2.next = 3;
                      return exporter.parse(mesh);
                    case 3:
                      arraybuffer = _context2.sent;
                      blob = new Blob([arraybuffer], {
                        type: 'application/octet-stream'
                      });
                      createLinkAndClick(URL.createObjectURL(blob));
                    case 6:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              }));
            };
            _context3.next = 16;
            return exportUSDZ(sceneForAR);
          case 16:
            _context3.next = 24;
            break;
          case 18:
            sceneForAR.traverse(traverseSceneForAndroid);
            if (appState.androidARController) {
              _context3.next = 21;
              break;
            }
            return _context3.abrupt("return");
          case 21:
            appState.androidARController.setModel(sceneForAR);
            appState.androidARController.showCanvas();
            appState.androidARController.clickButton();
          case 24:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
  };
  var getCameraPosition = function getCameraPosition() {
    var _a;
    if (!((_a = appState.threeState) === null || _a === void 0 ? void 0 : _a.camera)) return new THREE.Vector3(0, 1, 7);
    var cameraRotate = getCamera().position.clone();
    return new THREE.Vector3(cameraRotate.x, cameraRotate.y, cameraRotate.z);
  };
  var changeMode = function changeMode(mode) {
    unselect();
    appState.setMode(mode);
  };
  var deleteModelPart = function deleteModelPart(id) {
    var deletePartInConfig = function deletePartInConfig(config) {
      if (config) {
        unselect();
        var currentNode = config.objects.find(function (item) {
          return item.userData.id === id;
        });
        var currentCustomNode = config.customObjects.find(function (item) {
          return item.userData.id === id;
        });
        var currentAnnotation = config.annotations.find(function (item) {
          return item.userData.id === id;
        });
        if (currentNode) {
          var another = config.objects.filter(function (item) {
            return item.userData.id !== id;
          });
          appState.updateDeletedObjects(currentNode);
          return Object.assign(Object.assign({}, config), {
            objects: another
          });
        }
        if (currentCustomNode) {
          var _another = config.customObjects.filter(function (item) {
            return item.userData.id !== id;
          });
          appState.updateDeletedObjects(currentCustomNode);
          return Object.assign(Object.assign({}, config), {
            customObjects: _another
          });
        }
        if (currentAnnotation) {
          var _another2 = config.annotations.filter(function (item) {
            return item.userData.id !== id;
          });
          appState.updateDeletedObjects(currentAnnotation);
          return Object.assign(Object.assign({}, config), {
            annotations: _another2
          });
        }
      }
    };
    var updated = deletePartInConfig(appState.config);
    if (updated) appState.setModelConfig(updated);
    if (!updated && !appState.uploadedModelsConfig.length) return;
    appState.uploadedModelsConfig.forEach(function (config) {
      var anotherConfig = appState.uploadedModelsConfig.filter(function (i) {
        return i.id !== config.id;
      });
      var updatedConfig = deletePartInConfig(config);
      if (!updatedConfig) return;
      appState.setUploadedModelsConfig([].concat(_toConsumableArray(anotherConfig), [Object.assign(Object.assign({}, config), updatedConfig)]));
    });
  };
  var setActiveByName = function setActiveByName(name) {
    if (appState.threeState) {
      appState.threeState.scene.traverse(function (item) {
        if (item.name === name) {
          appState.setActiveMesh(item);
        }
      });
    }
  };
  var setActiveById = function setActiveById(id) {
    if (appState.threeState) {
      appState.threeState.scene.traverse(function (item) {
        if (item.userData.id === id) {
          appState.setActiveMesh(item);
        }
      });
    }
  };
  var unselect = function unselect() {
    if (appState.activeMesh) {
      appState.setActiveMesh(null);
    }
  };
  var setActiveByHandle = function setActiveByHandle(mesh) {
    appState.setActiveMesh(mesh);
  };
  var getMeshById = function getMeshById(id) {
    var _a;
    if (!id) return;
    var res = undefined;
    if ((_a = appState === null || appState === void 0 ? void 0 : appState.threeState) === null || _a === void 0 ? void 0 : _a.scene) {
      appState.threeState.scene.traverse(function (item) {
        if (item.userData.id === id) {
          res = item;
        }
      });
      return res;
    }
    return res;
  };
  var getMeshByName = function getMeshByName(name) {
    var _a, _b;
    var res = null;
    var validName = function validName(name) {
      return name.split('.').join('');
    };
    if ((_a = appState === null || appState === void 0 ? void 0 : appState.threeState) === null || _a === void 0 ? void 0 : _a.scene) {
      (_b = appState === null || appState === void 0 ? void 0 : appState.threeState) === null || _b === void 0 ? void 0 : _b.scene.traverse(function (item) {
        if (validName(item.name) === validName(name)) {
          res = item;
        }
      });
      return res;
    }
    return res;
  };
  var getCamera = function getCamera() {
    var _a;
    return (_a = appState.controls) === null || _a === void 0 ? void 0 : _a.object;
  };
  var getDefaultCamera = function getDefaultCamera() {
    return _.find(appState.config.customObjects, {
      type: 'Default_Camera'
    });
  };
  return {
    changeCameraProps: changeCameraProps,
    setActiveByName: setActiveByName,
    setActiveById: setActiveById,
    setActiveByHandle: setActiveByHandle,
    getMeshById: getMeshById,
    getMeshByName: getMeshByName,
    getCamera: getCamera,
    deleteModelPart: deleteModelPart,
    changeMode: changeMode,
    unselect: unselect,
    getCameraPosition: getCameraPosition,
    getDefaultCamera: getDefaultCamera,
    startARSession: startARSession,
    updatePostProcessing: updatePostProcessing
  };
};

var $some = arrayIteration.some;


var STRICT_METHOD$1 = arrayMethodIsStrict('some');

// `Array.prototype.some` method
// https://tc39.es/ecma262/#sec-array.prototype.some
_export({ target: 'Array', proto: true, forced: !STRICT_METHOD$1 }, {
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var utilsConfig = function utilsConfig() {
  var appState = useBoundStore.getState();
  var mergeModelConfigs = function mergeModelConfigs(config) {
    if (!appState) return;
    appState.setModelConfig(Object.assign({}, appState.config));
  };
  var updatePreview = function updatePreview(preview) {
    if (!appState) return;
    appState.setPreviewScene([].concat(_toConsumableArray(appState.previewScene), [preview]));
  };
  var resetModel = function resetModel() {
    var oldAsset = appState.defaultModel;
    if (!oldAsset) return;
    var resetAsset = Object.assign(Object.assign({}, oldAsset), {
      patch: {
        scene: oldAsset.patch.scene,
        config: {
          objects: [],
          deletedObjects: [],
          customObjects: []
        }
      }
    });
    updateInnerConfig().then(function () {
      appState.setModelConfig(Object.assign(Object.assign({}, appState.config), {
        objects: appState.config.defaultObjects,
        annotations: [],
        customObjects: appState.config.customObjects.filter(function (i) {
          return i.type === AMAMeshType.Default_Camera;
        })
      }));
      appState.setUploadedModelsConfig([]);
    });
    return {
      annotations: appState.config.annotations,
      model: resetAsset
    };
  };
  function updateNode(configNode, sceneNode, updatedArr) {
    var removeGeometry = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var check = function check(node) {
      var isFinal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _a, _b, _c;
      return {
        position: node.position.toArray(),
        scale: node.scale.toArray(),
        rotation: node.rotation.toArray(),
        name: node.name,
        visible: node.visible,
        castShadow: node.castShadow,
        receiveShadow: node.receiveShadow,
        material: isFinal ? (_a = node === null || node === void 0 ? void 0 : node.material) === null || _a === void 0 ? void 0 : _a.userData : (_c = (_b = node === null || node === void 0 ? void 0 : node.material) === null || _b === void 0 ? void 0 : _b.userData) === null || _c === void 0 ? void 0 : _c.id,
        userData: Object.assign(Object.assign({}, node.userData), {
          visibleInAR: node.userData.visibleInAR
        })
      };
    };
    if (sceneNode instanceof THREE.Bone) {
      return;
    }
    var _final = Object.assign(Object.assign(Object.assign({}, configNode), check(sceneNode, true)), removeGeometry && {
      geometry: undefined
    });
    var checkedObj = check(sceneNode);
    var currentObj = check(configNode);
    if ('custom' in _final) {
      updatedArr.push(_final);
      return;
    }
    if (!_.isEqual(currentObj, checkedObj)) {
      updatedArr.push(_final);
    }
  }
  var update = function update() {
    var removeGeometry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var updatedItems = [];
    var updatedAnnotations = [];
    var updatedCustomNodes = [];
    if (!appState.threeState) return;
    window.three.scene.traverse(function (item) {
      var next = _.find(appState.defaultConfig.objects, function (value) {
        return value.userData.id === item.userData.id;
      });
      var updatedAnnotation = _.find(appState.config.annotations, function (value) {
        var _a;
        return ((_a = value === null || value === void 0 ? void 0 : value.userData) === null || _a === void 0 ? void 0 : _a.id) && value.userData.id === item.userData.id;
      });
      var updatedCustom = appState.config.customObjects.find(function (value) {
        var _a;
        return ((_a = value === null || value === void 0 ? void 0 : value.userData) === null || _a === void 0 ? void 0 : _a.id) && value.userData.id === item.userData.id;
      });
      if (updatedAnnotation) {
        var _final2 = Object.assign(Object.assign({}, updatedAnnotation), {
          position: JSON.stringify(item.position.toArray())
        });
        updatedAnnotations.push(_final2);
      }
      if (updatedCustom) {
        updateNode(updatedCustom, item, updatedCustomNodes, removeGeometry);
      }
      if (next) {
        updateNode(next, item, updatedItems, removeGeometry);
      }
    });
    return {
      id: appState.config.id,
      updatedItems: updatedItems,
      updatedAnnotations: updatedAnnotations,
      updatedCustomNodes: updatedCustomNodes
    };
  };
  var updateUploadedModels = function updateUploadedModels() {
    var updatedItems = [];
    var updatedAnnotations = [];
    var updatedCustomNodes = [];
    var updatedConfigs = [];
    if (!appState.uploadedModelsConfig.length) return [];
    appState.uploadedModelsConfig.forEach(function (config) {
      var _a;
      if (!appState.threeState) return;
      var finalConfig = {
        id: config.id,
        modelId: (_a = config === null || config === void 0 ? void 0 : config.additionalOptions) === null || _a === void 0 ? void 0 : _a.modelId,
        updatedItems: [],
        updatedCustomNodes: [],
        updatedAnnotations: []
      };
      updatedItems = [];
      updatedCustomNodes = [];
      updatedAnnotations = [];
      appState.threeState.scene.traverse(function (item) {
        var next = _.find(config.objects, function (value) {
          return value.userData.id === item.userData.id;
        });
        var updatedAnnotation = _.find(config.annotations, function (value) {
          return value.userData.id === item.userData.id;
        });
        var defaultAnnotation = _.find(config.annotations, function (value) {
          return value.userData.id === item.userData.id;
        });
        var updatedCustom = _.find(config.customObjects, function (value) {
          return value.userData.id === item.userData.id;
        });
        if (updatedAnnotation) {
          var _final3 = Object.assign(Object.assign({}, updatedAnnotation), {
            position: JSON.stringify(item.position.toArray())
          });
          if (!updatedAnnotation.position.equals(item.position)) {
            updatedAnnotations.push(_final3);
            return;
          }
          if (updatedAnnotation.value !== (defaultAnnotation === null || defaultAnnotation === void 0 ? void 0 : defaultAnnotation.value)) {
            updatedAnnotations.push(_final3);
            return;
          }
        }
        if (updatedCustom) {
          updateNode(updatedCustom, item, updatedCustomNodes, true);
        }
        if (next) {
          updateNode(next, item, updatedItems, true);
        }
      });
      finalConfig.updatedItems = updatedItems;
      finalConfig.updatedCustomNodes = updatedCustomNodes;
      updatedConfigs.push(finalConfig);
    });
    return updatedConfigs;
  };
  var updateInnerConfig = function updateInnerConfig() {
    return new Promise(function (resolve, reject) {
      var config = update(false);
      var newUpdated = [];
      var newCustom = [];
      var newAnnotations = [];
      if (!config) {
        reject();
        return;
      }
      config.updatedItems.forEach(function (item) {
        var current = Object.assign(Object.assign({}, item), {
          position: new THREE.Vector3().fromArray(item.position),
          scale: new THREE.Vector3().fromArray(item.scale),
          rotation: new THREE.Euler().fromArray(item.rotation)
        });
        var _final4 = ObjectSceneFactory.getObject(item.type, current);
        newUpdated.push(_final4);
      });
      config.updatedCustomNodes.forEach(function (item) {
        var current = Object.assign(Object.assign({}, item), {
          position: new THREE.Vector3().fromArray(item.position),
          scale: new THREE.Vector3().fromArray(item.scale),
          rotation: new THREE.Euler().fromArray(item.rotation)
        });
        var _final5 = ObjectSceneFactory.getObject(item.type, current);
        newCustom.push(_final5);
      });
      config.updatedAnnotations.forEach(function (item) {
        new AnnotationAMA(item);
      });
      var defaultObjects = _.filter(appState.config.objects, function (item) {
        var current = _.find(newUpdated, function (value) {
          return value.userData.id === item.userData.id;
        });
        if (!current) return true;
      });
      var defaultCustom = _.filter(appState.config.customObjects, function (item) {
        var current = _.find(newCustom, function (value) {
          return value.userData.id === item.userData.id;
        });
        if (!current) return true;
      });
      var defaultAnnotations = _.filter(appState.config.annotations, function (item) {
        var current = _.find(newAnnotations, function (value) {
          return value.userData.id === item.userData.id;
        });
        if (!current) return true;
      });
      appState.setModelConfig(Object.assign(Object.assign({}, appState.config), {
        objects: [].concat(_toConsumableArray(defaultObjects), newUpdated),
        customObjects: [].concat(_toConsumableArray(defaultCustom), newCustom),
        annotations: [].concat(_toConsumableArray(defaultAnnotations), newAnnotations)
      }));
      setTimeout(function () {
        resolve(true);
      }, 500);
    });
  };
  var updateConfig = function updateConfig() {
    var _a, _b, _c;
    var updatedConfig = update();
    var updatedUploadedModesConfig = updateUploadedModels();
    console.log(updatedConfig);
    console.log(updatedUploadedModesConfig);
    if (!updatedConfig) return;
    var modelAsset = appState.defaultModel;
    if (!modelAsset) return;
    var modelAssetsNodes = (_a = modelAsset.patch.config) === null || _a === void 0 ? void 0 : _a.objects;
    var modelAssetsDeletedNodes = (_b = modelAsset.patch.config) === null || _b === void 0 ? void 0 : _b.deletedObjects;
    var uploadedModesConfig = ((_c = modelAsset.patch.config) === null || _c === void 0 ? void 0 : _c.uploadedModelsConfig) || [];
    var deleted = appState.deletedObjects.map(function (item) {
      return {
        id: item.id,
        dbId: item.dbId,
        userData: item.userData,
        type: item.type
      };
    });
    var mutationPatchData = function mutationPatchData(patchObj, updatedArr) {
      var _final7 = _toConsumableArray(patchObj);
      var newUpdated = _toConsumableArray(updatedArr);
      _final7.forEach(function (item, inx) {
        if (item) {
          var updated = _.find(newUpdated, {
            id: item.id
          });
          if (updated) {
            _final7[inx] = updated;
            newUpdated = newUpdated.filter(function (el) {
              return el.id !== updated.id;
            });
          }
        }
      });
      return [].concat(_toConsumableArray(_final7), _toConsumableArray(newUpdated));
    };
    var mutationModelPatchData = function mutationModelPatchData(patchObj, updatedArr) {
      var _final8 = structuredClone(patchObj);
      var newUpdated = structuredClone(updatedArr);
      _final8.forEach(function (config) {
        var updated = _.find(newUpdated, {
          modelId: config.modelId
        });
        if (updated) {
          config.updatedItems = mutationPatchData(config.updatedItems, updated.updatedItems);
          config.updatedCustomNodes = mutationPatchData(config.updatedCustomNodes, updated.updatedCustomNodes);
          newUpdated = newUpdated.filter(function (el) {
            return el.modelId !== updated.modelId;
          });
        }
      });
      return [].concat(_toConsumableArray(_final8), _toConsumableArray(newUpdated));
    };
    var newObjects = (modelAssetsNodes === null || modelAssetsNodes === void 0 ? void 0 : modelAssetsNodes.length) ? mutationPatchData(modelAssetsNodes, updatedConfig.updatedItems) : updatedConfig.updatedItems;
    var updateDeletedObjects = (modelAssetsDeletedNodes === null || modelAssetsDeletedNodes === void 0 ? void 0 : modelAssetsDeletedNodes.length) ? mutationPatchData(modelAssetsDeletedNodes, deleted) : deleted;
    var updateModels = (uploadedModesConfig === null || uploadedModesConfig === void 0 ? void 0 : uploadedModesConfig.length) ? mutationModelPatchData(uploadedModesConfig, updatedUploadedModesConfig) : updatedUploadedModesConfig;
    console.log(updateModels);
    var res = Object.assign(Object.assign({}, modelAsset), {
      patch: {
        scene: modelAsset.patch.scene,
        config: {
          objects: newObjects,
          deletedObjects: updateDeletedObjects,
          customObjects: updatedConfig.updatedCustomNodes,
          uploadedModelsConfig: updateModels
        }
      }
    });
    console.log(res);
    return {
      model: res,
      annotations: updatedConfig.updatedAnnotations
    };
  };
  var getConfigItem = function getConfigItem(sceneNode, config) {
    if (appState) {
      var currentNode = config.objects.find(function (item) {
        return item.userData.id === sceneNode.userData.id;
      });
      var currentCustomNode = config.customObjects.find(function (item) {
        return item.userData.id === sceneNode.userData.id;
      });
      if (currentNode) return currentNode;
      if (currentCustomNode) return currentCustomNode;
    }
  };
  var getCurrentConfigObj = function getCurrentConfigObj(sceneNode) {
    if (!appState) return;
    var _final9 = getConfigItem(sceneNode, appState.config);
    if (!_final9 && appState.uploadedModelsConfig.length) {
      for (var i = 0; i < appState.uploadedModelsConfig.length; i++) {
        var config = appState.uploadedModelsConfig[i];
        _final9 = getConfigItem(sceneNode, config);
        if (_final9) break;
      }
    }
    return _final9;
  };
  var updateObjectData = function updateObjectData(obj, newData) {
    var areValuesInArray = function areValuesInArray(arr1, arr2) {
      return arr1.some(function (item) {
        return arr2.includes(item);
      });
    };
    if (!appState) return;
    var updatedConfig = getUpdatedObjectConfig(obj, newData, appState.getCurrent().config);
    if (!updatedConfig && appState.getCurrent().uploadedModelsConfig.length) {
      var _loop = function _loop() {
        var config = appState.getCurrent().uploadedModelsConfig[i];
        updatedConfig = getUpdatedObjectConfig(obj, newData, config);
        if (updatedConfig) {
          var _final10 = Object.assign(Object.assign({}, config), updatedConfig);
          var otherConfigs = appState.getCurrent().uploadedModelsConfig.filter(function (i) {
            return i.id !== _final10.id;
          });
          appState.setUploadedModelsConfig([].concat(_toConsumableArray(otherConfigs), [_final10]));
          return "break";
        }
      };
      for (var i = 0; i <= appState.getCurrent().uploadedModelsConfig.length; i++) {
        var _ret = _loop();
        if (_ret === "break") break;
      }
    } else {
      appState.setModelConfig(Object.assign(Object.assign({}, appState.getCurrent().config), updatedConfig));
    }
    if (!areValuesInArray(Object.keys(newData), PROPS_TO_UPDATE_TREE)) return;
    appState.runUpdateTree({});
  };
  var updateObjectsData = function updateObjectsData(objects, newData) {
    if (!appState) return;
    var areValuesInArray = function areValuesInArray(arr1, arr2) {
      return arr1.some(function (item) {
        return arr2.includes(item);
      });
    };
    var updatedConfigs = getUpdatedObjectsConfigs(objects, newData, appState.config);
    appState.setModelConfig(Object.assign(Object.assign({}, appState.config), updatedConfigs));
    if (!areValuesInArray(Object.keys(newData), PROPS_TO_UPDATE_TREE)) return;
    appState.runUpdateTree({});
  };
  function getUpdatedObjectConfig(obj, newData, config) {
    if (!appState) return;
    var currentNode = config.objects.find(function (item) {
      return item.userData.id === obj.userData.id;
    });
    var currentCustomNode = config.customObjects.find(function (item) {
      return item.userData.id === obj.userData.id;
    });
    var currentAnnotation = config.annotations.find(function (item) {
      return item.userData.id === obj.userData.id;
    });
    if (currentNode) {
      var another = config.objects.filter(function (item) {
        return item.userData.id !== obj.userData.id;
      });
      var _final11 = Object.assign(Object.assign({}, currentNode), newData);
      return {
        objects: [].concat(_toConsumableArray(another), [_final11])
      };
    }
    if (currentCustomNode) {
      var _another = config.customObjects.filter(function (item) {
        return item.userData.id !== obj.userData.id;
      });
      var _final12 = Object.assign(Object.assign({}, currentCustomNode), newData);
      return {
        customObjects: [].concat(_toConsumableArray(_another), [_final12])
      };
    }
    if (currentAnnotation) {
      var _another2 = config.annotations.filter(function (item) {
        return item.userData.id !== obj.userData.id;
      });
      var _final13 = Object.assign(Object.assign({}, currentAnnotation), newData);
      return {
        annotations: [].concat(_toConsumableArray(_another2), [_final13])
      };
    }
  }
  var getUpdatedObjectsConfigs = function getUpdatedObjectsConfigs(objects, newData, config) {
    if (!appState) return;
    var result = {};
    var currentNodes = config.objects.filter(function (item) {
      return objects.filter(function (object) {
        return object.userData.id === item.userData.id;
      }).length;
    });
    var currentCustomNodes = config.customObjects.filter(function (item) {
      return objects.filter(function (object) {
        return object.userData.id === item.userData.id;
      }).length;
    });
    var currentAnnotations = config.annotations.filter(function (item) {
      return objects.filter(function (object) {
        return object.userData.id === item.userData.id;
      }).length;
    });
    if (currentNodes.length) {
      var anotherNodes = config.objects.filter(function (item) {
        return !objects.find(function (object) {
          return object.userData.id === item.userData.id;
        });
      });
      var updatedNodes = currentNodes.map(function (node) {
        return Object.assign(Object.assign({}, node), newData);
      });
      result['objects'] = [].concat(_toConsumableArray(anotherNodes), _toConsumableArray(updatedNodes));
    }
    if (currentCustomNodes.length) {
      var anotherCustomNodes = config.customObjects.filter(function (item) {
        return !objects.find(function (object) {
          return object.userData.id === item.userData.id;
        });
      });
      var updatedCustomNodes = currentCustomNodes.map(function (node) {
        return Object.assign(Object.assign({}, node), newData);
      });
      result['customObjects'] = [].concat(_toConsumableArray(anotherCustomNodes), _toConsumableArray(updatedCustomNodes));
    }
    if (currentAnnotations.length) {
      var anotherAnnotations = config.annotations.filter(function (item) {
        return !objects.find(function (object) {
          return object.userData.id === item.userData.id;
        });
      });
      var updatedAnnotations = currentAnnotations.map(function (node) {
        return Object.assign(Object.assign({}, node), newData);
      });
      result['annotations'] = [].concat(_toConsumableArray(anotherAnnotations), _toConsumableArray(updatedAnnotations));
    }
    return result;
  };
  var updateUploadedModelData = function updateUploadedModelData(obj, newData) {
    if (!appState.uploadedModelsConfig.length) return;
    appState.uploadedModelsConfig.forEach(function (config) {
      var anotherConfig = appState.uploadedModelsConfig.filter(function (i) {
        return i.id !== config.id;
      });
      var updatedConfig = getUpdatedObjectConfig(obj, newData, config);
      if (!updatedConfig) return;
      appState.setUploadedModelsConfig([].concat(_toConsumableArray(anotherConfig), [Object.assign(Object.assign({}, config), updatedConfig)]));
    });
  };
  return {
    updatePreview: updatePreview,
    getCurrentConfigObj: getCurrentConfigObj,
    updateObjectData: updateObjectData,
    updateObjectsData: updateObjectsData,
    updateConfig: updateConfig,
    resetModel: resetModel,
    updateInnerConfig: updateInnerConfig,
    mergeModelConfigs: mergeModelConfigs,
    updateUploadedModelData: updateUploadedModelData
  };
};

var utilsLogic = function utilsLogic() {
  var appState = useBoundStore(function (state) {
    return state;
  });
  var updateRuleConfig = function updateRuleConfig(ruleData) {
    if (!appState) return;
    if (appState.config.rules) {
      var otherRules = appState.config.rules.filter(function (item) {
        return item.id !== ruleData.id;
      });
      appState.setModelConfig(Object.assign(Object.assign({}, appState.config), {
        rules: [].concat(_toConsumableArray(otherRules), [ruleData])
      }));
    }
  };
  var createRuleConfig = function createRuleConfig(ruleData) {
    if (!appState) return;
    if (appState.config.rules) {
      appState.setModelConfig(Object.assign(Object.assign({}, appState.config), {
        rules: [].concat(_toConsumableArray(appState.config.rules), [ruleData])
      }));
    }
  };
  var deleteRuleConfig = function deleteRuleConfig(id) {
    if (!appState) return;
    if (appState.config.rules) {
      var otherRules = appState.config.rules.filter(function (item) {
        return item.id !== id;
      });
      appState.setModelConfig(Object.assign(Object.assign({}, appState.config), {
        rules: otherRules
      }));
    }
  };
  return {
    updateRuleConfig: updateRuleConfig,
    deleteRuleConfig: deleteRuleConfig,
    createRuleConfig: createRuleConfig
  };
};

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  // eslint-disable-next-line es/no-array-from -- required for testing
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
_export({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: arrayFrom
});

var utilsAnimations = function utilsAnimations() {
  var state = useBoundStore.getState();
  var playAnimation = function playAnimation(animName) {
    var animation = getAnimation(animName);
    if (!animName || !animation) return;
    animation.play();
  };
  var getAnimation = function getAnimation(animName) {
    if (!animName) return;
    return state.animations.get(animName);
  };
  var getCurrentAnimation = function getCurrentAnimation() {
    var current = undefined;
    var list = animationList();
    list.forEach(function (name) {
      var animation = getAnimation(name);
      if (animation && (animation === null || animation === void 0 ? void 0 : animation.playClick)) {
        current = animation;
      }
    });
    return current;
  };
  var stopAllAnimations = function stopAllAnimations() {
    var list = animationList();
    list.forEach(function (name) {
      var animation = getAnimation(name);
      if (animation && (animation === null || animation === void 0 ? void 0 : animation.playClick)) {
        animation.stop();
      }
    });
  };
  var playAllAnimations = function playAllAnimations() {
    var list = animationList();
    list.forEach(function (name) {
      var animation = getAnimation(name);
      if (!animation) return;
      animation === null || animation === void 0 ? void 0 : animation.play();
    });
  };
  var animationList = function animationList() {
    return Array.from(state.animations.keys());
  };
  return {
    getAnimation: getAnimation,
    stopAllAnimations: stopAllAnimations,
    playAllAnimations: playAllAnimations,
    animationList: animationList,
    playAnimation: playAnimation,
    getCurrentAnimation: getCurrentAnimation
  };
};

var utilsEditor = function utilsEditor() {
  var appState = useBoundStore(function (state) {
    return state;
  });
  var scene = utilsScene();
  var config = utilsConfig();
  var logic = utilsLogic();
  var animations = utilsAnimations();
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, scene), config), logic), appState), animations);
};

var AMAControls = function AMAControls(_ref) {
  var pan = _ref.pan;
  var _useBoundStore = useBoundStore(function (state) {
      return [state.controls, state.setControls];
    }),
    _useBoundStore2 = _slicedToArray(_useBoundStore, 2);
    _useBoundStore2[0];
    var setControls = _useBoundStore2[1];
  var _utilsEditor = utilsEditor(),
    activeCamera = _utilsEditor.activeCamera;
    _utilsEditor.config;
    _utilsEditor.setModelConfig;
    var setCameraIsRotate = _utilsEditor.setCameraIsRotate;
    _utilsEditor.setActiveCamera;
    var mode = _utilsEditor.mode;
    _utilsEditor.getCurrent;
    var updateObjectData = _utilsEditor.updateObjectData,
    getCurrentConfigObj = _utilsEditor.getCurrentConfigObj;
  var changeHandler = function changeHandler(e) {
    var _a, _b, _c;
    if (mode === AMAMode.VIEWER) return;
    setCameraIsRotate(false);
    var current = getCurrentConfigObj(activeCamera);
    if (!isCamera(current)) return;
    if (!(e === null || e === void 0 ? void 0 : e.target.object)) return;
    var _final = Object.assign(Object.assign({}, current), {
      position: new THREE.Vector3().copy((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.object.position),
      rotation: new THREE.Euler().copy((_b = e === null || e === void 0 ? void 0 : e.target) === null || _b === void 0 ? void 0 : _b.object.rotation),
      target: Object.assign(Object.assign({}, current.target), {
        position: (_c = e === null || e === void 0 ? void 0 : e.target.target) === null || _c === void 0 ? void 0 : _c.clone()
      })
    });
    updateObjectData(activeCamera, _final);
  };
  var startRotate = function startRotate() {
    if (mode === AMAMode.VIEWER) return;
  };
  return /*#__PURE__*/React__default.createElement(OrbitControls, {
    enableDamping: false,
    onStart: startRotate,
    onEnd: changeHandler,
    makeDefault: true,
    ref: setControls,
    enablePan: pan
  });
};

var $Function = Function;
var concat$1 = functionUncurryThis([].concat);
var join = functionUncurryThis([].join);
var factories = {};

var construct = function (C, argsLength, args) {
  if (!hasOwnProperty_1(factories, argsLength)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    factories[argsLength] = $Function('C,a', 'return new C(' + join(list, ',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
var functionBind = functionBindNative ? $Function.bind : function bind(that /* , ...args */) {
  var F = aCallable(this);
  var Prototype = F.prototype;
  var partArgs = arraySlice(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = concat$1(partArgs, arraySlice(arguments));
    return this instanceof boundFunction ? construct(F, args.length, args) : F.apply(that, args);
  };
  if (isObject(Prototype)) boundFunction.prototype = Prototype;
  return boundFunction;
};

// TODO: Remove from `core-js@4`



// `Function.prototype.bind` method
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
_export({ target: 'Function', proto: true, forced: Function.bind !== functionBind }, {
  bind: functionBind
});

var path = global_1;

// a string of all valid unicode whitespaces
var whitespaces = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var replace$2 = functionUncurryThis(''.replace);
var ltrim = RegExp('^[' + whitespaces + ']+');
var rtrim = RegExp('(^|[^' + whitespaces + '])[' + whitespaces + ']+$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString_1(requireObjectCoercible($this));
    if (TYPE & 1) string = replace$2(string, ltrim, '');
    if (TYPE & 2) string = replace$2(string, rtrim, '$1');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};

var getOwnPropertyNames = objectGetOwnPropertyNames.f;
var getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;
var defineProperty = objectDefineProperty.f;

var trim = stringTrim.trim;

var NUMBER = 'Number';
var NativeNumber = global_1[NUMBER];
path[NUMBER];
var NumberPrototype = NativeNumber.prototype;
var TypeError$1 = global_1.TypeError;
var stringSlice$3 = functionUncurryThis(''.slice);
var charCodeAt = functionUncurryThis(''.charCodeAt);

// `ToNumeric` abstract operation
// https://tc39.es/ecma262/#sec-tonumeric
var toNumeric = function (value) {
  var primValue = toPrimitive(value, 'number');
  return typeof primValue == 'bigint' ? primValue : toNumber(primValue);
};

// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, 'number');
  var first, third, radix, maxCode, digits, length, index, code;
  if (isSymbol(it)) throw TypeError$1('Cannot convert a Symbol value to a number');
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = charCodeAt(it, 0);
    if (first === 43 || first === 45) {
      third = charCodeAt(it, 2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (charCodeAt(it, 1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = stringSlice$3(it, 2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = charCodeAt(digits, index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

var FORCED$3 = isForced_1(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'));

var calledWithNew = function (dummy) {
  // includes check on 1..constructor(foo) case
  return objectIsPrototypeOf(NumberPrototype, dummy) && fails(function () { thisNumberValue(dummy); });
};

// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
var NumberWrapper = function Number(value) {
  var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
  return calledWithNew(this) ? inheritIfRequired(Object(n), this, NumberWrapper) : n;
};

NumberWrapper.prototype = NumberPrototype;
if (FORCED$3 && !isPure) NumberPrototype.constructor = NumberWrapper;

_export({ global: true, constructor: true, wrap: true, forced: FORCED$3 }, {
  Number: NumberWrapper
});

// Use `internal/copy-constructor-properties` helper in `core-js@4`
var copyConstructorProperties = function (target, source) {
  for (var keys = descriptors ? getOwnPropertyNames(source) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,' +
    // ESNext
    'fromString,range'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (hasOwnProperty_1(source, key = keys[j]) && !hasOwnProperty_1(target, key)) {
      defineProperty(target, key, getOwnPropertyDescriptor$2(source, key));
    }
  }
};
if (FORCED$3 || isPure) copyConstructorProperties(path[NUMBER], NativeNumber);

var MouseRaycast = /*#__PURE__*/function () {
  function MouseRaycast(state) {
    _classCallCheck(this, MouseRaycast);
    this.state = state;
    this.mousePosition = this.calcPosition.bind(this);
    this.pointerDown = this.pointerDown.bind(this);
    this.nodes = undefined;
    this.intersected = undefined;
    this.allNodes();
    if (MouseRaycast.instance) {
      return MouseRaycast.instance;
    }
    MouseRaycast.instance = this;
  }
  _createClass(MouseRaycast, [{
    key: "allNodes",
    value: function allNodes() {
      var _a;
      this.nodes = (_a = this.state.threeState) === null || _a === void 0 ? void 0 : _a.scene.children[0];
    }
  }, {
    key: "checkRulesAndCondition",
    value: function checkRulesAndCondition(obj) {
      var customCb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (event, value) {};
      var checkRules = function checkRules(config) {
        if (config.rules.length) {
          config.rules.forEach(function (item) {
            item.condition.forEach(function (el) {
              if (Number(el.connection_id) === obj.userData.dbId) {
                item.action.forEach(function (action) {
                  customCb(undefined, action);
                });
                return;
              }
              if (Number(el.connection_id) === obj.userData.id) {
                item.action.forEach(function (action) {
                  customCb(undefined, action);
                });
                return;
              }
            });
          });
        }
      };
      checkRules(this.state.config);
      if (!this.state.uploadedModelsConfig.length) return;
      this.state.uploadedModelsConfig.forEach(function (config) {
        checkRules(config);
      });
    }
  }, {
    key: "debounce",
    value: function debounce(fn, ms) {
      var timeout;
      return function () {
        var _this = this;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        var fnCall = function fnCall() {
          fn.apply(_this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(fnCall, ms);
      };
    }
  }, {
    key: "calcPosition",
    value: function calcPosition(event) {
      var _this2 = this;
      var _a;
      var rayCaster = new THREE.Raycaster();
      var camera = (_a = this.state.controls) === null || _a === void 0 ? void 0 : _a.object;
      var canvasEl = event.target;
      if (!camera || !this.nodes || !canvasEl) return;
      var x = event.offsetX / canvasEl.clientWidth * 2 - 1;
      var y = -(event.offsetY / canvasEl.clientHeight) * 2 + 1;
      rayCaster.setFromCamera(new THREE.Vector2(x, y), camera);
      var intersected = rayCaster.intersectObjects(this.nodes.children, true);
      var withoutCurrent = intersected.filter(function (el) {
        return el.object.type !== 'Sprite';
      });
      this.intersected = intersected[0];
      this.state.setHoveredObj(intersected[0]);
      document.body.style.cursor = 'default';
      if (intersected[0]) {
        var t = function t() {
          _this2.state.setHoveredObj(intersected[0]);
          document.body.style.cursor = 'pointer';
        };
        this.checkRulesAndCondition(intersected[0].object, t);
      }
      if (withoutCurrent[0]) {
        var pos = new THREE.Vector3().copy(withoutCurrent[0].point);
        pos.z = pos.z + 0.01;
        this.state.setNewAnnotation({
          position: pos
        });
      } else {
        this.state.setNewAnnotation(undefined);
      }
    }
  }, {
    key: "updateProperty",
    value: function updateProperty(action, props) {
      var _this$state$asyncUpda;
      if (!action) return;
      var data = JSON.parse(action.value);
      var mesh = this.state.getMeshById(data.modelPart.patch.meshId);
      if (!mesh) return;
      mesh[props] = data.value;
      this.state.asyncUpdateConfig(mesh, (_this$state$asyncUpda = {}, _this$state$asyncUpda[props] = data.value, _this$state$asyncUpda));
    }
  }, {
    key: "changeCamera",
    value: function changeCamera(action) {
      var _a;
      if (!action) return;
      var data = JSON.parse(action.value);
      var mesh = this.state.getMeshById(data.camera.value);
      if (mesh) {
        var currentConfig = this.state.getCurrentConfigObj(mesh);
        if (currentConfig && (currentConfig.type === AMAMeshType.PerspectiveCamera || currentConfig.type === AMAMeshType.Default_Camera)) {
          this.state.setDynamicCamera({
            position: mesh.position,
            target: ((_a = currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.target) === null || _a === void 0 ? void 0 : _a.position) || new THREE.Vector3(0, 0, 0)
          });
        }
      }
    }
  }, {
    key: "pointerDown",
    value: function pointerDown() {
      var _this3 = this;
      if (this.intersected) {
        var clickCb = function clickCb(e, action) {
          if (!action) return;
          if (action.type_action === AMARuleTypeAction.ActivateAnimation) {
            var data = JSON.parse(action.value);
            _this3.state.playAnimation(data.animation);
          }
          if (action.type_action === AMARuleTypeAction.SetVisibility) {
            _this3.updateProperty(action, 'visible');
          }
          if (action.type_action === AMARuleTypeAction.SetActiveCamera) {
            _this3.changeCamera(action);
          }
        };
        this.checkRulesAndCondition(this.intersected.object, clickCb);
      }
    }
  }, {
    key: "initListener",
    value: function initListener() {
      var _a;
      if (!this.state.threeState) return;
      (_a = this.state.threeState) === null || _a === void 0 ? void 0 : _a.gl.domElement.addEventListener('mousemove', this.mousePosition);
    }
  }, {
    key: "removeListener",
    value: function removeListener() {
      var _a;
      if (!this.state.threeState) return;
      (_a = this.state.threeState) === null || _a === void 0 ? void 0 : _a.gl.domElement.removeEventListener('mousemove', this.mousePosition);
    }
  }]);
  return MouseRaycast;
}();

var utilsAnnotation = function utilsAnnotation() {
  var appState = useBoundStore(function (state) {
    return state;
  });
  var utilsEditorState = utilsEditor();
  var startCreateAnnotation = function startCreateAnnotation() {
    utilsEditorState.unselect();
    var hs = {
      type: 'New_Annotation',
      position: JSON.stringify(new THREE.Vector3(1000, 1000, 1000).toArray())
    };
    appState.setNewAnnotation({
      position: new THREE.Vector3(1000, 1000, 1000)
    });
    var Mouse = new MouseRaycast(appState);
    Mouse.initListener();
    appState.createAnnotation(new AnnotationAMA(hs));
  };
  var removeBlankAnnotation = function removeBlankAnnotation() {
    var annotations = appState.config.annotations.filter(function (i) {
      return i.type !== AMAMeshType.New_Annotation;
    });
    appState.setModelConfig(Object.assign(Object.assign({}, appState.config), {
      annotations: annotations
    }));
  };
  var finishCreateAnnotation = function finishCreateAnnotation() {
    var _a;
    if ((_a = appState.newAnnotation) === null || _a === void 0 ? void 0 : _a.position) {
      var Mouse = new MouseRaycast(appState);
      Mouse.removeListener();
      MouseRaycast.instance = null;
    }
  };
  var createHotspot = function createHotspot(hs) {
    utilsEditorState.unselect();
    appState.createAnnotation(hs);
    appState.setNewAnnotation(undefined);
  };
  return {
    startCreateAnnotation: startCreateAnnotation,
    finishCreateAnnotation: finishCreateAnnotation,
    removeBlankAnnotation: removeBlankAnnotation,
    createHotspot: createHotspot
  };
};

var AMACameraControls = function AMACameraControls() {
  var _useThree = useThree(),
    camera = _useThree.camera;
  var _utilsEditor = utilsEditor(),
    activeCamera = _utilsEditor.activeCamera,
    getCurrentConfigObj = _utilsEditor.getCurrentConfigObj,
    mode = _utilsEditor.mode,
    dynamicCamera = _utilsEditor.dynamicCamera,
    setCameraControls = _utilsEditor.setCameraControls,
    cache = _utilsEditor.cache,
    setCameraIsRotate = _utilsEditor.setCameraIsRotate;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    disableAutoRotate = _useState2[0],
    setDisableAutoRotate = _useState2[1];
  var cameraControlsRef = useRef(null);
  var configCamera = useMemo(function () {
    var camera = getCurrentConfigObj(activeCamera);
    if (isCamera(camera)) return camera;
  }, [activeCamera]);
  var updateDynamicCamera = function updateDynamicCamera() {
    var _a;
    if (cameraControlsRef.current && dynamicCamera) {
      var _dynamicCamera$positi = dynamicCamera.position,
        posX = _dynamicCamera$positi.x,
        posY = _dynamicCamera$positi.y,
        posZ = _dynamicCamera$positi.z;
      var _dynamicCamera$target = dynamicCamera.target,
        tarX = _dynamicCamera$target.x,
        tarY = _dynamicCamera$target.y,
        tarZ = _dynamicCamera$target.z;
      setDisableAutoRotate(!!dynamicCamera.returnToDefault);
      (_a = cameraControlsRef.current) === null || _a === void 0 ? void 0 : _a.setLookAt(posX, posY, posZ, tarX, tarY, tarZ, true);
    }
  };
  var updateActiveCamera = function updateActiveCamera() {
    var _a, _b;
    if (cameraControlsRef.current && activeCamera) {
      var current = getCurrentConfigObj(activeCamera);
      if (!isCamera(current)) return;
      if (!((_a = current === null || current === void 0 ? void 0 : current.target) === null || _a === void 0 ? void 0 : _a.position)) return;
      var _current$position = current.position,
        posX = _current$position.x,
        posY = _current$position.y,
        posZ = _current$position.z;
      var _current$target$posit = current.target.position,
        tarX = _current$target$posit.x,
        tarY = _current$target$posit.y,
        tarZ = _current$target$posit.z;
      (_b = cameraControlsRef.current) === null || _b === void 0 ? void 0 : _b.setLookAt(posX, posY, posZ, tarX, tarY, tarZ, true);
    }
  };
  var onRest = function onRest() {
    if (!cameraControlsRef.current) return;
    cameraControlsRef.current.removeEventListener('rest', onRest);
    setDisableAutoRotate(false);
  };
  var rotateStart = function rotateStart() {
    if (!cameraControlsRef.current) return;
    cameraControlsRef.current.removeEventListener('rest', onRest);
    setDisableAutoRotate(true);
    if (cache.get(FIRST_TIME.click)) {
      setCameraIsRotate(true);
    }
  };
  var rotateEnd = function rotateEnd() {
    var _a;
    if (dynamicCamera === null || dynamicCamera === void 0 ? void 0 : dynamicCamera.returnToDefault) {
      updateDynamicCamera();
      return;
    }
    if ((_a = cameraControlsRef.current) === null || _a === void 0 ? void 0 : _a.active) {
      cameraControlsRef.current.addEventListener('rest', onRest);
    } else {
      onRest();
    }
  };
  useEffect(function () {
    if (mode === AMAMode.EDITOR) return;
    if (!cache.get(FIRST_TIME.click)) {
      setTimeout(function () {
        updateActiveCamera();
        updateDynamicCamera();
      }, 1300);
      return;
    }
    updateActiveCamera();
    updateDynamicCamera();
  }, [cameraControlsRef.current, dynamicCamera]);
  useEffect(function () {
    var _a;
    if (cameraControlsRef.current) {
      if (mode === AMAMode.VIEWER) {
        (_a = cameraControlsRef.current) === null || _a === void 0 ? void 0 : _a.setFocalOffset(1.2, 0, 0);
      }
      setCameraControls(cameraControlsRef.current);
    }
  }, [cameraControlsRef.current]);
  useFrame(function (state, delta, frame) {
    var _a, _b;
    if (!cameraControlsRef.current || !configCamera || ((_a = cameraControlsRef.current) === null || _a === void 0 ? void 0 : _a.active)) return;
    if (!disableAutoRotate && ((_b = configCamera === null || configCamera === void 0 ? void 0 : configCamera.updatedControls) === null || _b === void 0 ? void 0 : _b.autoRotate)) {
      cameraControlsRef.current.azimuthAngle += (configCamera.updatedControls.autoRotateSpeed || 1) * (delta * 3) * THREE.MathUtils.DEG2RAD;
    }
  });
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, camera && configCamera && mode !== AMAMode.EDITOR ? /*#__PURE__*/React__default.createElement(CameraControls, Object.assign({}, configCamera.updatedControls, {
    camera: camera,
    ref: cameraControlsRef,
    onStart: rotateStart,
    onEnd: rotateEnd,
    dollySpeed: 0.3
  })) : null);
};

var LoadingScreen = function LoadingScreen() {
  var _useProgress = useProgress(),
    progress = _useProgress.progress;
  var _utilsEditor = utilsEditor(),
    loadingProgress = _utilsEditor.loadingProgress,
    setLoadingProgress = _utilsEditor.setLoadingProgress;
  React__default.useEffect(function () {
    if (progress >= 100 && loadingProgress.isLoading) {
      setLoadingProgress({
        isLoading: false,
        isLoaded: true,
        isRendered: false
      });
      return;
    }
    if (progress < 100 && !loadingProgress.isLoading) {
      setLoadingProgress({
        isLoading: true,
        isLoaded: false,
        isRendered: false
      });
      return;
    }
    return function () {};
  }, [progress, loadingProgress.isLoading]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
};

var PostProcessingSMAA = function PostProcessingSMAA() {
  return /*#__PURE__*/React__default.createElement(SMAA, null);
};

var PostProcessingBloom = function PostProcessingBloom() {
  var _a, _b;
  var _utilsEditor = utilsEditor(),
    postProcessing = _utilsEditor.postProcessing;
  var bloomEffect = postProcessing;
  var effectRef = useRef(null);
  useFrame(function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    if (effectRef.current) {
      effectRef.current.intensity = (_b = (_a = bloomEffect === null || bloomEffect === void 0 ? void 0 : bloomEffect.effect) === null || _a === void 0 ? void 0 : _a.intensity) === null || _b === void 0 ? void 0 : _b.value;
      effectRef.current.kernelSize = (_d = (_c = bloomEffect === null || bloomEffect === void 0 ? void 0 : bloomEffect.effect) === null || _c === void 0 ? void 0 : _c.kernelSize) === null || _d === void 0 ? void 0 : _d.value;
      effectRef.current.luminanceThreshold = (_f = (_e = bloomEffect === null || bloomEffect === void 0 ? void 0 : bloomEffect.effect) === null || _e === void 0 ? void 0 : _e.luminanceThreshold) === null || _f === void 0 ? void 0 : _f.value;
      effectRef.current.luminanceSmoothing = (_h = (_g = bloomEffect === null || bloomEffect === void 0 ? void 0 : bloomEffect.effect) === null || _g === void 0 ? void 0 : _g.luminanceSmoothing) === null || _h === void 0 ? void 0 : _h.value;
      effectRef.current.mipmapBlur = (_k = (_j = bloomEffect === null || bloomEffect === void 0 ? void 0 : bloomEffect.effect) === null || _j === void 0 ? void 0 : _j.mipmapBlur) === null || _k === void 0 ? void 0 : _k.value;
      effectRef.current.resolutionX = (_m = (_l = bloomEffect === null || bloomEffect === void 0 ? void 0 : bloomEffect.effect) === null || _l === void 0 ? void 0 : _l.resolutionX) === null || _m === void 0 ? void 0 : _m.value;
      effectRef.current.resolutionY = (_p = (_o = bloomEffect === null || bloomEffect === void 0 ? void 0 : bloomEffect.effect) === null || _o === void 0 ? void 0 : _o.resolutionY) === null || _p === void 0 ? void 0 : _p.value;
    }
  });
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Bloom, {
    ref: effectRef,
    blurPass: undefined,
    blendFunction: (_b = (_a = bloomEffect === null || bloomEffect === void 0 ? void 0 : bloomEffect.effect) === null || _a === void 0 ? void 0 : _a.blendFunction) === null || _b === void 0 ? void 0 : _b.value
  }), /*#__PURE__*/React__default.createElement(PostProcessingSMAA, null));
};

var PostProcessingNoise = function PostProcessingNoise() {
  var _a, _b;
  var _utilsEditor = utilsEditor(),
    postProcessing = _utilsEditor.postProcessing;
  var noiseEffect = postProcessing;
  var effectRef = useRef();
  useFrame(function () {
    var _a, _b;
    if (effectRef.current) {
      effectRef.current.hue = (_b = (_a = noiseEffect === null || noiseEffect === void 0 ? void 0 : noiseEffect.effect) === null || _a === void 0 ? void 0 : _a.premultiply) === null || _b === void 0 ? void 0 : _b.value;
    }
  });
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Noise, {
    ref: effectRef,
    blendFunction: (_b = (_a = noiseEffect === null || noiseEffect === void 0 ? void 0 : noiseEffect.effect) === null || _a === void 0 ? void 0 : _a.blendFunction) === null || _b === void 0 ? void 0 : _b.value
  }), /*#__PURE__*/React__default.createElement(PostProcessingSMAA, null));
};

var PostProcessingDoF = function PostProcessingDoF() {
  var _a, _b;
  var _utilsEditor = utilsEditor(),
    postProcessing = _utilsEditor.postProcessing;
  var dofEffect = postProcessing;
  var effectRef = useRef();
  useFrame(function () {
    var _a, _b, _c, _d, _e, _f;
    if (effectRef.current) {
      effectRef.current.focusDistance = (_b = (_a = dofEffect === null || dofEffect === void 0 ? void 0 : dofEffect.effect) === null || _a === void 0 ? void 0 : _a.focusDistance) === null || _b === void 0 ? void 0 : _b.value;
      effectRef.current.bokehScale = (_d = (_c = dofEffect === null || dofEffect === void 0 ? void 0 : dofEffect.effect) === null || _c === void 0 ? void 0 : _c.bokehScale) === null || _d === void 0 ? void 0 : _d.value;
      effectRef.current.focalLength = (_f = (_e = dofEffect === null || dofEffect === void 0 ? void 0 : dofEffect.effect) === null || _e === void 0 ? void 0 : _e.focalLength) === null || _f === void 0 ? void 0 : _f.value;
    }
  });
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DepthOfField, {
    ref: effectRef,
    blendFunction: (_b = (_a = dofEffect === null || dofEffect === void 0 ? void 0 : dofEffect.effect) === null || _a === void 0 ? void 0 : _a.blendFunction) === null || _b === void 0 ? void 0 : _b.value,
    focusDistance: 2
  }), /*#__PURE__*/React__default.createElement(PostProcessingSMAA, null));
};

var PostProcessingChromaticAberration = function PostProcessingChromaticAberration() {
  var _a, _b, _c, _d;
  var _utilsEditor = utilsEditor(),
    postProcessing = _utilsEditor.postProcessing;
  var chromaticAberrationEffect = postProcessing;
  var effectRef = useRef();
  useFrame(function () {
    var _a, _b, _c, _d, _e, _f;
    if (effectRef.current) {
      effectRef.current.offset = (_b = (_a = chromaticAberrationEffect === null || chromaticAberrationEffect === void 0 ? void 0 : chromaticAberrationEffect.effect) === null || _a === void 0 ? void 0 : _a.offset) === null || _b === void 0 ? void 0 : _b.value;
      effectRef.current.radialModulation = (_d = (_c = chromaticAberrationEffect === null || chromaticAberrationEffect === void 0 ? void 0 : chromaticAberrationEffect.effect) === null || _c === void 0 ? void 0 : _c.radialModulation) === null || _d === void 0 ? void 0 : _d.value;
      effectRef.current.modulationOffset = (_f = (_e = chromaticAberrationEffect === null || chromaticAberrationEffect === void 0 ? void 0 : chromaticAberrationEffect.effect) === null || _e === void 0 ? void 0 : _e.modulationOffset) === null || _f === void 0 ? void 0 : _f.value;
    }
  });
  return /*#__PURE__*/React__default.createElement(ChromaticAberration, {
    ref: effectRef,
    blendFunction: (_b = (_a = chromaticAberrationEffect === null || chromaticAberrationEffect === void 0 ? void 0 : chromaticAberrationEffect.effect) === null || _a === void 0 ? void 0 : _a.blendFunction) === null || _b === void 0 ? void 0 : _b.value,
    radialModulation: (_c = chromaticAberrationEffect === null || chromaticAberrationEffect === void 0 ? void 0 : chromaticAberrationEffect.effect.radialModulation) === null || _c === void 0 ? void 0 : _c.value,
    modulationOffset: (_d = chromaticAberrationEffect === null || chromaticAberrationEffect === void 0 ? void 0 : chromaticAberrationEffect.effect.modulationOffset) === null || _d === void 0 ? void 0 : _d.value
  });
};

var PostProcessingBrightnessContrast = function PostProcessingBrightnessContrast() {
  var _a, _b;
  var _utilsEditor = utilsEditor(),
    postProcessing = _utilsEditor.postProcessing;
  var brightnessEffect = postProcessing;
  var brightnessContrastEffect = useRef();
  useFrame(function () {
    var _a, _b, _c, _d;
    if (brightnessContrastEffect.current) {
      brightnessContrastEffect.current.brightness = (_b = (_a = brightnessEffect === null || brightnessEffect === void 0 ? void 0 : brightnessEffect.effect) === null || _a === void 0 ? void 0 : _a.brightness) === null || _b === void 0 ? void 0 : _b.value;
      brightnessContrastEffect.current.contrast = (_d = (_c = brightnessEffect === null || brightnessEffect === void 0 ? void 0 : brightnessEffect.effect) === null || _c === void 0 ? void 0 : _c.contrast) === null || _d === void 0 ? void 0 : _d.value;
    }
  });
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BrightnessContrast, {
    ref: brightnessContrastEffect,
    blendFunction: (_b = (_a = brightnessEffect === null || brightnessEffect === void 0 ? void 0 : brightnessEffect.effect) === null || _a === void 0 ? void 0 : _a.blendFunction) === null || _b === void 0 ? void 0 : _b.value
  }), /*#__PURE__*/React__default.createElement(PostProcessingSMAA, null));
};

var PostProcessingHueSaturation = function PostProcessingHueSaturation() {
  var _a, _b;
  var _utilsEditor = utilsEditor(),
    postProcessing = _utilsEditor.postProcessing;
  var hueSaturationEffect = postProcessing;
  var effectRef = useRef();
  useFrame(function () {
    var _a, _b, _c, _d;
    if (effectRef.current) {
      effectRef.current.hue = (_b = (_a = hueSaturationEffect === null || hueSaturationEffect === void 0 ? void 0 : hueSaturationEffect.effect) === null || _a === void 0 ? void 0 : _a.hue) === null || _b === void 0 ? void 0 : _b.value;
      effectRef.current.saturation = (_d = (_c = hueSaturationEffect === null || hueSaturationEffect === void 0 ? void 0 : hueSaturationEffect.effect) === null || _c === void 0 ? void 0 : _c.saturation) === null || _d === void 0 ? void 0 : _d.value;
    }
  });
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(HueSaturation, {
    ref: effectRef,
    blendFunction: (_b = (_a = hueSaturationEffect === null || hueSaturationEffect === void 0 ? void 0 : hueSaturationEffect.effect) === null || _a === void 0 ? void 0 : _a.blendFunction) === null || _b === void 0 ? void 0 : _b.value
  }), /*#__PURE__*/React__default.createElement(PostProcessingSMAA, null));
};

var PostProcessingSSAO = function PostProcessingSSAO() {
  var _a, _b, _c, _d, _e, _f;
  var _utilsEditor = utilsEditor(),
    postProcessing = _utilsEditor.postProcessing;
  var SSAOEffect = postProcessing;
  var effectRef = useRef();
  useFrame(function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
    if (effectRef.current) {
      effectRef.current.samples = (_b = (_a = SSAOEffect === null || SSAOEffect === void 0 ? void 0 : SSAOEffect.effect) === null || _a === void 0 ? void 0 : _a.samples) === null || _b === void 0 ? void 0 : _b.value;
      effectRef.current.rings = (_d = (_c = SSAOEffect === null || SSAOEffect === void 0 ? void 0 : SSAOEffect.effect) === null || _c === void 0 ? void 0 : _c.rings) === null || _d === void 0 ? void 0 : _d.value;
      effectRef.current.distanceThreshold = (_f = (_e = SSAOEffect === null || SSAOEffect === void 0 ? void 0 : SSAOEffect.effect) === null || _e === void 0 ? void 0 : _e.distanceThreshold) === null || _f === void 0 ? void 0 : _f.value;
      effectRef.current.distanceFalloff = (_h = (_g = SSAOEffect === null || SSAOEffect === void 0 ? void 0 : SSAOEffect.effect) === null || _g === void 0 ? void 0 : _g.distanceFalloff) === null || _h === void 0 ? void 0 : _h.value;
      effectRef.current.rangeThreshold = (_k = (_j = SSAOEffect === null || SSAOEffect === void 0 ? void 0 : SSAOEffect.effect) === null || _j === void 0 ? void 0 : _j.rangeThreshold) === null || _k === void 0 ? void 0 : _k.value;
      effectRef.current.rangeFalloff = (_m = (_l = SSAOEffect === null || SSAOEffect === void 0 ? void 0 : SSAOEffect.effect) === null || _l === void 0 ? void 0 : _l.rangeFalloff) === null || _m === void 0 ? void 0 : _m.value;
      effectRef.current.luminanceInfluence = (_p = (_o = SSAOEffect === null || SSAOEffect === void 0 ? void 0 : SSAOEffect.effect) === null || _o === void 0 ? void 0 : _o.luminanceInfluence) === null || _p === void 0 ? void 0 : _p.value;
      effectRef.current.radius = (_r = (_q = SSAOEffect === null || SSAOEffect === void 0 ? void 0 : SSAOEffect.effect) === null || _q === void 0 ? void 0 : _q.radius) === null || _r === void 0 ? void 0 : _r.value;
      effectRef.current.bias = (_t = (_s = SSAOEffect === null || SSAOEffect === void 0 ? void 0 : SSAOEffect.effect) === null || _s === void 0 ? void 0 : _s.bias) === null || _t === void 0 ? void 0 : _t.value;
      effectRef.current.worldDistanceThreshold = (_v = (_u = SSAOEffect === null || SSAOEffect === void 0 ? void 0 : SSAOEffect.effect) === null || _u === void 0 ? void 0 : _u.worldDistanceThreshold) === null || _v === void 0 ? void 0 : _v.value;
      effectRef.current.worldDistanceFalloff = (_x = (_w = SSAOEffect === null || SSAOEffect === void 0 ? void 0 : SSAOEffect.effect) === null || _w === void 0 ? void 0 : _w.worldDistanceFalloff) === null || _x === void 0 ? void 0 : _x.value;
      effectRef.current.worldProximityThreshold = (_z = (_y = SSAOEffect === null || SSAOEffect === void 0 ? void 0 : SSAOEffect.effect) === null || _y === void 0 ? void 0 : _y.worldProximityThreshold) === null || _z === void 0 ? void 0 : _z.value;
      effectRef.current.worldProximityFalloff = (_1 = (_0 = SSAOEffect === null || SSAOEffect === void 0 ? void 0 : SSAOEffect.effect) === null || _0 === void 0 ? void 0 : _0.worldProximityFalloff) === null || _1 === void 0 ? void 0 : _1.value;
    }
  });
  return /*#__PURE__*/React__default.createElement(SSAO, {
    ref: effectRef,
    blendFunction: (_b = (_a = SSAOEffect === null || SSAOEffect === void 0 ? void 0 : SSAOEffect.effect) === null || _a === void 0 ? void 0 : _a.blendFunction) === null || _b === void 0 ? void 0 : _b.value,
    worldDistanceThreshold: (_c = SSAOEffect.effect.worldDistanceThreshold) === null || _c === void 0 ? void 0 : _c.value,
    worldDistanceFalloff: (_d = SSAOEffect.effect.worldDistanceFalloff) === null || _d === void 0 ? void 0 : _d.value,
    worldProximityThreshold: (_e = SSAOEffect.effect.worldProximityThreshold) === null || _e === void 0 ? void 0 : _e.value,
    worldProximityFalloff: (_f = SSAOEffect.effect.worldProximityFalloff) === null || _f === void 0 ? void 0 : _f.value
  });
};

var PostProcessingToneMapping = function PostProcessingToneMapping() {
  var _a, _b;
  var _utilsEditor = utilsEditor(),
    postProcessing = _utilsEditor.postProcessing;
  var toneMappingEffect = postProcessing;
  var effectRef = useRef();
  useFrame(function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    if (effectRef.current) {
      effectRef.current.adaptive = (_b = (_a = toneMappingEffect === null || toneMappingEffect === void 0 ? void 0 : toneMappingEffect.effect) === null || _a === void 0 ? void 0 : _a.adaptive) === null || _b === void 0 ? void 0 : _b.value;
      effectRef.current.resolution = (_d = (_c = toneMappingEffect === null || toneMappingEffect === void 0 ? void 0 : toneMappingEffect.effect) === null || _c === void 0 ? void 0 : _c.resolution) === null || _d === void 0 ? void 0 : _d.value;
      effectRef.current.middleGrey = (_f = (_e = toneMappingEffect === null || toneMappingEffect === void 0 ? void 0 : toneMappingEffect.effect) === null || _e === void 0 ? void 0 : _e.middleGrey) === null || _f === void 0 ? void 0 : _f.value;
      effectRef.current.maxLuminance = (_h = (_g = toneMappingEffect === null || toneMappingEffect === void 0 ? void 0 : toneMappingEffect.effect) === null || _g === void 0 ? void 0 : _g.maxLuminance) === null || _h === void 0 ? void 0 : _h.value;
      effectRef.current.averageLuminance = (_k = (_j = toneMappingEffect === null || toneMappingEffect === void 0 ? void 0 : toneMappingEffect.effect) === null || _j === void 0 ? void 0 : _j.averageLuminance) === null || _k === void 0 ? void 0 : _k.value;
      effectRef.current.adaptationRate = (_m = (_l = toneMappingEffect === null || toneMappingEffect === void 0 ? void 0 : toneMappingEffect.effect) === null || _l === void 0 ? void 0 : _l.adaptationRate) === null || _m === void 0 ? void 0 : _m.value;
    }
  });
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ToneMapping, {
    ref: effectRef,
    blendFunction: (_b = (_a = toneMappingEffect === null || toneMappingEffect === void 0 ? void 0 : toneMappingEffect.effect) === null || _a === void 0 ? void 0 : _a.blendFunction) === null || _b === void 0 ? void 0 : _b.value
  }), /*#__PURE__*/React__default.createElement(PostProcessingSMAA, null));
};

var PostProcessingVignette = function PostProcessingVignette() {
  var _a, _b;
  var _utilsEditor = utilsEditor(),
    postProcessing = _utilsEditor.postProcessing;
  var vignette = postProcessing;
  var effectRef = useRef();
  useFrame(function () {
    var _a, _b, _c, _d, _e, _f;
    if (effectRef.current) {
      effectRef.current.offset = (_b = (_a = vignette === null || vignette === void 0 ? void 0 : vignette.effect) === null || _a === void 0 ? void 0 : _a.offset) === null || _b === void 0 ? void 0 : _b.value;
      effectRef.current.darkness = (_d = (_c = vignette === null || vignette === void 0 ? void 0 : vignette.effect) === null || _c === void 0 ? void 0 : _c.darkness) === null || _d === void 0 ? void 0 : _d.value;
      effectRef.current.eskil = (_f = (_e = vignette === null || vignette === void 0 ? void 0 : vignette.effect) === null || _e === void 0 ? void 0 : _e.eskil) === null || _f === void 0 ? void 0 : _f.value;
    }
  });
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Vignette, {
    ref: effectRef,
    blendFunction: (_b = (_a = vignette === null || vignette === void 0 ? void 0 : vignette.effect) === null || _a === void 0 ? void 0 : _a.blendFunction) === null || _b === void 0 ? void 0 : _b.value
  }), /*#__PURE__*/React__default.createElement(PostProcessingSMAA, null));
};

var postProcess = {
  bloom: /*#__PURE__*/React__default.createElement(PostProcessingBloom, null),
  noise: /*#__PURE__*/React__default.createElement(PostProcessingNoise, null),
  dof: /*#__PURE__*/React__default.createElement(PostProcessingDoF, null),
  chromatic_aberration: /*#__PURE__*/React__default.createElement(PostProcessingChromaticAberration, null),
  brightness_contrast: /*#__PURE__*/React__default.createElement(PostProcessingBrightnessContrast, null),
  hue_saturation: /*#__PURE__*/React__default.createElement(PostProcessingHueSaturation, null),
  smaa: /*#__PURE__*/React__default.createElement(PostProcessingSMAA, null),
  ssao: /*#__PURE__*/React__default.createElement(PostProcessingSSAO, null),
  tone_mapping: /*#__PURE__*/React__default.createElement(PostProcessingToneMapping, null),
  vignette: /*#__PURE__*/React__default.createElement(PostProcessingVignette, null),
  '': /*#__PURE__*/React__default.createElement(React__default.Fragment, null)
};
var PostProcessing = function PostProcessing(_ref) {
  _objectDestructuringEmpty(_ref);
  var _utilsEditor = utilsEditor(),
    postProcessing = _utilsEditor.postProcessing;
  return /*#__PURE__*/React__default.createElement(React__default.Suspense, {
    fallback: null
  }, /*#__PURE__*/React__default.createElement(EffectComposer, {
    multisampling: 0
  }, postProcess[postProcessing.name]));
};

var ARController = /*#__PURE__*/_createClass(function ARController() {
  var _this = this;
  _classCallCheck(this, ARController);
  this.init = function () {
    var _a, _b;
    (_a = document.getElementById('WebXR')) === null || _a === void 0 ? void 0 : _a.remove();
    _this.container = document.createElement('div');
    _this.container.id = 'WebXR';
    _this.container.style.position = 'fixed';
    _this.container.style.top = '0';
    _this.container.style.left = '0';
    _this.container.style.zIndex = '-1';
    document.body.appendChild(_this.container);
    _this.scene = new THREE.Scene();
    _this.camera = new THREE.PerspectiveCamera(70, window.innerWidth / window.innerHeight, 0.01, 20);
    _this.camera.updateProjectionMatrix();
    _this.initLight();
    _this.renderer = new THREE.WebGLRenderer({
      antialias: true,
      alpha: true,
      preserveDrawingBuffer: true
    });
    _this.renderer.setPixelRatio(window.devicePixelRatio);
    _this.renderer.setSize(window.innerWidth, window.innerHeight);
    _this.renderer.xr.enabled = true;
    _this.container.appendChild(_this.renderer.domElement);
    (_b = document.getElementById('ARbutton')) === null || _b === void 0 ? void 0 : _b.remove();
    _this.button = ARButton.createButton(_this.renderer, {
      requiredFeatures: ['hit-test']
    });
    _this.controller = _this.renderer.xr.getController(0);
    _this.controller.addEventListener('select', _this.onSelect);
    _this.controller.addEventListener('selectstart', _this.onSelectStart);
    _this.controller.addEventListener('selectend', _this.onSelectEnd);
    _this.scene.add(_this.controller);
    _this.reticle = new THREE.Mesh(new THREE.RingGeometry(0.15, 0.18, 32).rotateX(-Math.PI / 2), new THREE.MeshBasicMaterial());
    _this.reticle.matrixAutoUpdate = false;
    _this.reticle.visible = false;
    _this.scene.add(_this.reticle);
    window.addEventListener('resize', _this.onWindowResize);
    _this.hideCanvas();
  };
  this.onSelectStart = function () {
    var animateRotation = function animateRotation() {
      _this.animation = setInterval(function () {
        if (_this.scene.children.some(function (child) {
          return child.uuid === _this.object.uuid;
        })) {
          _this.object.rotateY(0.05);
        }
      }, 20);
    };
    _this.timeout = setTimeout(function () {
      animateRotation();
    }, 300);
  };
  this.onSelectEnd = function () {
    if (_this.timeout) {
      clearTimeout(_this.timeout);
    }
    if (_this.animation) {
      clearInterval(_this.animation);
    }
  };
  this.initLight = function () {
    _this.fl_light = new THREE.DirectionalLight(0xbfbfbf, 0.6);
    _this.fr_light = new THREE.DirectionalLight(0xbfbfbf, 0.6);
    _this.bl_light = new THREE.DirectionalLight(0xbfbfbf, 0.6);
    _this.br_light = new THREE.DirectionalLight(0xbfbfbf, 0.6);
    _this.fl_light.position.set(-7.5, 10, 7.5);
    _this.fr_light.position.set(7.5, 10, 7.5);
    _this.bl_light.position.set(-7.5, 10, -7.5);
    _this.br_light.position.set(7.5, 10, -7.5);
    _this.ambient = new THREE.AmbientLight(0xffffff, 0.1);
    _this.scene.add(_this.fl_light);
    _this.scene.add(_this.fr_light);
    _this.scene.add(_this.bl_light);
    _this.scene.add(_this.br_light);
    _this.scene.add(_this.ambient);
  };
  this.clickButton = function () {
    if (_this.button) {
      _this.button.click();
    }
  };
  this.hideCanvas = function () {
    var container = document.getElementById('WebXR');
    if (container) {
      container.style.display = 'none';
    }
  };
  this.showCanvas = function () {
    var container = document.getElementById('WebXR');
    if (container) {
      container.style.display = '';
    }
  };
  this.onWindowResize = function () {
    _this.camera.aspect = window.innerWidth / window.innerHeight;
    _this.camera.updateProjectionMatrix();
    _this.renderer.setSize(window.innerWidth, window.innerHeight);
  };
  this.onSelect = function () {
    if (_this.reticle.visible) {
      _this.object.position.setFromMatrixPosition(_this.reticle.matrix);
      _this.scene.add(_this.object);
    }
  };
  this.setModel = function (mesh) {
    _this.scene.remove(_this.object);
    _this.object = mesh.clone();
    if (_this.objectSize) {
      _this.object.scale.set(_this.objectSize, _this.objectSize, _this.objectSize);
    }
    _this.object.updateMatrix();
    _this.object.updateMatrixWorld();
    _this.object.castShadow = true;
  };
  this.setModelSize = function (size) {
    _this.objectSize = size;
  };
  this.render = function (timestamp, frame) {
    if (frame) {
      var referenceSpace = _this.renderer.xr.getReferenceSpace();
      var session = _this.renderer.xr.getSession();
      if (_this.hitTestSourceRequested === false) {
        var self = _this;
        session === null || session === void 0 ? void 0 : session.requestReferenceSpace('viewer').then(function (referenceSpace) {
          var _a, _b;
          (_b = (_a = session.requestHitTestSource) === null || _a === void 0 ? void 0 : _a.call(session, {
            space: referenceSpace
          })) === null || _b === void 0 ? void 0 : _b.then(function (source) {
            self.hitTestSource = source;
          });
        });
        session === null || session === void 0 ? void 0 : session.addEventListener('end', function () {
          self.hitTestSourceRequested = false;
          self.hitTestSource = null;
        });
        _this.hitTestSourceRequested = true;
      }
      if (_this.hitTestSource) {
        var hitTestResults = frame.getHitTestResults(_this.hitTestSource);
        if (hitTestResults.length) {
          var hit = hitTestResults[0];
          _this.reticle.visible = true;
          _this.reticle.matrix.fromArray(hit.getPose(referenceSpace).transform.matrix);
        } else {
          _this.reticle.visible = false;
        }
      }
    }
    _this.renderer.render(_this.scene, _this.camera);
  };
  this.animate = function () {
    _this.renderer.setAnimationLoop(_this.render);
  };
  this.camera = undefined;
  this.controller = undefined;
  this.scene = undefined;
  this.renderer = undefined;
  this.object = undefined;
  this.objectSize = undefined;
  this.fl_light = undefined;
  this.fr_light = undefined;
  this.bl_light = undefined;
  this.br_light = undefined;
  this.ambient = undefined;
  this.button = undefined;
  this.container = undefined;
  this.animation = undefined;
  this.timeout = undefined;
  this.reticle = undefined;
  this.hitTestSource = undefined;
  this.hitTestSourceRequested = false;
  this.init();
  this.animate();
});

var ARViewAndroid = function ARViewAndroid() {
  var utils = utilsEditor();
  var arController = useMemo(function () {
    return new ARController();
  }, []);
  useEffect(function () {
    if (!arController) {
      return;
    }
    utils.setAndroidARController(arController);
  }, [arController]);
  useEffect(function () {
    return function () {
      if (arController) {
        arController.hideCanvas();
      }
    };
  }, [arController]);
  return null;
};

function useLoadHDRJPGAsync(src) {
  var _this = this;
  var _useThree = useThree(),
    gl = _useThree.gl;
  function loadHDRJPG(src) {
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var loader, jpg, gainMapBackground;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            loader = new HDRJPGLoader(gl);
            _context.next = 3;
            return loader.loadAsync(src);
          case 3:
            jpg = _context.sent;
            gainMapBackground = jpg.renderTarget.texture;
            gainMapBackground.mapping = THREE.EquirectangularReflectionMapping;
            gainMapBackground.needsUpdate = true;
            return _context.abrupt("return", gainMapBackground);
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  }
  return suspend(function () {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return loadHDRJPG(src);
          case 2:
            return _context2.abrupt("return", _context2.sent);
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
  }, [src, gl]);
}

extend({
  GroundProjectedEnvImpl: GroundProjectedEnv
});
var CustomEnvironment = function CustomEnvironment(_ref) {
  var activeEnvironment = _ref.activeEnvironment;
  var result = useLoadHDRJPGAsync('https://amaspace-dev.s3.amazonaws.com/env_orig.jpg');
  if (result && activeEnvironment && activeEnvironment.ground) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Environment, {
      map: result,
      background: true
    }), /*#__PURE__*/React__default.createElement("groundProjectedEnvImpl", {
      args: [result],
      scale: activeEnvironment.ground.scale,
      height: activeEnvironment.ground.height,
      radius: activeEnvironment.ground.radius
    }));
  }
  return null;
};

extend({
  OrbitControls: OrbitControls$1,
  TransformControls: TransformControls
});
var PerfStats = function PerfStats() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Perf, {
    trackCPU: true
  }), /*#__PURE__*/React.createElement(StatsGl, null));
};
var CustomGrid = function CustomGrid() {
  var gridConfig = {
    cellSize: 0.5,
    cellThickness: 0.5,
    cellColor: '#6f6f6f',
    sectionSize: 3,
    sectionThickness: 1,
    sectionColor: '#9d4b4b',
    fadeDistance: 30,
    fadeStrength: 1,
    followCamera: false,
    infiniteGrid: true
  };
  return /*#__PURE__*/React.createElement(Grid, Object.assign({
    position: [0, -0.01, 0],
    args: [10.5, 10.5]
  }, gridConfig));
};
var SceneSetup = function SceneSetup(_ref) {
  var children = _ref.children,
    _ref$controls = _ref.controls,
    controls = _ref$controls === void 0 ? {} : _ref$controls;
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2);
    _React$useState2[0];
    var setMain = _React$useState2[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    stats = _useState2[0],
    toggleStats = _useState2[1];
  var _utilsEditor = utilsEditor(),
    showGrid = _utilsEditor.showGrid,
    backgroundColor = _utilsEditor.backgroundColor,
    animateCamera = _utilsEditor.animateCamera,
    activeEnvironment = _utilsEditor.activeEnvironment,
    postProcessing = _utilsEditor.postProcessing,
    config = _utilsEditor.config,
    setActiveCamera = _utilsEditor.setActiveCamera,
    setDynamicCamera = _utilsEditor.setDynamicCamera,
    cache = _utilsEditor.cache,
    cameraControls = _utilsEditor.cameraControls,
    unselect = _utilsEditor.unselect;
  var _utilsAnnotation = utilsAnnotation(),
    finishCreateAnnotation = _utilsAnnotation.finishCreateAnnotation;
  window.stats = stats;
  var keyCallbacks = useMemo(function () {
    return {
      KeyE: function KeyE(event) {
        if (!event.ctrlKey) return;
        event.preventDefault();
        if (!window.stats) {
          toggleStats(true);
        } else {
          toggleStats(false);
        }
      },
      Escape: function Escape(event) {
        event.preventDefault();
        unselect();
      }
    };
  }, []);
  var onKeyDown = function onKeyDown(event) {
    var _a;
    if (keyCallbacks[event.code] !== undefined) {
      (_a = keyCallbacks[event.code]) === null || _a === void 0 ? void 0 : _a.call(keyCallbacks, event);
    }
  };
  var defaultCamera = useMemo(function () {
    var _a;
    if (!config) return;
    var cameraPosition = (_a = config === null || config === void 0 ? void 0 : config.defaultSceneConfig) === null || _a === void 0 ? void 0 : _a.cameraPosition;
    var camera = _.find(config.customObjects, {
      id: cameraPosition === null || cameraPosition === void 0 ? void 0 : cameraPosition.cameraId
    });
    if ((camera === null || camera === void 0 ? void 0 : camera.type) === AMAMeshType.Default_Camera) return camera;
    return _.find(config.customObjects, {
      type: 'Default_Camera'
    });
  }, [config]);
  var firstTimeClick = function firstTimeClick() {
    if (cache.get(FIRST_TIME.click)) return;
    cache.set(FIRST_TIME.click, true);
    if (!defaultCamera || !cameraControls) return;
    setDynamicCamera({
      position: defaultCamera.position,
      target: defaultCamera.target.position
    });
    setActiveCamera(defaultCamera);
  };
  useEffect(function () {
    document.addEventListener('keydown', onKeyDown);
    return function () {
      return document.removeEventListener('keydown', onKeyDown);
    };
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Canvas, {
    shadows: true,
    onMouseUp: finishCreateAnnotation,
    onClick: firstTimeClick,
    camera: {
      fov: 60,
      position: new THREE.Vector3(5, 2, 5)
    },
    gl: {
      pixelRatio: window.devicePixelRatio,
      antialias: true,
      outputColorSpace: 'srgb',
      preserveDrawingBuffer: true
    }
  }, /*#__PURE__*/React.createElement(ARViewAndroid, null), /*#__PURE__*/React.createElement(React.Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement("group", {
    ref: setMain,
    name: "main_group"
  }, children)), /*#__PURE__*/React.createElement("color", {
    attach: "background",
    args: [backgroundColor]
  }), /*#__PURE__*/React.createElement("directionalLight", {
    position: [-3, 4, 5],
    intensity: 5.12
  }), activeEnvironment.url && /*#__PURE__*/React.createElement(CustomEnvironment, {
    activeEnvironment: activeEnvironment
  }), /*#__PURE__*/React.createElement(AMAControls, Object.assign({}, controls)), animateCamera && /*#__PURE__*/React.createElement(AMACameraControls, null), stats && /*#__PURE__*/React.createElement(PerfStats, null), postProcessing.name && /*#__PURE__*/React.createElement(PostProcessing, null), showGrid && /*#__PURE__*/React.createElement(CustomGrid, null)), /*#__PURE__*/React.createElement(LoadingScreen, null));
};

/* eslint-disable es/no-array-prototype-indexof -- required for testing */


var $indexOf = arrayIncludes.indexOf;


var nativeIndexOf = functionUncurryThisClause([].indexOf);

var NEGATIVE_ZERO = !!nativeIndexOf && 1 / nativeIndexOf([1], 1, -0) < 0;
var FORCED$2 = NEGATIVE_ZERO || !arrayMethodIsStrict('indexOf');

// `Array.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.indexof
_export({ target: 'Array', proto: true, forced: FORCED$2 }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    var fromIndex = arguments.length > 1 ? arguments[1] : undefined;
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? nativeIndexOf(this, searchElement, fromIndex) || 0
      : $indexOf(this, searchElement, fromIndex);
  }
});

var IsObject = function IsObject(url) {
  return url === Object(url) && !Array.isArray(url) && typeof url !== 'function';
};
function useTexture(input, onLoad) {
  var textures = useLoader(TextureLoader, IsObject(input) ? Object.values(input) : input);
  useLayoutEffect(function () {
    onLoad === null || onLoad === void 0 ? void 0 : onLoad(textures);
  }, [onLoad]);
  if (IsObject(input)) {
    var keys = Object.keys(input);
    var keyed = {};
    keys.forEach(function (key) {
      var _Object$assign;
      return Object.assign(keyed, (_Object$assign = {}, _Object$assign[key] = textures[keys.indexOf(key)], _Object$assign));
    });
    return keyed;
  } else {
    return textures;
  }
}
useTexture.preload = function (url) {
  return useLoader.preload(TextureLoader, url);
};
useTexture.clear = function (input) {
  return useLoader.clear(TextureLoader, input);
};

var AMATexture = function AMATexture(_ref) {
  var data = _ref.data;
  var validMaps = useMemo(function () {
    var _final = {};
    Object.keys(data).forEach(function (item) {
      if (data[item]) {
        _final[item] = data[item].url;
      }
    });
    return _final;
  }, [data]);
  var texture = useTexture(validMaps);
  var blank = useTexture('https://i.ibb.co/c1TpRZV/1572778667-3.jpg');
  var emptyMaps = function emptyMaps() {
    var maps = Object.keys(mapsTextures);
    return maps.map(function (item, index) {
      return /*#__PURE__*/React__default.createElement("primitive", {
        key: "unique-" + String(item + index),
        object: blank,
        attach: 'map'
      });
    });
  };
  var renderMaps = function renderMaps() {
    var maps = Object.keys(texture);
    if (!Object.keys(data).length) {
      return emptyMaps();
    }
    return maps.map(function (item) {
      var textureMap = texture[item];
      var encoding = ['emissiveMap', 'map', 'sheenColorMap', 'specularColorMap', 'alphaMap'].includes(item) ? 'srgb' : '';
      return data[item].patch.visible && textureMap ? /*#__PURE__*/React__default.createElement("primitive", {
        key: textureMap.uuid,
        object: textureMap,
        attach: item,
        colorSpace: encoding,
        flipY: false
      }, /*#__PURE__*/React__default.createElement("vector2", {
        attach: 'repeat',
        args: data[item].patch.scale || [1, 1]
      }), /*#__PURE__*/React__default.createElement("vector2", {
        attach: 'offset',
        args: data[item].patch.offset || [0, 0]
      })) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
    });
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, renderMaps());
};

var mapsTextures = {
  map: undefined,
  roughnessMap: undefined,
  alphaMap: undefined,
  metalnessMap: undefined,
  normalMap: undefined,
  emissiveMap: undefined,
  aoMap: undefined
};
var AMAStandardMaterial = function AMAStandardMaterial(_ref) {
  var data = _ref.data;
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
  var textureAttach = function textureAttach() {
    var maps = Object.assign({}, mapsTextures);
    if (data && data.textures) {
      Object.keys(maps).forEach(function (item) {
        var texture = data.textures.find(function (el) {
          return el.type === item;
        });
        if (texture) maps[item] = texture;else {
          delete maps[item];
        }
      });
    }
    return maps;
  };
  return /*#__PURE__*/React__default.createElement(React__default.Suspense, {
    fallback: null
  }, /*#__PURE__*/React__default.createElement("meshStandardMaterial", {
    color: (_a = data.properties) === null || _a === void 0 ? void 0 : _a.color,
    emissive: (_b = data.properties) === null || _b === void 0 ? void 0 : _b.emissive,
    name: (_c = data.properties) === null || _c === void 0 ? void 0 : _c.name,
    envMapIntensity: 2.5,
    depthTest: (_d = data === null || data === void 0 ? void 0 : data.properties) === null || _d === void 0 ? void 0 : _d.depthTest,
    depthWrite: (_e = data === null || data === void 0 ? void 0 : data.properties) === null || _e === void 0 ? void 0 : _e.depthWrite,
    fog: (_f = data.properties) === null || _f === void 0 ? void 0 : _f.fog,
    lightMapIntensity: (_g = data.properties) === null || _g === void 0 ? void 0 : _g.lightMapIntensity,
    metalness: (_h = data.properties) === null || _h === void 0 ? void 0 : _h.metalness,
    roughness: (_j = data.properties) === null || _j === void 0 ? void 0 : _j.roughness,
    blending: ((_k = data.properties) === null || _k === void 0 ? void 0 : _k.blending) || THREE.NoBlending,
    transparent: ((_l = data.properties) === null || _l === void 0 ? void 0 : _l.alphaMode) === 'BLEND' ? true : (_m = data.properties) === null || _m === void 0 ? void 0 : _m.transparent,
    opacity: (_o = data.properties) === null || _o === void 0 ? void 0 : _o.alpha,
    wireframe: (_p = data.properties) === null || _p === void 0 ? void 0 : _p.wireframe,
    side: ((_q = data.properties) === null || _q === void 0 ? void 0 : _q.doubleside) ? THREE.DoubleSide : (_r = data.properties) === null || _r === void 0 ? void 0 : _r.side,
    normalScale: (_s = data.properties) === null || _s === void 0 ? void 0 : _s.normalScale,
    userData: data
  }, /*#__PURE__*/React__default.createElement(AMATexture, {
    data: textureAttach()
  })));
};

var MaterialConstructor = function MaterialConstructor() {
  var _useMaterialState = useMaterialState(),
    config = _useMaterialState.config;
  var _utilsEditor = utilsEditor(),
    createThreeScene = _utilsEditor.createThreeScene;
  var three = useThree();
  useEffect(function () {
    if (three) {
      createThreeScene(three);
    }
  }, []);
  return /*#__PURE__*/React__default.createElement(AMAStandardMaterial, {
    data: config
  });
};

var MaterialEditor = function MaterialEditor(_ref) {
  var config = _ref.config;
  return /*#__PURE__*/React.createElement(SceneSetup, {
    controls: {
      pan: false
    }
  }, config ? /*#__PURE__*/React.createElement("mesh", {
    name: "test-sphere",
    position: [0, 0, 0],
    onClick: function onClick() {
      console.log('click');
    }
  }, /*#__PURE__*/React.createElement("sphereGeometry", {
    args: [2, 64, 64]
  }), /*#__PURE__*/React.createElement(MaterialConstructor, null)) : null);
};

var MaterialPlayer = function MaterialPlayer(_ref) {
  var assetId = _ref.assetId,
    apiKey = _ref.apiKey,
    data = _ref.data;
  var config = useLoadAsset(assetId, apiKey);
  var update = useTransformDefaultMaterial(data ? data : config);
  var _utilsEditor = utilsEditor(),
    toggleGrid = _utilsEditor.toggleGrid;
  var _useMaterialState = useMaterialState(),
    setConfig = _useMaterialState.setConfig;
  useEffect(function () {
    if (update) {
      setConfig(update);
    }
  }, []);
  useEffect(function () {
    toggleGrid(false);
  }, []);
  return /*#__PURE__*/React.createElement(MaterialEditor, {
    config: update
  });
};

var $reduce = arrayReduce.left;




// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !engineIsNode && engineV8Version > 79 && engineV8Version < 83;
var FORCED$1 = CHROME_BUG || !arrayMethodIsStrict('reduce');

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
_export({ target: 'Array', proto: true, forced: FORCED$1 }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});

var floor = Math.floor;
var charAt = functionUncurryThis(''.charAt);
var replace$1 = functionUncurryThis(''.replace);
var stringSlice$2 = functionUncurryThis(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var getSubstitution = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace$1(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice$2(str, 0, position);
      case "'": return stringSlice$2(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice$2(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};

var REPLACE = wellKnownSymbol('replace');
var max$2 = Math.max;
var min$2 = Math.min;
var concat = functionUncurryThis([].concat);
var push$1 = functionUncurryThis([].push);
var stringIndexOf = functionUncurryThis(''.indexOf);
var stringSlice$1 = functionUncurryThis(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegexpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = isNullOrUndefined(searchValue) ? undefined : getMethod(searchValue, REPLACE);
      return replacer
        ? functionCall(replacer, searchValue, O, replaceValue)
        : functionCall(nativeReplace, toString_1(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject(this);
      var S = toString_1(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable(replaceValue);
      if (!functionalReplace) replaceValue = toString_1(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regexpExecAbstract(rx, S);
        if (result === null) break;

        push$1(results, result);
        if (!global) break;

        var matchStr = toString_1(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString_1(result[0]);
        var position = max$2(min$2(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push$1(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push$1(replacerArgs, namedCaptures);
          var replacement = toString_1(functionApply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice$1(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + stringSlice$1(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

var useHovered = function useHovered() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _ref.onPointerMoveCb;
    _ref.onPointerOutCb;
    _ref.onPointerOverCb;
    var _ref$onPointerDownCb = _ref.onPointerDownCb,
    onPointerDownCb = _ref$onPointerDownCb === void 0 ? function () {} : _ref$onPointerDownCb;
  var utils = utilsEditor();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hovered = _useState2[0],
    setHovered = _useState2[1];
  useCursor(hovered);
  var checkRulesAndCondition = useCallback(function (obj) {
    var customCb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (event, value) {};
    var checkRules = function checkRules(config) {
      if (config.rules.length) {
        config.rules.forEach(function (item) {
          item.condition.forEach(function (el) {
            if (Number(el.connection_id) === obj.userData.dbId) {
              item.action.forEach(function (action) {
                customCb(undefined, action);
              });
              return;
            }
            if (Number(el.connection_id) === obj.userData.id) {
              item.action.forEach(function (action) {
                customCb(undefined, action);
              });
              return;
            }
          });
        });
      }
    };
    checkRules(utils.config);
    if (!utils.uploadedModelsConfig.length) return;
    utils.uploadedModelsConfig.forEach(function (config) {
      checkRules(config);
    });
  }, [utils.config]);
  var updateProperty = function updateProperty(action, props) {
    var _utils$asyncUpdateCon;
    if (!action) return;
    var data = JSON.parse(action.value);
    var mesh = utils.getMeshById(data.modelPart.patch.meshId);
    if (!mesh) return;
    mesh[props] = data.value;
    utils.asyncUpdateConfig(mesh, (_utils$asyncUpdateCon = {}, _utils$asyncUpdateCon[props] = data.value, _utils$asyncUpdateCon));
  };
  var updateMaterialProperty = function updateMaterialProperty(action) {
    if (!action) return;
    var data = JSON.parse(action.value);
    var mesh = utils.getMeshById(data.modelPart.patch.meshId);
    var _MaterialUpdate$updat = MaterialUpdate.updateMaterial(data.value, utils.config.textures),
      textures = _MaterialUpdate$updat.textures,
      properties = _MaterialUpdate$updat.properties;
    var _final = Object.assign(Object.assign({}, data.value), {
      patch: {
        properties: properties,
        textures: textures
      }
    });
    if (!mesh) return;
    utils.asyncUpdateConfig(mesh, {
      material: new MaterialAMA(_final)
    });
  };
  var changeCamera = function changeCamera(action) {
    var _a;
    if (!action) return;
    var data = JSON.parse(action.value);
    var mesh = utils.getMeshById(data.camera.value);
    if (mesh) {
      var currentConfig = utils.getCurrentConfigObj(mesh);
      if (!isCamera(currentConfig)) return;
      utils.setDynamicCamera({
        position: mesh.position,
        target: ((_a = currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.target) === null || _a === void 0 ? void 0 : _a.position) || new THREE.Vector3(0, 0, 0)
      });
    }
  };
  var onPointerMissed = function onPointerMissed(event) {
    if (utils.mode === AMAMode.VIEWER) return;
    if (event.type === 'click') {
      utils.setActiveMesh(null);
    }
  };
  var onClick = function onClick(event) {
    if (utils.mode === AMAMode.EDITOR) {
      if (event.type === 'click') {
        event.stopPropagation();
        utils.setActiveById(event.object.userData.id);
      }
      return;
    }
  };
  var onPointerDown = function onPointerDown(event) {
    if (utils.mode === AMAMode.EDITOR) return;
    onPointerDownCb();
    var clickCb = function clickCb(e, action) {
      if (!action) return;
      if (action.type_action === AMARuleTypeAction.ActivateAnimation) {
        if (typeof action.value === 'string') {
          var data = JSON.parse(action.value);
          utils.playAnimation(data.animation);
        }
      }
      if (action.type_action === AMARuleTypeAction.SetMaterial) {
        updateMaterialProperty(action);
      }
      if (action.type_action === AMARuleTypeAction.SetVisibility) {
        updateProperty(action, 'visible');
      }
      if (action.type_action === AMARuleTypeAction.SetActiveCamera) {
        changeCamera(action);
      }
    };
    checkRulesAndCondition(event.object, clickCb);
  };
  return {
    handlers: {
      onPointerMissed: onPointerMissed,
      onClick: onClick,
      onPointerDown: onPointerDown
    },
    setHovered: setHovered
  };
};
var useHoveredAnnotation = function useHoveredAnnotation() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _ref2.onPointerMoveCb;
    var _ref2$onPointerOutCb = _ref2.onPointerOutCb,
    onPointerOutCb = _ref2$onPointerOutCb === void 0 ? function () {} : _ref2$onPointerOutCb,
    _ref2$onPointerOverCb = _ref2.onPointerOverCb,
    onPointerOverCb = _ref2$onPointerOverCb === void 0 ? function () {} : _ref2$onPointerOverCb,
    _ref2$onPointerDownCb = _ref2.onPointerDownCb,
    onPointerDownCb = _ref2$onPointerDownCb === void 0 ? function () {} : _ref2$onPointerDownCb;
  var utils = utilsEditor();
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hovered = _useState4[0],
    setHovered = _useState4[1];
  useCursor(hovered);
  var checkRulesAndCondition = useCallback(function (obj) {
    var customCb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (event, value) {};
    var checkRules = function checkRules(config) {
      if (config.rules.length) {
        config.rules.forEach(function (item) {
          item.condition.forEach(function (el) {
            if (Number(el.connection_id) === obj.userData.dbId) {
              item.action.forEach(function (action) {
                customCb(undefined, action);
              });
              return;
            }
            if (Number(el.connection_id) === obj.userData.id) {
              item.action.forEach(function (action) {
                customCb(undefined, action);
              });
              return;
            }
          });
        });
      }
    };
    checkRules(utils.config);
    if (!utils.uploadedModelsConfig.length) return;
    utils.uploadedModelsConfig.forEach(function (config) {
      checkRules(config);
    });
  }, [utils.config]);
  var onPointerOver = function onPointerOver(event) {
    onPointerOverCb();
    if (utils.mode === AMAMode.EDITOR) {
      setHovered(true);
      return;
    }
    var cb = function cb() {
      return setHovered(true);
    };
    checkRulesAndCondition(event.object, cb);
  };
  var onPointerOut = function onPointerOut() {
    onPointerOutCb();
    setHovered(false);
  };
  var updateProperty = function updateProperty(action, props) {
    var _utils$asyncUpdateCon2;
    if (!action) return;
    var data = JSON.parse(action.value);
    var mesh = utils.getMeshById(data.modelPart.patch.meshId);
    if (!mesh) return;
    mesh[props] = data.value;
    utils.asyncUpdateConfig(mesh, (_utils$asyncUpdateCon2 = {}, _utils$asyncUpdateCon2[props] = data.value, _utils$asyncUpdateCon2));
  };
  var updateMaterialProperty = function updateMaterialProperty(action) {
    if (!action) return;
    var data = JSON.parse(action.value);
    var mesh = utils.getMeshById(data.modelPart.patch.meshId);
    var _MaterialUpdate$updat2 = MaterialUpdate.updateMaterial(data.value, utils.config.textures),
      textures = _MaterialUpdate$updat2.textures,
      properties = _MaterialUpdate$updat2.properties;
    var _final2 = Object.assign(Object.assign({}, data.value), {
      patch: {
        properties: properties,
        textures: textures
      }
    });
    if (!mesh) return;
    utils.asyncUpdateConfig(mesh, {
      material: new MaterialAMA(_final2)
    });
  };
  var changeCamera = function changeCamera(action) {
    var _a;
    if (!action) return;
    var data = JSON.parse(action.value);
    var mesh = utils.getMeshById(data.camera.value);
    if (mesh) {
      var currentConfig = utils.getCurrentConfigObj(mesh);
      if (!isCamera(currentConfig)) return;
      utils.setDynamicCamera({
        position: mesh.position,
        target: ((_a = currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.target) === null || _a === void 0 ? void 0 : _a.position) || new THREE.Vector3(0, 0, 0)
      });
    }
  };
  var onPointerMissed = function onPointerMissed(event) {
    if (event.type === 'click') {
      utils.setActiveMesh(null);
    }
  };
  var onClick = function onClick(event) {
    if (event.type === 'click') {
      if (event.object.name === TARGET_NAME) {
        if (!event.object.parent) return;
        utils.setActiveByHandle(event.object.parent);
        return;
      }
      event.stopPropagation();
      utils.setActiveById(event.object.userData.id);
    }
  };
  var onPointerDown = function onPointerDown(event) {
    if (utils.mode === AMAMode.EDITOR) return;
    onPointerDownCb();
    var clickCb = function clickCb(e, action) {
      if (!action) return;
      if (action.type_action === AMARuleTypeAction.ActivateAnimation) {
        if (typeof action.value === 'string') utils.playAnimation(action.value);
      }
      if (action.type_action === AMARuleTypeAction.SetMaterial) {
        updateMaterialProperty(action);
      }
      if (action.type_action === AMARuleTypeAction.SetVisibility) {
        updateProperty(action, 'visible');
      }
      if (action.type_action === AMARuleTypeAction.SetActiveCamera) {
        changeCamera(action);
      }
    };
    checkRulesAndCondition(event.object, clickCb);
  };
  return {
    handlers: {
      onPointerMissed: onPointerMissed,
      onClick: onClick,
      onPointerDown: onPointerDown,
      onPointerOver: onPointerOver,
      onPointerOut: onPointerOut
    },
    setHovered: setHovered
  };
};

var MeshObject = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var data = _ref.data,
    children = _ref.children;
  var _useHovered = useHovered(),
    handlers = _useHovered.handlers;
  useEffect(function () {
    if (!data.lazyLoad || !ref.current) return;
    var ti = setTimeout(function () {
      ref.current.visible = true;
    }, data.lazyLoadStep * 700);
    return function () {
      return clearTimeout(ti);
    };
  }, [ref]);
  return /*#__PURE__*/React__default.createElement("mesh", Object.assign({
    ref: ref,
    receiveShadow: data.receiveShadow,
    castShadow: data.castShadow,
    visible: !data.lazyLoad,
    position: data.position,
    rotation: data.rotation,
    scale: data.scale,
    name: data.name,
    geometry: data.geometry,
    userData: data.userData
  }, handlers), (data === null || data === void 0 ? void 0 : data.material) ? /*#__PURE__*/React__default.createElement(AMAStandardMaterial, {
    data: data.material
  }) : null, children);
});
var MeshObject$1 = /*#__PURE__*/React__default.memo(MeshObject);

var BasicObject$1 = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var data = _ref.data,
    children = _ref.children;
  var _useHovered = useHovered(),
    handlers = _useHovered.handlers;
  return /*#__PURE__*/React__default.createElement("object3D", Object.assign({
    ref: ref,
    receiveShadow: data.receiveShadow,
    castShadow: data.castShadow,
    visible: data.visible,
    position: data.position,
    rotation: data.rotation,
    scale: data.scale,
    name: data.name,
    userData: data.userData
  }, handlers), children);
});
var BasicObject$2 = /*#__PURE__*/React__default.memo(BasicObject$1);

var SkinnedMeshObject = function SkinnedMeshObject(_ref) {
  var data = _ref.data,
    children = _ref.children;
  var meshRef = useRef(null);
  return /*#__PURE__*/React__default.createElement("skinnedMesh", {
    ref: meshRef,
    receiveShadow: data.receiveShadow,
    visible: data.visible,
    castShadow: data.castShadow,
    name: data.name,
    geometry: data.geometry,
    skeleton: data.skeleton,
    userData: data.userData
  }, data ? /*#__PURE__*/React__default.createElement(AMAStandardMaterial, {
    data: data.material
  }) : null, children);
};

var DirectionalLight = function DirectionalLight(_ref) {
  var data = _ref.data;
  var _a, _b, _c, _d;
  var _utilsEditor = utilsEditor(),
    mode = _utilsEditor.mode;
  var lightHelper = useRef();
  var _useHovered = useHovered(),
    handlers = _useHovered.handlers;
  useHelper(mode === AMAMode.EDITOR && lightHelper, DirectionalLightHelper);
  return /*#__PURE__*/React__default.createElement(Sphere, Object.assign({
    args: [0.2, 0.2, 0.2],
    position: data.position,
    userData: data.userData,
    rotation: data.rotation,
    scale: data.scale,
    name: data.name
  }, handlers), /*#__PURE__*/React__default.createElement("meshStandardMaterial", {
    color: "hotpink",
    visible: false
  }), /*#__PURE__*/React__default.createElement("directionalLight", {
    position: [0, 0, 0],
    ref: lightHelper,
    castShadow: (_a = data.updatedLight) === null || _a === void 0 ? void 0 : _a.castShadow,
    intensity: (_b = data.updatedLight) === null || _b === void 0 ? void 0 : _b.intensity,
    color: (_c = data.updatedLight) === null || _c === void 0 ? void 0 : _c.color,
    visible: (_d = data.updatedLight) === null || _d === void 0 ? void 0 : _d.visible
  }));
};

var PlaneCustomComponent = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var data = _ref.data,
    children = _ref.children,
    selected = _ref.selected;
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
  var _useHovered = useHovered(),
    handlers = _useHovered.handlers;
  useHelper(selected && ref, THREE.BoxHelper);
  return /*#__PURE__*/React.createElement("mesh", Object.assign({
    ref: ref,
    receiveShadow: data.receiveShadow,
    castShadow: data.castShadow,
    visible: data.visible,
    userData: data.userData,
    position: data.position,
    rotation: data.rotation,
    scale: data.scale,
    name: data.name
  }, handlers), /*#__PURE__*/React.createElement("planeGeometry", {
    args: [(_a = data === null || data === void 0 ? void 0 : data.updatedGeometry) === null || _a === void 0 ? void 0 : _a.width, (_b = data === null || data === void 0 ? void 0 : data.updatedGeometry) === null || _b === void 0 ? void 0 : _b.height],
    attach: 'geometry'
  }), data.material ? /*#__PURE__*/React.createElement(AMAStandardMaterial, {
    data: data.material
  }) : /*#__PURE__*/React.createElement("meshStandardMaterial", {
    metalness: (_c = data.updatedMaterial) === null || _c === void 0 ? void 0 : _c.metalness,
    roughness: (_d = data.updatedMaterial) === null || _d === void 0 ? void 0 : _d.roughness,
    color: (_e = data.updatedMaterial) === null || _e === void 0 ? void 0 : _e.color,
    side: (_f = data.updatedMaterial) === null || _f === void 0 ? void 0 : _f.side,
    transparent: true,
    opacity: (_g = data.updatedMaterial) === null || _g === void 0 ? void 0 : _g.opacity,
    blending: ((_h = data.updatedMaterial) === null || _h === void 0 ? void 0 : _h.blending) ? (_j = data.updatedMaterial) === null || _j === void 0 ? void 0 : _j.blending : THREE.NormalBlending,
    wireframe: (_k = data.updatedMaterial) === null || _k === void 0 ? void 0 : _k.wireframe
  }), children);
});

var BoxCustomComponent = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var data = _ref.data,
    children = _ref.children,
    selected = _ref.selected;
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
  var _useHovered = useHovered(),
    handlers = _useHovered.handlers;
  useHelper(selected && ref, THREE.BoxHelper);
  return /*#__PURE__*/React.createElement("mesh", Object.assign({
    ref: ref,
    receiveShadow: data.receiveShadow,
    castShadow: data.castShadow,
    visible: data.visible,
    userData: data.userData,
    position: data.position,
    rotation: data.rotation,
    scale: data.scale,
    name: data.name
  }, handlers), /*#__PURE__*/React.createElement("boxGeometry", {
    args: [(_a = data === null || data === void 0 ? void 0 : data.updatedGeometry) === null || _a === void 0 ? void 0 : _a.width, (_b = data === null || data === void 0 ? void 0 : data.updatedGeometry) === null || _b === void 0 ? void 0 : _b.height, (_c = data === null || data === void 0 ? void 0 : data.updatedGeometry) === null || _c === void 0 ? void 0 : _c.depth]
  }), data.material ? /*#__PURE__*/React.createElement(AMAStandardMaterial, {
    data: data.material
  }) : /*#__PURE__*/React.createElement("meshStandardMaterial", {
    metalness: (_d = data.updatedMaterial) === null || _d === void 0 ? void 0 : _d.metalness,
    roughness: (_e = data.updatedMaterial) === null || _e === void 0 ? void 0 : _e.roughness,
    color: (_f = data.updatedMaterial) === null || _f === void 0 ? void 0 : _f.color,
    side: (_g = data.updatedMaterial) === null || _g === void 0 ? void 0 : _g.side,
    transparent: true,
    opacity: (_h = data.updatedMaterial) === null || _h === void 0 ? void 0 : _h.opacity,
    blending: ((_j = data.updatedMaterial) === null || _j === void 0 ? void 0 : _j.blending) ? (_k = data.updatedMaterial) === null || _k === void 0 ? void 0 : _k.blending : THREE.NormalBlending,
    wireframe: (_l = data.updatedMaterial) === null || _l === void 0 ? void 0 : _l.wireframe
  }), children);
});

var SphereCustomComponent = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var data = _ref.data,
    children = _ref.children,
    selected = _ref.selected;
  var _a, _b, _c, _d, _e, _f, _g, _h, _j;
  var _useHovered = useHovered(),
    handlers = _useHovered.handlers;
  useHelper(selected && ref, THREE.BoxHelper);
  return /*#__PURE__*/React.createElement("mesh", Object.assign({
    ref: ref,
    receiveShadow: data.receiveShadow,
    castShadow: data.castShadow,
    visible: data.visible,
    userData: data.userData,
    position: data.position,
    rotation: data.rotation,
    scale: data.scale,
    name: data.name
  }, handlers), /*#__PURE__*/React.createElement("sphereGeometry", {
    args: [(_a = data === null || data === void 0 ? void 0 : data.updatedGeometry) === null || _a === void 0 ? void 0 : _a.radius]
  }), data.material ? /*#__PURE__*/React.createElement(AMAStandardMaterial, {
    data: data.material
  }) : /*#__PURE__*/React.createElement("meshStandardMaterial", {
    metalness: (_b = data.updatedMaterial) === null || _b === void 0 ? void 0 : _b.metalness,
    roughness: (_c = data.updatedMaterial) === null || _c === void 0 ? void 0 : _c.roughness,
    color: (_d = data.updatedMaterial) === null || _d === void 0 ? void 0 : _d.color,
    side: (_e = data.updatedMaterial) === null || _e === void 0 ? void 0 : _e.side,
    transparent: true,
    opacity: (_f = data.updatedMaterial) === null || _f === void 0 ? void 0 : _f.opacity,
    blending: ((_g = data.updatedMaterial) === null || _g === void 0 ? void 0 : _g.blending) ? (_h = data.updatedMaterial) === null || _h === void 0 ? void 0 : _h.blending : THREE.NormalBlending,
    wireframe: (_j = data.updatedMaterial) === null || _j === void 0 ? void 0 : _j.wireframe
  }), children);
});

var SpotLight$1 = function SpotLight(_ref) {
  var data = _ref.data;
  var _a, _b, _c, _d, _e;
  var _utilsEditor = utilsEditor(),
    mode = _utilsEditor.mode;
  var lightHelper = useRef();
  var _useHovered = useHovered(),
    handlers = _useHovered.handlers;
  useHelper(mode === AMAMode.EDITOR && lightHelper, SpotLightHelper);
  return /*#__PURE__*/React__default.createElement(Sphere, Object.assign({
    position: data.position,
    userData: data.userData,
    rotation: data.rotation,
    scale: data.scale,
    name: data.name
  }, handlers), /*#__PURE__*/React__default.createElement("meshStandardMaterial", {
    color: "hotpink",
    visible: false
  }), /*#__PURE__*/React__default.createElement("spotLight", {
    position: [0, 0, 0],
    ref: lightHelper,
    castShadow: (_a = data.updatedLight) === null || _a === void 0 ? void 0 : _a.castShadow,
    intensity: (_b = data.updatedLight) === null || _b === void 0 ? void 0 : _b.intensity,
    color: (_c = data.updatedLight) === null || _c === void 0 ? void 0 : _c.color,
    visible: (_d = data.updatedLight) === null || _d === void 0 ? void 0 : _d.visible,
    angle: (_e = data.updatedLight) === null || _e === void 0 ? void 0 : _e.angle
  }));
};

var PointLight = function PointLight(_ref) {
  var data = _ref.data;
  var _a, _b, _c, _d;
  var _utilsEditor = utilsEditor(),
    mode = _utilsEditor.mode;
  var lightHelper = useRef();
  var _useHovered = useHovered(),
    handlers = _useHovered.handlers;
  useHelper(mode === AMAMode.EDITOR && lightHelper, PointLightHelper);
  return /*#__PURE__*/React__default.createElement(Sphere, Object.assign({
    position: data.position,
    userData: data.userData,
    rotation: data.rotation,
    scale: data.scale,
    name: data.name
  }, handlers), /*#__PURE__*/React__default.createElement("meshStandardMaterial", {
    color: "hotpink",
    visible: false
  }), /*#__PURE__*/React__default.createElement("pointLight", {
    position: [0, 0, 0],
    ref: lightHelper,
    castShadow: (_a = data.updatedLight) === null || _a === void 0 ? void 0 : _a.castShadow,
    intensity: (_b = data.updatedLight) === null || _b === void 0 ? void 0 : _b.intensity,
    color: (_c = data.updatedLight) === null || _c === void 0 ? void 0 : _c.color,
    visible: (_d = data.updatedLight) === null || _d === void 0 ? void 0 : _d.visible
  }));
};

var AreaLight = function AreaLight(_ref) {
  var data = _ref.data;
  var lightHelper = useRef();
  var _useHovered = useHovered(),
    handlers = _useHovered.handlers;
  return /*#__PURE__*/React__default.createElement(Sphere, Object.assign({
    position: data.position,
    userData: data.userData,
    rotation: data.rotation,
    scale: data.scale,
    name: data.name
  }, handlers), /*#__PURE__*/React__default.createElement("meshStandardMaterial", {
    color: "hotpink",
    visible: false
  }), /*#__PURE__*/React__default.createElement("rectAreaLight", {
    position: [0, 0, 0],
    ref: lightHelper,
    castShadow: true,
    "shadow-mapSize": 1024
  }));
};

var SpotLight = function SpotLight(_ref) {
  var data = _ref.data;
  var _a, _b, _c, _d;
  var _utilsEditor = utilsEditor(),
    mode = _utilsEditor.mode;
  var lightHelper = useRef();
  var _useHovered = useHovered(),
    handlers = _useHovered.handlers;
  useHelper(mode === AMAMode.EDITOR && lightHelper, HemisphereLightHelper, 1);
  return /*#__PURE__*/React__default.createElement(Sphere, Object.assign({
    position: data.position,
    userData: data.userData,
    rotation: data.rotation,
    scale: data.scale,
    name: data.name
  }, handlers), /*#__PURE__*/React__default.createElement("meshStandardMaterial", {
    color: "hotpink",
    visible: false
  }), /*#__PURE__*/React__default.createElement("hemisphereLight", {
    color: (_a = data.updatedLight) === null || _a === void 0 ? void 0 : _a.color,
    position: [0, 0, 0],
    ref: lightHelper,
    castShadow: (_b = data.updatedLight) === null || _b === void 0 ? void 0 : _b.castShadow,
    intensity: (_c = data.updatedLight) === null || _c === void 0 ? void 0 : _c.intensity,
    visible: (_d = data.updatedLight) === null || _d === void 0 ? void 0 : _d.visible
  }));
};

var CustomPerspectiveCamera = function CustomPerspectiveCamera(_ref) {
  var data = _ref.data;
  var _a;
  var cameraHelper = useRef(null);
  var _utilsEditor = utilsEditor(),
    activeCamera = _utilsEditor.activeCamera,
    mode = _utilsEditor.mode;
  var _useHovered = useHovered(),
    handlers = _useHovered.handlers;
  var showHelpers = ((_a = activeCamera === null || activeCamera === void 0 ? void 0 : activeCamera.userData) === null || _a === void 0 ? void 0 : _a.id) !== data.userData.id && mode === AMAMode.EDITOR;
  useHelper(showHelpers && cameraHelper, CameraHelper);
  useEffect(function () {
    var _a;
    if (cameraHelper.current) {
      cameraHelper.current.lookAt(new THREE.Vector3().copy((_a = data.target) === null || _a === void 0 ? void 0 : _a.position));
    }
  }, [cameraHelper]);
  return /*#__PURE__*/React__default.createElement(Sphere, Object.assign({
    args: [0.2, 0.2, 0.2],
    castShadow: false,
    position: data.position,
    userData: data.userData,
    rotation: data.rotation,
    scale: data.scale,
    name: data.name
  }, handlers), /*#__PURE__*/React__default.createElement("meshStandardMaterial", {
    color: "hotpink",
    visible: false
  }), /*#__PURE__*/React__default.createElement(PerspectiveCamera, {
    castShadow: false,
    ref: cameraHelper,
    position: [0, 0, 0]
  }));
};

var BasicObject = function BasicObject(_ref) {
  var data = _ref.data,
    children = _ref.children,
    selected = _ref.selected;
  var groupRef = useRef(null);
  var _useHovered = useHovered(),
    handlers = _useHovered.handlers;
  var _utilsEditor = utilsEditor(),
    setModelGroup = _utilsEditor.setModelGroup,
    mode = _utilsEditor.mode;
  useHelper(selected && groupRef, THREE.BoxHelper, 'yellow');
  useEffect(function () {
    if (groupRef.current) {
      setModelGroup(groupRef.current);
    }
  }, [groupRef.current, mode]);
  return /*#__PURE__*/React__default.createElement("group", Object.assign({
    ref: groupRef,
    visible: data.visible,
    position: data.position,
    rotation: data.rotation,
    scale: data.scale,
    name: data.name,
    userData: data.userData
  }, handlers), children);
};

var BoneComponent = function BoneComponent(_ref) {
  var data = _ref.data;
    _ref.selected;
    _ref.children;
  var _utilsEditor = utilsEditor(),
    mode = _utilsEditor.mode,
    activeAnimation = _utilsEditor.activeAnimation,
    config = _utilsEditor.config,
    setActiveAnimation = _utilsEditor.setActiveAnimation,
    getCurrentConfigObj = _utilsEditor.getCurrentConfigObj;
    _utilsEditor.getMeshByName;
  var boneRef = useRef(null);
  var _useAnimations = useAnimations(config.animations, boneRef),
    actions = _useAnimations.actions,
    mixer = _useAnimations.mixer;
    _useAnimations.clips;
  useHelper(mode === AMAMode.EDITOR && boneRef, THREE.SkeletonHelper);
  useEffect(function () {
    if (!config.additionalOptions.bone) return;
    animateModel();
    console.log('animate from bones');
    return function () {
      if (activeAnimation) {
        var animation = actions[activeAnimation];
        if (animation) {
          animation.fadeOut(0.5);
        }
      }
    };
  }, [activeAnimation, mode]);
  var animateModel = function animateModel() {
    if (activeAnimation) {
      if (mode === AMAMode.EDITOR) {
        mixer.stopAllAction();
        setActiveAnimation(null);
        return;
      }
      var animation = actions[activeAnimation];
      if (animation) {
        var timeAnim = animation.getClip().duration * 1000;
        animation.loop = THREE.LoopOnce;
        animation.reset().fadeIn(0.5).play();
        setTimeout(function () {
          setActiveAnimation(null);
        }, timeAnim);
      }
    }
  };
  var renderObject = function renderObject(value) {
    var data = getCurrentConfigObj(value);
    if (!data) return;
    if (!isSpecificObject(data, AMAMeshType.Bone)) return;
    return /*#__PURE__*/React__default.createElement("primitive", {
      key: data === null || data === void 0 ? void 0 : data.id,
      object: value,
      userData: data === null || data === void 0 ? void 0 : data.userData
    }, data.material ? /*#__PURE__*/React__default.createElement(AMAStandardMaterial, {
      data: data.material
    }) : null, value.children.map(renderObject));
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("primitive", {
    ref: boneRef,
    object: data.object,
    name: data.name,
    position: data.position,
    rotation: data.rotation,
    userData: data.userData,
    scale: data.scale,
    casShadow: false,
    receiveShadow: false
  }), boneRef.current && boneRef.current.children.map(renderObject));
};

var DuplicateModel = function DuplicateModel(path) {
  var _useGLTF = useGLTF(path ? path : ''),
    scene = _useGLTF.scene,
    materials = _useGLTF.materials,
    animations = _useGLTF.animations;
  var clone = useMemo(function () {
    return SkeletonUtils.clone(scene);
  }, [scene]);
  var _useGraph = useGraph(clone),
    nodes = _useGraph.nodes;
  return {
    nodes: nodes,
    materials: materials,
    animations: animations,
    clone: clone
  };
};

var TargetCustomComponent = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var data = _ref.data;
    _ref.children;
    var selected = _ref.selected;
  var _a;
  var _DuplicateModel = DuplicateModel(TARGET_CUSTOM_URL),
    clone = _DuplicateModel.clone;
  var _useHovered = useHovered(),
    handlers = _useHovered.handlers;
  var editor = utilsEditor();
  useHelper(selected && ref, THREE.BoxHelper);
  useEffect(function () {
    if (data.userData.parent && ref.current) {
      var parentNode = editor.getMeshById(data.userData.parent);
      if (!parentNode) return;
      parentNode === null || parentNode === void 0 ? void 0 : parentNode.add(ref.current);
    }
  }, [data, (_a = editor.threeState) === null || _a === void 0 ? void 0 : _a.scene, ref.current]);
  return /*#__PURE__*/React.createElement(Box, Object.assign({
    ref: ref,
    args: [0.5, 0.5, 0.5],
    castShadow: false,
    position: data.position,
    rotation: data.rotation,
    scale: data.scale,
    userData: data.userData,
    name: data.name,
    visible: editor.mode === AMAMode.EDITOR
  }, handlers), /*#__PURE__*/React.createElement("meshStandardMaterial", {
    color: "hotpink",
    visible: false
  }), /*#__PURE__*/React.createElement("primitive", {
    object: clone
  }));
});

var ObjectComponent = function ObjectComponent(_ref) {
  var data = _ref.data,
    children = _ref.children,
    material = _ref.material,
    textures = _ref.textures,
    selected = _ref.selected,
    setAnimationsData = _ref.setAnimationsData;
  var _utilsEditor = utilsEditor(),
    config = _utilsEditor.config,
    uploadedModelsConfig = _utilsEditor.uploadedModelsConfig;
  var nodeRef = useRef(null);
  var updateAnimations = function updateAnimations(config) {
    config.animations.forEach(function (activeClip) {
      var tracks = [];
      activeClip.tracks.forEach(function (i) {
        var t = function t(name) {
          return name.replace(/[_\s]/g, '').split('.')[0];
        };
        var noDot = function noDot(str) {
          return str.replace(/[_\s.]/g, '');
        };
        if (t(i.name) === noDot(data.name)) {
          tracks.push(i);
        }
      });
      if (!tracks.length) return;
      var animationData = {
        name: activeClip.name,
        nodes: nodeRef.current,
        tracks: tracks,
        clip: activeClip
      };
      setAnimationsData(function (prevState) {
        return [].concat(_toConsumableArray(prevState), [animationData]);
      });
    });
  };
  useEffect(function () {
    if (!nodeRef.current) return;
    if (uploadedModelsConfig.length) {
      uploadedModelsConfig.forEach(function (uploadConfig) {
        updateAnimations(uploadConfig);
      });
    }
    updateAnimations(config);
  }, [nodeRef]);
  var renderObject = function renderObject() {
    switch (data.type) {
      case AMAMeshType.Mesh:
        return /*#__PURE__*/React__default.createElement(MeshObject$1, {
          ref: nodeRef,
          data: data
        }, children);
      case AMAMeshType.SkinnedMesh:
        return /*#__PURE__*/React__default.createElement(SkinnedMeshObject, {
          data: data,
          textures: textures,
          material: material
        }, children);
      case AMAMeshType.Target:
        return /*#__PURE__*/React__default.createElement(TargetCustomComponent, {
          key: data.id,
          ref: nodeRef,
          selected: selected,
          data: data
        }, children);
      case AMAMeshType.Bone:
        return /*#__PURE__*/React__default.createElement(BoneComponent, {
          selected: selected,
          data: data
        }, children);
      case AMAMeshType.Plane:
        return /*#__PURE__*/React__default.createElement(PlaneCustomComponent, {
          ref: nodeRef,
          selected: selected,
          data: data,
          key: data.id
        }, children);
      case AMAMeshType.Sphere:
        return /*#__PURE__*/React__default.createElement(SphereCustomComponent, {
          ref: nodeRef,
          selected: selected,
          data: data,
          key: data.id
        }, children);
      case AMAMeshType.Box:
        return /*#__PURE__*/React__default.createElement(BoxCustomComponent, {
          ref: nodeRef,
          selected: selected,
          data: data,
          key: data.id
        }, children);
      case AMAMeshType.Directional_Light:
        return /*#__PURE__*/React__default.createElement(DirectionalLight, {
          data: data
        });
      case AMAMeshType.Spot_Light:
        return /*#__PURE__*/React__default.createElement(SpotLight$1, {
          data: data
        });
      case AMAMeshType.Point_Light:
        return /*#__PURE__*/React__default.createElement(PointLight, {
          data: data
        });
      case AMAMeshType.Area_Light:
        return /*#__PURE__*/React__default.createElement(AreaLight, {
          data: data
        });
      case AMAMeshType.Hemisphere_Light:
        return /*#__PURE__*/React__default.createElement(SpotLight, {
          data: data
        });
      case AMAMeshType.PerspectiveCamera:
        return /*#__PURE__*/React__default.createElement(CustomPerspectiveCamera, {
          data: data
        });
      case AMAMeshType.Default_Camera:
        return /*#__PURE__*/React__default.createElement(CustomPerspectiveCamera, {
          data: data
        });
      case AMAMeshType.Model_Group:
        return /*#__PURE__*/React__default.createElement(BasicObject, {
          selected: selected,
          data: data
        }, children);
      default:
        return /*#__PURE__*/React__default.createElement(BasicObject$2, {
          ref: nodeRef,
          data: data
        }, children);
    }
  };
  return renderObject();
};

var useModelTree = function useModelTree() {
  var _utilsEditor = utilsEditor(),
    config = _utilsEditor.config,
    uploadedModelsConfig = _utilsEditor.uploadedModelsConfig;
  var res = React__default.useMemo(function () {
    var objectsWithoutParent = config.objects.filter(function (object) {
      return !config.objects.some(function (el) {
        return el.children.includes(object.id);
      });
    });
    var uploadedModelsWithoutParent = uploadedModelsConfig.map(function (config) {
      return config ? config.objects.filter(function (object) {
        return !config.objects.some(function (el) {
          return el.children.includes(object.id);
        });
      }) : [];
    });
    var transformObject = function transformObject(object, currentModel) {
      var res = {
        object: object,
        children: currentModel.objects.filter(function (i) {
          return object.children.includes(i.id);
        }).map(function (i) {
          return transformObject(i, currentModel);
        })
      };
      if (object.type === AMAMeshType.Mesh || object.type === AMAMeshType.SkinnedMesh) {
        if (!(object === null || object === void 0 ? void 0 : object.material)) return res;
        var targetMaterial = currentModel.materials.find(function (el) {
          return el.id === object.material.id;
        });
        if (targetMaterial) {
          res.material = targetMaterial;
          if (!targetMaterial.textures) return {};
          res.textures = Object.keys(targetMaterial.textures).map(function (key) {
            if (!targetMaterial.textures) return {};
            var tId = targetMaterial.textures[key];
            var tData = currentModel.textures.find(function (el) {
              return el.id === tId;
            });
            if (tData) {
              return tData;
            }
            return {};
          }).filter(function (i) {
            return i;
          });
        }
      }
      return res;
    };
    var getUploadedCustom = function getUploadedCustom(config) {
      return config.customObjects.map(function (i, inx) {
        return transformObject(i, config);
      }) || [];
    };
    var objectTrees = objectsWithoutParent.map(function (i) {
      return transformObject(i, config);
    });
    var customObjects = config.customObjects.map(function (i) {
      return transformObject(i, config);
    });
    var uploadedCustoms = uploadedModelsConfig.map(function (config) {
      return getUploadedCustom(config);
    }).flat();
    var modelsTrees = uploadedModelsWithoutParent.flat().map(function (i, inx) {
      return transformObject(i, uploadedModelsConfig[inx]);
    });
    return [].concat(_toConsumableArray(objectTrees), _toConsumableArray(customObjects), _toConsumableArray(uploadedCustoms), _toConsumableArray(modelsTrees));
  }, [config]);
  return res;
};

var AnimationAMA = /*#__PURE__*/function () {
  function AnimationAMA(clip, mixer) {
    _classCallCheck(this, AnimationAMA);
    this.clip = clip;
    this.mixer = mixer;
    this.action = mixer.clipAction(clip);
    this.clock = new THREE.Clock();
    this.isPlaying = false;
    this.toggleClick = false;
    this.playClick = false;
    this.time = undefined;
  }
  _createClass(AnimationAMA, [{
    key: "toggle",
    value: function toggle() {
      clearTimeout(this.time);
      if (this.toggleClick) {
        this.stop();
        return this;
      }
      this.toggleClick = true;
      this.play();
      return this;
    }
  }, {
    key: "play",
    value: function play(props) {
      var _this = this;
      clearTimeout(this.time);
      this.isPlaying = true;
      this.playClick = true;
      this.animate();
      this.action.loop = THREE.LoopOnce;
      this.action.clampWhenFinished = true;
      this.action.reset().fadeIn(0.5).play();
      this.time = setTimeout(function () {
        _this.isPlaying = false;
      }, this.clip.duration * 1000);
      return this;
    }
  }, {
    key: "stop",
    value: function stop() {
      var _this2 = this;
      clearTimeout(this.time);
      this.isPlaying = true;
      this.playClick = false;
      this.toggleClick = false;
      this.animate();
      this.action.fadeOut(0.5);
      this.time = setTimeout(function () {
        _this2.isPlaying = false;
      }, this.clip.duration * 1000);
      return this;
    }
  }, {
    key: "animate",
    value: function animate() {
      if (!this.isPlaying) return;
      var mixerUpdateDelta = this.clock.getDelta();
      this.mixer.update(mixerUpdateDelta);
      console.log('update');
      requestAnimationFrame(this.animate.bind(this));
    }
  }]);
  return AnimationAMA;
}();

var ModelContainer = function ModelContainer() {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    animationsData = _useState2[0],
    setAnimationsData = _useState2[1];
  var group = useRef(null);
  var treeNodes = useModelTree();
  var three = useThree();
  var utils = utilsEditor();
  window.three = three;
  window.customizer = utilsEditor();
  function mergeArrayObjects(arr, key) {
    return arr.reduce(function (result, current) {
      var keyValue = current[key];
      if (!result[keyValue]) {
        result[keyValue] = Object.assign({}, current);
      } else {
        for (var prop in current) {
          if (current.hasOwnProperty(prop) && prop !== key && prop !== 'clip') {
            if (!Array.isArray(result[keyValue][prop])) {
              result[keyValue][prop] = [result[keyValue][prop]];
            }
            result[keyValue][prop].push(current[prop]);
          }
        }
      }
      return result;
    }, {});
  }
  var createAnimations = function createAnimations() {
    if (!animationsData.length) return;
    var mergedObject = mergeArrayObjects(animationsData, 'name');
    Object.keys(mergedObject).forEach(function (anim) {
      var _a;
      var _group = new THREE.Group();
      var item = mergedObject[anim];
      var node = item.nodes;
      if (item.nodes.length) {
        if ((_a = item.nodes[0]) === null || _a === void 0 ? void 0 : _a.parent) item.nodes[0].parent.add(_group);
        item.nodes.forEach(function (i) {
          node = _group;
          _group.add(i);
        });
      }
      var mixer = new THREE.AnimationMixer(node);
      if (utils.animations.get(anim)) return;
      utils.animations.set(anim, new AnimationAMA(item.clip, mixer));
    });
  };
  var updatingIncomingCameras = function updatingIncomingCameras() {
    var customObjs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var configObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var uploadedModels = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var defaultCamera = customObjs.filter(function (i) {
      return i.type === AMAMeshType.Default_Camera;
    });
    var customCameras = [].concat(_toConsumableArray(customObjs), _toConsumableArray(configObj)).filter(function (i) {
      return i.type === AMAMeshType.PerspectiveCamera;
    });
    var cameras = [].concat(_toConsumableArray(defaultCamera), _toConsumableArray(customCameras));
    var uploadedModelsCameras = [];
    utils.setModelConfig(Object.assign(Object.assign({}, utils.config), {
      cameras: cameras
    }));
    if (!uploadedModels.length) return;
    uploadedModels.forEach(function (config) {
      uploadedModelsCameras.push.apply(uploadedModelsCameras, _toConsumableArray(config.cameras));
    });
    utils.setModelConfig(Object.assign(Object.assign({}, utils.config), {
      cameras: [].concat(_toConsumableArray(cameras), uploadedModelsCameras)
    }));
  };
  var isSelected = function isSelected(id, object) {
    if (object.object && utils.activeMesh) {
      return utils.activeMesh.userData.id === id;
    }
    return false;
  };
  var updateCamera = function updateCamera() {
    var _a, _b, _c;
    var cam = three.camera,
      controls = three.controls;
    var orbitCont = controls;
    var camera = cam;
    if (!utils.activeCamera || !orbitCont) return;
    var current = utils.getCurrentConfigObj(utils.activeCamera);
    var target = new THREE.Vector3();
    if (!current) return;
    if (!isCamera(current)) return;
    updateCameraProps(orbitCont, camera, current);
    if (orbitCont && (current === null || current === void 0 ? void 0 : current.target)) {
      var cameraTarget = ((_a = current.target) === null || _a === void 0 ? void 0 : _a.object) ? (_c = utils.getMeshById((_b = current.target) === null || _b === void 0 ? void 0 : _b.object)) === null || _c === void 0 ? void 0 : _c.position : current.target.position;
      if (!cameraTarget) return;
      orbitCont.target = new THREE.Vector3().copy(cameraTarget);
      return;
    }
    if (utils.activeCamera.children[0]) {
      utils.activeCamera.children[0].getWorldDirection(target);
    }
    camera.updateProjectionMatrix();
    var mouseCam = utils.activeCamera.position.clone();
    orbitCont.target = mouseCam.add(target);
  };
  var updateCameraProps = function updateCameraProps(controls, camera, updatedObj) {
    var setDefaultProps = function setDefaultProps() {
      Object.keys(DEFAULT_CONTROLS_PROPS).forEach(function (item) {
        controls[item] = DEFAULT_CONTROLS_PROPS[item];
      });
      Object.keys(DEFAULT_CAMERA_PROPS).forEach(function (item) {
        var value = DEFAULT_CAMERA_PROPS[item];
        if (value === null || value === void 0 ? void 0 : value.isVector3) {
          camera[item].copy(value);
          return;
        }
        camera[item] = value;
      });
    };
    var updateProps = function updateProps(target, obj) {
      Object.keys(updatedObj[target]).forEach(function (item) {
        var value = updatedObj[target][item];
        if (value === null || value === void 0 ? void 0 : value.isVector3) {
          obj[item].copy(value);
          return;
        }
        obj[item] = value;
      });
    };
    setDefaultProps();
    camera.position.copy(utils.activeCamera.position);
    camera.userData = {
      id: updatedObj.id
    };
    if (updatedObj === null || updatedObj === void 0 ? void 0 : updatedObj.updatedControls) {
      updateProps('updatedControls', controls);
    }
    if (updatedObj === null || updatedObj === void 0 ? void 0 : updatedObj.updatedCamera) {
      updateProps('updatedCamera', camera);
    }
    camera.updateProjectionMatrix();
  };
  var renderObject = function renderObject(object) {
    return /*#__PURE__*/React.createElement(ObjectComponent, {
      key: object.object.id,
      data: object.object,
      material: object.material,
      textures: object.textures,
      selected: isSelected(object.object.userData.id, object),
      setAnimationsData: setAnimationsData
    }, /*#__PURE__*/React.createElement(Edges, {
      visible: isSelected(object.object.userData.id, object),
      scale: 1,
      renderOrder: 1000,
      threshold: 15
    }, /*#__PURE__*/React.createElement("meshBasicMaterial", {
      transparent: true,
      opacity: 0.8,
      color: "yellow",
      depthTest: false
    })), object.children.map(renderObject));
  };
  useEffect(function () {
    var _a;
    if (!utils.activeCamera) return;
    var camera = three.camera;
    var defaultCamera = _.isEqual((_a = utils.activeCamera) === null || _a === void 0 ? void 0 : _a.position, DEFAULT_CAMERA_POSITION);
    var current = utils.getCurrentConfigObj(utils.activeCamera);
    if (!current) return;
    camera.userData = {
      id: current.id
    };
    if (defaultCamera && utils.modelGroup) {
      utils.focus(utils.modelGroup);
      return;
    }
    updateCamera();
  }, [utils.activeCamera, three.controls, utils.modelGroup]);
  useEffect(function () {
    utils.setSceneTree(treeNodes);
  }, [utils.isUpdatedTree]);
  useEffect(function () {
    if (three) {
      utils.createThreeScene(three);
    }
  }, []);
  useEffect(function () {
    createAnimations();
  }, [animationsData]);
  useEffect(function () {
    var _utils$config = utils.config,
      customObjects = _utils$config.customObjects,
      objects = _utils$config.objects;
    updatingIncomingCameras(customObjects, objects, utils.uploadedModelsConfig);
  }, [utils.uploadedModelsConfig, utils.config.customObjects]);
  useEffect(function () {
    var ti = setInterval(function () {
      var finder = window.three.scene.getObjectByName(utils.config.objects[0].name);
      if (finder) {
        clearInterval(ti);
        setTimeout(function () {
          utils.setLoadingProgress({
            isLoading: false,
            isLoaded: false,
            isRendered: true
          });
        }, 500);
      }
    }, 100);
    return function () {
      return clearInterval(ti);
    };
  }, []);
  return /*#__PURE__*/React.createElement("group", {
    ref: group,
    name: GROUP_NODES_NAME
  }, treeNodes.map(renderObject));
};

var useLifecycle = function useLifecycle(_ref) {
  var _ref$onLoaded = _ref.onLoaded,
    onLoaded = _ref$onLoaded === void 0 ? function () {} : _ref$onLoaded,
    _ref$onLoading = _ref.onLoading,
    onLoading = _ref$onLoading === void 0 ? function () {} : _ref$onLoading,
    _ref$onRendered = _ref.onRendered,
    onRendered = _ref$onRendered === void 0 ? function () {} : _ref$onRendered;
  var _utilsEditor = utilsEditor(),
    loadingProgress = _utilsEditor.loadingProgress;
  var fireAction = function fireAction(loadingProgress) {
    if (loadingProgress.isLoading) {
      onLoading();
      return;
    }
    if (loadingProgress.isLoaded) {
      onLoaded();
      return;
    }
    if (loadingProgress.isRendered) {
      onRendered();
      return;
    }
  };
  useEffect(function () {
    fireAction(loadingProgress);
  }, [loadingProgress]);
  return "useLifecycle";
};

var useLoadProduct = function useLoadProduct(assetId, apiKey) {
  var data = suspend(function () {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return loadProduct(assetId, apiKey);
          case 2:
            return _context.abrupt("return", _context.sent);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  }, [assetId]);
  return data;
};

var utilsMaterial = function utilsMaterial() {
  var materialState = useMaterialState(function (state) {
    return state;
  });
  var createMaterialFromAsset = function createMaterialFromAsset(data) {
    var textures = [];
    var materialAsset = data.assets[0];
    var defaultTextures = materialAsset.patch.textures;
    for (var key in defaultTextures) {
      var tx = data.assets.filter(function (i) {
        return i.type === 'texture';
      });
      var find = _.find(tx, {
        id: defaultTextures[key]
      });
      if (find) {
        var _final = Object.assign(Object.assign({}, find), {
          type: key
        });
        textures.push(new TextureAMA(_final));
      }
    }
    return MaterialUpdate.updateMaterial(materialAsset, textures);
  };
  var updateMaterialProps = function updateMaterialProps(props) {
    if (!materialState.config) return;
    materialState.setConfig(Object.assign(Object.assign({}, materialState.config), {
      properties: Object.assign(Object.assign({}, materialState.config.properties), props)
    }));
  };
  var updateMaterialTextures = function updateMaterialTextures(texture) {
    if (!materialState.config) return;
    var otherTextures = materialState.config.textures.filter(function (item) {
      return item.type !== texture.type;
    });
    materialState.setConfig(Object.assign(Object.assign({}, materialState.config), {
      textures: [].concat(_toConsumableArray(otherTextures), [texture])
    }));
  };
  return Object.assign({
    updateMaterialProps: updateMaterialProps,
    updateMaterialTextures: updateMaterialTextures,
    createMaterialFromAsset: createMaterialFromAsset
  }, materialState);
};

var Model = /*#__PURE__*/memo(function (_ref) {
  var data = _ref.data;
  var update = useTransformDefault(data.modelData);
  var modelConfig = useTransformModelConfig(update, data);
  var utils = utilsEditor();
  var addParentForModel = function addParentForModel() {
    var _a;
    if (!((_a = data.target) === null || _a === void 0 ? void 0 : _a.userData)) return;
    var modelNode = utils.getMeshByName(data.name);
    var parent = utils.getMeshById(data.target.userData.parent);
    if (!parent || !modelNode) return;
    parent.add(modelNode);
  };
  useEffect(function () {
    if (modelConfig === null || modelConfig === void 0 ? void 0 : modelConfig.uploadedModels) {
      utils.setDynamicModels([].concat(_toConsumableArray(utils.dynamicModels), _toConsumableArray(modelConfig === null || modelConfig === void 0 ? void 0 : modelConfig.uploadedModels)));
    }
    if (modelConfig) {
      var model = modelConfig.objects[0];
      utils.asyncUploadModelsConfig(modelConfig);
      if (model.visible) utils.cache.set(model.name, model);
    }
  }, []);
  useEffect(function () {
    utils.runUpdateTree({});
    addParentForModel();
  }, [utils.uploadedModelsConfig]);
  return null;
});
var Material = /*#__PURE__*/memo(function (_ref2) {
  var data = _ref2.data;
  var materialEdit = utilsMaterial();
  var utils = utilsEditor();
  var three = useThree();
  useEffect(function () {
    var ti = setInterval(function () {
      var targetModel = null;
      three.scene.traverse(function (item) {
        var _a, _b, _c;
        if (!((_a = data.target) === null || _a === void 0 ? void 0 : _a.id)) return;
        if (((_b = item === null || item === void 0 ? void 0 : item.userData) === null || _b === void 0 ? void 0 : _b.id) === ((_c = data.target) === null || _c === void 0 ? void 0 : _c.id)) {
          targetModel = item;
        }
      });
      if (data && targetModel) {
        var material = materialEdit.createMaterialFromAsset(data);
        var config = Object.assign(Object.assign({}, data), {
          material: material
        });
        utils.updateObjectData(targetModel, {
          material: material
        });
        utils.asyncUploadMaterialsConfig(config);
        clearInterval(ti);
      }
    }, 300);
  }, [data]);
  return null;
});
var ModelUploaded = /*#__PURE__*/memo(function (_ref3) {
  var data = _ref3.data;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    modelData = _useState2[0],
    setModelData = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    materialsData = _useState4[0],
    setMaterialsData = _useState4[1];
  var _utilsEditor = utilsEditor(),
    apiKey = _utilsEditor.apiKey;
  var assetData = useLoadProduct(data.modelData ? '' : data.modelId, apiKey);
  var updateAsset = function updateAsset(asset) {
    if (!asset || !asset.assets || !asset.assets.length) {
      return;
    }
    asset.assets[0] = Object.assign(Object.assign({}, asset.assets[0]), {
      patch: Object.assign(Object.assign({}, asset.assets[0].patch), {
        config: Object.assign(Object.assign({}, asset.assets[0].patch.config), {
          customObjects: (data === null || data === void 0 ? void 0 : data.updatedCustomNodes) || [],
          objects: (data === null || data === void 0 ? void 0 : data.updatedItems) || []
        })
      })
    });
  };
  useEffect(function () {
    if (assetData) {
      var targetAsset = assetData.assets && assetData.assets.length ? assetData.assets[0] : null;
      if (targetAsset && targetAsset.type === 'material') {
        setMaterialsData(Object.assign(Object.assign({}, data), assetData));
        return;
      }
      updateAsset(assetData);
      setModelData(Object.assign(Object.assign({}, data), {
        modelData: Object.assign(Object.assign({}, assetData), data.modelData)
      }));
      return;
    }
    if (data.modelData) {
      updateAsset(data.modelData);
      setModelData(data);
    }
  }, [assetData]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, modelData ? /*#__PURE__*/React.createElement(Model, {
    data: modelData
  }) : null, materialsData ? /*#__PURE__*/React.createElement(Material, {
    data: materialsData
  }) : null);
});

var modulesQuill = {
  toolbar: false,
  clipboard: {
    matchVisual: false
  }
};
var HotspotRender = function HotspotRender(_ref) {
  var annotationData = _ref.annotationData;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    visibleInfo = _useState2[0],
    setVisibleInfo = _useState2[1];
  var texture = useTexture$1(HOTSPOT_URL);
  var utils = utilsEditor();
  var _useHoveredAnnotation = useHoveredAnnotation({
      onPointerOverCb: function onPointerOverCb() {
        return setVisibleInfo(true);
      },
      onPointerOutCb: function onPointerOutCb() {
        return setVisibleInfo(false);
      }
    }),
    handlers = _useHoveredAnnotation.handlers;
  return /*#__PURE__*/React.createElement("group", null, /*#__PURE__*/React.createElement("sprite", Object.assign({
    name: annotationData.name,
    position: annotationData.position,
    scale: 0.07,
    userData: annotationData.userData
  }, handlers), /*#__PURE__*/React.createElement("spriteMaterial", {
    depthWrite: false,
    map: texture,
    sizeAttenuation: false
  }), utils.mode === AMAMode.VIEWER && (annotationData === null || annotationData === void 0 ? void 0 : annotationData.value) && /*#__PURE__*/React.createElement(Html, {
    style: {
      transition: 'all 0.5s',
      opacity: !visibleInfo ? 0 : 1,
      transform: "scale(" + (!visibleInfo ? 0.5 : 1) + ")",
      backgroundColor: 'rgba(0,0,0,0.3)',
      color: 'white',
      marginLeft: '20px',
      userSelect: 'none',
      minWidth: '200px'
    }
  }, /*#__PURE__*/React.createElement(ReactQuill, {
    modules: modulesQuill,
    defaultValue: annotationData.value,
    readOnly: true
  }))));
};

var HotspotCreate = function HotspotCreate() {
  var texture = useTexture$1(HOTSPOT_URL);
  var _utilsEditor = utilsEditor(),
    newAnnotation = _utilsEditor.newAnnotation;
  return /*#__PURE__*/React.createElement("group", null, /*#__PURE__*/React.createElement("sprite", {
    position: newAnnotation === null || newAnnotation === void 0 ? void 0 : newAnnotation.position,
    scale: 0.07
  }, /*#__PURE__*/React.createElement("spriteMaterial", {
    depthWrite: false,
    map: texture,
    sizeAttenuation: false
  })));
};

var HotspotEdit = function HotspotEdit(_ref) {
  var modelConfig = _ref.modelConfig;
  var utils = utilsEditor();
  var newAnnotation = function newAnnotation() {
    if (modelConfig.annotations) {
      var newHs = modelConfig.annotations.find(function (i) {
        return i.type === AMAMeshType.New_Annotation;
      });
      if (newHs) {
        return /*#__PURE__*/React.createElement(HotspotCreate, null);
      }
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    }
  };
  var allAnnotations = function allAnnotations() {
    if (modelConfig.annotations) {
      var _final = [];
      var checkAnnotations = function checkAnnotations(config) {
        config.annotations.forEach(function (i) {
          if (i.type !== AMAMeshType.New_Annotation) {
            _final.push(i);
          }
        });
      };
      checkAnnotations(utils.config);
      if (utils.uploadedModelsConfig.length) {
        utils.uploadedModelsConfig.forEach(function (config) {
          checkAnnotations(config);
        });
      }
      return _final.map(function (hs) {
        return /*#__PURE__*/React.createElement(HotspotRender, {
          key: hs.id,
          annotationData: hs
        });
      });
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, allAnnotations(), newAnnotation());
};

var ModelEditor = function ModelEditor() {
  var utils = utilsEditor();
  var runOnPageLoadAnimation = function runOnPageLoadAnimation() {
    if (utils.mode !== AMAMode.VIEWER) return;
    console.log('Renderer');
    var checkRules = function checkRules(innerConfig) {
      var _a;
      (_a = innerConfig.rules) === null || _a === void 0 ? void 0 : _a.forEach(function (rule) {
        rule.condition.forEach(function (condition) {
          if (condition.type_condition !== AMARuleTypeCondition.OnPageLoad) {
            return;
          }
          rule.action.forEach(function (action) {
            if (action.type_action !== AMARuleTypeAction.ActivateAnimation) return;
            setTimeout(function () {
              if (typeof action.value === 'string') {
                var data = JSON.parse(action.value);
                utils.playAnimation(data.animation);
              }
            }, 500);
          });
        });
      });
    };
    checkRules(utils.config);
    if (!utils.uploadedModelsConfig.length) return;
    utils.uploadedModelsConfig.forEach(function (uploadedConfig) {
      checkRules(uploadedConfig);
    });
  };
  useLifecycle({
    onRendered: runOnPageLoadAnimation
  });
  return /*#__PURE__*/React.createElement(SceneSetup, null, utils.activeMesh && utils.mode === AMAMode.EDITOR ? /*#__PURE__*/React.createElement(TransformControls$1, {
    object: utils.activeMesh,
    mode: utils.transformMode,
    showZ: utils.axis,
    showX: utils.axis,
    showY: utils.axis
  }) : null, /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(ModelContainer, null), utils.dynamicModels.map(function (config) {
    return /*#__PURE__*/React.createElement(React.Suspense, {
      fallback: null
    }, /*#__PURE__*/React.createElement(ModelUploaded, {
      data: config
    }));
  })), /*#__PURE__*/React.createElement(HotspotEdit, {
    modelConfig: utils.config
  }));
};

var ModelPlayer = function ModelPlayer(_ref) {
  var assetId = _ref.assetId,
    apiKey = _ref.apiKey,
    presetConfig = _ref.presetConfig,
    data = _ref.data;
  var configDefault = useLoadProduct(assetId, apiKey);
  var update = useTransformDefault(data ? data : configDefault);
  var modelConfig = useTransformModelConfig(update);
  var _utilsEditor = utilsEditor(),
    setModelConfig = _utilsEditor.setModelConfig,
    setDefaultConfig = _utilsEditor.setDefaultConfig,
    setDefaultModel = _utilsEditor.setDefaultModel,
    changeMode = _utilsEditor.changeMode,
    toggleGrid = _utilsEditor.toggleGrid,
    changeBackgroundColor = _utilsEditor.changeBackgroundColor,
    setDefaultCameraPosition = _utilsEditor.setDefaultCameraPosition,
    setActiveCamera = _utilsEditor.setActiveCamera,
    setAnimateCamera = _utilsEditor.setAnimateCamera,
    setActiveEnvironment = _utilsEditor.setActiveEnvironment,
    changePostProcessing = _utilsEditor.changePostProcessing,
    setDynamicModels = _utilsEditor.setDynamicModels,
    setDefaultCamera = _utilsEditor.setDefaultCamera,
    setApiKey = _utilsEditor.setApiKey,
    cache = _utilsEditor.cache;
  var defaultModel = useMemo(function () {
    if (!configDefault && !data) return;
    return _.find(data ? data.assets : configDefault.assets, {
      type: 'model'
    });
  }, [configDefault]);
  var defaultCamera = useMemo(function () {
    var _a, _b;
    if (!modelConfig) return;
    var cameraPosition = (_b = (_a = update.scene.model.patch.config) === null || _a === void 0 ? void 0 : _a.defaultSceneConfig) === null || _b === void 0 ? void 0 : _b.cameraPosition;
    var camera = _.find(modelConfig.customObjects, {
      id: cameraPosition === null || cameraPosition === void 0 ? void 0 : cameraPosition.cameraId
    });
    if (isCamera(camera)) return camera;
    return _.find(modelConfig.customObjects, {
      type: 'Default_Camera'
    });
  }, [modelConfig]);
  var firstTimeOption = function firstTimeOption() {
    if (!modelConfig || !defaultCamera) return;
    if ((presetConfig === null || presetConfig === void 0 ? void 0 : presetConfig.mode) === AMAMode.VIEWER) {
      var camera = ObjectSceneFactory.getObject(AMAMeshType.Default_Camera, firstTimeCamera);
      setModelConfig(Object.assign(Object.assign({}, modelConfig), {
        customObjects: [].concat(_toConsumableArray(modelConfig.customObjects), [camera])
      }));
      setActiveCamera(camera);
      return;
    }
    setActiveCamera(defaultCamera);
  };
  useEffect(function () {
    if (modelConfig && defaultModel && defaultCamera) {
      var model = modelConfig.objects[0];
      setDefaultModel(defaultModel);
      setModelConfig(modelConfig);
      setDefaultConfig(modelConfig);
      setDefaultCamera(defaultCamera);
      firstTimeOption();
      if (model.visible) cache.set(model.name, model);
      console.log('save configs');
    }
  }, [configDefault, defaultModel]);
  useEffect(function () {
    if (modelConfig === null || modelConfig === void 0 ? void 0 : modelConfig.uploadedModels) {
      setDynamicModels(modelConfig === null || modelConfig === void 0 ? void 0 : modelConfig.uploadedModels);
    }
    if (presetConfig) {
      var initConfig = Object.assign(Object.assign({}, DEFAULT_INIT_CONFIG), presetConfig);
      console.log('update', initConfig);
      changeMode(initConfig.mode);
      toggleGrid(initConfig.grid);
      changeBackgroundColor(initConfig.backgroundColor);
    }
    if (modelConfig && modelConfig.defaultSceneConfig) {
      var config = modelConfig.defaultSceneConfig;
      if (config.grid !== undefined) toggleGrid(config.grid);
      if (config.animateCamera !== undefined) setAnimateCamera(config.animateCamera);
      if (config.activeEnvironment !== undefined) setActiveEnvironment(config.activeEnvironment);
      if (config.backgroundColor) changeBackgroundColor(config.backgroundColor);
      if (config.cameraPosition) setDefaultCameraPosition(config.cameraPosition);
      if (config.postProcessing) changePostProcessing(config.postProcessing);
    }
  }, []);
  useEffect(function () {
    if (apiKey) {
      setApiKey(apiKey);
    }
  }, [apiKey]);
  return /*#__PURE__*/React.createElement(ModelEditor, null);
};

var customObjects = function customObjects() {
  var utils = utilsEditor();
  function createDefaultData(type) {
    var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : THREE.MathUtils.generateUUID();
    return {
      name: "custom_" + type,
      type: type,
      id: id,
      children: [],
      position: new THREE.Vector3(0, 0, 0),
      scale: new THREE.Vector3(1, 1, 1),
      rotation: new THREE.Euler(0, 0, 0),
      custom: true,
      userData: {},
      visible: true
    };
  }
  var createModel = function createModel(data) {
    return new Promise(function (resolve) {
      utils.setDynamicModels([].concat(_toConsumableArray(utils.getCurrent().dynamicModels), [data]));
      var ti = setInterval(function () {
        var finder = window.three.scene.getObjectByName(data.name);
        if (finder) {
          var res = finder.children.filter(function (i) {
            return 'isMesh' in i;
          });
          var _final = res.every(function (i) {
            return i.visible;
          });
          if (finder && _final) {
            clearInterval(ti);
            setTimeout(function () {
              resolve(finder);
            }, 500);
          }
        }
      }, 100);
    });
  };
  var createTarget = function createTarget(id) {
    var defaultData = createDefaultData(AMAMeshType.Target, id);
    var newObj = ObjectSceneFactory.getObject(AMAMeshType.Target, defaultData);
    utils.createCustomObjects(newObj);
    setTimeout(function () {
      utils.setActiveById(newObj.userData.id);
    }, 100);
    return newObj;
  };
  var createPlane = function createPlane(id) {
    var defaultData = createDefaultData(AMAMeshType.Plane, id);
    var newObj = ObjectSceneFactory.getObject(AMAMeshType.Plane, defaultData);
    utils.createCustomObjects(newObj);
    setTimeout(function () {
      utils.setActiveById(newObj.userData.id);
    }, 0);
    return newObj;
  };
  var createBox = function createBox(id) {
    var defaultData = createDefaultData(AMAMeshType.Box, id);
    var newObj = ObjectSceneFactory.getObject(defaultData.type, defaultData);
    utils.createCustomObjects(newObj);
    setTimeout(function () {
      utils.setActiveById(newObj.userData.id);
    }, 0);
    return newObj;
  };
  var createSphere = function createSphere(id) {
    var defaultData = createDefaultData(AMAMeshType.Sphere, id);
    var newObj = ObjectSceneFactory.getObject(defaultData.type, defaultData);
    utils.createCustomObjects(newObj);
    setTimeout(function () {
      utils.setActiveById(newObj.userData.id);
    }, 0);
    return newObj;
  };
  var create = {
    plane: createPlane,
    box: createBox,
    sphere: createSphere,
    target: createTarget,
    model: createModel
  };
  return {
    create: create
  };
};

var customLights = function customLights() {
  var utils = utilsEditor();
  function createDefaultData(type) {
    var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : THREE.MathUtils.generateUUID();
    return {
      name: "custom_" + type,
      type: type,
      id: id,
      children: [],
      position: new THREE.Vector3(0, 0, 0),
      scale: new THREE.Vector3(1, 1, 1),
      rotation: new THREE.Euler(0, 0, 0),
      custom: true,
      userData: {},
      visible: true
    };
  }
  var createDirectionalLight = function createDirectionalLight() {
    var defaultData = createDefaultData(AMAMeshType.Directional_Light);
    var newObj = ObjectSceneFactory.getObject(AMAMeshType.Directional_Light, defaultData);
    utils.createCustomObjects(newObj);
    setTimeout(function () {
      utils.setActiveById(newObj.userData.id);
    }, 0);
    return newObj;
  };
  var createSpotLight = function createSpotLight() {
    var defaultData = createDefaultData(AMAMeshType.Spot_Light);
    var newObj = ObjectSceneFactory.getObject(defaultData.type, defaultData);
    utils.createCustomObjects(newObj);
    setTimeout(function () {
      utils.setActiveById(newObj.userData.id);
    }, 0);
    return newObj;
  };
  var createPointLight = function createPointLight() {
    var defaultData = createDefaultData(AMAMeshType.Point_Light);
    var newObj = ObjectSceneFactory.getObject(defaultData.type, defaultData);
    utils.createCustomObjects(newObj);
    setTimeout(function () {
      utils.setActiveById(newObj.userData.id);
    }, 0);
    return newObj;
  };
  var createHemisphereLight = function createHemisphereLight() {
    var defaultData = createDefaultData(AMAMeshType.Hemisphere_Light);
    var newObj = ObjectSceneFactory.getObject(defaultData.type, defaultData);
    utils.createCustomObjects(newObj);
    setTimeout(function () {
      utils.setActiveById(newObj.userData.id);
    }, 0);
    return newObj;
  };
  var create = {
    directional: createDirectionalLight,
    spot: createSpotLight,
    point: createPointLight,
    hemisphere: createHemisphereLight
  };
  return {
    create: create
  };
};

var customCameras = function customCameras() {
  var utils = utilsEditor();
  var createDefaultData = function createDefaultData(type) {
    return {
      name: "custom_" + type,
      type: type,
      id: THREE.MathUtils.generateUUID(),
      children: [],
      position: new THREE.Vector3(-5, 5, 5),
      scale: new THREE.Vector3(1, 1, 1),
      rotation: new THREE.Euler(0, 0, 0),
      custom: true,
      userData: {},
      visible: true,
      target: {
        position: new THREE.Vector3(0, 0, 0)
      }
    };
  };
  var createPerspectiveCamera = function createPerspectiveCamera() {
    var defaultData = createDefaultData(AMAMeshType.PerspectiveCamera);
    var newObj = ObjectSceneFactory.getObject(defaultData.type, defaultData);
    utils.createCustomObjects(newObj);
    setTimeout(function () {
      utils.setActiveById(newObj.userData.id);
    }, 0);
    return newObj;
  };
  var create = {
    perspective: createPerspectiveCamera
  };
  return {
    create: create
  };
};

var InstanceScene = function InstanceScene(_ref) {
  var presetConfig = _ref.presetConfig,
    assetId = _ref.assetId,
    apiKey = _ref.apiKey,
    data = _ref.data;
  var configDefault = useLoadProduct(assetId, apiKey);
  var updatedAsset = useTransformDefaultScene(data ? data : configDefault);
  var config = createDefaultConfig(updatedAsset);
  var utils = utilsEditor();
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    _useState2[1];
  var defaultCamera = useMemo(function () {
    var _a;
    if (!config || !updatedAsset) return;
    var cameraPosition = (_a = updatedAsset.defaultSceneConfig) === null || _a === void 0 ? void 0 : _a.cameraPosition;
    var camera = _.find(config.customObjects, {
      id: cameraPosition === null || cameraPosition === void 0 ? void 0 : cameraPosition.cameraId
    });
    if (camera) return camera;
    return _.find(config.customObjects, {
      type: 'Default_Camera'
    });
  }, []);
  var defaultModel = useMemo(function () {
    if (!configDefault && !data) return;
    return _.find(data ? data.assets : configDefault.assets, {
      type: 'scene'
    });
  }, [configDefault]);
  useEffect(function () {
    if (config === null || config === void 0 ? void 0 : config.uploadedModels) {
      utils.setDynamicModels(_toConsumableArray(config === null || config === void 0 ? void 0 : config.uploadedModels));
      return;
    }
  }, []);
  useEffect(function () {
    if (defaultCamera && config && defaultModel) {
      utils.setActiveCamera(defaultCamera);
      utils.setDefaultModel(defaultModel);
      utils.setModelConfig(config);
      utils.setDefaultConfig(config);
      console.log('save configs');
    }
  }, [defaultCamera]);
  useEffect(function () {
    if (presetConfig) {
      var initConfig = Object.assign(Object.assign({}, DEFAULT_INIT_CONFIG), presetConfig);
      utils.changeMode(initConfig.mode);
      utils.toggleGrid(initConfig.grid);
      utils.changeBackgroundColor(initConfig.backgroundColor);
    }
    if (config && config.defaultSceneConfig) {
      var configInstance = config.defaultSceneConfig;
      if (configInstance.grid !== undefined) utils.toggleGrid(configInstance.grid);
      if (configInstance.animateCamera !== undefined) utils.setAnimateCamera(configInstance.animateCamera);
      if (configInstance.activeEnvironment !== undefined) utils.setActiveEnvironment(configInstance.activeEnvironment);
      if (configInstance.backgroundColor) utils.changeBackgroundColor(configInstance.backgroundColor);
      if (configInstance.cameraPosition) utils.setDefaultCameraPosition(configInstance.cameraPosition);
      if (configInstance.postProcessing) utils.changePostProcessing(configInstance.postProcessing);
    }
  }, []);
  useEffect(function () {
    utils.setLoadingProgress({
      isLoading: false,
      isLoaded: false,
      isRendered: true
    });
  }, []);
  return /*#__PURE__*/React__default.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React__default.createElement(ModelEditor, null));
};

var EditorConstructor = function EditorConstructor(_ref) {
  var type = _ref.type,
    assetId = _ref.assetId,
    apiKey = _ref.apiKey,
    presetConfig = _ref.presetConfig,
    data = _ref.data,
    uploadedModels = _ref.uploadedModels;
  useEffect(function () {
    return function () {
      resetAllStores();
      clear$1([assetId]);
    };
  }, []);
  window.customizer = utilsEditor();
  window.customObjects = {
    shape: customObjects(),
    light: customLights(),
    camera: customCameras()
  };
  var render = function render() {
    switch (type) {
      case 'material':
        return /*#__PURE__*/React__default.createElement(MaterialPlayer, {
          assetId: assetId,
          apiKey: apiKey,
          data: data
        });
      case 'model':
        return /*#__PURE__*/React__default.createElement(ModelPlayer, {
          assetId: assetId,
          apiKey: apiKey,
          presetConfig: presetConfig,
          data: data,
          uploadedModels: uploadedModels
        });
      case 'scene':
        return /*#__PURE__*/React__default.createElement(InstanceScene, {
          presetConfig: presetConfig,
          apiKey: apiKey,
          assetId: assetId,
          data: data,
          uploadedModels: uploadedModels
        });
      default:
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
    }
  };
  return render();
};

var PreviewModel = function PreviewModel(_ref) {
  var dataModel = _ref.dataModel,
    previewRef = _ref.previewRef;
  var modelRef = useRef(null);
  var model = useGLTF(dataModel.url);
  var _utilsEditor = utilsEditor(),
    focus = _utilsEditor.focus;
  useEffect(function () {
    if (modelRef.current) {
      focus(modelRef.current);
    }
  }, [modelRef.current]);
  var RenderPreview = function RenderPreview() {
    var _useThree = useThree(),
      gl = _useThree.gl;
    var _utilsEditor2 = utilsEditor(),
      updatePreview = _utilsEditor2.updatePreview;
    useEffect(function () {
      if ((gl === null || gl === void 0 ? void 0 : gl.domElement) && (modelRef === null || modelRef === void 0 ? void 0 : modelRef.current) && model) {
        if (previewRef.current) return;
        setTimeout(function () {
          var screenshot = gl.domElement.toDataURL();
          previewRef.current = screenshot;
          updatePreview(Object.assign(Object.assign({}, dataModel), {
            preview: screenshot
          }));
        }, 300);
      }
    }, [gl, modelRef === null || modelRef === void 0 ? void 0 : modelRef.current, model]);
    return /*#__PURE__*/React__default.createElement("mesh", null);
  };
  return /*#__PURE__*/React__default.createElement(SceneSetup, null, /*#__PURE__*/React__default.createElement(RenderPreview, null), /*#__PURE__*/React__default.createElement("primitive", {
    ref: modelRef,
    object: model.scene
  }));
};

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = descriptors && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();

var arraySetLength = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray(O) && !getOwnPropertyDescriptor$1(O, 'length').writable) {
    throw $TypeError('Cannot set read only .length');
  } return O.length = length;
} : function (O, length) {
  return O.length = length;
};

var HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport('splice');

var max$1 = Math.max;
var min$1 = Math.min;

// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$1 }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min$1(max$1(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
    }
    doesNotExceedSafeInteger(len + insertCount - actualDeleteCount);
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else deletePropertyOrThrow(O, to);
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) deletePropertyOrThrow(O, k - 1);
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else deletePropertyOrThrow(O, to);
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    arraySetLength(O, len - actualDeleteCount + insertCount);
    return A;
  }
});

var ARRAY_BUFFER = 'ArrayBuffer';
var ArrayBuffer$1 = arrayBuffer[ARRAY_BUFFER];
var NativeArrayBuffer = global_1[ARRAY_BUFFER];

// `ArrayBuffer` constructor
// https://tc39.es/ecma262/#sec-arraybuffer-constructor
_export({ global: true, constructor: true, forced: NativeArrayBuffer !== ArrayBuffer$1 }, {
  ArrayBuffer: ArrayBuffer$1
});

setSpecies(ARRAY_BUFFER);

// `DataView` constructor
// https://tc39.es/ecma262/#sec-dataview-constructor
_export({ global: true, constructor: true, forced: !arrayBufferBasicDetection }, {
  DataView: arrayBuffer.DataView
});

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var $Array = Array;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = lengthOfArrayLike(O);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (isConstructor(Constructor) && (Constructor === $Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === $Array || Constructor === undefined) {
        return arraySlice(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? $Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});

// `Int8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
typedArrayConstructor('Int8', function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

// `Int16Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
typedArrayConstructor('Int16', function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

// `Uint16Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
typedArrayConstructor('Uint16', function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

// `Uint32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
typedArrayConstructor('Uint32', function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

// `Float32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
typedArrayConstructor('Float32', function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

var test = [];
var nativeSort = functionUncurryThis(test.sort);
var push = functionUncurryThis(test.push);

// IE8-
var FAILS_ON_UNDEFINED = fails(function () {
  test.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails(function () {
  test.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict('sort');

var STABLE_SORT = !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (engineV8Version) return engineV8Version < 70;
  if (engineFfVersion && engineFfVersion > 3) return;
  if (engineIsIeOrEdge) return true;
  if (engineWebkitVersion) return engineWebkitVersion < 603;

  var result = '';
  var code, chr, value, index;

  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66: case 69: case 70: case 72: value = 3; break;
      case 68: case 71: value = 4; break;
      default: value = 2;
    }

    for (index = 0; index < 47; index++) {
      test.push({ k: chr + index, v: value });
    }
  }

  test.sort(function (a, b) { return b.v - a.v; });

  for (index = 0; index < test.length; index++) {
    chr = test[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});

var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString_1(x) > toString_1(y) ? 1 : -1;
  };
};

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
_export({ target: 'Array', proto: true, forced: FORCED }, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aCallable(comparefn);

    var array = toObject(this);

    if (STABLE_SORT) return comparefn === undefined ? nativeSort(array) : nativeSort(array, comparefn);

    var items = [];
    var arrayLength = lengthOfArrayLike(array);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) push(items, array[index]);
    }

    arraySort(items, getSortCompare(comparefn));

    itemsLength = lengthOfArrayLike(items);
    index = 0;

    while (index < itemsLength) array[index] = items[index++];
    while (index < arrayLength) deletePropertyOrThrow(array, index++);

    return array;
  }
});

// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
var sameValue = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

// @@search logic
fixRegexpWellKnownSymbolLogic('search', function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible(this);
      var searcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, SEARCH);
      return searcher ? functionCall(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString_1(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (string) {
      var rx = anObject(this);
      var S = toString_1(string);
      var res = maybeCallNative(nativeSearch, rx, S);

      if (res.done) return res.value;

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regexpExecAbstract(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});

// @@match logic
fixRegexpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, MATCH);
      return matcher ? functionCall(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString_1(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject(this);
      var S = toString_1(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regexpExecAbstract(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regexpExecAbstract(rx, S)) !== null) {
        var matchStr = toString_1(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});

var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;







// eslint-disable-next-line es/no-string-prototype-startswith -- safe
var nativeStartsWith = functionUncurryThisClause(''.startsWith);
var stringSlice = functionUncurryThisClause(''.slice);
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegexpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
_export({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = toString_1(requireObjectCoercible(this));
    notARegexp(searchString);
    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = toString_1(searchString);
    return nativeStartsWith
      ? nativeStartsWith(that, search, index)
      : stringSlice(that, index, index + search.length) === search;
  }
});

// `Set` constructor
// https://tc39.es/ecma262/#sec-set-objects
collection('Set', function (init) {
  return function Set() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);

// `Number.EPSILON` constant
// https://tc39.es/ecma262/#sec-number.epsilon
_export({ target: 'Number', stat: true, nonConfigurable: true, nonWritable: true }, {
  EPSILON: Math.pow(2, -52)
});

var log = Math.log;
var LOG10E = Math.LOG10E;

// eslint-disable-next-line es/no-math-log10 -- safe
var mathLog10 = Math.log10 || function log10(x) {
  return log(x) * LOG10E;
};

// `Math.log10` method
// https://tc39.es/ecma262/#sec-math.log10
_export({ target: 'Math', stat: true }, {
  log10: mathLog10
});

var quot = /"/g;
var replace = functionUncurryThis(''.replace);

// `CreateHTML` abstract operation
// https://tc39.es/ecma262/#sec-createhtml
var createHtml = function (string, tag, attribute, value) {
  var S = toString_1(requireObjectCoercible(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + replace(toString_1(value), quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
var stringHtmlForced = function (METHOD_NAME) {
  return fails(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};

// `String.prototype.sub` method
// https://tc39.es/ecma262/#sec-string.prototype.sub
_export({ target: 'String', proto: true, forced: stringHtmlForced('sub') }, {
  sub: function sub() {
    return createHtml(this, 'sub', '', '');
  }
});

/**
 * @param {BufferGeometry} geometry
 * @param {number} drawMode
 * @return {BufferGeometry}
 */
function toTrianglesDrawMode(geometry, drawMode) {
  if (drawMode === TrianglesDrawMode) {
    console.warn('THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles.');
    return geometry;
  }
  if (drawMode === TriangleFanDrawMode || drawMode === TriangleStripDrawMode) {
    var index = geometry.getIndex();

    // generate index if not present

    if (index === null) {
      var indices = [];
      var position = geometry.getAttribute('position');
      if (position !== undefined) {
        for (var i = 0; i < position.count; i++) {
          indices.push(i);
        }
        geometry.setIndex(indices);
        index = geometry.getIndex();
      } else {
        console.error('THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible.');
        return geometry;
      }
    }

    //

    var numberOfTriangles = index.count - 2;
    var newIndices = [];
    if (drawMode === TriangleFanDrawMode) {
      // gl.TRIANGLE_FAN

      for (var _i10 = 1; _i10 <= numberOfTriangles; _i10++) {
        newIndices.push(index.getX(0));
        newIndices.push(index.getX(_i10));
        newIndices.push(index.getX(_i10 + 1));
      }
    } else {
      // gl.TRIANGLE_STRIP

      for (var _i12 = 0; _i12 < numberOfTriangles; _i12++) {
        if (_i12 % 2 === 0) {
          newIndices.push(index.getX(_i12));
          newIndices.push(index.getX(_i12 + 1));
          newIndices.push(index.getX(_i12 + 2));
        } else {
          newIndices.push(index.getX(_i12 + 2));
          newIndices.push(index.getX(_i12 + 1));
          newIndices.push(index.getX(_i12));
        }
      }
    }
    if (newIndices.length / 3 !== numberOfTriangles) {
      console.error('THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.');
    }

    // build final geometry

    var newGeometry = geometry.clone();
    newGeometry.setIndex(newIndices);
    newGeometry.clearGroups();
    return newGeometry;
  } else {
    console.error('THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:', drawMode);
    return geometry;
  }
}

var GLTFLoader = /*#__PURE__*/function (_Loader) {
  _inherits(GLTFLoader, _Loader);
  var _super = _createSuper(GLTFLoader);
  function GLTFLoader(manager) {
    var _this;
    _classCallCheck(this, GLTFLoader);
    _this = _super.call(this, manager);
    _this.dracoLoader = null;
    _this.ktx2Loader = null;
    _this.meshoptDecoder = null;
    _this.pluginCallbacks = [];
    _this.register(function (parser) {
      return new GLTFMaterialsClearcoatExtension(parser);
    });
    _this.register(function (parser) {
      return new GLTFTextureBasisUExtension(parser);
    });
    _this.register(function (parser) {
      return new GLTFTextureWebPExtension(parser);
    });
    _this.register(function (parser) {
      return new GLTFTextureAVIFExtension(parser);
    });
    _this.register(function (parser) {
      return new GLTFMaterialsSheenExtension(parser);
    });
    _this.register(function (parser) {
      return new GLTFMaterialsTransmissionExtension(parser);
    });
    _this.register(function (parser) {
      return new GLTFMaterialsVolumeExtension(parser);
    });
    _this.register(function (parser) {
      return new GLTFMaterialsIorExtension(parser);
    });
    _this.register(function (parser) {
      return new GLTFMaterialsEmissiveStrengthExtension(parser);
    });
    _this.register(function (parser) {
      return new GLTFMaterialsSpecularExtension(parser);
    });
    _this.register(function (parser) {
      return new GLTFMaterialsIridescenceExtension(parser);
    });
    _this.register(function (parser) {
      return new GLTFMaterialsAnisotropyExtension(parser);
    });
    _this.register(function (parser) {
      return new GLTFLightsExtension(parser);
    });
    _this.register(function (parser) {
      return new GLTFMeshoptCompression(parser);
    });
    _this.register(function (parser) {
      return new GLTFMeshGpuInstancing(parser);
    });
    return _this;
  }
  _createClass(GLTFLoader, [{
    key: "load",
    value: function load(url, onLoad, onProgress, onError) {
      var scope = this;
      var resourcePath;
      if (this.resourcePath !== '') {
        resourcePath = this.resourcePath;
      } else if (this.path !== '') {
        resourcePath = this.path;
      } else {
        resourcePath = LoaderUtils.extractUrlBase(url);
      }

      // Tells the LoadingManager to track an extra item, which resolves after
      // the model is fully loaded. This means the count of items loaded will
      // be incorrect, but ensures manager.onLoad() does not fire early.
      this.manager.itemStart(url);
      var _onError = function _onError(e) {
        if (onError) {
          onError(e);
        } else {
          console.error(e);
        }
        scope.manager.itemError(url);
        scope.manager.itemEnd(url);
      };
      var loader = new FileLoader(this.manager);
      loader.setPath(this.path);
      loader.setResponseType('arraybuffer');
      loader.setRequestHeader(this.requestHeader);
      loader.setWithCredentials(this.withCredentials);
      loader.load(url, function (data) {
        try {
          scope.parse(data, resourcePath, function (gltf) {
            onLoad(gltf);
            scope.manager.itemEnd(url);
          }, _onError);
        } catch (e) {
          _onError(e);
        }
      }, onProgress, _onError);
    }
  }, {
    key: "setDRACOLoader",
    value: function setDRACOLoader(dracoLoader) {
      this.dracoLoader = dracoLoader;
      return this;
    }
  }, {
    key: "setDDSLoader",
    value: function setDDSLoader() {
      throw new Error('THREE.GLTFLoader: "MSFT_texture_dds" no longer supported. Please update to "KHR_texture_basisu".');
    }
  }, {
    key: "setKTX2Loader",
    value: function setKTX2Loader(ktx2Loader) {
      this.ktx2Loader = ktx2Loader;
      return this;
    }
  }, {
    key: "setMeshoptDecoder",
    value: function setMeshoptDecoder(meshoptDecoder) {
      this.meshoptDecoder = meshoptDecoder;
      return this;
    }
  }, {
    key: "register",
    value: function register(callback) {
      if (this.pluginCallbacks.indexOf(callback) === -1) {
        this.pluginCallbacks.push(callback);
      }
      return this;
    }
  }, {
    key: "unregister",
    value: function unregister(callback) {
      if (this.pluginCallbacks.indexOf(callback) !== -1) {
        this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(callback), 1);
      }
      return this;
    }
  }, {
    key: "parse",
    value: function parse(data, path, onLoad, onError) {
      var json;
      var extensions = {};
      var plugins = {};
      var textDecoder = new TextDecoder();
      if (typeof data === 'string') {
        json = JSON.parse(data);
      } else if (data instanceof ArrayBuffer) {
        var magic = textDecoder.decode(new Uint8Array(data, 0, 4));
        if (magic === BINARY_EXTENSION_HEADER_MAGIC) {
          try {
            extensions[EXTENSIONS.KHR_BINARY_GLTF] = new GLTFBinaryExtension(data);
          } catch (error) {
            if (onError) onError(error);
            return;
          }
          json = JSON.parse(extensions[EXTENSIONS.KHR_BINARY_GLTF].content);
        } else {
          json = JSON.parse(textDecoder.decode(data));
        }
      } else {
        json = data;
      }
      if (json.asset === undefined || json.asset.version[0] < 2) {
        if (onError) onError(new Error('THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported.'));
        return;
      }
      var parser = new GLTFParser(json, {
        path: path || this.resourcePath || '',
        crossOrigin: this.crossOrigin,
        requestHeader: this.requestHeader,
        manager: this.manager,
        ktx2Loader: this.ktx2Loader,
        meshoptDecoder: this.meshoptDecoder
      });
      parser.fileLoader.setRequestHeader(this.requestHeader);
      for (var i = 0; i < this.pluginCallbacks.length; i++) {
        var plugin = this.pluginCallbacks[i](parser);
        plugins[plugin.name] = plugin;

        // Workaround to avoid determining as unknown extension
        // in addUnknownExtensionsToUserData().
        // Remove this workaround if we move all the existing
        // extension handlers to plugin system
        extensions[plugin.name] = true;
      }
      if (json.extensionsUsed) {
        for (var _i2 = 0; _i2 < json.extensionsUsed.length; ++_i2) {
          var extensionName = json.extensionsUsed[_i2];
          var extensionsRequired = json.extensionsRequired || [];
          switch (extensionName) {
            case EXTENSIONS.KHR_MATERIALS_UNLIT:
              extensions[extensionName] = new GLTFMaterialsUnlitExtension();
              break;
            case EXTENSIONS.KHR_DRACO_MESH_COMPRESSION:
              extensions[extensionName] = new GLTFDracoMeshCompressionExtension(json, this.dracoLoader);
              break;
            case EXTENSIONS.KHR_TEXTURE_TRANSFORM:
              extensions[extensionName] = new GLTFTextureTransformExtension();
              break;
            case EXTENSIONS.KHR_MESH_QUANTIZATION:
              extensions[extensionName] = new GLTFMeshQuantizationExtension();
              break;
            default:
              if (extensionsRequired.indexOf(extensionName) >= 0 && plugins[extensionName] === undefined) {
                console.warn('THREE.GLTFLoader: Unknown extension "' + extensionName + '".');
              }
          }
        }
      }
      parser.setExtensions(extensions);
      parser.setPlugins(plugins);
      parser.parse(onLoad, onError);
    }
  }, {
    key: "parseAsync",
    value: function parseAsync(data, path) {
      var scope = this;
      return new Promise(function (resolve, reject) {
        scope.parse(data, path, resolve, reject);
      });
    }
  }]);
  return GLTFLoader;
}(Loader);
/* GLTFREGISTRY */
function GLTFRegistry() {
  var objects = {};
  return {
    get: function get(key) {
      return objects[key];
    },
    add: function add(key, object) {
      objects[key] = object;
    },
    remove: function remove(key) {
      delete objects[key];
    },
    removeAll: function removeAll() {
      objects = {};
    }
  };
}

/*********************************/
/********** EXTENSIONS ***********/
/*********************************/

var EXTENSIONS = {
  KHR_BINARY_GLTF: 'KHR_binary_glTF',
  KHR_DRACO_MESH_COMPRESSION: 'KHR_draco_mesh_compression',
  KHR_LIGHTS_PUNCTUAL: 'KHR_lights_punctual',
  KHR_MATERIALS_CLEARCOAT: 'KHR_materials_clearcoat',
  KHR_MATERIALS_IOR: 'KHR_materials_ior',
  KHR_MATERIALS_SHEEN: 'KHR_materials_sheen',
  KHR_MATERIALS_SPECULAR: 'KHR_materials_specular',
  KHR_MATERIALS_TRANSMISSION: 'KHR_materials_transmission',
  KHR_MATERIALS_IRIDESCENCE: 'KHR_materials_iridescence',
  KHR_MATERIALS_ANISOTROPY: 'KHR_materials_anisotropy',
  KHR_MATERIALS_UNLIT: 'KHR_materials_unlit',
  KHR_MATERIALS_VOLUME: 'KHR_materials_volume',
  KHR_TEXTURE_BASISU: 'KHR_texture_basisu',
  KHR_TEXTURE_TRANSFORM: 'KHR_texture_transform',
  KHR_MESH_QUANTIZATION: 'KHR_mesh_quantization',
  KHR_MATERIALS_EMISSIVE_STRENGTH: 'KHR_materials_emissive_strength',
  EXT_TEXTURE_WEBP: 'EXT_texture_webp',
  EXT_TEXTURE_AVIF: 'EXT_texture_avif',
  EXT_MESHOPT_COMPRESSION: 'EXT_meshopt_compression',
  EXT_MESH_GPU_INSTANCING: 'EXT_mesh_gpu_instancing'
};

/**
 * Punctual Lights Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_lights_punctual
 */
var GLTFLightsExtension = /*#__PURE__*/function () {
  function GLTFLightsExtension(parser) {
    _classCallCheck(this, GLTFLightsExtension);
    this.parser = parser;
    this.name = EXTENSIONS.KHR_LIGHTS_PUNCTUAL;

    // Object3D instance caches
    this.cache = {
      refs: {},
      uses: {}
    };
  }
  _createClass(GLTFLightsExtension, [{
    key: "_markDefs",
    value: function _markDefs() {
      var parser = this.parser;
      var nodeDefs = this.parser.json.nodes || [];
      for (var nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++) {
        var nodeDef = nodeDefs[nodeIndex];
        if (nodeDef.extensions && nodeDef.extensions[this.name] && nodeDef.extensions[this.name].light !== undefined) {
          parser._addNodeRef(this.cache, nodeDef.extensions[this.name].light);
        }
      }
    }
  }, {
    key: "_loadLight",
    value: function _loadLight(lightIndex) {
      var parser = this.parser;
      var cacheKey = 'light:' + lightIndex;
      var dependency = parser.cache.get(cacheKey);
      if (dependency) return dependency;
      var json = parser.json;
      var extensions = json.extensions && json.extensions[this.name] || {};
      var lightDefs = extensions.lights || [];
      var lightDef = lightDefs[lightIndex];
      var lightNode;
      var color = new Color(0xffffff);
      if (lightDef.color !== undefined) color.setRGB(lightDef.color[0], lightDef.color[1], lightDef.color[2], LinearSRGBColorSpace);
      var range = lightDef.range !== undefined ? lightDef.range : 0;
      switch (lightDef.type) {
        case 'directional':
          lightNode = new DirectionalLight$1(color);
          lightNode.target.position.set(0, 0, -1);
          lightNode.add(lightNode.target);
          break;
        case 'point':
          lightNode = new PointLight$1(color);
          lightNode.distance = range;
          break;
        case 'spot':
          lightNode = new SpotLight$2(color);
          lightNode.distance = range;
          // Handle spotlight properties.
          lightDef.spot = lightDef.spot || {};
          lightDef.spot.innerConeAngle = lightDef.spot.innerConeAngle !== undefined ? lightDef.spot.innerConeAngle : 0;
          lightDef.spot.outerConeAngle = lightDef.spot.outerConeAngle !== undefined ? lightDef.spot.outerConeAngle : Math.PI / 4.0;
          lightNode.angle = lightDef.spot.outerConeAngle;
          lightNode.penumbra = 1.0 - lightDef.spot.innerConeAngle / lightDef.spot.outerConeAngle;
          lightNode.target.position.set(0, 0, -1);
          lightNode.add(lightNode.target);
          break;
        default:
          throw new Error('THREE.GLTFLoader: Unexpected light type: ' + lightDef.type);
      }

      // Some lights (e.g. spot) default to a position other than the origin. Reset the position
      // here, because node-level parsing will only override position if explicitly specified.
      lightNode.position.set(0, 0, 0);
      lightNode.decay = 2;
      assignExtrasToUserData(lightNode, lightDef);
      if (lightDef.intensity !== undefined) lightNode.intensity = lightDef.intensity;
      lightNode.name = parser.createUniqueName(lightDef.name || 'light_' + lightIndex);
      dependency = Promise.resolve(lightNode);
      parser.cache.add(cacheKey, dependency);
      return dependency;
    }
  }, {
    key: "getDependency",
    value: function getDependency(type, index) {
      if (type !== 'light') return;
      return this._loadLight(index);
    }
  }, {
    key: "createNodeAttachment",
    value: function createNodeAttachment(nodeIndex) {
      var self = this;
      var parser = this.parser;
      var json = parser.json;
      var nodeDef = json.nodes[nodeIndex];
      var lightDef = nodeDef.extensions && nodeDef.extensions[this.name] || {};
      var lightIndex = lightDef.light;
      if (lightIndex === undefined) return null;
      return this._loadLight(lightIndex).then(function (light) {
        return parser._getNodeRef(self.cache, lightIndex, light);
      });
    }
  }]);
  return GLTFLightsExtension;
}();
/**
 * Unlit Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_unlit
 */
var GLTFMaterialsUnlitExtension = /*#__PURE__*/function () {
  function GLTFMaterialsUnlitExtension() {
    _classCallCheck(this, GLTFMaterialsUnlitExtension);
    this.name = EXTENSIONS.KHR_MATERIALS_UNLIT;
  }
  _createClass(GLTFMaterialsUnlitExtension, [{
    key: "getMaterialType",
    value: function getMaterialType() {
      return MeshBasicMaterial;
    }
  }, {
    key: "extendParams",
    value: function extendParams(materialParams, materialDef, parser) {
      var pending = [];
      materialParams.color = new Color(1.0, 1.0, 1.0);
      materialParams.opacity = 1.0;
      var metallicRoughness = materialDef.pbrMetallicRoughness;
      if (metallicRoughness) {
        if (Array.isArray(metallicRoughness.baseColorFactor)) {
          var array = metallicRoughness.baseColorFactor;
          materialParams.color.setRGB(array[0], array[1], array[2], LinearSRGBColorSpace);
          materialParams.opacity = array[3];
        }
        if (metallicRoughness.baseColorTexture !== undefined) {
          pending.push(parser.assignTexture(materialParams, 'map', metallicRoughness.baseColorTexture, SRGBColorSpace));
        }
      }
      return Promise.all(pending);
    }
  }]);
  return GLTFMaterialsUnlitExtension;
}();
/**
 * Materials Emissive Strength Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/blob/5768b3ce0ef32bc39cdf1bef10b948586635ead3/extensions/2.0/Khronos/KHR_materials_emissive_strength/README.md
 */
var GLTFMaterialsEmissiveStrengthExtension = /*#__PURE__*/function () {
  function GLTFMaterialsEmissiveStrengthExtension(parser) {
    _classCallCheck(this, GLTFMaterialsEmissiveStrengthExtension);
    this.parser = parser;
    this.name = EXTENSIONS.KHR_MATERIALS_EMISSIVE_STRENGTH;
  }
  _createClass(GLTFMaterialsEmissiveStrengthExtension, [{
    key: "extendMaterialParams",
    value: function extendMaterialParams(materialIndex, materialParams) {
      var parser = this.parser;
      var materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) {
        return Promise.resolve();
      }
      var emissiveStrength = materialDef.extensions[this.name].emissiveStrength;
      if (emissiveStrength !== undefined) {
        materialParams.emissiveIntensity = emissiveStrength;
      }
      return Promise.resolve();
    }
  }]);
  return GLTFMaterialsEmissiveStrengthExtension;
}();
/**
 * Clearcoat Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_clearcoat
 */
var GLTFMaterialsClearcoatExtension = /*#__PURE__*/function () {
  function GLTFMaterialsClearcoatExtension(parser) {
    _classCallCheck(this, GLTFMaterialsClearcoatExtension);
    this.parser = parser;
    this.name = EXTENSIONS.KHR_MATERIALS_CLEARCOAT;
  }
  _createClass(GLTFMaterialsClearcoatExtension, [{
    key: "getMaterialType",
    value: function getMaterialType(materialIndex) {
      var parser = this.parser;
      var materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
      return MeshPhysicalMaterial;
    }
  }, {
    key: "extendMaterialParams",
    value: function extendMaterialParams(materialIndex, materialParams) {
      var parser = this.parser;
      var materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) {
        return Promise.resolve();
      }
      var pending = [];
      var extension = materialDef.extensions[this.name];
      if (extension.clearcoatFactor !== undefined) {
        materialParams.clearcoat = extension.clearcoatFactor;
      }
      if (extension.clearcoatTexture !== undefined) {
        pending.push(parser.assignTexture(materialParams, 'clearcoatMap', extension.clearcoatTexture));
      }
      if (extension.clearcoatRoughnessFactor !== undefined) {
        materialParams.clearcoatRoughness = extension.clearcoatRoughnessFactor;
      }
      if (extension.clearcoatRoughnessTexture !== undefined) {
        pending.push(parser.assignTexture(materialParams, 'clearcoatRoughnessMap', extension.clearcoatRoughnessTexture));
      }
      if (extension.clearcoatNormalTexture !== undefined) {
        pending.push(parser.assignTexture(materialParams, 'clearcoatNormalMap', extension.clearcoatNormalTexture));
        if (extension.clearcoatNormalTexture.scale !== undefined) {
          var scale = extension.clearcoatNormalTexture.scale;
          materialParams.clearcoatNormalScale = new Vector2(scale, scale);
        }
      }
      return Promise.all(pending);
    }
  }]);
  return GLTFMaterialsClearcoatExtension;
}();
/**
 * Iridescence Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_iridescence
 */
var GLTFMaterialsIridescenceExtension = /*#__PURE__*/function () {
  function GLTFMaterialsIridescenceExtension(parser) {
    _classCallCheck(this, GLTFMaterialsIridescenceExtension);
    this.parser = parser;
    this.name = EXTENSIONS.KHR_MATERIALS_IRIDESCENCE;
  }
  _createClass(GLTFMaterialsIridescenceExtension, [{
    key: "getMaterialType",
    value: function getMaterialType(materialIndex) {
      var parser = this.parser;
      var materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
      return MeshPhysicalMaterial;
    }
  }, {
    key: "extendMaterialParams",
    value: function extendMaterialParams(materialIndex, materialParams) {
      var parser = this.parser;
      var materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) {
        return Promise.resolve();
      }
      var pending = [];
      var extension = materialDef.extensions[this.name];
      if (extension.iridescenceFactor !== undefined) {
        materialParams.iridescence = extension.iridescenceFactor;
      }
      if (extension.iridescenceTexture !== undefined) {
        pending.push(parser.assignTexture(materialParams, 'iridescenceMap', extension.iridescenceTexture));
      }
      if (extension.iridescenceIor !== undefined) {
        materialParams.iridescenceIOR = extension.iridescenceIor;
      }
      if (materialParams.iridescenceThicknessRange === undefined) {
        materialParams.iridescenceThicknessRange = [100, 400];
      }
      if (extension.iridescenceThicknessMinimum !== undefined) {
        materialParams.iridescenceThicknessRange[0] = extension.iridescenceThicknessMinimum;
      }
      if (extension.iridescenceThicknessMaximum !== undefined) {
        materialParams.iridescenceThicknessRange[1] = extension.iridescenceThicknessMaximum;
      }
      if (extension.iridescenceThicknessTexture !== undefined) {
        pending.push(parser.assignTexture(materialParams, 'iridescenceThicknessMap', extension.iridescenceThicknessTexture));
      }
      return Promise.all(pending);
    }
  }]);
  return GLTFMaterialsIridescenceExtension;
}();
/**
 * Sheen Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/main/extensions/2.0/Khronos/KHR_materials_sheen
 */
var GLTFMaterialsSheenExtension = /*#__PURE__*/function () {
  function GLTFMaterialsSheenExtension(parser) {
    _classCallCheck(this, GLTFMaterialsSheenExtension);
    this.parser = parser;
    this.name = EXTENSIONS.KHR_MATERIALS_SHEEN;
  }
  _createClass(GLTFMaterialsSheenExtension, [{
    key: "getMaterialType",
    value: function getMaterialType(materialIndex) {
      var parser = this.parser;
      var materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
      return MeshPhysicalMaterial;
    }
  }, {
    key: "extendMaterialParams",
    value: function extendMaterialParams(materialIndex, materialParams) {
      var parser = this.parser;
      var materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) {
        return Promise.resolve();
      }
      var pending = [];
      materialParams.sheenColor = new Color(0, 0, 0);
      materialParams.sheenRoughness = 0;
      materialParams.sheen = 1;
      var extension = materialDef.extensions[this.name];
      if (extension.sheenColorFactor !== undefined) {
        var colorFactor = extension.sheenColorFactor;
        materialParams.sheenColor.setRGB(colorFactor[0], colorFactor[1], colorFactor[2], LinearSRGBColorSpace);
      }
      if (extension.sheenRoughnessFactor !== undefined) {
        materialParams.sheenRoughness = extension.sheenRoughnessFactor;
      }
      if (extension.sheenColorTexture !== undefined) {
        pending.push(parser.assignTexture(materialParams, 'sheenColorMap', extension.sheenColorTexture, SRGBColorSpace));
      }
      if (extension.sheenRoughnessTexture !== undefined) {
        pending.push(parser.assignTexture(materialParams, 'sheenRoughnessMap', extension.sheenRoughnessTexture));
      }
      return Promise.all(pending);
    }
  }]);
  return GLTFMaterialsSheenExtension;
}();
/**
 * Transmission Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_transmission
 * Draft: https://github.com/KhronosGroup/glTF/pull/1698
 */
var GLTFMaterialsTransmissionExtension = /*#__PURE__*/function () {
  function GLTFMaterialsTransmissionExtension(parser) {
    _classCallCheck(this, GLTFMaterialsTransmissionExtension);
    this.parser = parser;
    this.name = EXTENSIONS.KHR_MATERIALS_TRANSMISSION;
  }
  _createClass(GLTFMaterialsTransmissionExtension, [{
    key: "getMaterialType",
    value: function getMaterialType(materialIndex) {
      var parser = this.parser;
      var materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
      return MeshPhysicalMaterial;
    }
  }, {
    key: "extendMaterialParams",
    value: function extendMaterialParams(materialIndex, materialParams) {
      var parser = this.parser;
      var materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) {
        return Promise.resolve();
      }
      var pending = [];
      var extension = materialDef.extensions[this.name];
      if (extension.transmissionFactor !== undefined) {
        materialParams.transmission = extension.transmissionFactor;
      }
      if (extension.transmissionTexture !== undefined) {
        pending.push(parser.assignTexture(materialParams, 'transmissionMap', extension.transmissionTexture));
      }
      return Promise.all(pending);
    }
  }]);
  return GLTFMaterialsTransmissionExtension;
}();
/**
 * Materials Volume Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_volume
 */
var GLTFMaterialsVolumeExtension = /*#__PURE__*/function () {
  function GLTFMaterialsVolumeExtension(parser) {
    _classCallCheck(this, GLTFMaterialsVolumeExtension);
    this.parser = parser;
    this.name = EXTENSIONS.KHR_MATERIALS_VOLUME;
  }
  _createClass(GLTFMaterialsVolumeExtension, [{
    key: "getMaterialType",
    value: function getMaterialType(materialIndex) {
      var parser = this.parser;
      var materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
      return MeshPhysicalMaterial;
    }
  }, {
    key: "extendMaterialParams",
    value: function extendMaterialParams(materialIndex, materialParams) {
      var parser = this.parser;
      var materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) {
        return Promise.resolve();
      }
      var pending = [];
      var extension = materialDef.extensions[this.name];
      materialParams.thickness = extension.thicknessFactor !== undefined ? extension.thicknessFactor : 0;
      if (extension.thicknessTexture !== undefined) {
        pending.push(parser.assignTexture(materialParams, 'thicknessMap', extension.thicknessTexture));
      }
      materialParams.attenuationDistance = extension.attenuationDistance || Infinity;
      var colorArray = extension.attenuationColor || [1, 1, 1];
      materialParams.attenuationColor = new Color().setRGB(colorArray[0], colorArray[1], colorArray[2], LinearSRGBColorSpace);
      return Promise.all(pending);
    }
  }]);
  return GLTFMaterialsVolumeExtension;
}();
/**
 * Materials ior Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_ior
 */
var GLTFMaterialsIorExtension = /*#__PURE__*/function () {
  function GLTFMaterialsIorExtension(parser) {
    _classCallCheck(this, GLTFMaterialsIorExtension);
    this.parser = parser;
    this.name = EXTENSIONS.KHR_MATERIALS_IOR;
  }
  _createClass(GLTFMaterialsIorExtension, [{
    key: "getMaterialType",
    value: function getMaterialType(materialIndex) {
      var parser = this.parser;
      var materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
      return MeshPhysicalMaterial;
    }
  }, {
    key: "extendMaterialParams",
    value: function extendMaterialParams(materialIndex, materialParams) {
      var parser = this.parser;
      var materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) {
        return Promise.resolve();
      }
      var extension = materialDef.extensions[this.name];
      materialParams.ior = extension.ior !== undefined ? extension.ior : 1.5;
      return Promise.resolve();
    }
  }]);
  return GLTFMaterialsIorExtension;
}();
/**
 * Materials specular Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_specular
 */
var GLTFMaterialsSpecularExtension = /*#__PURE__*/function () {
  function GLTFMaterialsSpecularExtension(parser) {
    _classCallCheck(this, GLTFMaterialsSpecularExtension);
    this.parser = parser;
    this.name = EXTENSIONS.KHR_MATERIALS_SPECULAR;
  }
  _createClass(GLTFMaterialsSpecularExtension, [{
    key: "getMaterialType",
    value: function getMaterialType(materialIndex) {
      var parser = this.parser;
      var materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
      return MeshPhysicalMaterial;
    }
  }, {
    key: "extendMaterialParams",
    value: function extendMaterialParams(materialIndex, materialParams) {
      var parser = this.parser;
      var materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) {
        return Promise.resolve();
      }
      var pending = [];
      var extension = materialDef.extensions[this.name];
      materialParams.specularIntensity = extension.specularFactor !== undefined ? extension.specularFactor : 1.0;
      if (extension.specularTexture !== undefined) {
        pending.push(parser.assignTexture(materialParams, 'specularIntensityMap', extension.specularTexture));
      }
      var colorArray = extension.specularColorFactor || [1, 1, 1];
      materialParams.specularColor = new Color().setRGB(colorArray[0], colorArray[1], colorArray[2], LinearSRGBColorSpace);
      if (extension.specularColorTexture !== undefined) {
        pending.push(parser.assignTexture(materialParams, 'specularColorMap', extension.specularColorTexture, SRGBColorSpace));
      }
      return Promise.all(pending);
    }
  }]);
  return GLTFMaterialsSpecularExtension;
}();
/**
 * Materials anisotropy Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_anisotropy
 */
var GLTFMaterialsAnisotropyExtension = /*#__PURE__*/function () {
  function GLTFMaterialsAnisotropyExtension(parser) {
    _classCallCheck(this, GLTFMaterialsAnisotropyExtension);
    this.parser = parser;
    this.name = EXTENSIONS.KHR_MATERIALS_ANISOTROPY;
  }
  _createClass(GLTFMaterialsAnisotropyExtension, [{
    key: "getMaterialType",
    value: function getMaterialType(materialIndex) {
      var parser = this.parser;
      var materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
      return MeshPhysicalMaterial;
    }
  }, {
    key: "extendMaterialParams",
    value: function extendMaterialParams(materialIndex, materialParams) {
      var parser = this.parser;
      var materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) {
        return Promise.resolve();
      }
      var pending = [];
      var extension = materialDef.extensions[this.name];
      if (extension.anisotropyStrength !== undefined) {
        materialParams.anisotropy = extension.anisotropyStrength;
      }
      if (extension.anisotropyRotation !== undefined) {
        materialParams.anisotropyRotation = extension.anisotropyRotation;
      }
      if (extension.anisotropyTexture !== undefined) {
        pending.push(parser.assignTexture(materialParams, 'anisotropyMap', extension.anisotropyTexture));
      }
      return Promise.all(pending);
    }
  }]);
  return GLTFMaterialsAnisotropyExtension;
}();
/**
 * BasisU Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_texture_basisu
 */
var GLTFTextureBasisUExtension = /*#__PURE__*/function () {
  function GLTFTextureBasisUExtension(parser) {
    _classCallCheck(this, GLTFTextureBasisUExtension);
    this.parser = parser;
    this.name = EXTENSIONS.KHR_TEXTURE_BASISU;
  }
  _createClass(GLTFTextureBasisUExtension, [{
    key: "loadTexture",
    value: function loadTexture(textureIndex) {
      var parser = this.parser;
      var json = parser.json;
      var textureDef = json.textures[textureIndex];
      if (!textureDef.extensions || !textureDef.extensions[this.name]) {
        return null;
      }
      var extension = textureDef.extensions[this.name];
      var loader = parser.options.ktx2Loader;
      if (!loader) {
        if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) {
          throw new Error('THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures');
        } else {
          // Assumes that the extension is optional and that a fallback texture is present
          return null;
        }
      }
      return parser.loadTextureImage(textureIndex, extension.source, loader);
    }
  }]);
  return GLTFTextureBasisUExtension;
}();
/**
 * WebP Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_texture_webp
 */
var GLTFTextureWebPExtension = /*#__PURE__*/function () {
  function GLTFTextureWebPExtension(parser) {
    _classCallCheck(this, GLTFTextureWebPExtension);
    this.parser = parser;
    this.name = EXTENSIONS.EXT_TEXTURE_WEBP;
    this.isSupported = null;
  }
  _createClass(GLTFTextureWebPExtension, [{
    key: "loadTexture",
    value: function loadTexture(textureIndex) {
      var name = this.name;
      var parser = this.parser;
      var json = parser.json;
      var textureDef = json.textures[textureIndex];
      if (!textureDef.extensions || !textureDef.extensions[name]) {
        return null;
      }
      var extension = textureDef.extensions[name];
      var source = json.images[extension.source];
      var loader = parser.textureLoader;
      if (source.uri) {
        var handler = parser.options.manager.getHandler(source.uri);
        if (handler !== null) loader = handler;
      }
      return this.detectSupport().then(function (isSupported) {
        if (isSupported) return parser.loadTextureImage(textureIndex, extension.source, loader);
        if (json.extensionsRequired && json.extensionsRequired.indexOf(name) >= 0) {
          throw new Error('THREE.GLTFLoader: WebP required by asset but unsupported.');
        }

        // Fall back to PNG or JPEG.
        return parser.loadTexture(textureIndex);
      });
    }
  }, {
    key: "detectSupport",
    value: function detectSupport() {
      if (!this.isSupported) {
        this.isSupported = new Promise(function (resolve) {
          var image = new Image();

          // Lossy test image. Support for lossy images doesn't guarantee support for all
          // WebP images, unfortunately.
          image.src = 'data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA';
          image.onload = image.onerror = function () {
            resolve(image.height === 1);
          };
        });
      }
      return this.isSupported;
    }
  }]);
  return GLTFTextureWebPExtension;
}();
/**
 * AVIF Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_texture_avif
 */
var GLTFTextureAVIFExtension = /*#__PURE__*/function () {
  function GLTFTextureAVIFExtension(parser) {
    _classCallCheck(this, GLTFTextureAVIFExtension);
    this.parser = parser;
    this.name = EXTENSIONS.EXT_TEXTURE_AVIF;
    this.isSupported = null;
  }
  _createClass(GLTFTextureAVIFExtension, [{
    key: "loadTexture",
    value: function loadTexture(textureIndex) {
      var name = this.name;
      var parser = this.parser;
      var json = parser.json;
      var textureDef = json.textures[textureIndex];
      if (!textureDef.extensions || !textureDef.extensions[name]) {
        return null;
      }
      var extension = textureDef.extensions[name];
      var source = json.images[extension.source];
      var loader = parser.textureLoader;
      if (source.uri) {
        var handler = parser.options.manager.getHandler(source.uri);
        if (handler !== null) loader = handler;
      }
      return this.detectSupport().then(function (isSupported) {
        if (isSupported) return parser.loadTextureImage(textureIndex, extension.source, loader);
        if (json.extensionsRequired && json.extensionsRequired.indexOf(name) >= 0) {
          throw new Error('THREE.GLTFLoader: AVIF required by asset but unsupported.');
        }

        // Fall back to PNG or JPEG.
        return parser.loadTexture(textureIndex);
      });
    }
  }, {
    key: "detectSupport",
    value: function detectSupport() {
      if (!this.isSupported) {
        this.isSupported = new Promise(function (resolve) {
          var image = new Image();

          // Lossy test image.
          image.src = 'data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAABcAAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAEAAAABAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQAMAAAAABNjb2xybmNseAACAAIABoAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAAB9tZGF0EgAKCBgABogQEDQgMgkQAAAAB8dSLfI=';
          image.onload = image.onerror = function () {
            resolve(image.height === 1);
          };
        });
      }
      return this.isSupported;
    }
  }]);
  return GLTFTextureAVIFExtension;
}();
/**
 * meshopt BufferView Compression Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_meshopt_compression
 */
var GLTFMeshoptCompression = /*#__PURE__*/function () {
  function GLTFMeshoptCompression(parser) {
    _classCallCheck(this, GLTFMeshoptCompression);
    this.name = EXTENSIONS.EXT_MESHOPT_COMPRESSION;
    this.parser = parser;
  }
  _createClass(GLTFMeshoptCompression, [{
    key: "loadBufferView",
    value: function loadBufferView(index) {
      var json = this.parser.json;
      var bufferView = json.bufferViews[index];
      if (bufferView.extensions && bufferView.extensions[this.name]) {
        var extensionDef = bufferView.extensions[this.name];
        var buffer = this.parser.getDependency('buffer', extensionDef.buffer);
        var decoder = this.parser.options.meshoptDecoder;
        if (!decoder || !decoder.supported) {
          if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) {
            throw new Error('THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files');
          } else {
            // Assumes that the extension is optional and that fallback buffer data is present
            return null;
          }
        }
        return buffer.then(function (res) {
          var byteOffset = extensionDef.byteOffset || 0;
          var byteLength = extensionDef.byteLength || 0;
          var count = extensionDef.count;
          var stride = extensionDef.byteStride;
          var source = new Uint8Array(res, byteOffset, byteLength);
          if (decoder.decodeGltfBufferAsync) {
            return decoder.decodeGltfBufferAsync(count, stride, source, extensionDef.mode, extensionDef.filter).then(function (res) {
              return res.buffer;
            });
          } else {
            // Support for MeshoptDecoder 0.18 or earlier, without decodeGltfBufferAsync
            return decoder.ready.then(function () {
              var result = new ArrayBuffer(count * stride);
              decoder.decodeGltfBuffer(new Uint8Array(result), count, stride, source, extensionDef.mode, extensionDef.filter);
              return result;
            });
          }
        });
      } else {
        return null;
      }
    }
  }]);
  return GLTFMeshoptCompression;
}();
/**
 * GPU Instancing Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_mesh_gpu_instancing
 *
 */
var GLTFMeshGpuInstancing = /*#__PURE__*/function () {
  function GLTFMeshGpuInstancing(parser) {
    _classCallCheck(this, GLTFMeshGpuInstancing);
    this.name = EXTENSIONS.EXT_MESH_GPU_INSTANCING;
    this.parser = parser;
  }
  _createClass(GLTFMeshGpuInstancing, [{
    key: "createNodeMesh",
    value: function createNodeMesh(nodeIndex) {
      var _this2 = this;
      var json = this.parser.json;
      var nodeDef = json.nodes[nodeIndex];
      if (!nodeDef.extensions || !nodeDef.extensions[this.name] || nodeDef.mesh === undefined) {
        return null;
      }
      var meshDef = json.meshes[nodeDef.mesh];

      // No Points or Lines + Instancing support yet
      var _iterator = _createForOfIteratorHelper(meshDef.primitives),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var primitive = _step.value;
          if (primitive.mode !== WEBGL_CONSTANTS.TRIANGLES && primitive.mode !== WEBGL_CONSTANTS.TRIANGLE_STRIP && primitive.mode !== WEBGL_CONSTANTS.TRIANGLE_FAN && primitive.mode !== undefined) {
            return null;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var extensionDef = nodeDef.extensions[this.name];
      var attributesDef = extensionDef.attributes;

      // @TODO: Can we support InstancedMesh + SkinnedMesh?

      var pending = [];
      var attributes = {};
      var _loop = function _loop(key) {
        pending.push(_this2.parser.getDependency('accessor', attributesDef[key]).then(function (accessor) {
          attributes[key] = accessor;
          return attributes[key];
        }));
      };
      for (var key in attributesDef) {
        _loop(key);
      }
      if (pending.length < 1) {
        return null;
      }
      pending.push(this.parser.createNodeMesh(nodeIndex));
      return Promise.all(pending).then(function (results) {
        var nodeObject = results.pop();
        var meshes = nodeObject.isGroup ? nodeObject.children : [nodeObject];
        var count = results[0].count; // All attribute counts should be same
        var instancedMeshes = [];
        var _iterator2 = _createForOfIteratorHelper(meshes),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var mesh = _step2.value;
            // Temporal variables
            var m = new Matrix4();
            var p = new Vector3();
            var q = new Quaternion();
            var s = new Vector3(1, 1, 1);
            var instancedMesh = new InstancedMesh(mesh.geometry, mesh.material, count);
            for (var i = 0; i < count; i++) {
              if (attributes.TRANSLATION) {
                p.fromBufferAttribute(attributes.TRANSLATION, i);
              }
              if (attributes.ROTATION) {
                q.fromBufferAttribute(attributes.ROTATION, i);
              }
              if (attributes.SCALE) {
                s.fromBufferAttribute(attributes.SCALE, i);
              }
              instancedMesh.setMatrixAt(i, m.compose(p, q, s));
            }

            // Add instance attributes to the geometry, excluding TRS.
            for (var attributeName in attributes) {
              if (attributeName !== 'TRANSLATION' && attributeName !== 'ROTATION' && attributeName !== 'SCALE') {
                mesh.geometry.setAttribute(attributeName, attributes[attributeName]);
              }
            }

            // Just in case
            Object3D.prototype.copy.call(instancedMesh, mesh);
            _this2.parser.assignFinalMaterial(instancedMesh);
            instancedMeshes.push(instancedMesh);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        if (nodeObject.isGroup) {
          nodeObject.clear();
          nodeObject.add.apply(nodeObject, instancedMeshes);
          return nodeObject;
        }
        return instancedMeshes[0];
      });
    }
  }]);
  return GLTFMeshGpuInstancing;
}();
/* BINARY EXTENSION */
var BINARY_EXTENSION_HEADER_MAGIC = 'glTF';
var BINARY_EXTENSION_HEADER_LENGTH = 12;
var BINARY_EXTENSION_CHUNK_TYPES = {
  JSON: 0x4e4f534a,
  BIN: 0x004e4942
};
var GLTFBinaryExtension = /*#__PURE__*/_createClass(function GLTFBinaryExtension(data) {
  _classCallCheck(this, GLTFBinaryExtension);
  this.name = EXTENSIONS.KHR_BINARY_GLTF;
  this.content = null;
  this.body = null;
  var headerView = new DataView(data, 0, BINARY_EXTENSION_HEADER_LENGTH);
  var textDecoder = new TextDecoder();
  this.header = {
    magic: textDecoder.decode(new Uint8Array(data.slice(0, 4))),
    version: headerView.getUint32(4, true),
    length: headerView.getUint32(8, true)
  };
  if (this.header.magic !== BINARY_EXTENSION_HEADER_MAGIC) {
    throw new Error('THREE.GLTFLoader: Unsupported glTF-Binary header.');
  } else if (this.header.version < 2.0) {
    throw new Error('THREE.GLTFLoader: Legacy binary file detected.');
  }
  var chunkContentsLength = this.header.length - BINARY_EXTENSION_HEADER_LENGTH;
  var chunkView = new DataView(data, BINARY_EXTENSION_HEADER_LENGTH);
  var chunkIndex = 0;
  while (chunkIndex < chunkContentsLength) {
    var chunkLength = chunkView.getUint32(chunkIndex, true);
    chunkIndex += 4;
    var chunkType = chunkView.getUint32(chunkIndex, true);
    chunkIndex += 4;
    if (chunkType === BINARY_EXTENSION_CHUNK_TYPES.JSON) {
      var contentArray = new Uint8Array(data, BINARY_EXTENSION_HEADER_LENGTH + chunkIndex, chunkLength);
      this.content = textDecoder.decode(contentArray);
    } else if (chunkType === BINARY_EXTENSION_CHUNK_TYPES.BIN) {
      var byteOffset = BINARY_EXTENSION_HEADER_LENGTH + chunkIndex;
      this.body = data.slice(byteOffset, byteOffset + chunkLength);
    }

    // Clients must ignore chunks with unknown types.

    chunkIndex += chunkLength;
  }
  if (this.content === null) {
    throw new Error('THREE.GLTFLoader: JSON content not found.');
  }
});
/**
 * DRACO Mesh Compression Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_draco_mesh_compression
 */
var GLTFDracoMeshCompressionExtension = /*#__PURE__*/function () {
  function GLTFDracoMeshCompressionExtension(json, dracoLoader) {
    _classCallCheck(this, GLTFDracoMeshCompressionExtension);
    if (!dracoLoader) {
      throw new Error('THREE.GLTFLoader: No DRACOLoader instance provided.');
    }
    this.name = EXTENSIONS.KHR_DRACO_MESH_COMPRESSION;
    this.json = json;
    this.dracoLoader = dracoLoader;
    this.dracoLoader.preload();
  }
  _createClass(GLTFDracoMeshCompressionExtension, [{
    key: "decodePrimitive",
    value: function decodePrimitive(primitive, parser) {
      var json = this.json;
      var dracoLoader = this.dracoLoader;
      var bufferViewIndex = primitive.extensions[this.name].bufferView;
      var gltfAttributeMap = primitive.extensions[this.name].attributes;
      var threeAttributeMap = {};
      var attributeNormalizedMap = {};
      var attributeTypeMap = {};
      for (var attributeName in gltfAttributeMap) {
        var threeAttributeName = ATTRIBUTES[attributeName] || attributeName.toLowerCase();
        threeAttributeMap[threeAttributeName] = gltfAttributeMap[attributeName];
      }
      for (var _attributeName2 in primitive.attributes) {
        var _threeAttributeName = ATTRIBUTES[_attributeName2] || _attributeName2.toLowerCase();
        if (gltfAttributeMap[_attributeName2] !== undefined) {
          var accessorDef = json.accessors[primitive.attributes[_attributeName2]];
          var componentType = WEBGL_COMPONENT_TYPES[accessorDef.componentType];
          attributeTypeMap[_threeAttributeName] = componentType.name;
          attributeNormalizedMap[_threeAttributeName] = accessorDef.normalized === true;
        }
      }
      return parser.getDependency('bufferView', bufferViewIndex).then(function (bufferView) {
        return new Promise(function (resolve) {
          dracoLoader.decodeDracoFile(bufferView, function (geometry) {
            for (var _attributeName4 in geometry.attributes) {
              var attribute = geometry.attributes[_attributeName4];
              var normalized = attributeNormalizedMap[_attributeName4];
              if (normalized !== undefined) attribute.normalized = normalized;
            }
            resolve(geometry);
          }, threeAttributeMap, attributeTypeMap);
        });
      });
    }
  }]);
  return GLTFDracoMeshCompressionExtension;
}();
/**
 * Texture Transform Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_texture_transform
 */
var GLTFTextureTransformExtension = /*#__PURE__*/function () {
  function GLTFTextureTransformExtension() {
    _classCallCheck(this, GLTFTextureTransformExtension);
    this.name = EXTENSIONS.KHR_TEXTURE_TRANSFORM;
  }
  _createClass(GLTFTextureTransformExtension, [{
    key: "extendTexture",
    value: function extendTexture(texture, transform) {
      if ((transform.texCoord === undefined || transform.texCoord === texture.channel) && transform.offset === undefined && transform.rotation === undefined && transform.scale === undefined) {
        // See https://github.com/mrdoob/three.js/issues/21819.
        return texture;
      }
      texture = texture.clone();
      if (transform.texCoord !== undefined) {
        texture.channel = transform.texCoord;
      }
      if (transform.offset !== undefined) {
        texture.offset.fromArray(transform.offset);
      }
      if (transform.rotation !== undefined) {
        texture.rotation = transform.rotation;
      }
      if (transform.scale !== undefined) {
        texture.repeat.fromArray(transform.scale);
      }
      texture.needsUpdate = true;
      return texture;
    }
  }]);
  return GLTFTextureTransformExtension;
}();
/**
 * Mesh Quantization Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_mesh_quantization
 */
var GLTFMeshQuantizationExtension = /*#__PURE__*/_createClass(function GLTFMeshQuantizationExtension() {
  _classCallCheck(this, GLTFMeshQuantizationExtension);
  this.name = EXTENSIONS.KHR_MESH_QUANTIZATION;
});
/*********************************/
/********** INTERPOLATION ********/
/*********************************/
// Spline Interpolation
// Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#appendix-c-spline-interpolation
var GLTFCubicSplineInterpolant = /*#__PURE__*/function (_Interpolant) {
  _inherits(GLTFCubicSplineInterpolant, _Interpolant);
  var _super2 = _createSuper(GLTFCubicSplineInterpolant);
  function GLTFCubicSplineInterpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    _classCallCheck(this, GLTFCubicSplineInterpolant);
    return _super2.call(this, parameterPositions, sampleValues, sampleSize, resultBuffer);
  }
  _createClass(GLTFCubicSplineInterpolant, [{
    key: "copySampleValue_",
    value: function copySampleValue_(index) {
      // Copies a sample value to the result buffer. See description of glTF
      // CUBICSPLINE values layout in interpolate_() function below.

      var result = this.resultBuffer,
        values = this.sampleValues,
        valueSize = this.valueSize,
        offset = index * valueSize * 3 + valueSize;
      for (var i = 0; i !== valueSize; i++) {
        result[i] = values[offset + i];
      }
      return result;
    }
  }, {
    key: "interpolate_",
    value: function interpolate_(i1, t0, t, t1) {
      var result = this.resultBuffer;
      var values = this.sampleValues;
      var stride = this.valueSize;
      var stride2 = stride * 2;
      var stride3 = stride * 3;
      var td = t1 - t0;
      var p = (t - t0) / td;
      var pp = p * p;
      var ppp = pp * p;
      var offset1 = i1 * stride3;
      var offset0 = offset1 - stride3;
      var s2 = -2 * ppp + 3 * pp;
      var s3 = ppp - pp;
      var s0 = 1 - s2;
      var s1 = s3 - pp + p;

      // Layout of keyframe output values for CUBICSPLINE animations:
      //   [ inTangent_1, splineVertex_1, outTangent_1, inTangent_2, splineVertex_2, ... ]
      for (var i = 0; i !== stride; i++) {
        var p0 = values[offset0 + i + stride]; // splineVertex_k
        var m0 = values[offset0 + i + stride2] * td; // outTangent_k * (t_k+1 - t_k)
        var p1 = values[offset1 + i + stride]; // splineVertex_k+1
        var m1 = values[offset1 + i] * td; // inTangent_k+1 * (t_k+1 - t_k)

        result[i] = s0 * p0 + s1 * m0 + s2 * p1 + s3 * m1;
      }
      return result;
    }
  }]);
  return GLTFCubicSplineInterpolant;
}(Interpolant);
var _q = new Quaternion();
var GLTFCubicSplineQuaternionInterpolant = /*#__PURE__*/function (_GLTFCubicSplineInter) {
  _inherits(GLTFCubicSplineQuaternionInterpolant, _GLTFCubicSplineInter);
  var _super3 = _createSuper(GLTFCubicSplineQuaternionInterpolant);
  function GLTFCubicSplineQuaternionInterpolant() {
    _classCallCheck(this, GLTFCubicSplineQuaternionInterpolant);
    return _super3.apply(this, arguments);
  }
  _createClass(GLTFCubicSplineQuaternionInterpolant, [{
    key: "interpolate_",
    value: function interpolate_(i1, t0, t, t1) {
      var result = _get(_getPrototypeOf(GLTFCubicSplineQuaternionInterpolant.prototype), "interpolate_", this).call(this, i1, t0, t, t1);
      _q.fromArray(result).normalize().toArray(result);
      return result;
    }
  }]);
  return GLTFCubicSplineQuaternionInterpolant;
}(GLTFCubicSplineInterpolant);
/*********************************/
/********** INTERNALS ************/
/*********************************/
/* CONSTANTS */
var WEBGL_CONSTANTS = {
  FLOAT: 5126,
  //FLOAT_MAT2: 35674,
  FLOAT_MAT3: 35675,
  FLOAT_MAT4: 35676,
  FLOAT_VEC2: 35664,
  FLOAT_VEC3: 35665,
  FLOAT_VEC4: 35666,
  LINEAR: 9729,
  REPEAT: 10497,
  SAMPLER_2D: 35678,
  POINTS: 0,
  LINES: 1,
  LINE_LOOP: 2,
  LINE_STRIP: 3,
  TRIANGLES: 4,
  TRIANGLE_STRIP: 5,
  TRIANGLE_FAN: 6,
  UNSIGNED_BYTE: 5121,
  UNSIGNED_SHORT: 5123
};
var WEBGL_COMPONENT_TYPES = {
  5120: Int8Array,
  5121: Uint8Array,
  5122: Int16Array,
  5123: Uint16Array,
  5125: Uint32Array,
  5126: Float32Array
};
var WEBGL_FILTERS = {
  9728: NearestFilter,
  9729: LinearFilter,
  9984: NearestMipmapNearestFilter,
  9985: LinearMipmapNearestFilter,
  9986: NearestMipmapLinearFilter,
  9987: LinearMipmapLinearFilter
};
var WEBGL_WRAPPINGS = {
  33071: ClampToEdgeWrapping,
  33648: MirroredRepeatWrapping,
  10497: RepeatWrapping
};
var WEBGL_TYPE_SIZES = {
  SCALAR: 1,
  VEC2: 2,
  VEC3: 3,
  VEC4: 4,
  MAT2: 4,
  MAT3: 9,
  MAT4: 16
};
var ATTRIBUTES = {
  POSITION: 'position',
  NORMAL: 'normal',
  TANGENT: 'tangent',
  TEXCOORD_0: 'uv',
  TEXCOORD_1: 'uv1',
  TEXCOORD_2: 'uv2',
  TEXCOORD_3: 'uv3',
  COLOR_0: 'color',
  WEIGHTS_0: 'skinWeight',
  JOINTS_0: 'skinIndex'
};
var PATH_PROPERTIES = {
  scale: 'scale',
  translation: 'position',
  rotation: 'quaternion',
  weights: 'morphTargetInfluences'
};
var INTERPOLATION = {
  CUBICSPLINE: undefined,
  // We use a custom interpolant (GLTFCubicSplineInterpolation) for CUBICSPLINE tracks. Each
  // keyframe track will be initialized with a default interpolation type, then modified.
  LINEAR: InterpolateLinear,
  STEP: InterpolateDiscrete
};
var ALPHA_MODES = {
  OPAQUE: 'OPAQUE',
  MASK: 'MASK',
  BLEND: 'BLEND'
};

/**
 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#default-material
 */
function createDefaultMaterial(cache) {
  if (cache['DefaultMaterial'] === undefined) {
    cache['DefaultMaterial'] = new MeshStandardMaterial({
      color: 0xffffff,
      emissive: 0x000000,
      metalness: 1,
      roughness: 1,
      transparent: false,
      depthTest: true,
      side: FrontSide
    });
  }
  return cache['DefaultMaterial'];
}
function addUnknownExtensionsToUserData(knownExtensions, object, objectDef) {
  // Add unknown glTF extensions to an object's userData.

  for (var name in objectDef.extensions) {
    if (knownExtensions[name] === undefined) {
      object.userData.gltfExtensions = object.userData.gltfExtensions || {};
      object.userData.gltfExtensions[name] = objectDef.extensions[name];
    }
  }
}

/**
 * @param {Object3D|Material|BufferGeometry} object
 * @param {GLTF.definition} gltfDef
 */
function assignExtrasToUserData(object, gltfDef) {
  if (gltfDef.extras !== undefined) {
    if (typeof gltfDef.extras === 'object') {
      Object.assign(object.userData, gltfDef.extras);
    } else {
      console.warn('THREE.GLTFLoader: Ignoring primitive type .extras, ' + gltfDef.extras);
    }
  }
}

/**
 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#morph-targets
 *
 * @param {BufferGeometry} geometry
 * @param {Array<GLTF.Target>} targets
 * @param {GLTFParser} parser
 * @return {Promise<BufferGeometry>}
 */
function addMorphTargets(geometry, targets, parser) {
  var hasMorphPosition = false;
  var hasMorphNormal = false;
  var hasMorphColor = false;
  for (var i = 0, il = targets.length; i < il; i++) {
    var target = targets[i];
    if (target.POSITION !== undefined) hasMorphPosition = true;
    if (target.NORMAL !== undefined) hasMorphNormal = true;
    if (target.COLOR_0 !== undefined) hasMorphColor = true;
    if (hasMorphPosition && hasMorphNormal && hasMorphColor) break;
  }
  if (!hasMorphPosition && !hasMorphNormal && !hasMorphColor) return Promise.resolve(geometry);
  var pendingPositionAccessors = [];
  var pendingNormalAccessors = [];
  var pendingColorAccessors = [];
  for (var _i4 = 0, _il2 = targets.length; _i4 < _il2; _i4++) {
    var _target = targets[_i4];
    if (hasMorphPosition) {
      var pendingAccessor = _target.POSITION !== undefined ? parser.getDependency('accessor', _target.POSITION) : geometry.attributes.position;
      pendingPositionAccessors.push(pendingAccessor);
    }
    if (hasMorphNormal) {
      var _pendingAccessor = _target.NORMAL !== undefined ? parser.getDependency('accessor', _target.NORMAL) : geometry.attributes.normal;
      pendingNormalAccessors.push(_pendingAccessor);
    }
    if (hasMorphColor) {
      var _pendingAccessor2 = _target.COLOR_0 !== undefined ? parser.getDependency('accessor', _target.COLOR_0) : geometry.attributes.color;
      pendingColorAccessors.push(_pendingAccessor2);
    }
  }
  return Promise.all([Promise.all(pendingPositionAccessors), Promise.all(pendingNormalAccessors), Promise.all(pendingColorAccessors)]).then(function (accessors) {
    var morphPositions = accessors[0];
    var morphNormals = accessors[1];
    var morphColors = accessors[2];
    if (hasMorphPosition) geometry.morphAttributes.position = morphPositions;
    if (hasMorphNormal) geometry.morphAttributes.normal = morphNormals;
    if (hasMorphColor) geometry.morphAttributes.color = morphColors;
    geometry.morphTargetsRelative = true;
    return geometry;
  });
}

/**
 * @param {Mesh} mesh
 * @param {GLTF.Mesh} meshDef
 */
function updateMorphTargets(mesh, meshDef) {
  mesh.updateMorphTargets();
  if (meshDef.weights !== undefined) {
    for (var i = 0, il = meshDef.weights.length; i < il; i++) {
      mesh.morphTargetInfluences[i] = meshDef.weights[i];
    }
  }

  // .extras has user-defined data, so check that .extras.targetNames is an array.
  if (meshDef.extras && Array.isArray(meshDef.extras.targetNames)) {
    var targetNames = meshDef.extras.targetNames;
    if (mesh.morphTargetInfluences.length === targetNames.length) {
      mesh.morphTargetDictionary = {};
      for (var _i6 = 0, _il4 = targetNames.length; _i6 < _il4; _i6++) {
        mesh.morphTargetDictionary[targetNames[_i6]] = _i6;
      }
    } else {
      console.warn('THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.');
    }
  }
}
function createPrimitiveKey(primitiveDef) {
  var geometryKey;
  var dracoExtension = primitiveDef.extensions && primitiveDef.extensions[EXTENSIONS.KHR_DRACO_MESH_COMPRESSION];
  if (dracoExtension) {
    geometryKey = 'draco:' + dracoExtension.bufferView + ':' + dracoExtension.indices + ':' + createAttributesKey(dracoExtension.attributes);
  } else {
    geometryKey = primitiveDef.indices + ':' + createAttributesKey(primitiveDef.attributes) + ':' + primitiveDef.mode;
  }
  if (primitiveDef.targets !== undefined) {
    for (var i = 0, il = primitiveDef.targets.length; i < il; i++) {
      geometryKey += ':' + createAttributesKey(primitiveDef.targets[i]);
    }
  }
  return geometryKey;
}
function createAttributesKey(attributes) {
  var attributesKey = '';
  var keys = Object.keys(attributes).sort();
  for (var i = 0, il = keys.length; i < il; i++) {
    attributesKey += keys[i] + ':' + attributes[keys[i]] + ';';
  }
  return attributesKey;
}
function getNormalizedComponentScale(constructor) {
  // Reference:
  // https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_mesh_quantization#encoding-quantized-data

  switch (constructor) {
    case Int8Array:
      return 1 / 127;
    case Uint8Array:
      return 1 / 255;
    case Int16Array:
      return 1 / 32767;
    case Uint16Array:
      return 1 / 65535;
    default:
      throw new Error('THREE.GLTFLoader: Unsupported normalized accessor component type.');
  }
}
function getImageURIMimeType(uri) {
  if (uri.search(/\.jpe?g($|\?)/i) > 0 || uri.search(/^data\:image\/jpeg/) === 0) return 'image/jpeg';
  if (uri.search(/\.webp($|\?)/i) > 0 || uri.search(/^data\:image\/webp/) === 0) return 'image/webp';
  return 'image/png';
}
var _identityMatrix = new Matrix4();

/* GLTF PARSER */
var GLTFParser = /*#__PURE__*/function () {
  function GLTFParser() {
    var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, GLTFParser);
    this.json = json;
    this.extensions = {};
    this.plugins = {};
    this.options = options;

    // loader object cache
    this.cache = new GLTFRegistry();

    // associations between Three.js objects and glTF elements
    this.associations = new Map();

    // BufferGeometry caching
    this.primitiveCache = {};

    // Node cache
    this.nodeCache = {};

    // Object3D instance caches
    this.meshCache = {
      refs: {},
      uses: {}
    };
    this.cameraCache = {
      refs: {},
      uses: {}
    };
    this.lightCache = {
      refs: {},
      uses: {}
    };
    this.sourceCache = {};
    this.textureCache = {};

    // Track node names, to ensure no duplicates
    this.nodeNamesUsed = {};

    // Use an ImageBitmapLoader if imageBitmaps are supported. Moves much of the
    // expensive work of uploading a texture to the GPU off the main thread.

    var isSafari = false;
    var isFirefox = false;
    var firefoxVersion = -1;
    if (typeof navigator !== 'undefined') {
      isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) === true;
      isFirefox = navigator.userAgent.indexOf('Firefox') > -1;
      firefoxVersion = isFirefox ? navigator.userAgent.match(/Firefox\/([0-9]+)\./)[1] : -1;
    }
    if (typeof createImageBitmap === 'undefined' || isSafari || isFirefox && firefoxVersion < 98) {
      this.textureLoader = new TextureLoader(this.options.manager);
    } else {
      this.textureLoader = new ImageBitmapLoader(this.options.manager);
    }
    this.textureLoader.setCrossOrigin(this.options.crossOrigin);
    this.textureLoader.setRequestHeader(this.options.requestHeader);
    this.fileLoader = new FileLoader(this.options.manager);
    this.fileLoader.setResponseType('arraybuffer');
    if (this.options.crossOrigin === 'use-credentials') {
      this.fileLoader.setWithCredentials(true);
    }
  }
  _createClass(GLTFParser, [{
    key: "setExtensions",
    value: function setExtensions(extensions) {
      this.extensions = extensions;
    }
  }, {
    key: "setPlugins",
    value: function setPlugins(plugins) {
      this.plugins = plugins;
    }
  }, {
    key: "parse",
    value: function parse(onLoad, onError) {
      var parser = this;
      var json = this.json;
      var extensions = this.extensions;

      // Clear the loader cache
      this.cache.removeAll();
      this.nodeCache = {};

      // Mark the special nodes/meshes in json for efficient parse
      this._invokeAll(function (ext) {
        return ext._markDefs && ext._markDefs();
      });
      Promise.all(this._invokeAll(function (ext) {
        return ext.beforeRoot && ext.beforeRoot();
      })).then(function () {
        return Promise.all([parser.getDependencies('scene'), parser.getDependencies('animation'), parser.getDependencies('camera')]);
      }).then(function (dependencies) {
        var result = {
          scene: dependencies[0][json.scene || 0],
          scenes: dependencies[0],
          animations: dependencies[1],
          cameras: dependencies[2],
          asset: json.asset,
          parser: parser,
          userData: {}
        };
        addUnknownExtensionsToUserData(extensions, result, json);
        assignExtrasToUserData(result, json);
        return Promise.all(parser._invokeAll(function (ext) {
          return ext.afterRoot && ext.afterRoot(result);
        })).then(function () {
          onLoad(result);
        });
      })["catch"](onError);
    }

    /**
     * Marks the special nodes/meshes in json for efficient parse.
     */
  }, {
    key: "_markDefs",
    value: function _markDefs() {
      var nodeDefs = this.json.nodes || [];
      var skinDefs = this.json.skins || [];
      var meshDefs = this.json.meshes || [];

      // Nothing in the node definition indicates whether it is a Bone or an
      // Object3D. Use the skins' joint references to mark bones.
      for (var skinIndex = 0, skinLength = skinDefs.length; skinIndex < skinLength; skinIndex++) {
        var joints = skinDefs[skinIndex].joints;
        for (var i = 0, il = joints.length; i < il; i++) {
          nodeDefs[joints[i]].isBone = true;
        }
      }

      // Iterate over all nodes, marking references to shared resources,
      // as well as skeleton joints.
      for (var nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++) {
        var nodeDef = nodeDefs[nodeIndex];
        if (nodeDef.mesh !== undefined) {
          this._addNodeRef(this.meshCache, nodeDef.mesh);

          // Nothing in the mesh definition indicates whether it is
          // a SkinnedMesh or Mesh. Use the node's mesh reference
          // to mark SkinnedMesh if node has skin.
          if (nodeDef.skin !== undefined) {
            meshDefs[nodeDef.mesh].isSkinnedMesh = true;
          }
        }
        if (nodeDef.camera !== undefined) {
          this._addNodeRef(this.cameraCache, nodeDef.camera);
        }
      }
    }

    /**
     * Counts references to shared node / Object3D resources. These resources
     * can be reused, or "instantiated", at multiple nodes in the scene
     * hierarchy. Mesh, Camera, and Light instances are instantiated and must
     * be marked. Non-scenegraph resources (like Materials, Geometries, and
     * Textures) can be reused directly and are not marked here.
     *
     * Example: CesiumMilkTruck sample model reuses "Wheel" meshes.
     */
  }, {
    key: "_addNodeRef",
    value: function _addNodeRef(cache, index) {
      if (index === undefined) return;
      if (cache.refs[index] === undefined) {
        cache.refs[index] = cache.uses[index] = 0;
      }
      cache.refs[index]++;
    }

    /** Returns a reference to a shared resource, cloning it if necessary. */
  }, {
    key: "_getNodeRef",
    value: function _getNodeRef(cache, index, object) {
      var _this3 = this;
      if (cache.refs[index] <= 1) return object;
      var ref = object.clone();

      // Propagates mappings to the cloned object, prevents mappings on the
      // original object from being lost.
      var updateMappings = function updateMappings(original, clone) {
        var mappings = _this3.associations.get(original);
        if (mappings != null) {
          _this3.associations.set(clone, mappings);
        }
        var _iterator3 = _createForOfIteratorHelper(original.children.entries()),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _ref = _step3.value;
            var _ref2 = _slicedToArray(_ref, 2);
            var i = _ref2[0];
            var child = _ref2[1];
            updateMappings(child, clone.children[i]);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      };
      updateMappings(object, ref);
      ref.name += '_instance_' + cache.uses[index]++;
      return ref;
    }
  }, {
    key: "_invokeOne",
    value: function _invokeOne(func) {
      var extensions = Object.values(this.plugins);
      extensions.push(this);
      for (var i = 0; i < extensions.length; i++) {
        var result = func(extensions[i]);
        if (result) return result;
      }
      return null;
    }
  }, {
    key: "_invokeAll",
    value: function _invokeAll(func) {
      var extensions = Object.values(this.plugins);
      extensions.unshift(this);
      var pending = [];
      for (var i = 0; i < extensions.length; i++) {
        var result = func(extensions[i]);
        if (result) pending.push(result);
      }
      return pending;
    }

    /**
     * Requests the specified dependency asynchronously, with caching.
     * @param {string} type
     * @param {number} index
     * @return {Promise<Object3D|Material|THREE.Texture|AnimationClip|ArrayBuffer|Object>}
     */
  }, {
    key: "getDependency",
    value: function getDependency(type, index) {
      var cacheKey = type + ':' + index;
      var dependency = this.cache.get(cacheKey);
      if (!dependency) {
        switch (type) {
          case 'scene':
            dependency = this.loadScene(index);
            break;
          case 'node':
            dependency = this._invokeOne(function (ext) {
              return ext.loadNode && ext.loadNode(index);
            });
            break;
          case 'mesh':
            dependency = this._invokeOne(function (ext) {
              return ext.loadMesh && ext.loadMesh(index);
            });
            break;
          case 'accessor':
            dependency = this.loadAccessor(index);
            break;
          case 'bufferView':
            dependency = this._invokeOne(function (ext) {
              return ext.loadBufferView && ext.loadBufferView(index);
            });
            break;
          case 'buffer':
            dependency = this.loadBuffer(index);
            break;
          case 'material':
            dependency = this._invokeOne(function (ext) {
              return ext.loadMaterial && ext.loadMaterial(index);
            });
            break;
          case 'texture':
            dependency = this._invokeOne(function (ext) {
              return ext.loadTexture && ext.loadTexture(index);
            });
            break;
          case 'skin':
            dependency = this.loadSkin(index);
            break;
          case 'animation':
            dependency = this._invokeOne(function (ext) {
              return ext.loadAnimation && ext.loadAnimation(index);
            });
            break;
          case 'camera':
            dependency = this.loadCamera(index);
            break;
          default:
            dependency = this._invokeOne(function (ext) {
              return ext != this && ext.getDependency && ext.getDependency(type, index);
            });
            if (!dependency) {
              throw new Error('Unknown type: ' + type);
            }
            break;
        }
        this.cache.add(cacheKey, dependency);
      }
      return dependency;
    }

    /**
     * Requests all dependencies of the specified type asynchronously, with caching.
     * @param {string} type
     * @return {Promise<Array<Object>>}
     */
  }, {
    key: "getDependencies",
    value: function getDependencies(type) {
      var dependencies = this.cache.get(type);
      if (!dependencies) {
        var parser = this;
        var defs = this.json[type + (type === 'mesh' ? 'es' : 's')] || [];
        dependencies = Promise.all(defs.map(function (def, index) {
          return parser.getDependency(type, index);
        }));
        this.cache.add(type, dependencies);
      }
      return dependencies;
    }

    /**
     * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
     * @param {number} bufferIndex
     * @return {Promise<ArrayBuffer>}
     */
  }, {
    key: "loadBuffer",
    value: function loadBuffer(bufferIndex) {
      var bufferDef = this.json.buffers[bufferIndex];
      var loader = this.fileLoader;
      if (bufferDef.type && bufferDef.type !== 'arraybuffer') {
        throw new Error('THREE.GLTFLoader: ' + bufferDef.type + ' buffer type is not supported.');
      }

      // If present, GLB container is required to be the first buffer.
      if (bufferDef.uri === undefined && bufferIndex === 0) {
        return Promise.resolve(this.extensions[EXTENSIONS.KHR_BINARY_GLTF].body);
      }
      var options = this.options;
      return new Promise(function (resolve, reject) {
        loader.load(LoaderUtils.resolveURL(bufferDef.uri, options.path), resolve, undefined, function () {
          reject(new Error('THREE.GLTFLoader: Failed to load buffer "' + bufferDef.uri + '".'));
        });
      });
    }

    /**
     * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
     * @param {number} bufferViewIndex
     * @return {Promise<ArrayBuffer>}
     */
  }, {
    key: "loadBufferView",
    value: function loadBufferView(bufferViewIndex) {
      var bufferViewDef = this.json.bufferViews[bufferViewIndex];
      return this.getDependency('buffer', bufferViewDef.buffer).then(function (buffer) {
        var byteLength = bufferViewDef.byteLength || 0;
        var byteOffset = bufferViewDef.byteOffset || 0;
        return buffer.slice(byteOffset, byteOffset + byteLength);
      });
    }

    /**
     * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#accessors
     * @param {number} accessorIndex
     * @return {Promise<BufferAttribute|InterleavedBufferAttribute>}
     */
  }, {
    key: "loadAccessor",
    value: function loadAccessor(accessorIndex) {
      var parser = this;
      var json = this.json;
      var accessorDef = this.json.accessors[accessorIndex];
      if (accessorDef.bufferView === undefined && accessorDef.sparse === undefined) {
        var itemSize = WEBGL_TYPE_SIZES[accessorDef.type];
        var TypedArray = WEBGL_COMPONENT_TYPES[accessorDef.componentType];
        var normalized = accessorDef.normalized === true;
        var array = new TypedArray(accessorDef.count * itemSize);
        return Promise.resolve(new BufferAttribute(array, itemSize, normalized));
      }
      var pendingBufferViews = [];
      if (accessorDef.bufferView !== undefined) {
        pendingBufferViews.push(this.getDependency('bufferView', accessorDef.bufferView));
      } else {
        pendingBufferViews.push(null);
      }
      if (accessorDef.sparse !== undefined) {
        pendingBufferViews.push(this.getDependency('bufferView', accessorDef.sparse.indices.bufferView));
        pendingBufferViews.push(this.getDependency('bufferView', accessorDef.sparse.values.bufferView));
      }
      return Promise.all(pendingBufferViews).then(function (bufferViews) {
        var bufferView = bufferViews[0];
        var itemSize = WEBGL_TYPE_SIZES[accessorDef.type];
        var TypedArray = WEBGL_COMPONENT_TYPES[accessorDef.componentType];

        // For VEC3: itemSize is 3, elementBytes is 4, itemBytes is 12.
        var elementBytes = TypedArray.BYTES_PER_ELEMENT;
        var itemBytes = elementBytes * itemSize;
        var byteOffset = accessorDef.byteOffset || 0;
        var byteStride = accessorDef.bufferView !== undefined ? json.bufferViews[accessorDef.bufferView].byteStride : undefined;
        var normalized = accessorDef.normalized === true;
        var array, bufferAttribute;

        // The buffer is not interleaved if the stride is the item size in bytes.
        if (byteStride && byteStride !== itemBytes) {
          // Each "slice" of the buffer, as defined by 'count' elements of 'byteStride' bytes, gets its own InterleavedBuffer
          // This makes sure that IBA.count reflects accessor.count properly
          var ibSlice = Math.floor(byteOffset / byteStride);
          var ibCacheKey = 'InterleavedBuffer:' + accessorDef.bufferView + ':' + accessorDef.componentType + ':' + ibSlice + ':' + accessorDef.count;
          var ib = parser.cache.get(ibCacheKey);
          if (!ib) {
            array = new TypedArray(bufferView, ibSlice * byteStride, accessorDef.count * byteStride / elementBytes);

            // Integer parameters to IB/IBA are in array elements, not bytes.
            ib = new InterleavedBuffer(array, byteStride / elementBytes);
            parser.cache.add(ibCacheKey, ib);
          }
          bufferAttribute = new InterleavedBufferAttribute(ib, itemSize, byteOffset % byteStride / elementBytes, normalized);
        } else {
          if (bufferView === null) {
            array = new TypedArray(accessorDef.count * itemSize);
          } else {
            array = new TypedArray(bufferView, byteOffset, accessorDef.count * itemSize);
          }
          bufferAttribute = new BufferAttribute(array, itemSize, normalized);
        }

        // https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#sparse-accessors
        if (accessorDef.sparse !== undefined) {
          var itemSizeIndices = WEBGL_TYPE_SIZES.SCALAR;
          var TypedArrayIndices = WEBGL_COMPONENT_TYPES[accessorDef.sparse.indices.componentType];
          var byteOffsetIndices = accessorDef.sparse.indices.byteOffset || 0;
          var byteOffsetValues = accessorDef.sparse.values.byteOffset || 0;
          var sparseIndices = new TypedArrayIndices(bufferViews[1], byteOffsetIndices, accessorDef.sparse.count * itemSizeIndices);
          var sparseValues = new TypedArray(bufferViews[2], byteOffsetValues, accessorDef.sparse.count * itemSize);
          if (bufferView !== null) {
            // Avoid modifying the original ArrayBuffer, if the bufferView wasn't initialized with zeroes.
            bufferAttribute = new BufferAttribute(bufferAttribute.array.slice(), bufferAttribute.itemSize, bufferAttribute.normalized);
          }
          for (var i = 0, il = sparseIndices.length; i < il; i++) {
            var index = sparseIndices[i];
            bufferAttribute.setX(index, sparseValues[i * itemSize]);
            if (itemSize >= 2) bufferAttribute.setY(index, sparseValues[i * itemSize + 1]);
            if (itemSize >= 3) bufferAttribute.setZ(index, sparseValues[i * itemSize + 2]);
            if (itemSize >= 4) bufferAttribute.setW(index, sparseValues[i * itemSize + 3]);
            if (itemSize >= 5) throw new Error('THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.');
          }
        }
        return bufferAttribute;
      });
    }

    /**
     * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#textures
     * @param {number} textureIndex
     * @return {Promise<THREE.Texture|null>}
     */
  }, {
    key: "loadTexture",
    value: function loadTexture(textureIndex) {
      var json = this.json;
      var options = this.options;
      var textureDef = json.textures[textureIndex];
      var sourceIndex = textureDef.source;
      var sourceDef = json.images[sourceIndex];
      var loader = this.textureLoader;
      if (sourceDef.uri) {
        var handler = options.manager.getHandler(sourceDef.uri);
        if (handler !== null) loader = handler;
      }
      return this.loadTextureImage(textureIndex, sourceIndex, loader);
    }
  }, {
    key: "loadTextureImage",
    value: function loadTextureImage(textureIndex, sourceIndex, loader) {
      var parser = this;
      var json = this.json;
      var textureDef = json.textures[textureIndex];
      var sourceDef = json.images[sourceIndex];
      var cacheKey = (sourceDef.uri || sourceDef.bufferView) + ':' + textureDef.sampler;
      if (this.textureCache[cacheKey]) {
        // See https://github.com/mrdoob/three.js/issues/21559.
        return this.textureCache[cacheKey];
      }
      var promise = this.loadImageSource(sourceIndex, loader).then(function (texture) {
        texture.flipY = false;
        texture.name = textureDef.name || sourceDef.name || '';
        if (texture.name === '' && typeof sourceDef.uri === 'string' && sourceDef.uri.startsWith('data:image/') === false) {
          texture.name = sourceDef.uri;
        }
        var samplers = json.samplers || {};
        var sampler = samplers[textureDef.sampler] || {};
        texture.magFilter = WEBGL_FILTERS[sampler.magFilter] || LinearFilter;
        texture.minFilter = WEBGL_FILTERS[sampler.minFilter] || LinearMipmapLinearFilter;
        texture.wrapS = WEBGL_WRAPPINGS[sampler.wrapS] || RepeatWrapping;
        texture.wrapT = WEBGL_WRAPPINGS[sampler.wrapT] || RepeatWrapping;
        parser.associations.set(texture, {
          textures: textureIndex
        });
        return texture;
      })["catch"](function () {
        return null;
      });
      this.textureCache[cacheKey] = promise;
      return promise;
    }
  }, {
    key: "loadImageSource",
    value: function loadImageSource(sourceIndex, loader) {
      var parser = this;
      var json = this.json;
      var options = this.options;
      if (this.sourceCache[sourceIndex] !== undefined) {
        return this.sourceCache[sourceIndex].then(function (texture) {
          return texture.clone();
        });
      }
      var sourceDef = json.images[sourceIndex];
      var URL = self.URL || self.webkitURL;
      var sourceURI = sourceDef.uri || '';
      var isObjectURL = false;
      if (sourceDef.bufferView !== undefined) {
        // Load binary image data from bufferView, if provided.

        sourceURI = parser.getDependency('bufferView', sourceDef.bufferView).then(function (bufferView) {
          isObjectURL = true;
          var blob = new Blob([bufferView], {
            type: sourceDef.mimeType
          });
          sourceURI = URL.createObjectURL(blob);
          return sourceURI;
        });
      } else if (sourceDef.uri === undefined) {
        throw new Error('THREE.GLTFLoader: Image ' + sourceIndex + ' is missing URI and bufferView');
      }
      var promise = Promise.resolve(sourceURI).then(function (sourceURI) {
        return new Promise(function (resolve, reject) {
          var onLoad = resolve;
          if (loader.isImageBitmapLoader === true) {
            onLoad = function onLoad(imageBitmap) {
              var texture = new Texture(imageBitmap);
              texture.needsUpdate = true;
              resolve(texture);
            };
          }
          loader.load(LoaderUtils.resolveURL(sourceURI, options.path), onLoad, undefined, reject);
        });
      }).then(function (texture) {
        // Clean up resources and configure Texture.

        if (isObjectURL === true) {
          URL.revokeObjectURL(sourceURI);
        }
        texture.userData.mimeType = sourceDef.mimeType || getImageURIMimeType(sourceDef.uri);
        return texture;
      })["catch"](function (error) {
        console.error("THREE.GLTFLoader: Couldn't load texture", sourceURI);
        throw error;
      });
      this.sourceCache[sourceIndex] = promise;
      return promise;
    }

    /**
     * Asynchronously assigns a texture to the given material parameters.
     * @param {Object} materialParams
     * @param {string} mapName
     * @param {Object} mapDef
     * @return {Promise<Texture>}
     */
  }, {
    key: "assignTexture",
    value: function assignTexture(materialParams, mapName, mapDef, colorSpace) {
      var parser = this;
      return this.getDependency('texture', mapDef.index).then(function (texture) {
        if (!texture) return null;
        if (mapDef.texCoord !== undefined && mapDef.texCoord > 0) {
          texture = texture.clone();
          texture.channel = mapDef.texCoord;
        }
        if (parser.extensions[EXTENSIONS.KHR_TEXTURE_TRANSFORM]) {
          var transform = mapDef.extensions !== undefined ? mapDef.extensions[EXTENSIONS.KHR_TEXTURE_TRANSFORM] : undefined;
          if (transform) {
            var gltfReference = parser.associations.get(texture);
            texture = parser.extensions[EXTENSIONS.KHR_TEXTURE_TRANSFORM].extendTexture(texture, transform);
            parser.associations.set(texture, gltfReference);
          }
        }
        if (colorSpace !== undefined) {
          texture.colorSpace = colorSpace;
        }
        materialParams[mapName] = texture;
        return texture;
      });
    }

    /**
     * Assigns final material to a Mesh, Line, or Points instance. The instance
     * already has a material (generated from the glTF material options alone)
     * but reuse of the same glTF material may require multiple threejs materials
     * to accommodate different primitive types, defines, etc. New materials will
     * be created if necessary, and reused from a cache.
     * @param  {Object3D} mesh Mesh, Line, or Points instance.
     */
  }, {
    key: "assignFinalMaterial",
    value: function assignFinalMaterial(mesh) {
      var geometry = mesh.geometry;
      var material = mesh.material;
      var useDerivativeTangents = geometry.attributes.tangent === undefined;
      var useVertexColors = geometry.attributes.color !== undefined;
      var useFlatShading = geometry.attributes.normal === undefined;
      if (mesh.isPoints) {
        var cacheKey = 'PointsMaterial:' + material.uuid;
        var pointsMaterial = this.cache.get(cacheKey);
        if (!pointsMaterial) {
          pointsMaterial = new PointsMaterial();
          Material$1.prototype.copy.call(pointsMaterial, material);
          pointsMaterial.color.copy(material.color);
          pointsMaterial.map = material.map;
          pointsMaterial.sizeAttenuation = false; // glTF spec says points should be 1px

          this.cache.add(cacheKey, pointsMaterial);
        }
        material = pointsMaterial;
      } else if (mesh.isLine) {
        var _cacheKey = 'LineBasicMaterial:' + material.uuid;
        var lineMaterial = this.cache.get(_cacheKey);
        if (!lineMaterial) {
          lineMaterial = new LineBasicMaterial();
          Material$1.prototype.copy.call(lineMaterial, material);
          lineMaterial.color.copy(material.color);
          lineMaterial.map = material.map;
          this.cache.add(_cacheKey, lineMaterial);
        }
        material = lineMaterial;
      }

      // Clone the material if it will be modified
      if (useDerivativeTangents || useVertexColors || useFlatShading) {
        var _cacheKey2 = 'ClonedMaterial:' + material.uuid + ':';
        if (useDerivativeTangents) _cacheKey2 += 'derivative-tangents:';
        if (useVertexColors) _cacheKey2 += 'vertex-colors:';
        if (useFlatShading) _cacheKey2 += 'flat-shading:';
        var cachedMaterial = this.cache.get(_cacheKey2);
        if (!cachedMaterial) {
          cachedMaterial = material.clone();
          if (useVertexColors) cachedMaterial.vertexColors = true;
          if (useFlatShading) cachedMaterial.flatShading = true;
          if (useDerivativeTangents) {
            // https://github.com/mrdoob/three.js/issues/11438#issuecomment-507003995
            if (cachedMaterial.normalScale) cachedMaterial.normalScale.y *= -1;
            if (cachedMaterial.clearcoatNormalScale) cachedMaterial.clearcoatNormalScale.y *= -1;
          }
          this.cache.add(_cacheKey2, cachedMaterial);
          this.associations.set(cachedMaterial, this.associations.get(material));
        }
        material = cachedMaterial;
      }
      mesh.material = material;
    }
  }, {
    key: "getMaterialType",
    value: function getMaterialType( /* materialIndex */
    ) {
      return MeshStandardMaterial;
    }

    /**
     * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#materials
     * @param {number} materialIndex
     * @return {Promise<Material>}
     */
  }, {
    key: "loadMaterial",
    value: function loadMaterial(materialIndex) {
      var parser = this;
      var json = this.json;
      var extensions = this.extensions;
      var materialDef = json.materials[materialIndex];
      var materialType;
      var materialParams = {};
      var materialExtensions = materialDef.extensions || {};
      var pending = [];
      if (materialExtensions[EXTENSIONS.KHR_MATERIALS_UNLIT]) {
        var kmuExtension = extensions[EXTENSIONS.KHR_MATERIALS_UNLIT];
        materialType = kmuExtension.getMaterialType();
        pending.push(kmuExtension.extendParams(materialParams, materialDef, parser));
      } else {
        // Specification:
        // https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#metallic-roughness-material

        var metallicRoughness = materialDef.pbrMetallicRoughness || {};
        materialParams.color = new Color(1.0, 1.0, 1.0);
        materialParams.opacity = 1.0;
        if (Array.isArray(metallicRoughness.baseColorFactor)) {
          var array = metallicRoughness.baseColorFactor;
          materialParams.color.setRGB(array[0], array[1], array[2], LinearSRGBColorSpace);
          materialParams.opacity = array[3];
        }
        if (metallicRoughness.baseColorTexture !== undefined) {
          pending.push(parser.assignTexture(materialParams, 'map', metallicRoughness.baseColorTexture, SRGBColorSpace));
        }
        materialParams.metalness = metallicRoughness.metallicFactor !== undefined ? metallicRoughness.metallicFactor : 1.0;
        materialParams.roughness = metallicRoughness.roughnessFactor !== undefined ? metallicRoughness.roughnessFactor : 1.0;
        if (metallicRoughness.metallicRoughnessTexture !== undefined) {
          pending.push(parser.assignTexture(materialParams, 'metalnessMap', metallicRoughness.metallicRoughnessTexture));
          pending.push(parser.assignTexture(materialParams, 'roughnessMap', metallicRoughness.metallicRoughnessTexture));
        }
        materialType = this._invokeOne(function (ext) {
          return ext.getMaterialType && ext.getMaterialType(materialIndex);
        });
        pending.push(Promise.all(this._invokeAll(function (ext) {
          return ext.extendMaterialParams && ext.extendMaterialParams(materialIndex, materialParams);
        })));
      }
      if (materialDef.doubleSided === true) {
        materialParams.side = DoubleSide;
      }
      var alphaMode = materialDef.alphaMode || ALPHA_MODES.OPAQUE;
      if (alphaMode === ALPHA_MODES.BLEND) {
        materialParams.transparent = true;

        // See: https://github.com/mrdoob/three.js/issues/17706
        materialParams.depthWrite = false;
      } else {
        materialParams.transparent = false;
        if (alphaMode === ALPHA_MODES.MASK) {
          materialParams.alphaTest = materialDef.alphaCutoff !== undefined ? materialDef.alphaCutoff : 0.5;
        }
      }
      if (materialDef.normalTexture !== undefined && materialType !== MeshBasicMaterial) {
        pending.push(parser.assignTexture(materialParams, 'normalMap', materialDef.normalTexture));
        materialParams.normalScale = new Vector2(1, 1);
        if (materialDef.normalTexture.scale !== undefined) {
          var scale = materialDef.normalTexture.scale;
          materialParams.normalScale.set(scale, scale);
        }
      }
      if (materialDef.occlusionTexture !== undefined && materialType !== MeshBasicMaterial) {
        pending.push(parser.assignTexture(materialParams, 'aoMap', materialDef.occlusionTexture));
        if (materialDef.occlusionTexture.strength !== undefined) {
          materialParams.aoMapIntensity = materialDef.occlusionTexture.strength;
        }
      }
      if (materialDef.emissiveFactor !== undefined && materialType !== MeshBasicMaterial) {
        var emissiveFactor = materialDef.emissiveFactor;
        materialParams.emissive = new Color().setRGB(emissiveFactor[0], emissiveFactor[1], emissiveFactor[2], LinearSRGBColorSpace);
      }
      if (materialDef.emissiveTexture !== undefined && materialType !== MeshBasicMaterial) {
        pending.push(parser.assignTexture(materialParams, 'emissiveMap', materialDef.emissiveTexture, SRGBColorSpace));
      }
      return Promise.all(pending).then(function () {
        var material = new materialType(materialParams);
        if (materialDef.name) material.name = materialDef.name;
        assignExtrasToUserData(material, materialDef);
        parser.associations.set(material, {
          materials: materialIndex
        });
        if (materialDef.extensions) addUnknownExtensionsToUserData(extensions, material, materialDef);
        return material;
      });
    }

    /** When Object3D instances are targeted by animation, they need unique names. */
  }, {
    key: "createUniqueName",
    value: function createUniqueName(originalName) {
      var sanitizedName = PropertyBinding.sanitizeNodeName(originalName || '');
      if (sanitizedName in this.nodeNamesUsed) {
        return sanitizedName + '_' + ++this.nodeNamesUsed[sanitizedName];
      } else {
        this.nodeNamesUsed[sanitizedName] = 0;
        return sanitizedName;
      }
    }

    /**
     * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#geometry
     *
     * Creates BufferGeometries from primitives.
     *
     * @param {Array<GLTF.Primitive>} primitives
     * @return {Promise<Array<BufferGeometry>>}
     */
  }, {
    key: "loadGeometries",
    value: function loadGeometries(primitives) {
      var parser = this;
      var extensions = this.extensions;
      var cache = this.primitiveCache;
      function createDracoPrimitive(primitive) {
        return extensions[EXTENSIONS.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(primitive, parser).then(function (geometry) {
          return addPrimitiveAttributes(geometry, primitive, parser);
        });
      }
      var pending = [];
      for (var i = 0, il = primitives.length; i < il; i++) {
        var primitive = primitives[i];
        var cacheKey = createPrimitiveKey(primitive);

        // See if we've already created this geometry
        var cached = cache[cacheKey];
        if (cached) {
          // Use the cached geometry if it exists
          pending.push(cached.promise);
        } else {
          var geometryPromise = void 0;
          if (primitive.extensions && primitive.extensions[EXTENSIONS.KHR_DRACO_MESH_COMPRESSION]) {
            // Use DRACO geometry if available
            geometryPromise = createDracoPrimitive(primitive);
          } else {
            // Otherwise create a new geometry
            geometryPromise = addPrimitiveAttributes(new BufferGeometry(), primitive, parser);
          }

          // Cache this geometry
          cache[cacheKey] = {
            primitive: primitive,
            promise: geometryPromise
          };
          pending.push(geometryPromise);
        }
      }
      return Promise.all(pending);
    }

    /**
     * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#meshes
     * @param {number} meshIndex
     * @return {Promise<Group|Mesh|SkinnedMesh>}
     */
  }, {
    key: "loadMesh",
    value: function loadMesh(meshIndex) {
      var parser = this;
      var json = this.json;
      var extensions = this.extensions;
      var meshDef = json.meshes[meshIndex];
      var primitives = meshDef.primitives;
      var pending = [];
      for (var i = 0, il = primitives.length; i < il; i++) {
        var material = primitives[i].material === undefined ? createDefaultMaterial(this.cache) : this.getDependency('material', primitives[i].material);
        pending.push(material);
      }
      pending.push(parser.loadGeometries(primitives));
      return Promise.all(pending).then(function (results) {
        var materials = results.slice(0, results.length - 1);
        var geometries = results[results.length - 1];
        var meshes = [];
        for (var _i8 = 0, _il6 = geometries.length; _i8 < _il6; _i8++) {
          var geometry = geometries[_i8];
          var primitive = primitives[_i8];

          // 1. create Mesh

          var mesh = void 0;
          var _material = materials[_i8];
          if (primitive.mode === WEBGL_CONSTANTS.TRIANGLES || primitive.mode === WEBGL_CONSTANTS.TRIANGLE_STRIP || primitive.mode === WEBGL_CONSTANTS.TRIANGLE_FAN || primitive.mode === undefined) {
            // .isSkinnedMesh isn't in glTF spec. See ._markDefs()
            mesh = meshDef.isSkinnedMesh === true ? new SkinnedMesh(geometry, _material) : new Mesh(geometry, _material);
            if (mesh.isSkinnedMesh === true) {
              // normalize skin weights to fix malformed assets (see #15319)
              mesh.normalizeSkinWeights();
            }
            if (primitive.mode === WEBGL_CONSTANTS.TRIANGLE_STRIP) {
              mesh.geometry = toTrianglesDrawMode(mesh.geometry, TriangleStripDrawMode);
            } else if (primitive.mode === WEBGL_CONSTANTS.TRIANGLE_FAN) {
              mesh.geometry = toTrianglesDrawMode(mesh.geometry, TriangleFanDrawMode);
            }
          } else if (primitive.mode === WEBGL_CONSTANTS.LINES) {
            mesh = new LineSegments(geometry, _material);
          } else if (primitive.mode === WEBGL_CONSTANTS.LINE_STRIP) {
            mesh = new Line(geometry, _material);
          } else if (primitive.mode === WEBGL_CONSTANTS.LINE_LOOP) {
            mesh = new LineLoop(geometry, _material);
          } else if (primitive.mode === WEBGL_CONSTANTS.POINTS) {
            mesh = new Points(geometry, _material);
          } else {
            throw new Error('THREE.GLTFLoader: Primitive mode unsupported: ' + primitive.mode);
          }
          if (Object.keys(mesh.geometry.morphAttributes).length > 0) {
            updateMorphTargets(mesh, meshDef);
          }
          mesh.name = parser.createUniqueName(meshDef.name || 'mesh_' + meshIndex);
          assignExtrasToUserData(mesh, meshDef);
          if (primitive.extensions) addUnknownExtensionsToUserData(extensions, mesh, primitive);
          parser.assignFinalMaterial(mesh);
          meshes.push(mesh);
        }
        for (var _i10 = 0, _il8 = meshes.length; _i10 < _il8; _i10++) {
          parser.associations.set(meshes[_i10], {
            meshes: meshIndex,
            primitives: _i10
          });
        }
        if (meshes.length === 1) {
          if (meshDef.extensions) addUnknownExtensionsToUserData(extensions, meshes[0], meshDef);
          return meshes[0];
        }
        var group = new Group();
        if (meshDef.extensions) addUnknownExtensionsToUserData(extensions, group, meshDef);
        parser.associations.set(group, {
          meshes: meshIndex
        });
        for (var _i12 = 0, _il10 = meshes.length; _i12 < _il10; _i12++) {
          group.add(meshes[_i12]);
        }
        return group;
      });
    }

    /**
     * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#cameras
     * @param {number} cameraIndex
     * @return {Promise<THREE.Camera>}
     */
  }, {
    key: "loadCamera",
    value: function loadCamera(cameraIndex) {
      var camera;
      var cameraDef = this.json.cameras[cameraIndex];
      var params = cameraDef[cameraDef.type];
      if (!params) {
        console.warn('THREE.GLTFLoader: Missing camera parameters.');
        return;
      }
      if (cameraDef.type === 'perspective') {
        camera = new PerspectiveCamera$1(MathUtils.radToDeg(params.yfov), params.aspectRatio || 1, params.znear || 1, params.zfar || 2e6);
      } else if (cameraDef.type === 'orthographic') {
        camera = new OrthographicCamera(-params.xmag, params.xmag, params.ymag, -params.ymag, params.znear, params.zfar);
      }
      if (cameraDef.name) camera.name = this.createUniqueName(cameraDef.name);
      assignExtrasToUserData(camera, cameraDef);
      return Promise.resolve(camera);
    }

    /**
     * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#skins
     * @param {number} skinIndex
     * @return {Promise<Skeleton>}
     */
  }, {
    key: "loadSkin",
    value: function loadSkin(skinIndex) {
      var skinDef = this.json.skins[skinIndex];
      var pending = [];
      for (var i = 0, il = skinDef.joints.length; i < il; i++) {
        pending.push(this._loadNodeShallow(skinDef.joints[i]));
      }
      if (skinDef.inverseBindMatrices !== undefined) {
        pending.push(this.getDependency('accessor', skinDef.inverseBindMatrices));
      } else {
        pending.push(null);
      }
      return Promise.all(pending).then(function (results) {
        var inverseBindMatrices = results.pop();
        var jointNodes = results;

        // Note that bones (joint nodes) may or may not be in the
        // scene graph at this time.

        var bones = [];
        var boneInverses = [];
        for (var _i14 = 0, _il12 = jointNodes.length; _i14 < _il12; _i14++) {
          var jointNode = jointNodes[_i14];
          if (jointNode) {
            bones.push(jointNode);
            var mat = new Matrix4();
            if (inverseBindMatrices !== null) {
              mat.fromArray(inverseBindMatrices.array, _i14 * 16);
            }
            boneInverses.push(mat);
          } else {
            console.warn('THREE.GLTFLoader: Joint "%s" could not be found.', skinDef.joints[_i14]);
          }
        }
        return new Skeleton(bones, boneInverses);
      });
    }

    /**
     * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#animations
     * @param {number} animationIndex
     * @return {Promise<AnimationClip>}
     */
  }, {
    key: "loadAnimation",
    value: function loadAnimation(animationIndex) {
      var json = this.json;
      var parser = this;
      var animationDef = json.animations[animationIndex];
      var animationName = animationDef.name ? animationDef.name : 'animation_' + animationIndex;
      var pendingNodes = [];
      var pendingInputAccessors = [];
      var pendingOutputAccessors = [];
      var pendingSamplers = [];
      var pendingTargets = [];
      for (var i = 0, il = animationDef.channels.length; i < il; i++) {
        var channel = animationDef.channels[i];
        var sampler = animationDef.samplers[channel.sampler];
        var target = channel.target;
        var name = target.node;
        var input = animationDef.parameters !== undefined ? animationDef.parameters[sampler.input] : sampler.input;
        var output = animationDef.parameters !== undefined ? animationDef.parameters[sampler.output] : sampler.output;
        if (target.node === undefined) continue;
        pendingNodes.push(this.getDependency('node', name));
        pendingInputAccessors.push(this.getDependency('accessor', input));
        pendingOutputAccessors.push(this.getDependency('accessor', output));
        pendingSamplers.push(sampler);
        pendingTargets.push(target);
      }
      return Promise.all([Promise.all(pendingNodes), Promise.all(pendingInputAccessors), Promise.all(pendingOutputAccessors), Promise.all(pendingSamplers), Promise.all(pendingTargets)]).then(function (dependencies) {
        var nodes = dependencies[0];
        var inputAccessors = dependencies[1];
        var outputAccessors = dependencies[2];
        var samplers = dependencies[3];
        var targets = dependencies[4];
        var tracks = [];
        for (var _i16 = 0, _il14 = nodes.length; _i16 < _il14; _i16++) {
          var node = nodes[_i16];
          var inputAccessor = inputAccessors[_i16];
          var outputAccessor = outputAccessors[_i16];
          var _sampler = samplers[_i16];
          var _target2 = targets[_i16];
          if (node === undefined) continue;
          if (node.updateMatrix) {
            node.updateMatrix();
          }
          var createdTracks = parser._createAnimationTracks(node, inputAccessor, outputAccessor, _sampler, _target2);
          if (createdTracks) {
            for (var k = 0; k < createdTracks.length; k++) {
              tracks.push(createdTracks[k]);
            }
          }
        }
        return new AnimationClip(animationName, undefined, tracks);
      });
    }
  }, {
    key: "createNodeMesh",
    value: function createNodeMesh(nodeIndex) {
      var json = this.json;
      var parser = this;
      var nodeDef = json.nodes[nodeIndex];
      if (nodeDef.mesh === undefined) return null;
      return parser.getDependency('mesh', nodeDef.mesh).then(function (mesh) {
        var node = parser._getNodeRef(parser.meshCache, nodeDef.mesh, mesh);

        // if weights are provided on the node, override weights on the mesh.
        if (nodeDef.weights !== undefined) {
          node.traverse(function (o) {
            if (!o.isMesh) return;
            for (var i = 0, il = nodeDef.weights.length; i < il; i++) {
              o.morphTargetInfluences[i] = nodeDef.weights[i];
            }
          });
        }
        return node;
      });
    }

    /**
     * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#nodes-and-hierarchy
     * @param {number} nodeIndex
     * @return {Promise<Object3D>}
     */
  }, {
    key: "loadNode",
    value: function loadNode(nodeIndex) {
      var json = this.json;
      var parser = this;
      var nodeDef = json.nodes[nodeIndex];
      var nodePending = parser._loadNodeShallow(nodeIndex);
      var childPending = [];
      var childrenDef = nodeDef.children || [];
      for (var i = 0, il = childrenDef.length; i < il; i++) {
        childPending.push(parser.getDependency('node', childrenDef[i]));
      }
      var skeletonPending = nodeDef.skin === undefined ? Promise.resolve(null) : parser.getDependency('skin', nodeDef.skin);
      return Promise.all([nodePending, Promise.all(childPending), skeletonPending]).then(function (results) {
        var node = results[0];
        var children = results[1];
        var skeleton = results[2];
        if (skeleton !== null) {
          // This full traverse should be fine because
          // child glTF nodes have not been added to this node yet.
          node.traverse(function (mesh) {
            if (!mesh.isSkinnedMesh) return;
            mesh.bind(skeleton, _identityMatrix);
          });
        }
        for (var _i18 = 0, _il16 = children.length; _i18 < _il16; _i18++) {
          node.add(children[_i18]);
        }
        return node;
      });
    }

    // ._loadNodeShallow() parses a single node.
    // skin and child nodes are created and added in .loadNode() (no '_' prefix).
  }, {
    key: "_loadNodeShallow",
    value: function _loadNodeShallow(nodeIndex) {
      var json = this.json;
      var extensions = this.extensions;
      var parser = this;

      // This method is called from .loadNode() and .loadSkin().
      // Cache a node to avoid duplication.

      if (this.nodeCache[nodeIndex] !== undefined) {
        return this.nodeCache[nodeIndex];
      }
      var nodeDef = json.nodes[nodeIndex];

      // reserve node's name before its dependencies, so the root has the intended name.
      var nodeName = nodeDef.name ? parser.createUniqueName(nodeDef.name) : '';
      var pending = [];
      var meshPromise = parser._invokeOne(function (ext) {
        return ext.createNodeMesh && ext.createNodeMesh(nodeIndex);
      });
      if (meshPromise) {
        pending.push(meshPromise);
      }
      if (nodeDef.camera !== undefined) {
        pending.push(parser.getDependency('camera', nodeDef.camera).then(function (camera) {
          return parser._getNodeRef(parser.cameraCache, nodeDef.camera, camera);
        }));
      }
      parser._invokeAll(function (ext) {
        return ext.createNodeAttachment && ext.createNodeAttachment(nodeIndex);
      }).forEach(function (promise) {
        pending.push(promise);
      });
      this.nodeCache[nodeIndex] = Promise.all(pending).then(function (objects) {
        var node;

        // .isBone isn't in glTF spec. See ._markDefs
        if (nodeDef.isBone === true) {
          node = new Bone();
        } else if (objects.length > 1) {
          node = new Group();
        } else if (objects.length === 1) {
          node = objects[0];
        } else {
          node = new Object3D();
        }
        if (node !== objects[0]) {
          for (var i = 0, il = objects.length; i < il; i++) {
            node.add(objects[i]);
          }
        }
        if (nodeDef.name) {
          node.userData.name = nodeDef.name;
          node.name = nodeName;
        }
        assignExtrasToUserData(node, nodeDef);
        if (nodeDef.extensions) addUnknownExtensionsToUserData(extensions, node, nodeDef);
        if (nodeDef.matrix !== undefined) {
          var matrix = new Matrix4();
          matrix.fromArray(nodeDef.matrix);
          node.applyMatrix4(matrix);
        } else {
          if (nodeDef.translation !== undefined) {
            node.position.fromArray(nodeDef.translation);
          }
          if (nodeDef.rotation !== undefined) {
            node.quaternion.fromArray(nodeDef.rotation);
          }
          if (nodeDef.scale !== undefined) {
            node.scale.fromArray(nodeDef.scale);
          }
        }
        if (!parser.associations.has(node)) {
          parser.associations.set(node, {});
        }
        parser.associations.get(node).nodes = nodeIndex;
        return node;
      });
      return this.nodeCache[nodeIndex];
    }

    /**
     * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#scenes
     * @param {number} sceneIndex
     * @return {Promise<Group>}
     */
  }, {
    key: "loadScene",
    value: function loadScene(sceneIndex) {
      var extensions = this.extensions;
      var sceneDef = this.json.scenes[sceneIndex];
      var parser = this;

      // Loader returns Group, not Scene.
      // See: https://github.com/mrdoob/three.js/issues/18342#issuecomment-578981172
      var scene = new Group();
      if (sceneDef.name) scene.name = parser.createUniqueName(sceneDef.name);
      assignExtrasToUserData(scene, sceneDef);
      if (sceneDef.extensions) addUnknownExtensionsToUserData(extensions, scene, sceneDef);
      var nodeIds = sceneDef.nodes || [];
      var pending = [];
      for (var i = 0, il = nodeIds.length; i < il; i++) {
        pending.push(parser.getDependency('node', nodeIds[i]));
      }
      return Promise.all(pending).then(function (nodes) {
        for (var _i20 = 0, _il18 = nodes.length; _i20 < _il18; _i20++) {
          scene.add(nodes[_i20]);
        }

        // Removes dangling associations, associations that reference a node that
        // didn't make it into the scene.
        var reduceAssociations = function reduceAssociations(node) {
          var reducedAssociations = new Map();
          var _iterator4 = _createForOfIteratorHelper(parser.associations),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _ref3 = _step4.value;
              var _ref4 = _slicedToArray(_ref3, 2);
              var key = _ref4[0];
              var value = _ref4[1];
              if (key instanceof Material$1 || key instanceof Texture) {
                reducedAssociations.set(key, value);
              }
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
          node.traverse(function (node) {
            var mappings = parser.associations.get(node);
            if (mappings != null) {
              reducedAssociations.set(node, mappings);
            }
          });
          return reducedAssociations;
        };
        parser.associations = reduceAssociations(scene);
        return scene;
      });
    }
  }, {
    key: "_createAnimationTracks",
    value: function _createAnimationTracks(node, inputAccessor, outputAccessor, sampler, target) {
      var tracks = [];
      var targetName = node.name ? node.name : node.uuid;
      var targetNames = [];
      if (PATH_PROPERTIES[target.path] === PATH_PROPERTIES.weights) {
        node.traverse(function (object) {
          if (object.morphTargetInfluences) {
            targetNames.push(object.name ? object.name : object.uuid);
          }
        });
      } else {
        targetNames.push(targetName);
      }
      var TypedKeyframeTrack;
      switch (PATH_PROPERTIES[target.path]) {
        case PATH_PROPERTIES.weights:
          TypedKeyframeTrack = NumberKeyframeTrack;
          break;
        case PATH_PROPERTIES.rotation:
          TypedKeyframeTrack = QuaternionKeyframeTrack;
          break;
        case PATH_PROPERTIES.position:
        case PATH_PROPERTIES.scale:
          TypedKeyframeTrack = VectorKeyframeTrack;
          break;
        default:
          switch (outputAccessor.itemSize) {
            case 1:
              TypedKeyframeTrack = NumberKeyframeTrack;
              break;
            case 2:
            case 3:
            default:
              TypedKeyframeTrack = VectorKeyframeTrack;
              break;
          }
          break;
      }
      var interpolation = sampler.interpolation !== undefined ? INTERPOLATION[sampler.interpolation] : InterpolateLinear;
      var outputArray = this._getArrayFromAccessor(outputAccessor);
      for (var j = 0, jl = targetNames.length; j < jl; j++) {
        var track = new TypedKeyframeTrack(targetNames[j] + '.' + PATH_PROPERTIES[target.path], inputAccessor.array, outputArray, interpolation);

        // Override interpolation with custom factory method.
        if (sampler.interpolation === 'CUBICSPLINE') {
          this._createCubicSplineTrackInterpolant(track);
        }
        tracks.push(track);
      }
      return tracks;
    }
  }, {
    key: "_getArrayFromAccessor",
    value: function _getArrayFromAccessor(accessor) {
      var outputArray = accessor.array;
      if (accessor.normalized) {
        var scale = getNormalizedComponentScale(outputArray.constructor);
        var scaled = new Float32Array(outputArray.length);
        for (var j = 0, jl = outputArray.length; j < jl; j++) {
          scaled[j] = outputArray[j] * scale;
        }
        outputArray = scaled;
      }
      return outputArray;
    }
  }, {
    key: "_createCubicSplineTrackInterpolant",
    value: function _createCubicSplineTrackInterpolant(track) {
      track.createInterpolant = function InterpolantFactoryMethodGLTFCubicSpline(result) {
        // A CUBICSPLINE keyframe in glTF has three output values for each input value,
        // representing inTangent, splineVertex, and outTangent. As a result, track.getValueSize()
        // must be divided by three to get the interpolant's sampleSize argument.

        var interpolantType = this instanceof QuaternionKeyframeTrack ? GLTFCubicSplineQuaternionInterpolant : GLTFCubicSplineInterpolant;
        return new interpolantType(this.times, this.values, this.getValueSize() / 3, result);
      };

      // Mark as CUBICSPLINE. `track.getInterpolation()` doesn't support custom interpolants.
      track.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = true;
    }
  }]);
  return GLTFParser;
}();
/**
 * @param {BufferGeometry} geometry
 * @param {GLTF.Primitive} primitiveDef
 * @param {GLTFParser} parser
 */
function computeBounds(geometry, primitiveDef, parser) {
  var attributes = primitiveDef.attributes;
  var box = new Box3();
  if (attributes.POSITION !== undefined) {
    var accessor = parser.json.accessors[attributes.POSITION];
    var min = accessor.min;
    var max = accessor.max;

    // glTF requires 'min' and 'max', but VRM (which extends glTF) currently ignores that requirement.

    if (min !== undefined && max !== undefined) {
      box.set(new Vector3(min[0], min[1], min[2]), new Vector3(max[0], max[1], max[2]));
      if (accessor.normalized) {
        var boxScale = getNormalizedComponentScale(WEBGL_COMPONENT_TYPES[accessor.componentType]);
        box.min.multiplyScalar(boxScale);
        box.max.multiplyScalar(boxScale);
      }
    } else {
      console.warn('THREE.GLTFLoader: Missing min/max properties for accessor POSITION.');
      return;
    }
  } else {
    return;
  }
  var targets = primitiveDef.targets;
  if (targets !== undefined) {
    var maxDisplacement = new Vector3();
    var vector = new Vector3();
    for (var i = 0, il = targets.length; i < il; i++) {
      var target = targets[i];
      if (target.POSITION !== undefined) {
        var _accessor = parser.json.accessors[target.POSITION];
        var _min = _accessor.min;
        var _max = _accessor.max;

        // glTF requires 'min' and 'max', but VRM (which extends glTF) currently ignores that requirement.

        if (_min !== undefined && _max !== undefined) {
          // we need to get max of absolute components because target weight is [-1,1]
          vector.setX(Math.max(Math.abs(_min[0]), Math.abs(_max[0])));
          vector.setY(Math.max(Math.abs(_min[1]), Math.abs(_max[1])));
          vector.setZ(Math.max(Math.abs(_min[2]), Math.abs(_max[2])));
          if (_accessor.normalized) {
            var _boxScale = getNormalizedComponentScale(WEBGL_COMPONENT_TYPES[_accessor.componentType]);
            vector.multiplyScalar(_boxScale);
          }

          // Note: this assumes that the sum of all weights is at most 1. This isn't quite correct - it's more conservative
          // to assume that each target can have a max weight of 1. However, for some use cases - notably, when morph targets
          // are used to implement key-frame animations and as such only two are active at a time - this results in very large
          // boxes. So for now we make a box that's sometimes a touch too small but is hopefully mostly of reasonable size.
          maxDisplacement.max(vector);
        } else {
          console.warn('THREE.GLTFLoader: Missing min/max properties for accessor POSITION.');
        }
      }
    }

    // As per comment above this box isn't conservative, but has a reasonable size for a very large number of morph targets.
    box.expandByVector(maxDisplacement);
  }
  geometry.boundingBox = box;
  var sphere = new Sphere$1();
  box.getCenter(sphere.center);
  sphere.radius = box.min.distanceTo(box.max) / 2;
  geometry.boundingSphere = sphere;
}

/**
 * @param {BufferGeometry} geometry
 * @param {GLTF.Primitive} primitiveDef
 * @param {GLTFParser} parser
 * @return {Promise<BufferGeometry>}
 */
function addPrimitiveAttributes(geometry, primitiveDef, parser) {
  var attributes = primitiveDef.attributes;
  var pending = [];
  function assignAttributeAccessor(accessorIndex, attributeName) {
    return parser.getDependency('accessor', accessorIndex).then(function (accessor) {
      geometry.setAttribute(attributeName, accessor);
    });
  }
  for (var gltfAttributeName in attributes) {
    var threeAttributeName = ATTRIBUTES[gltfAttributeName] || gltfAttributeName.toLowerCase();

    // Skip attributes already provided by e.g. Draco extension.
    if (threeAttributeName in geometry.attributes) continue;
    pending.push(assignAttributeAccessor(attributes[gltfAttributeName], threeAttributeName));
  }
  if (primitiveDef.indices !== undefined && !geometry.index) {
    var accessor = parser.getDependency('accessor', primitiveDef.indices).then(function (accessor) {
      geometry.setIndex(accessor);
    });
    pending.push(accessor);
  }
  if (ColorManagement.workingColorSpace !== LinearSRGBColorSpace && 'COLOR_0' in attributes) {
    console.warn("THREE.GLTFLoader: Converting vertex colors from \"srgb-linear\" to \"" + ColorManagement.workingColorSpace + "\" not supported.");
  }
  assignExtrasToUserData(geometry, primitiveDef);
  computeBounds(geometry, primitiveDef, parser);
  return Promise.all(pending).then(function () {
    return primitiveDef.targets !== undefined ? addMorphTargets(geometry, primitiveDef.targets, parser) : geometry;
  });
}

var RenderPreview = function RenderPreview(_ref) {
  var updatePreview = _ref.updatePreview,
    dataModel = _ref.dataModel,
    inx = _ref.inx,
    allMaterials = _ref.allMaterials;
  var _useThree = useThree(),
    scene = _useThree.scene,
    gl = _useThree.gl;
  var _utilsEditor = utilsEditor(),
    focus = _utilsEditor.focus;
  useEffect(function () {
    if (!scene) return;
    if (!allMaterials.length) return;
    setTimeout(function () {
      var geometry = new THREE.SphereGeometry(2, 32, 16);
      var loader = new GLTFLoader();
      loader.load(dataModel === null || dataModel === void 0 ? void 0 : dataModel.url, function (model) {
        var modelTo = model.scene;
        focus(modelTo, 1.3);
        scene.add(modelTo);
        setTimeout(function () {
          var screen = gl.domElement.toDataURL();
          updatePreview(function (prev) {
            return [].concat(_toConsumableArray(prev), [Object.assign(Object.assign({}, dataModel), {
              preview: screen
            })]);
          });
          scene.remove(modelTo);
        }, 300);
      }, function (e) {}, function (e) {
        var currentMaterial = allMaterials.find(function (i) {
          var _a;
          return ((_a = i === null || i === void 0 ? void 0 : i.userData) === null || _a === void 0 ? void 0 : _a.id) === dataModel.id;
        });
        if (!currentMaterial) return;
        var sphere = new THREE.Mesh(geometry, currentMaterial);
        scene.add(sphere);
        setTimeout(function () {
          var screen = gl.domElement.toDataURL();
          updatePreview(function (prev) {
            return [].concat(_toConsumableArray(prev), [Object.assign(Object.assign({}, dataModel), {
              preview: screen
            })]);
          });
          scene.remove(sphere);
          sphere.geometry.dispose();
          sphere.material.dispose();
        }, 100);
      });
    }, 200 * inx);
  }, [scene, allMaterials]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
};
var RenderModelPreview = function RenderModelPreview(_ref2) {
  var setMaterials = _ref2.setMaterials,
    model = _ref2.model;
  var modelUpload = useGLTF(model.url);
  useEffect(function () {
    if (modelUpload === null || modelUpload === void 0 ? void 0 : modelUpload.materials) {
      setMaterials(Object.values(modelUpload.materials));
    }
  }, [modelUpload]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
};
var ViewerForPreview = function ViewerForPreview(_ref3) {
  var allAssets = _ref3.allAssets,
    updatePreview = _ref3.updatePreview;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    assets = _useState2[0],
    setAssets = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    materials = _useState4[0],
    setMaterials = _useState4[1];
  var validAssets = useMemo(function () {
    if (!allAssets) return;
    var materials = allAssets.filter(function (item) {
      return item.type === 'material';
    });
    return _toConsumableArray(materials);
  }, [allAssets]);
  var model = useMemo(function () {
    if (!allAssets) return;
    var model = allAssets.find(function (item) {
      return item.type === 'model';
    });
    return model;
  }, [allAssets]);
  var otherAssetsMat = useMemo(function () {
    if (!allAssets) return;
    var materials = allAssets.filter(function (item) {
      return item.type !== 'model';
    });
    var other = materials.filter(function (item) {
      return item.type !== 'material';
    });
    return _toConsumableArray(other);
  }, [allAssets]);
  useEffect(function () {
    if (validAssets) {
      setAssets(validAssets);
    }
  }, [validAssets]);
  return /*#__PURE__*/React__default.createElement(Canvas, {
    gl: {
      pixelRatio: window.devicePixelRatio,
      antialias: true,
      outputColorSpace: 'srgb',
      preserveDrawingBuffer: true
    }
  }, /*#__PURE__*/React__default.createElement("color", {
    attach: "background",
    args: ['#e4e4e4']
  }), model && /*#__PURE__*/React__default.createElement(RenderModelPreview, {
    setMaterials: setMaterials,
    model: model
  }), /*#__PURE__*/React__default.createElement(AMAControls, null), /*#__PURE__*/React__default.createElement("ambientLight", {
    intensity: 0.1
  }), /*#__PURE__*/React__default.createElement("directionalLight", {
    position: [-3, 15, 7]
  }), model && otherAssetsMat && assets.length && [].concat(_toConsumableArray(assets), [model]).map(function (item, inx) {
    return /*#__PURE__*/React__default.createElement(RenderPreview, {
      inx: inx,
      dataModel: item,
      updatePreview: updatePreview,
      allMaterials: materials
    });
  }));
};

var EditorInit = function EditorInit(assetId, authToken, initConfig, type) {
  console.table({
    assetId: assetId,
    apiToken: authToken,
    initConfig: initConfig,
    type: type
  });
  return /*#__PURE__*/React__default.createElement(React__default.Suspense, {
    fallback: null
  }, /*#__PURE__*/React__default.createElement(EditorConstructor, {
    assetId: assetId,
    apiKey: authToken,
    presetConfig: initConfig,
    type: type
  }));
};

var modelPlayerInit = function modelPlayerInit(_ref) {
  var el = _ref.el,
    assetId = _ref.assetId,
    apiKey = _ref.apiKey,
    initConfig = _ref.initConfig,
    type = _ref.type;
  ReactDOM.render(EditorInit(assetId, apiKey, initConfig, type), el);
};

window.playerInit = modelPlayerInit;

export { AMAHotspotType, AMAMaterialType, AMAMeshType, AMAMode, AMARuleTypeAction, AMARuleTypeCondition, AMATransformMode, AnnotationAMA, BLOOM_EFFECT, BRIGHTNESS_CONTRAST_EFFECT, BlendFunction, CHROMATIC_ABERRATION_EFFECT, CONFIG_DEFAULT, Config, DEFAULT_CAMERA, DEFAULT_CAMERA_POSITION, DEFAULT_CAMERA_PROPS, DEFAULT_CAMERA_TARGET, DEFAULT_CONTROLS_PROPS, DEFAULT_ENVIRONMENT_GROUND, DEFAULT_INIT_CONFIG, DEFAULT_LOADING_PROGRESS, DEFAULT_MATERIAL_PROPS, DOF_EFFECT, DefaultObjects, EditorConstructor, FIRST_TIME, GROUP_NODES_NAME, HOTSPOT_URL, HUE_SATURATION_EFFECT, KernelSize, MaterialAMA, MaterialPlayer, MaterialUpdate, ModelContainer, ModelEditor, ModelPlayer, NOISE_EFFECT, NodeUpdate, POST_PROCESSING_NAME, PROPS_TO_UPDATE_TREE, PreviewModel, SMAA_EFFECT, SSAO_EFFECT, TARGET_CUSTOM_URL, TARGET_NAME, TONE_MAPPING_EFFECT, TextureAMA, VIGNETTE_EFFECT, ViewerForPreview, VignetteTechnique, create, createDefaultConfig, customCameras, customLights, customObjects, firstTimeCamera, isAMABoxGeometry, isAMAPlaneGeometry, isAMASphereGeometry, isCamera, isCustomShapes, isDirectionalLight, isHemisphereLight, isLight, isMeshAMA, isPointLight, isSpecificObject, isSpotLight, isStandardMaterial, modelPlayerInit, resetAllStores, useBoundStore, useMaterialState, useTransformDefault, useTransformDefaultMaterial, useTransformDefaultScene, useTransformModelConfig, utilsAnimations, utilsAnnotation, utilsConfig, utilsEditor, utilsLogic, utilsMaterial, utilsScene };
